window.FLICKMOJI_CATALOG={
  "packs": [
    {
      "id": "hollywood_essentials",
      "name": "Hollywood Essentials",
      "is_premium": false,
      "puzzle_ids": [
        "np_01_01",
        "np_01_02",
        "np_01_03",
        "np_01_04",
        "np_01_05",
        "np_01_06",
        "np_01_07",
        "np_01_08",
        "np_01_09",
        "np_01_10",
        "np_02_01",
        "np_02_02",
        "np_02_03",
        "np_02_04",
        "np_02_05",
        "np_02_06",
        "np_02_07",
        "np_02_08",
        "np_02_09",
        "np_02_10",
        "np_03_01",
        "np_03_02",
        "np_03_03",
        "np_03_04",
        "np_03_05",
        "np_03_06",
        "np_03_07",
        "np_03_08",
        "np_03_09",
        "np_03_10",
        "np_04_01",
        "np_04_02",
        "np_04_03",
        "np_04_04",
        "np_04_05",
        "np_04_06",
        "np_04_07",
        "np_04_08",
        "np_04_09",
        "np_04_10",
        "np_05_01",
        "np_05_02",
        "np_05_03",
        "np_05_04",
        "np_05_05",
        "np_05_06",
        "np_05_07",
        "np_05_08",
        "np_05_09",
        "np_05_10",
        "np_06_01",
        "np_06_02",
        "np_06_03",
        "np_06_04",
        "np_06_05",
        "np_06_06",
        "np_06_07",
        "np_06_08",
        "np_06_09",
        "np_06_10",
        "np_07_01",
        "np_07_02",
        "np_07_03",
        "np_07_04",
        "np_07_05",
        "np_07_06",
        "np_07_07",
        "np_07_08",
        "np_07_09",
        "np_07_10",
        "np_08_01",
        "np_08_02",
        "np_08_03",
        "np_08_04",
        "np_08_05",
        "np_08_06",
        "np_08_07",
        "np_08_08",
        "np_08_09",
        "np_08_10",
        "np_09_01",
        "np_09_02",
        "np_09_03",
        "np_09_04",
        "np_09_05",
        "np_09_06",
        "np_09_07",
        "np_09_08",
        "np_09_09",
        "np_09_10",
        "np_10_01",
        "np_10_02",
        "np_10_03",
        "np_10_04",
        "np_10_05",
        "np_10_06",
        "np_10_07",
        "np_10_08",
        "np_10_09",
        "np_10_10",
        "np_11_01",
        "np_11_02",
        "np_11_03",
        "np_11_04",
        "np_11_05",
        "np_11_06",
        "np_11_07",
        "np_11_08",
        "np_11_09",
        "np_11_10",
        "np_12_01",
        "np_12_02",
        "np_12_03",
        "np_12_04",
        "np_12_05",
        "np_12_06",
        "np_12_07",
        "np_12_08",
        "np_12_09",
        "np_12_10",
        "np_13_01",
        "np_13_02",
        "np_13_03",
        "np_13_04",
        "np_13_05",
        "np_13_06",
        "np_13_07",
        "np_13_08",
        "np_13_09",
        "np_13_10",
        "np_14_01",
        "np_14_02",
        "np_14_03",
        "np_14_04",
        "np_14_05",
        "np_14_06",
        "np_14_07",
        "np_14_08",
        "np_14_09",
        "np_14_10",
        "np_15_01",
        "np_15_02",
        "np_15_03",
        "np_15_04",
        "np_15_05",
        "np_15_06",
        "np_15_07",
        "np_15_08",
        "np_15_09",
        "np_15_10",
        "np_16_01",
        "np_16_02",
        "np_16_03",
        "np_16_04",
        "np_16_05",
        "np_16_06",
        "np_16_07",
        "np_16_08",
        "np_16_09",
        "np_16_10",
        "np_17_01",
        "np_17_02",
        "np_17_03",
        "np_17_04",
        "np_17_05",
        "np_17_06",
        "np_17_07",
        "np_17_08",
        "np_17_09",
        "np_17_10",
        "np_18_01",
        "np_18_02",
        "np_18_03",
        "np_18_04",
        "np_18_05",
        "np_18_06",
        "np_18_07",
        "np_18_08",
        "np_18_09",
        "np_18_10",
        "np_19_01",
        "np_19_02",
        "np_19_03",
        "np_19_04",
        "np_19_05",
        "np_19_06",
        "np_19_07",
        "np_19_08",
        "np_19_09",
        "np_19_10",
        "np_20_01",
        "np_20_02",
        "np_20_03",
        "np_20_04",
        "np_20_05",
        "np_20_06",
        "np_20_07",
        "np_20_08",
        "np_20_09",
        "np_20_10",
        "np_21_01",
        "np_21_02",
        "np_21_03",
        "np_21_04",
        "np_21_05",
        "np_21_06",
        "np_21_07",
        "np_21_08",
        "np_21_09",
        "np_21_10",
        "np_22_01",
        "np_22_02",
        "np_22_03",
        "np_22_04",
        "np_22_05",
        "np_22_06",
        "np_22_07",
        "np_22_08",
        "np_22_09",
        "np_22_10",
        "np_23_01",
        "np_23_02",
        "np_23_03",
        "np_23_04",
        "np_23_05",
        "np_23_06",
        "np_23_07",
        "np_23_08",
        "np_23_09",
        "np_23_10",
        "np_24_01",
        "np_24_02",
        "np_24_03",
        "np_24_04",
        "np_24_05",
        "np_24_06",
        "np_24_07",
        "np_24_08",
        "np_24_09",
        "np_24_10",
        "np_25_01",
        "np_25_02",
        "np_25_03",
        "np_25_04",
        "np_25_05",
        "np_25_06",
        "np_25_07",
        "np_25_08",
        "np_25_09",
        "np_25_10",
        "np_26_01",
        "np_26_02",
        "np_26_03",
        "np_26_04",
        "np_26_05",
        "np_26_06",
        "np_26_07",
        "np_26_08",
        "np_26_09",
        "np_26_10",
        "np_27_01",
        "np_27_02",
        "np_27_03",
        "np_27_04",
        "np_27_05",
        "np_27_06",
        "np_27_07",
        "np_27_08",
        "np_27_09",
        "np_27_10",
        "np_28_01",
        "np_28_02",
        "np_28_03",
        "np_28_04",
        "np_28_05",
        "np_28_06",
        "np_28_07",
        "np_28_08",
        "np_28_09",
        "np_28_10",
        "np_29_01",
        "np_29_02",
        "np_29_03",
        "np_29_04",
        "np_29_05",
        "np_29_06",
        "np_29_07",
        "np_29_08",
        "np_29_09",
        "np_29_10",
        "np_30_01",
        "np_30_02",
        "np_30_03",
        "np_30_04",
        "np_30_05",
        "np_30_06",
        "np_30_07",
        "np_30_08",
        "np_30_09",
        "np_30_10"
      ]
    },
    {
      "id": "flickoff_exclusive",
      "name": "Flick-Off Exclusive",
      "is_premium": false,
      "puzzle_ids": [
        "fo_hunger_games",
        "fo_i_am_legend",
        "fo_space_jam",
        "fo_addams_family",
        "fo_wonderful_life",
        "fo_twister",
        "fo_world_war_z",
        "fo_21_jump_street",
        "fo_hook",
        "fo_free_willy",
        "fo_santa_clause",
        "fo_casper",
        "fo_parent_trap",
        "fo_scooby_doo",
        "fo_alvin",
        "fo_babe",
        "fo_honey_shrunk",
        "fo_kindergarten_cop",
        "fo_bodyguard",
        "fo_training_day",
        "fo_waynes_world",
        "fo_blues_brothers",
        "fo_sat_night_fever",
        "fo_beethoven",
        "fo_stuart_little",
        "fo_marley_me",
        "fo_perfect_storm",
        "fo_deep_impact",
        "fo_jingle_all_way",
        "fo_were_the_millers",
        "fo_twins",
        "fo_spy_kids",
        "fo_neverending",
        "fo_sister_act",
        "fo_bill_ted",
        "fo_trading_places",
        "fo_george_jungle",
        "fo_flubber",
        "fo_patch_adams",
        "fo_limitless",
        "fo_prisoners",
        "fo_life_is_beautiful",
        "fo_step_up",
        "fo_walk_remember",
        "fo_cliffhanger",
        "fo_backdraft",
        "fo_outbreak",
        "fo_volcano",
        "fo_dantes_peak",
        "fo_big_fish",
        "fo_splash",
        "fo_willow",
        "fo_small_soldiers",
        "fo_uncle_buck",
        "fo_sky_high"
      ]
    },
    {
      "id": "daily_exclusive",
      "name": "Daily Features",
      "is_premium": false,
      "puzzle_ids": [
        "dx_hitch",
        "dx_enchanted",
        "dx_cheaper_by_the_dozen",
        "dx_what_women_want",
        "dx_air_force_one",
        "dx_mighty_ducks",
        "dx_daddy_day_care",
        "dx_inspector_gadget",
        "dx_johnny_english",
        "dx_nanny_mcphee",
        "dx_ella_enchanted",
        "dx_rookie_of_the_year",
        "dx_little_giants",
        "dx_angels_in_the_outfield",
        "dx_the_pacifier",
        "dx_the_game_plan",
        "dx_bedtime_stories",
        "dx_agent_cody_banks",
        "dx_cats_dogs",
        "dx_snow_dogs",
        "dx_racing_stripes",
        "dx_dolphin_tale",
        "dx_soul_surfer",
        "dx_eight_below",
        "dx_fly_away_home",
        "dx_because_of_winn_dixie",
        "dx_nim_s_island",
        "dx_the_water_horse",
        "aa_top_gun_maverick",
        "aa_mission_impossible",
        "rc_notebook",
        "spielberg_catch_me",
        "hr_zombieland",
        "dc_v_vendetta",
        "alt_sense_sensibility",
        "alt_seven_pounds",
        "sf_demolition_man",
        "ni_doubtfire",
        "an_snow_white",
        "mi_bourne_identity",
        "mcu_spider_homecoming",
        "fam_polar_express",
        "an_spiderverse",
        "an_lego_movie",
        "sf_star_trek",
        "scorsese_shutter_island",
        "fam_charlie_factory",
        "alt_to_kill_mockingbird",
        "mcu_thor",
        "aa_cap_first_avenger",
        "aa_300",
        "an_despicable_me",
        "alt_ben_hur",
        "the_mask",
        "spielberg_lincoln",
        "mcu_deadpool",
        "scorsese_irishman",
        "alt_my_fair_lady",
        "mcu_doctor_strange",
        "scorsese_age_innocence",
        "he_inception",
        "an_incredibles",
        "an_soul",
        "an_encanto",
        "an_lilo_stitch",
        "ni_schindlers_list",
        "ni_romeo_juliet",
        "ni_trainspotting",
        "ni_heat",
        "ni_apollo_13",
        "mi_departed",
        "mi_devil_wears_prada",
        "th_gone_girl",
        "an_monsters_inc",
        "aa_casino_royale",
        "dumb_dumber",
        "spielberg_color_purple",
        "spielberg_amistad",
        "spielberg_a_i",
        "wa_royal_tenenbaums",
        "dis_alice_wonderland",
        "sp_sandlot",
        "sp_million_dollar_baby",
        "fam_matilda",
        "alt_american_sniper",
        "alt_unforgiven",
        "alt_roman_holiday",
        "alt_life_pi",
        "alt_little_women_2019",
        "ns_lucy",
        "mi_django",
        "aa_batman_2022",
        "ace_ventura",
        "spielberg_ready_player",
        "wa_life_aquatic",
        "scorsese_flower_moon",
        "mcu_captain_marvel",
        "dc_aquaman",
        "talladega",
        "50_first_dates",
        "qt_hateful_eight",
        "spielberg_war_horse",
        "wa_isle_dogs",
        "dis_101_dalmatians",
        "com_bruce_almighty",
        "alt_shakespeare_love",
        "alt_green_book",
        "alt_steel_magnolias",
        "sf_dune",
        "rc_youve_got_mail",
        "rc_crazy_rich",
        "rc_bridesmaids",
        "aa_lethal_weapon",
        "aa_casino",
        "mc_revenant",
        "coen_true_grit",
        "fincher_panic_room",
        "spielberg_post",
        "scorsese_aviator",
        "dis_peter_pan",
        "heist_inside_man",
        "fam_jumanji",
        "alt_platoon",
        "alt_butch_cassidy",
        "ns_click",
        "mc_social_network",
        "mi_v_vendetta",
        "bond_dr_no",
        "waterboy",
        "spielberg_minority_report",
        "alt_8_mile",
        "alt_the_rock",
        "mi_slumdog",
        "mi_1917",
        "spielberg_terminal",
        "an_beauty_and_beast",
        "sp_league_their_own",
        "sp_blind_side",
        "sp_miracle",
        "alt_napoleon",
        "alt_dirty_dozen",
        "mi_anchorman",
        "rc_princess_diaries",
        "rc_knocked_up",
        "mi_beautiful_mind",
        "an_wreck_ralph",
        "mcu_ant_man",
        "creed_1",
        "the_holiday",
        "spielberg_bridge_spies",
        "pix_good_dino",
        "rc_crazy_stupid",
        "rc_silver_linings",
        "rc_fault_stars",
        "rc_to_all_boys",
        "sp_rudy",
        "bio_amadeus",
        "act_bad_boys",
        "sf_5th_element",
        "com_hot_fuzz",
        "fam_chronicles_narnia",
        "for_downfall",
        "act_mr_mrs_smith",
        "alt_deer_hunter",
        "alt_all_about_eve",
        "alt_pride_prejudice",
        "alt_dolce_vita",
        "ns_horrible_bosses",
        "mi_imitation_game",
        "mcu_shang_chi",
        "dc_shazam",
        "bio_ali",
        "alt_con_air",
        "alt_terms_endearment",
        "alt_witness",
        "ns_hancock",
        "ns_the_town",
        "rc_sleepless",
        "cl_some_like_hot",
        "ni_cuckoos_nest",
        "knocked_up_2",
        "the_proposal",
        "spielberg_bfg",
        "wa_darjeeling",
        "wa_french_dispatch",
        "pix_onward",
        "dis_tarzan",
        "dw_kfp",
        "hr_omen",
        "sp_remember_titans",
        "sp_friday_night_lights",
        "bio_rocketman",
        "fam_night_museum",
        "for_book_thief",
        "alt_hurt_locker",
        "alt_hacksaw_ridge",
        "alt_tombstone",
        "alt_greatest_showman",
        "alt_erin_brockovich",
        "ns_i_robot",
        "ns_american_gangster",
        "mi_ford_ferrari",
        "just_go_with_it",
        "dodgeball",
        "yes_man",
        "ns_equalizer",
        "he_call_me_by_your_name",
        "an_sleeping_beauty",
        "an_bambi",
        "an_hercules",
        "mi_lotr_fellowship",
        "mi_borat",
        "rc_notting_hill",
        "rc_40_year_virgin",
        "rc_step_brothers",
        "aa_black_hawk_down",
        "ci_little_miss_sunshine",
        "ci_three_billboards",
        "cl_sting",
        "mi_la_confidential",
        "mi_jojo_rabbit",
        "hp_fantastic_beasts",
        "zoolander",
        "its_complicated",
        "ghibli_totoro",
        "dis_pocahontas",
        "dis_zootopia",
        "dw_prince_egypt",
        "dw_httyd",
        "hr_shaun_dead",
        "rc_10_things",
        "heist_now_you_see",
        "sp_tin_cup",
        "sp_chariots_fire",
        "bio_pursuit_happyness",
        "sf_godzilla_2014",
        "com_grown_ups",
        "an_secret_life_pets",
        "for_intouchables",
        "for_handmaiden",
        "alt_lone_survivor",
        "alt_empire_sun",
        "alt_apartment",
        "alt_moulin_rouge",
        "alt_philadelphia",
        "alt_united_93",
        "alt_127_hours",
        "alt_nomadland",
        "alt_seventh_seal",
        "alt_chocolat",
        "alt_fried_green",
        "alt_fall_guy",
        "alt_grapes_wrath",
        "ns_maze_runner",
        "ns_flight",
        "mi_mystic_river",
        "coen_hail_caesar",
        "nolan_tenet",
        "ns_enemy_state",
        "mi_prestige",
        "mi_spotlight",
        "walk_hard",
        "coen_burn_after",
        "coen_buster_scruggs",
        "wa_asteroid_city",
        "scorsese_silence",
        "an_mulan",
        "sf_signs",
        "alt_driving_miss_daisy",
        "alt_frida",
        "alt_captain_phillips",
        "alt_marriage_story",
        "ns_divergent",
        "mi_old_school",
        "rc_13_going_30",
        "ci_lady_bird",
        "an_klaus",
        "mcu_eternals",
        "dc_suicide_squad_2016",
        "the_other_guys",
        "scorsese_last_temptation",
        "dw_madagascar",
        "argo",
        "hr_amityville",
        "hr_night_living",
        "rc_cruel_intentions",
        "sp_hoosiers",
        "sp_coach_carter",
        "bio_walk_line",
        "act_expendables",
        "com_date_night",
        "an_rio",
        "for_water_elephants",
        "for_memories_murder",
        "for_snowpiercer",
        "alt_all_quiet_western",
        "alt_open_range",
        "alt_notorious",
        "alt_modern_times",
        "alt_bicycle_thieves",
        "ns_real_steel",
        "cl_lawrence_arabia",
        "ni_chinatown",
        "mi_12_years_slave",
        "dis_hunchback",
        "hr_texas_chainsaw",
        "hr_paranormal",
        "bio_mlk_selma_skip",
        "ind_nightcrawler",
        "sf_edge_tomorrow",
        "com_neighbors",
        "alt_sweeney_todd",
        "alt_up_in_air",
        "alt_disaster_artist",
        "alt_chicago_7",
        "ns_in_time",
        "bio_iron_lady",
        "alt_ordinary_people",
        "alt_christine",
        "alt_papillon",
        "rc_something_about_mary",
        "aa_crouching_tiger",
        "ci_boyhood",
        "cl_rear_window",
        "cl_12_angry_men",
        "ni_robocop",
        "mi_sin_city",
        "billy_madison",
        "nacho_libre",
        "coen_hudsucker",
        "coen_inside_llewyn",
        "fincher_killer",
        "spielberg_munich",
        "pix_turning_red",
        "ghibli_kiki",
        "dis_robin_hood",
        "dis_princess_frog",
        "dis_big_hero_6",
        "kingsman",
        "hr_28_days",
        "hr_insidious",
        "hr_others",
        "rc_shes_all_that",
        "sp_fighter",
        "sp_wrestler",
        "bio_dallas_buyers",
        "act_a_team",
        "act_man_on_fire",
        "ind_pacific_rim",
        "sf_war_worlds_2005",
        "sf_galaxy_quest",
        "com_clerks",
        "for_run_lola_run",
        "for_volver",
        "for_lives_others",
        "alt_we_were_soldiers",
        "alt_letters_iwo",
        "alt_paths_glory",
        "alt_310_yuma",
        "alt_hidalgo",
        "alt_wyatt_earp",
        "alt_hairspray",
        "alt_jfk",
        "alt_12_monkeys",
        "alt_english_patient",
        "alt_traffic",
        "alt_queen",
        "alt_blackkklansman",
        "alt_father",
        "alt_breathless",
        "ns_law_abiding",
        "an_moana",
        "fincher_mank",
        "hr_invisible_man_2020",
        "rc_save_last_dance",
        "sp_white_men_jump",
        "sp_days_thunder",
        "alt_in_bruges",
        "alt_cujo",
        "hr_dawn_dead",
        "sp_bull_durham",
        "sp_natural",
        "bio_steve_jobs",
        "alt_shane",
        "alt_third_man",
        "alt_cabaret",
        "alt_ripley",
        "alt_about_schmidt",
        "alt_michael_clayton",
        "alt_promising_young",
        "fincher_game",
        "atomic_blonde",
        "hr_cloverfield",
        "rc_never_been_kissed",
        "bio_cinderella_man",
        "alt_doubt",
        "alt_challengers",
        "mi_bring_it_on",
        "ni_pianist",
        "mi_drive",
        "mi_shape_water",
        "get_him_greek",
        "coen_millers_crossing",
        "spielberg_fabelmans",
        "scorsese_after_hours",
        "pix_lightyear",
        "ghibli_howl",
        "dis_bolt",
        "dw_megamind",
        "zero_dark_thirty",
        "hr_evil_dead",
        "hr_train_busan",
        "sp_any_given_sunday",
        "sp_concussion",
        "bio_bombshell",
        "bio_milk",
        "bio_atonement",
        "act_collateral",
        "act_extraction",
        "sf_planet_apes_2011",
        "com_pineapple",
        "fam_golden_compass",
        "fam_dennis_menace",
        "for_y_tu_mama",
        "for_mother",
        "for_the_host",
        "alt_stalag_17",
        "alt_line_fire",
        "an_tangled",
        "alt_good_night_luck",
        "alt_babel",
        "alt_diving_bell",
        "alt_nebraska",
        "alt_florida_project",
        "alt_beale_street",
        "alt_two_popes",
        "alt_road_perdition",
        "alt_the_mist",
        "alt_metropolis",
        "hr_descent",
        "hr_dont_breathe",
        "an_brave",
        "cl_annie_hall",
        "mi_snatch",
        "nolan_insomnia",
        "dis_emperor_groove",
        "dw_boss_baby",
        "hr_cabin_woods",
        "hr_sinister",
        "sp_warrior",
        "sp_southpaw",
        "act_jack_reacher",
        "act_gone_60_secs",
        "act_white_house_down",
        "sf_passengers",
        "com_central_intel",
        "alt_awakenings",
        "alt_insider",
        "alt_hours",
        "alt_once",
        "alt_margin_call",
        "alt_sound_metal",
        "alt_history_violence",
        "alt_pet_sematary",
        "mi_500_days_summer",
        "ci_donnie_darko",
        "coen_blood_simple",
        "ghibli_ponyo",
        "dis_sword_stone",
        "dis_ralph_breaks",
        "salt",
        "rc_just_married",
        "rc_how_lose_guy",
        "rc_maid_manhattan",
        "rc_two_weeks_notice",
        "rc_sweet_home_alabama",
        "rc_kate_leopold",
        "rc_my_big_greek",
        "rc_wedding_planner",
        "rc_definitely_maybe",
        "rc_letters_juliet",
        "rc_ps_love_you",
        "rc_dear_john",
        "rc_lake_house",
        "rc_music_lyrics",
        "rc_no_strings",
        "rc_friends_benefits",
        "rc_about_a_boy",
        "rc_the_vow",
        "rc_safe_haven",
        "rc_me_before_you",
        "rc_easy_a",
        "rc_remember_me",
        "rc_proposal_2",
        "rc_set_it_up",
        "rc_always_be_my_maybe",
        "bio_judy",
        "bio_king_richard",
        "com_house_bunny",
        "com_zack_miri",
        "fam_a_wrinkle_time",
        "alt_thin_red_line",
        "alt_unbreakable",
        "alt_ides_march",
        "cl_cinema_paradiso",
        "ni_once_upon_west",
        "ni_amhx",
        "coen_barton_fink",
        "dis_brother_bear",
        "dw_spirit",
        "hr_smile",
        "hr_lights_out",
        "sp_rush_2013",
        "act_red",
        "act_olympus_fallen",
        "sf_event_horizon",
        "alt_dead_man_walking",
        "alt_eyes_wide_shut",
        "alt_requiem",
        "alt_eastern_promises",
        "alt_seven_psychopaths",
        "alt_thank_you_smoking",
        "rc_about_time",
        "ci_birdman",
        "mi_donnie_brasco",
        "dc_flash_2023",
        "coen_serious_man",
        "wa_bottle_rocket",
        "ghibli_mononoke",
        "dw_antz",
        "dw_trolls",
        "hr_pearl",
        "heist_blood_diamond",
        "heist_logan_lucky",
        "heist_widows",
        "heist_kings_summer",
        "heist_killing_them_softly",
        "heist_layer_cake",
        "sp_we_marshall",
        "sp_invincible",
        "bio_jackie",
        "bio_glory",
        "act_unstoppable",
        "sf_oblivion",
        "com_paul",
        "an_ferdinand",
        "fam_richie_rich",
        "for_okja",
        "for_anatomy_fall",
        "alt_in_heights",
        "alt_education",
        "alt_gattaca",
        "alt_civil_war_2024",
        "dis_raya",
        "alt_crash",
        "mc_amelie",
        "dc_man_steel",
        "dw_chicken_run",
        "hr_orphanage",
        "rc_perks_wallflower",
        "sp_42",
        "sp_major_league",
        "sp_glory_road",
        "bio_ray",
        "com_baby_mama",
        "alt_born_july",
        "alt_match_point",
        "alt_eighth_grade",
        "hr_longlegs",
        "sf_district_9",
        "sf_looper",
        "th_babadook",
        "aa_road_warrior",
        "ci_parasite",
        "dc_black_adam",
        "nolan_following",
        "pix_elemental",
        "dis_atlantis",
        "dw_bee_movie",
        "safe_house",
        "hr_x",
        "rc_failure_launch",
        "sp_for_love_game",
        "sp_foxcatcher",
        "sp_senna",
        "bio_elvis_2",
        "bio_unbroken",
        "bio_judas",
        "act_taking_pelham",
        "act_machete",
        "act_gray_man",
        "sf_annihilation",
        "sf_ender",
        "com_get_smart",
        "com_bored_to_death",
        "com_mallrats",
        "fam_zathura",
        "for_motorcycle_diaries",
        "for_blue_warmest",
        "alt_streetcar",
        "alt_dog_day",
        "alt_my_left_foot",
        "alt_stranger_fiction",
        "alt_iron_giant",
        "knight_day",
        "act_old_guard",
        "com_pink_panther_06",
        "alt_marathon_man",
        "alt_name_father",
        "alt_punch_drunk",
        "ci_witch",
        "mc_pans_labyrinth",
        "scorsese_kundun",
        "dw_croods",
        "heist_the_italian_job_orig",
        "heist_lock_stock",
        "sp_slap_shot",
        "bio_trumbo",
        "bio_blonde",
        "bio_3_idiots",
        "com_other_woman",
        "for_pain_glory",
        "for_chungking",
        "alt_grand_illusion",
        "alt_bringing_up_baby",
        "alt_amores_perros",
        "alt_8_half",
        "ns_source_code",
        "ghibli_castle_sky",
        "ghibli_arrietty",
        "dis_wish",
        "hr_barbarian",
        "bio_big_eyes",
        "act_48_hrs",
        "act_smokin_aces",
        "ind_revolutionary",
        "ind_minari",
        "sf_riddick",
        "alt_african_queen",
        "alt_network",
        "alt_glengarry",
        "alt_bronx_tale",
        "alt_kevin",
        "alt_american_fiction",
        "alt_seventh_seal_c",
        "ci_manchester_sea",
        "ci_grand_budapest",
        "ni_once_upon_america",
        "ghibli_boy_heron",
        "dis_treasure_planet",
        "dw_captain_underpants",
        "rc_crossroads",
        "sp_bagger_vance",
        "bio_capote",
        "bio_nyad",
        "ind_past_lives",
        "ind_seven_samurai",
        "sf_jupiter_ascending",
        "sf_chappie",
        "sf_serenity",
        "an_coco",
        "com_dogma",
        "alt_philadelphia_story",
        "alt_beasts_southern",
        "alt_saltburn",
        "alt_anora",
        "alt_being_there",
        "alt_force_majeure",
        "ghibli_wind_rises",
        "alt_three_kings",
        "mc_city_of_god",
        "mc_room",
        "dc_blue_beetle",
        "ghibli_nausicaa",
        "dis_strange_world",
        "hr_pandora",
        "bio_pollock",
        "bio_marie_antoinette",
        "bio_ferrari",
        "ind_phantom_thread",
        "ind_ran",
        "com_old_dogs",
        "com_tucker_dale",
        "for_in_mood_love",
        "alt_double_indemnity",
        "alt_tick_tick",
        "alt_wonder_boys",
        "alt_poor_things",
        "alt_village",
        "alt_dancer_dark",
        "ns_phone_booth",
        "ghibli_kaguya",
        "mi_garden_state",
        "ci_moonlight",
        "mi_mulholland",
        "ghibli_porco",
        "bio_dangal",
        "ind_blue_valentine",
        "ind_amour",
        "com_pineapple_2",
        "alt_waterfront",
        "alt_power_dog",
        "alt_blue_velvet",
        "act_drive_angry",
        "alt_secretary",
        "mc_oldboy",
        "mi_roma",
        "ghibli_grave_fireflies",
        "bio_maestro",
        "act_shoot_em_up",
        "ind_winters_bone",
        "ind_separation",
        "ind_yojimbo",
        "com_observe_report",
        "alt_come_see",
        "alt_bad_lieutenant",
        "alt_brutalist",
        "ind_master",
        "for_yi_yi",
        "alt_prophet",
        "alt_zone_interest",
        "ci_moonrise_kingdom",
        "ind_take_shelter",
        "ind_lobster",
        "ind_ikiru",
        "ind_rashomon",
        "ind_only_lovers",
        "com_meet_dave",
        "for_run_for_your",
        "alt_touch_evil",
        "alt_belfast",
        "alt_dark_city",
        "ind_shoplifters",
        "ind_killing_sacred",
        "sf_under_skin",
        "alt_first_reformed",
        "alt_solaris",
        "alt_funny_games",
        "mc_sing_street",
        "ind_decision_leave",
        "alt_stagecoach",
        "alt_chronicle",
        "ind_drive_my_car",
        "ind_white_ribbon",
        "alt_3_days_condor",
        "alt_brazil",
        "bio_rrr",
        "ind_tree_life",
        "alt_sierra_madre",
        "alt_licorice_pizza",
        "alt_central_station",
        "alt_lost_highway",
        "ind_burning",
        "ind_4_months",
        "alt_happened_one_night",
        "alt_naked",
        "alt_fish_tank",
        "alt_cold_war",
        "alt_triangle",
        "alt_aftersun",
        "bio_society_snow",
        "ind_dogtooth",
        "alt_wages_fear",
        "alt_whale",
        "ind_taste_cherry",
        "alt_oslo",
        "alt_3_colors_blue",
        "alt_tar",
        "alt_inland_empire",
        "rep2_moneyball",
        "rep2_sully",
        "rep2_holes",
        "rep2_seabiscuit",
        "rep2_october_sky",
        "rep2_secretariat",
        "rep2_eddie_the_eagle",
        "rep2_the_rookie",
        "rep2_akeelah",
        "rep2_chef",
        "rep2_the_intern",
        "rep2_julie_julia",
        "rep2_27_dresses",
        "rep2_uncut_gems"
      ]
    }
  ],
  "puzzles": [
    {
      "id": "np_01_01",
      "title": "E.T. the Extra-Terrestrial",
      "aliases": [
        "ET",
        "E.T.",
        "E T",
        "ET the Extra Terrestrial"
      ],
      "emojis": [
        "🛸",
        "🌌",
        "🔦",
        "👦🏻",
        "🍬",
        "👽",
        "☎️",
        "🏠",
        "🚲",
        "🌕",
        "☝️",
        "❤️"
      ],
      "pack_id": "hollywood_essentials",
      "year": 1982
    },
    {
      "id": "np_01_02",
      "title": "Jaws",
      "aliases": [],
      "emojis": [
        "🏖️",
        "🏊‍♀️",
        "🦈",
        "😱",
        "🩸",
        "💀",
        "⛵",
        "🤿",
        "🔫",
        "🧯",
        "🦈",
        "💥"
      ],
      "pack_id": "hollywood_essentials",
      "year": 1975
    },
    {
      "id": "np_01_03",
      "title": "Die Hard",
      "aliases": [],
      "emojis": [
        "✈️",
        "🎄",
        "🏢",
        "🤵‍♂️",
        "🔫",
        "🦶",
        "🩸",
        "💥",
        "🛗",
        "💀"
      ],
      "pack_id": "hollywood_essentials",
      "year": 1988
    },
    {
      "id": "np_01_04",
      "title": "Pulp Fiction",
      "aliases": [],
      "emojis": [
        "🤵🏿‍♂️",
        "🤵‍♂️",
        "🔫",
        "💼",
        "🍔",
        "🥤",
        "🕺",
        "💃",
        "🏆",
        "💉",
        "🥊",
        "⌚"
      ],
      "pack_id": "hollywood_essentials",
      "year": 1994
    },
    {
      "id": "np_01_05",
      "title": "Ghostbusters",
      "aliases": [],
      "emojis": [
        "📚",
        "👻",
        "😱",
        "🚙",
        "👻",
        "🚫",
        "🟢",
        "⚡",
        "🐕",
        "🏙️",
        "☃️",
        "💥"
      ],
      "pack_id": "hollywood_essentials",
      "year": 1984
    },
    {
      "id": "np_01_06",
      "title": "Titanic",
      "aliases": [],
      "emojis": [
        "🇬🇧",
        "🚢",
        "🇺🇸",
        "💃",
        "🎨",
        "💎",
        "🧊",
        "💥",
        "🌊",
        "🥶",
        "🚪",
        "💀"
      ],
      "pack_id": "hollywood_essentials",
      "year": 1997
    },
    {
      "id": "np_01_07",
      "title": "It",
      "aliases": [],
      "emojis": [
        "🌧️",
        "⛵",
        "🕳️",
        "🤡",
        "🩸",
        "🏚️",
        "🤡",
        "🎈",
        "🚪",
        "🚪",
        "🚪",
        "😱"
      ],
      "pack_id": "hollywood_essentials",
      "year": 2017
    },
    {
      "id": "np_01_08",
      "title": "Rocky",
      "aliases": [],
      "emojis": [
        "🥊",
        "🇺🇸",
        "🥚",
        "🥩",
        "🏃",
        "📶",
        "🏛️",
        "🙌",
        "🥊",
        "❤️"
      ],
      "pack_id": "hollywood_essentials",
      "year": 1976
    },
    {
      "id": "np_01_09",
      "title": "The Exorcist",
      "aliases": [
        "Exorcist"
      ],
      "emojis": [
        "👧",
        "🛏️",
        "🌫️",
        "👿",
        "😱",
        "✝️",
        "👧",
        "🔄",
        "🤮",
        "👴",
        "💀"
      ],
      "pack_id": "hollywood_essentials",
      "year": 1973
    },
    {
      "id": "np_01_10",
      "title": "Sinners",
      "aliases": [],
      "emojis": [
        "👨🏿",
        "👨🏿",
        "💵",
        "🏠",
        "🥳",
        "🥃",
        "💃",
        "🎶",
        "🧛",
        "😱",
        "🔫",
        "🔥"
      ],
      "pack_id": "hollywood_essentials",
      "year": 2025
    },
    {
      "id": "np_02_01",
      "title": "Big",
      "aliases": [],
      "emojis": [
        "🎡",
        "🔮",
        "✨",
        "👦",
        "➡️",
        "👨",
        "🏙️",
        "🪀",
        "🤖",
        "👴",
        "🎹",
        "👨"
      ],
      "pack_id": "hollywood_essentials",
      "year": 1988
    },
    {
      "id": "np_02_02",
      "title": "Stand By Me",
      "aliases": [],
      "emojis": [
        "👬",
        "👬",
        "🛤️",
        "🚂",
        "🏃",
        "🥧",
        "🤮",
        "👦",
        "💀",
        "📰"
      ],
      "pack_id": "hollywood_essentials",
      "year": 1986
    },
    {
      "id": "np_02_03",
      "title": "Willy Wonka and the Chocolate Factory",
      "aliases": [
        "Willy Wonka",
        "Wonka"
      ],
      "emojis": [
        "🇬🇧",
        "👦",
        "🍫",
        "🎟️",
        "🌟",
        "👴",
        "🎩",
        "🏭",
        "🛗"
      ],
      "pack_id": "hollywood_essentials",
      "year": 1971
    },
    {
      "id": "np_02_04",
      "title": "Jurassic Park",
      "aliases": [],
      "emojis": [
        "🦟",
        "🧬",
        "🏝️",
        "🥚",
        "🦕",
        "🥛",
        "🦖",
        "⚡",
        "🌧️",
        "🚁"
      ],
      "pack_id": "hollywood_essentials",
      "year": 1993
    },
    {
      "id": "np_02_05",
      "title": "Face/Off",
      "aliases": [],
      "emojis": [
        "🎠",
        "👦",
        "🔫",
        "💀",
        "⏩",
        "💣",
        "😷",
        "🔪",
        "👨",
        "↔️",
        "👨🏻"
      ],
      "pack_id": "hollywood_essentials",
      "year": 1997
    },
    {
      "id": "np_02_06",
      "title": "Finding Nemo",
      "aliases": [],
      "emojis": [
        "🤡",
        "🐠",
        "🤿",
        "🦷",
        "🐟",
        "🦈",
        "🪼",
        "🐢",
        "🐳",
        "🤗"
      ],
      "pack_id": "hollywood_essentials",
      "year": 2003
    },
    {
      "id": "np_02_07",
      "title": "Big Trouble in Little China",
      "aliases": [],
      "emojis": [
        "👨",
        "🚚",
        "🐷",
        "💨",
        "🇨🇳",
        "🐉",
        "🥋",
        "⚡"
      ],
      "pack_id": "hollywood_essentials",
      "year": 1986
    },
    {
      "id": "np_02_08",
      "title": "Ghost",
      "aliases": [],
      "emojis": [
        "💑",
        "🏺",
        "⛓️‍💥",
        "🎵",
        "💀",
        "💔",
        "🪙",
        "👩🏿",
        "🔮",
        "👻",
        "💋",
        "🌅"
      ],
      "pack_id": "hollywood_essentials",
      "year": 1990
    },
    {
      "id": "np_02_09",
      "title": "Wonder Woman",
      "aliases": [],
      "emojis": [
        "🏝️",
        "👸🏽",
        "🛡️",
        "🐎",
        "🗡️",
        "✈️",
        "🇩🇪",
        "🪖",
        "⚡"
      ],
      "pack_id": "hollywood_essentials",
      "year": 2017
    },
    {
      "id": "np_02_10",
      "title": "Star Wars",
      "aliases": [
        "Star Wars: A New Hope",
        "A New Hope",
        "Star Wars Episode IV"
      ],
      "emojis": [
        "🏜️",
        "👦",
        "🤖",
        "🤖",
        "🧙",
        "⚔️",
        "🍺",
        "🛸",
        "👸",
        "💥",
        "🏅"
      ],
      "pack_id": "hollywood_essentials",
      "year": 1977
    },
    {
      "id": "np_03_01",
      "title": "Mad Max: Fury Road",
      "aliases": [
        "Mad Max Fury Road",
        "Fury Road",
        "Mad Max"
      ],
      "emojis": [
        "🏜️",
        "⛓️",
        "💧",
        "🚫",
        "🚗",
        "🚛",
        "👰‍♀️",
        "🚚",
        "🎸",
        "💥",
        "💧"
      ],
      "pack_id": "hollywood_essentials",
      "year": 2015
    },
    {
      "id": "np_03_02",
      "title": "Knives Out",
      "aliases": [],
      "emojis": [
        "🏠",
        "👴",
        "✍️",
        "📚",
        "💀",
        "🔪",
        "👪",
        "💰",
        "👩‍⚕️",
        "🤢",
        "🕵️‍♂️",
        "🍩"
      ],
      "pack_id": "hollywood_essentials",
      "year": 2019
    },
    {
      "id": "np_03_03",
      "title": "The Princess Bride",
      "aliases": [
        "Princess Bride"
      ],
      "emojis": [
        "👴",
        "📖",
        "👦🏻",
        "🤒",
        "🏴‍☠️",
        "👸",
        "🔥",
        "🐀",
        "⚔️",
        "💋",
        "❤️"
      ],
      "pack_id": "hollywood_essentials",
      "year": 1987
    },
    {
      "id": "np_03_04",
      "title": "Companion",
      "aliases": [],
      "emojis": [
        "👨🏻",
        "📦",
        "🤖",
        "👩🏻",
        "🔪",
        "🩸",
        "💀",
        "📴",
        "📱",
        "🌲",
        "🏃‍♀️‍➡️",
        "🚗"
      ],
      "pack_id": "hollywood_essentials",
      "year": 2025
    },
    {
      "id": "np_03_05",
      "title": "Being John Malkovich",
      "aliases": [],
      "emojis": [
        "👩‍❤️‍👨",
        "🐒",
        "📰",
        "🏢",
        "🛗",
        "🗂️",
        "🗄️",
        "🚪",
        "🧠",
        "🎬"
      ],
      "pack_id": "hollywood_essentials",
      "year": 1999
    },
    {
      "id": "np_03_06",
      "title": "The Martian",
      "aliases": [
        "Martian"
      ],
      "emojis": [
        "👨‍🚀",
        "🚀",
        "🔴",
        "🌀",
        "🆘",
        "🌱",
        "🥔",
        "📡",
        "🚀",
        "🤝",
        "🥳"
      ],
      "pack_id": "hollywood_essentials",
      "year": 2015
    },
    {
      "id": "np_03_07",
      "title": "The Goonies",
      "aliases": [
        "Goonies"
      ],
      "emojis": [
        "🏠",
        "🏖️",
        "🗺️",
        "🕳️",
        "🎹",
        "🍫",
        "⛵",
        "🏴‍☠️",
        "💀",
        "👁️",
        "🪙",
        "💎"
      ],
      "pack_id": "hollywood_essentials",
      "year": 1985
    },
    {
      "id": "np_03_08",
      "title": "Weapons",
      "aliases": [],
      "emojis": [
        "🌃",
        "🕑",
        "👦",
        "👧",
        "💨",
        "🧙‍♀️",
        "🌱",
        "☝️",
        "🩸",
        "😵‍💫",
        "🔪",
        "😱"
      ],
      "pack_id": "hollywood_essentials",
      "year": 2025
    },
    {
      "id": "np_03_09",
      "title": "Palm Springs",
      "aliases": [],
      "emojis": [
        "🌴",
        "💒",
        "👨",
        "👩",
        "🏜️",
        "👉",
        "👌",
        "🏹",
        "🕳️",
        "🌀",
        "🔄",
        "♾️"
      ],
      "pack_id": "hollywood_essentials",
      "year": 2020
    },
    {
      "id": "np_03_10",
      "title": "Home Alone",
      "aliases": [],
      "emojis": [
        "🎄",
        "🛫",
        "👦",
        "🏠",
        "🪞",
        "😱",
        "🚐",
        "🥷",
        "🥷",
        "🔥",
        "🕷️",
        "🛬"
      ],
      "pack_id": "hollywood_essentials",
      "year": 1990
    },
    {
      "id": "np_04_01",
      "title": "The Shining",
      "aliases": [
        "Shining"
      ],
      "emojis": [
        "👪",
        "🏨",
        "👦",
        "🚲",
        "👯‍♀️",
        "😱",
        "🛗",
        "🩸",
        "🪓",
        "🚪",
        "❄️",
        "💀"
      ],
      "pack_id": "hollywood_essentials",
      "year": 1980
    },
    {
      "id": "np_04_02",
      "title": "La La Land",
      "aliases": [],
      "emojis": [
        "🌴",
        "🚗",
        "🚙",
        "🎉",
        "💃",
        "🔭",
        "✨",
        "🎹",
        "🎷",
        "🎤",
        "❤️",
        "💔"
      ],
      "pack_id": "hollywood_essentials",
      "year": 2016
    },
    {
      "id": "np_04_03",
      "title": "Boogie Nights",
      "aliases": [],
      "emojis": [
        "🪩",
        "🕺",
        "🎬",
        "🛼",
        "👉",
        "👌",
        "💊",
        "🏆",
        "🥳",
        "🔫",
        "💀",
        "🧨"
      ],
      "pack_id": "hollywood_essentials",
      "year": 1997
    },
    {
      "id": "np_04_04",
      "title": "Ex Machina",
      "aliases": [],
      "emojis": [
        "🚁",
        "🏡",
        "👨‍💻",
        "🤖",
        "👗",
        "🧠",
        "🤫",
        "🕺",
        "🔪",
        "💀",
        "🚪",
        "💨"
      ],
      "pack_id": "hollywood_essentials",
      "year": 2014
    },
    {
      "id": "np_04_05",
      "title": "Liar Liar",
      "aliases": [],
      "emojis": [
        "👨",
        "⚖️",
        "🤥",
        "👦",
        "🎂",
        "🕯️",
        "💨",
        "🤥",
        "🚫",
        "⚖️"
      ],
      "pack_id": "hollywood_essentials",
      "year": 1997
    },
    {
      "id": "np_04_06",
      "title": "The Running Man",
      "aliases": [],
      "emojis": [
        "👪",
        "🤒",
        "📺",
        "💵",
        "🎤",
        "🏃‍➡️",
        "🏃‍♀️‍➡️",
        "💀",
        "🏃‍♂️‍➡️",
        "🚁",
        "👪"
      ],
      "pack_id": "hollywood_essentials",
      "year": 2025
    },
    {
      "id": "np_04_07",
      "title": "Pretty Woman",
      "aliases": [],
      "emojis": [
        "🌴",
        "🚗",
        "👢",
        "💵",
        "🏨",
        "🛍️",
        "👗",
        "💎",
        "🤵‍♂️",
        "🪜",
        "💋"
      ],
      "pack_id": "hollywood_essentials",
      "year": 1990
    },
    {
      "id": "np_04_08",
      "title": "Edward Scissorhands",
      "aliases": [],
      "emojis": [
        "👩",
        "💄",
        "🚗",
        "🏰",
        "✂️",
        "👦🏻",
        "✂️",
        "👧🏻",
        "❤️",
        "❄️",
        "🧊",
        "💃"
      ],
      "pack_id": "hollywood_essentials",
      "year": 1990
    },
    {
      "id": "np_04_09",
      "title": "Barbie",
      "aliases": [],
      "emojis": [
        "👱‍♀️",
        "👩🏾",
        "👩🏻",
        "🤪",
        "👚",
        "🩷",
        "👨",
        "👱‍♀️",
        "🚗",
        "🌴",
        "🛼",
        "🏢"
      ],
      "pack_id": "hollywood_essentials",
      "year": 2023
    },
    {
      "id": "np_04_10",
      "title": "Psycho",
      "aliases": [],
      "emojis": [
        "👩",
        "💰",
        "🚗",
        "🏨",
        "🚿",
        "🤪",
        "🔪",
        "😱",
        "💀",
        "🌀",
        "👵",
        "💀"
      ],
      "pack_id": "hollywood_essentials",
      "year": 1960
    },
    {
      "id": "np_05_01",
      "title": "The King's Speech",
      "aliases": [
        "Kings Speech"
      ],
      "emojis": [
        "🇬🇧",
        "🤴🏻",
        "🎙️",
        "🗣️",
        "📻",
        "🪖",
        "💥",
        "🏟️",
        "👏"
      ],
      "pack_id": "hollywood_essentials",
      "year": 2010
    },
    {
      "id": "np_05_02",
      "title": "The Sixth Sense",
      "aliases": [
        "Sixth Sense"
      ],
      "emojis": [
        "🔫",
        "👨‍⚕️",
        "⏩",
        "👦",
        "🤫",
        "👁️",
        "💀",
        "🥶",
        "😱",
        "🥨"
      ],
      "pack_id": "hollywood_essentials",
      "year": 1999
    },
    {
      "id": "np_05_03",
      "title": "Mamma Mia!",
      "aliases": [
        "Mamma Mia"
      ],
      "emojis": [
        "👱‍♀️",
        "✉️",
        "🇬🇷",
        "🏝️",
        "💍",
        "👩‍🎤",
        "🎶",
        "👨",
        "👨",
        "👨",
        "❓",
        "👰‍♀️"
      ],
      "pack_id": "hollywood_essentials",
      "year": 2008
    },
    {
      "id": "np_05_04",
      "title": "The Karate Kid",
      "aliases": [
        "Karate Kid"
      ],
      "emojis": [
        "👦",
        "🚚",
        "🌴",
        "🥷",
        "🤕",
        "👴",
        "🥢",
        "🪰",
        "🖌️",
        "🧽",
        "🥋",
        "🏅"
      ],
      "pack_id": "hollywood_essentials",
      "year": 1984
    },
    {
      "id": "np_05_05",
      "title": "A Quiet Place",
      "aliases": [
        "Quiet Place"
      ],
      "emojis": [
        "👦",
        "👂",
        "👽",
        "💀",
        "😱",
        "🌽",
        "👪",
        "👧",
        "🦻",
        "🤫",
        "👽",
        "🔫"
      ],
      "pack_id": "hollywood_essentials",
      "year": 2018
    },
    {
      "id": "np_05_06",
      "title": "A Christmas Story",
      "aliases": [],
      "emojis": [
        "👦",
        "👓",
        "🔫",
        "🦵",
        "💡",
        "🎅",
        "🛝",
        "🏫",
        "❄️",
        "👅",
        "🎄",
        "🐰"
      ],
      "pack_id": "hollywood_essentials",
      "year": 1983
    },
    {
      "id": "np_05_07",
      "title": "Terminator 2: Judgment Day",
      "aliases": [
        "Terminator 2",
        "T2"
      ],
      "emojis": [
        "👩",
        "⛓️",
        "🤖",
        "👦🏻",
        "🏍️",
        "💨",
        "👮‍♂️",
        "🏃‍♂️‍➡️",
        "🔫",
        "🏭",
        "🔥",
        "👍"
      ],
      "pack_id": "hollywood_essentials",
      "year": 1991
    },
    {
      "id": "np_05_08",
      "title": "Almost Famous",
      "aliases": [],
      "emojis": [
        "👦🏻",
        "✍️",
        "🚌",
        "🗺️",
        "🎸",
        "🥁",
        "🎤",
        "🏟️",
        "👱‍♀️",
        "🤩",
        "💔"
      ],
      "pack_id": "hollywood_essentials",
      "year": 2000
    },
    {
      "id": "np_05_09",
      "title": "Heretic",
      "aliases": [],
      "emojis": [
        "🚴‍♀️",
        "🚴‍♀️",
        "🏠",
        "👴",
        "📖",
        "🥧",
        "🕯️",
        "🔒",
        "🚪",
        "🚪",
        "🩸",
        "😱"
      ],
      "pack_id": "hollywood_essentials",
      "year": 2024
    },
    {
      "id": "np_05_10",
      "title": "Field of Dreams",
      "aliases": [],
      "emojis": [
        "🌽",
        "🌬️",
        "👨",
        "🚜",
        "⚾",
        "🔶",
        "👻",
        "🚗",
        "🚗",
        "🚗",
        "🚗"
      ],
      "pack_id": "hollywood_essentials",
      "year": 1989
    },
    {
      "id": "np_06_01",
      "title": "Carrie",
      "aliases": [],
      "emojis": [
        "👧",
        "🏫",
        "🚿",
        "🩸",
        "🤣",
        "💃",
        "👑",
        "🪣",
        "🩸",
        "😡",
        "🔥",
        "💀"
      ],
      "pack_id": "hollywood_essentials",
      "year": 1976
    },
    {
      "id": "np_06_02",
      "title": "The Menu",
      "aliases": [],
      "emojis": [
        "👨",
        "👩",
        "🏝️",
        "👨‍🍳",
        "🤪",
        "🍽️",
        "🔪",
        "💀",
        "🍩",
        "🔥",
        "⛵",
        "🍔"
      ],
      "pack_id": "hollywood_essentials",
      "year": 2022
    },
    {
      "id": "np_06_03",
      "title": "The Truman Show",
      "aliases": [
        "Truman Show"
      ],
      "emojis": [
        "📺",
        "👨",
        "💡",
        "🌧️",
        "⛵",
        "🌊",
        "📶",
        "🚪",
        "👋"
      ],
      "pack_id": "hollywood_essentials",
      "year": 1998
    },
    {
      "id": "np_06_04",
      "title": "The Naked Gun",
      "aliases": [],
      "emojis": [
        "🏦",
        "🔫",
        "👧",
        "👮‍♂️",
        "🚗",
        "🌭",
        "🌭",
        "🌭",
        "👩",
        "💘",
        "☃️",
        "💀"
      ],
      "pack_id": "hollywood_essentials",
      "year": 2025
    },
    {
      "id": "np_06_05",
      "title": "Top Gun",
      "aliases": [],
      "emojis": [
        "😎",
        "🏍️",
        "✈️",
        "🪖",
        "🏐",
        "❤️",
        "🪂",
        "🌊",
        "💀",
        "😢",
        "✈️"
      ],
      "pack_id": "hollywood_essentials",
      "year": 1986
    },
    {
      "id": "np_06_06",
      "title": "Marty Supreme",
      "aliases": [],
      "emojis": [
        "🗽",
        "👨",
        "👓",
        "👞",
        "🛁",
        "💥",
        "🇯🇵",
        "🏓",
        "🏅",
        "🇺🇸",
        "👶",
        "😭"
      ],
      "pack_id": "hollywood_essentials",
      "year": 2025
    },
    {
      "id": "np_06_07",
      "title": "The Piano",
      "aliases": [],
      "emojis": [
        "⛵",
        "🏝️",
        "👩🏻",
        "👧🏻",
        "🎹",
        "🎶",
        "👉",
        "👌",
        "😡",
        "🪓",
        "☝️",
        "🩸"
      ],
      "pack_id": "hollywood_essentials",
      "year": 1993
    },
    {
      "id": "np_06_08",
      "title": "Legally Blonde",
      "aliases": [],
      "emojis": [
        "👱‍♀️",
        "💔",
        "👙",
        "📼",
        "⚖️",
        "🏛️",
        "✅",
        "📚",
        "🐶",
        "💅",
        "⚖️",
        "🎓"
      ],
      "pack_id": "hollywood_essentials",
      "year": 2001
    },
    {
      "id": "np_06_09",
      "title": "No Country for Old Men",
      "aliases": [],
      "emojis": [
        "🏜️",
        "🤠",
        "💼",
        "💵",
        "🏪",
        "🪙",
        "🇲🇽",
        "🔫",
        "💀",
        "🚗",
        "💥",
        "🦴"
      ],
      "pack_id": "hollywood_essentials",
      "year": 2007
    },
    {
      "id": "np_06_10",
      "title": "Se7en",
      "aliases": [
        "Seven"
      ],
      "emojis": [
        "🗽",
        "🕵️‍♂️",
        "🕵🏿‍♂️",
        "🍝",
        "💀",
        "🤪",
        "🏜️",
        "🚐",
        "📦",
        "🔫",
        "💀"
      ],
      "pack_id": "hollywood_essentials",
      "year": 1995
    },
    {
      "id": "np_07_01",
      "title": "The Shawshank Redemption",
      "aliases": [
        "Shawshank",
        "Shawshank Redemption"
      ],
      "emojis": [
        "⚖️",
        "⛓️",
        "👨",
        "👨🏿",
        "🔨",
        "🖼️",
        "🕳️",
        "🏃",
        "🌧️",
        "🏝️",
        "🇲🇽",
        "🤝"
      ],
      "pack_id": "hollywood_essentials",
      "year": 1994
    },
    {
      "id": "np_07_02",
      "title": "Grease",
      "aliases": [],
      "emojis": [
        "🏖️",
        "☀️",
        "💑",
        "🏫",
        "👚",
        "🎵",
        "🕺",
        "💃",
        "🚗",
        "🔥",
        "🏁",
        "🎡"
      ],
      "pack_id": "hollywood_essentials",
      "year": 1978
    },
    {
      "id": "np_07_03",
      "title": "M3gan",
      "aliases": [
        "Megan"
      ],
      "emojis": [
        "👩",
        "👨",
        "💀",
        "👧",
        "😢",
        "👩🏻",
        "🛠️",
        "🤖",
        "💃",
        "🔪",
        "🛗",
        "💀"
      ],
      "pack_id": "hollywood_essentials",
      "year": 2022
    },
    {
      "id": "np_07_04",
      "title": "Cape Fear",
      "aliases": [],
      "emojis": [
        "⛓️",
        "💪",
        "👪",
        "⚖️",
        "🎆",
        "🚙",
        "🛥️",
        "⛈️",
        "🌊",
        "💀"
      ],
      "pack_id": "hollywood_essentials",
      "year": 1991
    },
    {
      "id": "np_07_05",
      "title": "Friday the 13th",
      "aliases": [
        "Friday The 13th"
      ],
      "emojis": [
        "🏕️",
        "🏞️",
        "🔪",
        "🩸",
        "😱",
        "💀",
        "💀",
        "💀",
        "🛶",
        "👻",
        "💦"
      ],
      "pack_id": "hollywood_essentials",
      "year": 1980
    },
    {
      "id": "np_07_06",
      "title": "North by Northwest",
      "aliases": [],
      "emojis": [
        "👨",
        "🇺🇳",
        "🔪",
        "💀",
        "🏃‍♂️‍➡️",
        "🌽",
        "✈️",
        "🌽",
        "🚚",
        "💥",
        "⛰️",
        "🕵️‍♀️"
      ],
      "pack_id": "hollywood_essentials",
      "year": 1959
    },
    {
      "id": "np_07_07",
      "title": "Talk to Me",
      "aliases": [],
      "emojis": [
        "🔪",
        "🩸",
        "💀",
        "⏩",
        "🥳",
        "👩🏿",
        "🤝",
        "🗣️",
        "👻",
        "😱"
      ],
      "pack_id": "hollywood_essentials",
      "year": 2022
    },
    {
      "id": "np_07_08",
      "title": "Jackie Brown",
      "aliases": [],
      "emojis": [
        "✈️",
        "👩🏿",
        "💼",
        "💵",
        "🍒",
        "🛍️",
        "↔️",
        "🛍️",
        "🔫",
        "📻",
        "🎶"
      ],
      "pack_id": "hollywood_essentials",
      "year": 1997
    },
    {
      "id": "np_07_09",
      "title": "Taxi Driver",
      "aliases": [],
      "emojis": [
        "🗽",
        "👨🏻",
        "🚕",
        "🗳️",
        "👧",
        "🛏️",
        "🪒",
        "👨‍🦲",
        "🔫",
        "💥",
        "💀",
        "📰"
      ],
      "pack_id": "hollywood_essentials",
      "year": 1976
    },
    {
      "id": "np_07_10",
      "title": "My Girl",
      "aliases": [],
      "emojis": [
        "👧",
        "👦",
        "👓",
        "💋",
        "🚲",
        "🌲",
        "🐝",
        "👦",
        "💀",
        "😢"
      ],
      "pack_id": "hollywood_essentials",
      "year": 1991
    },
    {
      "id": "np_08_01",
      "title": "The Holdovers",
      "aliases": [],
      "emojis": [
        "🏫",
        "👨‍🏫",
        "🎄",
        "👦",
        "👩🏿‍🍳",
        "🎉",
        "🥃",
        "❄️",
        "🌎"
      ],
      "pack_id": "hollywood_essentials",
      "year": 2023
    },
    {
      "id": "np_08_02",
      "title": "The Usual Suspects",
      "aliases": [
        "Usual Suspects"
      ],
      "emojis": [
        "🚢",
        "🔥",
        "⚰️",
        "👨",
        "👮‍♂️",
        "🗣️",
        "🤥",
        "💎",
        "☕",
        "💥",
        "😈",
        "💨"
      ],
      "pack_id": "hollywood_essentials",
      "year": 1995
    },
    {
      "id": "np_08_03",
      "title": "The Conversation",
      "aliases": [],
      "emojis": [
        "🌉",
        "🕵️‍♂️",
        "🎧",
        "📷",
        "🏨",
        "🚽",
        "🩸",
        "🩸"
      ],
      "pack_id": "hollywood_essentials",
      "year": 1974
    },
    {
      "id": "np_08_04",
      "title": "Juno",
      "aliases": [],
      "emojis": [
        "🏫",
        "🤰",
        "👩‍❤️‍👨",
        "🏠",
        "🎸",
        "💔",
        "🏃‍♂️",
        "🏥",
        "👶",
        "❤️",
        "🎸",
        "🎶"
      ],
      "pack_id": "hollywood_essentials",
      "year": 2007
    },
    {
      "id": "np_08_05",
      "title": "Hidden Figures",
      "aliases": [],
      "emojis": [
        "👩🏿",
        "👩🏿",
        "👩🏿",
        "🧮",
        "👨‍🚀",
        "🚀",
        "🌕",
        "🥳"
      ],
      "pack_id": "hollywood_essentials",
      "year": 2016
    },
    {
      "id": "np_08_06",
      "title": "The Long Walk",
      "aliases": [],
      "emojis": [
        "📺",
        "🪖",
        "👦",
        "👦🏿",
        "🛣️",
        "🚶",
        "🚶",
        "🚶",
        "🧍",
        "🔫",
        "💀",
        "🏆"
      ],
      "pack_id": "hollywood_essentials",
      "year": 2025
    },
    {
      "id": "np_08_07",
      "title": "Rain Man",
      "aliases": [],
      "emojis": [
        "⚰️",
        "📜",
        "👬",
        "❓",
        "🧠",
        "🚗",
        "🎰",
        "🤵‍♂️",
        "🤵‍♂️",
        "💵"
      ],
      "pack_id": "hollywood_essentials",
      "year": 1988
    },
    {
      "id": "np_08_08",
      "title": "Napoleon Dynamite",
      "aliases": [],
      "emojis": [
        "🏫",
        "🍟",
        "🚲",
        "🦙",
        "✍️",
        "🦁",
        "➕",
        "🐯",
        "🏈",
        "🗳️",
        "🕺",
        "👏"
      ],
      "pack_id": "hollywood_essentials",
      "year": 2004
    },
    {
      "id": "np_08_09",
      "title": "Kramer vs. Kramer",
      "aliases": [],
      "emojis": [
        "👪",
        "👩",
        "💨",
        "👦",
        "😢",
        "👨",
        "🫗",
        "🫟",
        "🍨",
        "🛝",
        "👩",
        "⚖️"
      ],
      "pack_id": "hollywood_essentials",
      "year": 1979
    },
    {
      "id": "np_08_10",
      "title": "Everything Everywhere All At Once",
      "aliases": [],
      "emojis": [
        "👪",
        "🪙",
        "🧺",
        "🥯",
        "👁️",
        "🌭",
        "🖐️",
        "🌀",
        "♾️",
        "🥋",
        "🪨",
        "🦝"
      ],
      "pack_id": "hollywood_essentials",
      "year": 2022
    },
    {
      "id": "np_09_01",
      "title": "Elf",
      "aliases": [],
      "emojis": [
        "❄️",
        "🧝",
        "➡️",
        "🗽",
        "🍬",
        "🏢",
        "🛗",
        "🍝",
        "🎅",
        "🛷"
      ],
      "pack_id": "hollywood_essentials",
      "year": 2003
    },
    {
      "id": "np_09_02",
      "title": "Say Anything",
      "aliases": [],
      "emojis": [
        "🏫",
        "🎓",
        "👦🏻",
        "📞",
        "👧",
        "🥳",
        "💔",
        "🖊️",
        "🌃",
        "🙆‍♂️",
        "📻",
        "🎵"
      ],
      "pack_id": "hollywood_essentials",
      "year": 1989
    },
    {
      "id": "np_09_03",
      "title": "There Will Be Blood",
      "aliases": [],
      "emojis": [
        "👨🏻",
        "⛏️",
        "🛢️",
        "💥",
        "👦",
        "🦻",
        "⛪",
        "🏰",
        "🥤",
        "🎳",
        "💀"
      ],
      "pack_id": "hollywood_essentials",
      "year": 2007
    },
    {
      "id": "np_09_04",
      "title": "Total Recall",
      "aliases": [],
      "emojis": [
        "💪",
        "🧠",
        "💉",
        "🪐",
        "🔴",
        "🔫",
        "🚕",
        "🤖",
        "🩻",
        "👩‍🦱",
        "💣",
        "🤯"
      ],
      "pack_id": "hollywood_essentials",
      "year": 1990
    },
    {
      "id": "np_09_05",
      "title": "Frozen",
      "aliases": [],
      "emojis": [
        "👧",
        "👧",
        "❄️",
        "💥",
        "🤕",
        "👑",
        "🎶",
        "🏰",
        "🥶",
        "☃️",
        "🧊",
        "❤️"
      ],
      "pack_id": "hollywood_essentials",
      "year": 2013
    },
    {
      "id": "np_09_06",
      "title": "Gangs of New York",
      "aliases": [],
      "emojis": [
        "🗽",
        "🗡️",
        "💀",
        "🇮🇪",
        "🐇",
        "💀",
        "🐖",
        "🔪",
        "🥃",
        "🔥",
        "🗡️",
        "💀"
      ],
      "pack_id": "hollywood_essentials",
      "year": 2002
    },
    {
      "id": "np_09_07",
      "title": "Bugonia",
      "aliases": [],
      "emojis": [
        "🏢",
        "💊",
        "🤵‍♀️",
        "💨",
        "⛓️",
        "🪒",
        "👩‍🦲",
        "🐝",
        "👽",
        "❓",
        "👮‍♂️"
      ],
      "pack_id": "hollywood_essentials",
      "year": 2025
    },
    {
      "id": "np_09_08",
      "title": "The Fugitive",
      "aliases": [],
      "emojis": [
        "👩",
        "💀",
        "👨‍⚕️",
        "💔",
        "⛓️",
        "🚌",
        "🚂",
        "💥",
        "🏃‍♂️",
        "👮‍♂️",
        "🦾"
      ],
      "pack_id": "hollywood_essentials",
      "year": 1993
    },
    {
      "id": "np_09_09",
      "title": "Risky Business",
      "aliases": [],
      "emojis": [
        "👦🏻",
        "🩲",
        "🎤",
        "🎵",
        "🥚",
        "🎉",
        "👩",
        "💵",
        "🚂",
        "👉",
        "👌"
      ],
      "pack_id": "hollywood_essentials",
      "year": 1983
    },
    {
      "id": "np_09_10",
      "title": "Do the Right Thing",
      "aliases": [],
      "emojis": [
        "🗽",
        "🌡️",
        "🥵",
        "📻",
        "👨🏿",
        "😡",
        "👨🏻",
        "😡",
        "👨🏽",
        "🗯️",
        "🍕",
        "🔥"
      ],
      "pack_id": "hollywood_essentials",
      "year": 1989
    },
    {
      "id": "np_10_01",
      "title": "Tron",
      "aliases": [],
      "emojis": [
        "🕹️",
        "🪙",
        "🖥️",
        "⌨️",
        "🥏",
        "🥏",
        "🏍️",
        "🏍️"
      ],
      "pack_id": "hollywood_essentials",
      "year": 1982
    },
    {
      "id": "np_10_02",
      "title": "Bridget Jones's Diary",
      "aliases": [
        "Bridget Jones",
        "Bridget Jones Diary"
      ],
      "emojis": [
        "📔",
        "🖊️",
        "🍷",
        "🚬",
        "👩",
        "📺",
        "👩‍🚒",
        "📼",
        "🎉",
        "🐰",
        "😳"
      ],
      "pack_id": "hollywood_essentials",
      "year": 2001
    },
    {
      "id": "np_10_03",
      "title": "Little Shop of Horrors",
      "aliases": [],
      "emojis": [
        "🌘",
        "🌆",
        "🏪",
        "🪟",
        "🪴",
        "☝️",
        "🩸",
        "😳",
        "🦷",
        "💀",
        "❤️",
        "🎶"
      ],
      "pack_id": "hollywood_essentials",
      "year": 1986
    },
    {
      "id": "np_10_04",
      "title": "Aladdin",
      "aliases": [],
      "emojis": [
        "👦🏽",
        "🐒",
        "👸🏽",
        "🐅",
        "💎",
        "🪔",
        "🧞‍♂️",
        "😈",
        "🦜",
        "⏳",
        "🎶",
        "❤️"
      ],
      "pack_id": "hollywood_essentials",
      "year": 1992
    },
    {
      "id": "np_10_05",
      "title": "The Color of Money",
      "aliases": [],
      "emojis": [
        "🤵‍♂️",
        "🥃",
        "👩🏻",
        "👨🏻",
        "🎱",
        "💥",
        "🚗",
        "🗺️",
        "🛣️",
        "🎱",
        "💵",
        "🟢"
      ],
      "pack_id": "hollywood_essentials",
      "year": 1986
    },
    {
      "id": "np_10_06",
      "title": "Baby Driver",
      "aliases": [],
      "emojis": [
        "🏦",
        "🔫",
        "💰",
        "🚗",
        "💨",
        "👨",
        "🦻",
        "🎧",
        "🎶",
        "👮",
        "⛓️",
        "👩‍❤️‍👨"
      ],
      "pack_id": "hollywood_essentials",
      "year": 2017
    },
    {
      "id": "np_10_07",
      "title": "The Outsiders",
      "aliases": [],
      "emojis": [
        "👦🏻",
        "🔪",
        "🩸",
        "🏃‍➡️",
        "⛪",
        "🌅",
        "🔥",
        "📰",
        "🤕",
        "💀",
        "💥",
        "🔫"
      ],
      "pack_id": "hollywood_essentials",
      "year": 1983
    },
    {
      "id": "np_10_08",
      "title": "Freaky Friday",
      "aliases": [],
      "emojis": [
        "🥠",
        "👧",
        "↔️",
        "👵",
        "🏫",
        "🎸",
        "🪞",
        "😱"
      ],
      "pack_id": "hollywood_essentials",
      "year": 2003
    },
    {
      "id": "np_10_09",
      "title": "Us",
      "aliases": [],
      "emojis": [
        "🎡",
        "👧🏿",
        "🪞",
        "😱",
        "🐇",
        "👩🏿",
        "👪",
        "🔴",
        "✂️",
        "📺",
        "👫",
        "👫"
      ],
      "pack_id": "hollywood_essentials",
      "year": 2019
    },
    {
      "id": "np_10_10",
      "title": "Backrooms",
      "aliases": [],
      "emojis": [
        "🏬",
        "🛏️",
        "🪑",
        "👨🏿",
        "✨",
        "🚪",
        "🚶🏿‍♂️",
        "👀",
        "🚶🏿‍♂️",
        "🏴‍☠️",
        "🧠",
        "🤯"
      ],
      "pack_id": "hollywood_essentials",
      "year": 2026
    },
    {
      "id": "np_11_01",
      "title": "CODA",
      "aliases": [],
      "emojis": [
        "👪",
        "🦻",
        "⛵",
        "🎣",
        "👧",
        "🗣️",
        "🎶",
        "🏫",
        "👏"
      ],
      "pack_id": "hollywood_essentials",
      "year": 2021
    },
    {
      "id": "np_11_02",
      "title": "Pee-wee's Big Adventure",
      "aliases": [],
      "emojis": [
        "🤵‍♂️",
        "🚲",
        "🤡",
        "⛓️",
        "⛓️‍💥",
        "😱",
        "🔮",
        "🚚",
        "👻",
        "🎬",
        "🚲"
      ],
      "pack_id": "hollywood_essentials",
      "year": 1985
    },
    {
      "id": "np_11_03",
      "title": "Léon: The Professional",
      "aliases": [
        "Leon",
        "Leon The Professional",
        "The Professional"
      ],
      "emojis": [
        "👧🏻",
        "😢",
        "👨",
        "🔫",
        "🪴",
        "👮‍♂️",
        "😈",
        "💣",
        "💀"
      ],
      "pack_id": "hollywood_essentials",
      "year": 1994
    },
    {
      "id": "np_11_04",
      "title": "Kill Bill",
      "aliases": [],
      "emojis": [
        "👰‍♀️",
        "🩸",
        "🤕",
        "😡",
        "🥋",
        "🟡",
        "🥷",
        "🥷",
        "❄️",
        "⚔️",
        "💀"
      ],
      "pack_id": "hollywood_essentials",
      "year": 2003
    },
    {
      "id": "np_11_05",
      "title": "Midsommar",
      "aliases": [],
      "emojis": [
        "👪",
        "☠️",
        "😢",
        "🇸🇪",
        "🏞️",
        "💐",
        "👩",
        "💐",
        "👨",
        "🐻",
        "🔥",
        "💀"
      ],
      "pack_id": "hollywood_essentials",
      "year": 2019
    },
    {
      "id": "np_11_06",
      "title": "Nope",
      "aliases": [],
      "emojis": [
        "🎬",
        "🐒",
        "🩸",
        "🏜️",
        "👨🏿",
        "👩🏿",
        "🏠",
        "🐎",
        "☁️",
        "🛸",
        "📹",
        "🎈"
      ],
      "pack_id": "hollywood_essentials",
      "year": 2022
    },
    {
      "id": "np_11_07",
      "title": "The Substance",
      "aliases": [],
      "emojis": [
        "👵🏻",
        "📦",
        "🚽",
        "💉",
        "🪞",
        "👩🏻",
        "🤩",
        "💉",
        "🤩",
        "💉",
        "👹",
        "😱"
      ],
      "pack_id": "hollywood_essentials",
      "year": 2024
    },
    {
      "id": "np_11_08",
      "title": "Brokeback Mountain",
      "aliases": [],
      "emojis": [
        "🐑",
        "🤠",
        "🤠",
        "🐑",
        "⛰️",
        "🏕️",
        "💋",
        "❤️",
        "⏩",
        "💀",
        "😢",
        "👕"
      ],
      "pack_id": "hollywood_essentials",
      "year": 2005
    },
    {
      "id": "np_11_09",
      "title": "Obsession",
      "aliases": [],
      "emojis": [
        "🐱",
        "💀",
        "👨",
        "💔",
        "👩🏻",
        "🏪",
        "✨",
        "😵‍💫",
        "😍",
        "😍",
        "😍",
        "😱"
      ],
      "pack_id": "hollywood_essentials",
      "year": 2025
    },
    {
      "id": "np_11_10",
      "title": "Twilight",
      "aliases": [],
      "emojis": [
        "👧",
        "🏫",
        "👦",
        "🍎",
        "🧛",
        "👪",
        "🌲",
        "✨",
        "🌲",
        "⚾",
        "💑"
      ],
      "pack_id": "hollywood_essentials",
      "year": 2008
    },
    {
      "id": "np_12_01",
      "title": "Coming to America",
      "aliases": [],
      "emojis": [
        "🌍",
        "🤴🏿",
        "👨🏿",
        "✈️",
        "🗽",
        "🍔",
        "🥤",
        "👩🏿",
        "❤️",
        "🌍",
        "💒"
      ],
      "pack_id": "hollywood_essentials",
      "year": 1988
    },
    {
      "id": "np_12_02",
      "title": "Four Weddings and a Funeral",
      "aliases": [
        "4 Weddings and a Funeral"
      ],
      "emojis": [
        "⏰",
        "😱",
        "👨",
        "🚗",
        "💒",
        "💒",
        "💒",
        "⚰️",
        "👩🏻",
        "🌧️",
        "💋"
      ],
      "pack_id": "hollywood_essentials",
      "year": 1994
    },
    {
      "id": "np_12_03",
      "title": "The Curious Case of Benjamin Button",
      "aliases": [
        "Benjamin Button"
      ],
      "emojis": [
        "🕰️",
        "👴",
        "➡️",
        "👨",
        "➡️",
        "👦",
        "➡️",
        "👶",
        "👩",
        "🩰",
        "💥",
        "🏥"
      ],
      "pack_id": "hollywood_essentials",
      "year": 2008
    },
    {
      "id": "np_12_04",
      "title": "Strangers on a Train",
      "aliases": [],
      "emojis": [
        "⚫",
        "⚪",
        "🚂",
        "👨",
        "👨",
        "🗣️",
        "🔁",
        "👩",
        "🙌",
        "💀",
        "🎾",
        "🎠"
      ],
      "pack_id": "hollywood_essentials",
      "year": 1951
    },
    {
      "id": "np_12_05",
      "title": "Lost in Translation",
      "aliases": [],
      "emojis": [
        "🇯🇵",
        "🎬",
        "🥃",
        "📷",
        "🌃",
        "🎤",
        "🎶",
        "👋"
      ],
      "pack_id": "hollywood_essentials",
      "year": 2003
    },
    {
      "id": "np_12_06",
      "title": "Ferris Bueller's Day Off",
      "aliases": [
        "Ferris Buellers Day Off",
        "Ferris Bueller"
      ],
      "emojis": [
        "🛏️",
        "🤒",
        "🤥",
        "🏎️",
        "🏟️",
        "⚾",
        "🖼️",
        "🎉",
        "🎤",
        "🎵",
        "🏎️",
        "💥"
      ],
      "pack_id": "hollywood_essentials",
      "year": 1986
    },
    {
      "id": "np_12_07",
      "title": "Halloween",
      "aliases": [],
      "emojis": [
        "🤡",
        "🔪",
        "🏥",
        "🎭",
        "🎃",
        "👧",
        "🚪",
        "🔫",
        "💀",
        "❓"
      ],
      "pack_id": "hollywood_essentials",
      "year": 1978
    },
    {
      "id": "np_12_08",
      "title": "Speed",
      "aliases": [],
      "emojis": [
        "🛗",
        "💣",
        "📞",
        "👮‍♂️",
        "🚌",
        "🔥",
        "🚌",
        "💣",
        "⏱️",
        "💥",
        "🚇",
        "💀"
      ],
      "pack_id": "hollywood_essentials",
      "year": 1994
    },
    {
      "id": "np_12_09",
      "title": "Starship Troopers",
      "aliases": [],
      "emojis": [
        "🏫",
        "🏈",
        "🎓",
        "🚀",
        "🪖",
        "🐜",
        "🔫",
        "🪲",
        "💥",
        "🎖️"
      ],
      "pack_id": "hollywood_essentials",
      "year": 1997
    },
    {
      "id": "np_12_10",
      "title": "Love Actually",
      "aliases": [],
      "emojis": [
        "🇬🇧",
        "🎄",
        "💒",
        "📼",
        "💑",
        "💑",
        "💑",
        "🛬",
        "🎵"
      ],
      "pack_id": "hollywood_essentials",
      "year": 2003
    },
    {
      "id": "np_13_01",
      "title": "Thelma & Louise",
      "aliases": [
        "Thelma and Louise"
      ],
      "emojis": [
        "👩‍🦰",
        "👩‍🦱",
        "🚙",
        "🔫",
        "👮‍♂️",
        "🌵",
        "☁️",
        "🚙",
        "☁️"
      ],
      "pack_id": "hollywood_essentials",
      "year": 1991
    },
    {
      "id": "np_13_02",
      "title": "Magnolia",
      "aliases": [],
      "emojis": [
        "🛏️",
        "👴",
        "🤒",
        "📺",
        "🎤",
        "👮‍♂️",
        "🔫",
        "🌧️",
        "🐸",
        "🚑",
        "💥"
      ],
      "pack_id": "hollywood_essentials",
      "year": 1999
    },
    {
      "id": "np_13_03",
      "title": "Elvis",
      "aliases": [],
      "emojis": [
        "🎪",
        "🎸",
        "🎙️",
        "🕺",
        "👴",
        "🤑",
        "🌟",
        "🎰",
        "💊",
        "💔"
      ],
      "pack_id": "hollywood_essentials",
      "year": 2022
    },
    {
      "id": "np_13_04",
      "title": "The Sound of Music",
      "aliases": [
        "Sound of Music"
      ],
      "emojis": [
        "🇦🇹",
        "👩",
        "👪",
        "⛰️",
        "🎶",
        "🪖",
        "🏃",
        "⛰️"
      ],
      "pack_id": "hollywood_essentials",
      "year": 1965
    },
    {
      "id": "np_13_05",
      "title": "Reservoir Dogs",
      "aliases": [],
      "emojis": [
        "🤵‍♂️",
        "⚪",
        "🤵🏻‍♂️",
        "🩷",
        "🤵🏽‍♂️",
        "🟤",
        "🤵‍♂️",
        "🟠",
        "🏦",
        "💵",
        "🔫",
        "💀"
      ],
      "pack_id": "hollywood_essentials",
      "year": 1992
    },
    {
      "id": "np_13_06",
      "title": "Sixteen Candles",
      "aliases": [
        "16 Candles"
      ],
      "emojis": [
        "🎂",
        "😢",
        "🏫",
        "🤓",
        "🕺",
        "⛪",
        "👰‍♀️",
        "🚗",
        "👦🏻",
        "🎂",
        "👧",
        "💋"
      ],
      "pack_id": "hollywood_essentials",
      "year": 1984
    },
    {
      "id": "np_13_07",
      "title": "Showgirls",
      "aliases": [],
      "emojis": [
        "🛣️",
        "👍🏻",
        "🎰",
        "💃",
        "🌋",
        "🤩",
        "👗",
        "💋",
        "💔",
        "🛣️",
        "👍🏻"
      ],
      "pack_id": "hollywood_essentials",
      "year": 1995
    },
    {
      "id": "np_13_08",
      "title": "Mean Girls",
      "aliases": [],
      "emojis": [
        "🌍",
        "➡️",
        "🇺🇸",
        "🏫",
        "👭",
        "👭",
        "📖",
        "🔥",
        "🎄",
        "💃",
        "💥",
        "🦽"
      ],
      "pack_id": "hollywood_essentials",
      "year": 2004
    },
    {
      "id": "np_13_09",
      "title": "Joker",
      "aliases": [],
      "emojis": [
        "🤡",
        "🤪",
        "🎭",
        "😢",
        "📶",
        "🕺",
        "📺",
        "👨",
        "🎤",
        "🔫",
        "💀"
      ],
      "pack_id": "hollywood_essentials",
      "year": 2019
    },
    {
      "id": "np_13_10",
      "title": "Gladiator",
      "aliases": [],
      "emojis": [
        "🇮🇹",
        "⚔️",
        "👑",
        "💀",
        "⛓️",
        "🏛️",
        "🏟️",
        "🦁",
        "👎",
        "💀",
        "🌾"
      ],
      "pack_id": "hollywood_essentials",
      "year": 2000
    },
    {
      "id": "np_14_01",
      "title": "Caddyshack",
      "aliases": [],
      "emojis": [
        "⛳",
        "🐿️",
        "💵",
        "⚖️",
        "🏊",
        "🛥️",
        "🏌️",
        "🐿️",
        "🕳️",
        "💣",
        "💥",
        "🏆"
      ],
      "pack_id": "hollywood_essentials",
      "year": 1980
    },
    {
      "id": "np_14_02",
      "title": "Leaving Las Vegas",
      "aliases": [],
      "emojis": [
        "✍️",
        "🎬",
        "🔥",
        "🚗",
        "🎰",
        "🥃",
        "🏨",
        "👩",
        "🥃",
        "🥃",
        "🥃",
        "💀"
      ],
      "pack_id": "hollywood_essentials",
      "year": 1995
    },
    {
      "id": "np_14_03",
      "title": "Five Nights at Freddy's",
      "aliases": [],
      "emojis": [
        "🍕",
        "🌃",
        "🔦",
        "📺",
        "🤖",
        "🐻",
        "🎩",
        "⚡",
        "🤖",
        "🐰",
        "👦",
        "👻"
      ],
      "pack_id": "hollywood_essentials",
      "year": 2023
    },
    {
      "id": "np_14_04",
      "title": "Sunset Boulevard",
      "aliases": [
        "Sunset Blvd"
      ],
      "emojis": [
        "👨",
        "✍️",
        "🎬",
        "🚗",
        "🏰",
        "👵",
        "🎬",
        "⭐",
        "🤪",
        "🔫",
        "🏊‍♂️",
        "💀"
      ],
      "pack_id": "hollywood_essentials",
      "year": 1950
    },
    {
      "id": "np_14_05",
      "title": "A Bug's Life",
      "aliases": [
        "A Bugs Life"
      ],
      "emojis": [
        "🌳",
        "🐜",
        "🐜",
        "🌾",
        "🦗",
        "😡",
        "🦋",
        "🎪",
        "🐦"
      ],
      "pack_id": "hollywood_essentials",
      "year": 1998
    },
    {
      "id": "np_14_06",
      "title": "Les Misérables",
      "aliases": [
        "Les Miserables"
      ],
      "emojis": [
        "🇫🇷",
        "👨",
        "🥖",
        "🕯️",
        "⛓️",
        "💨",
        "✊",
        "💣",
        "🔫",
        "💥",
        "❤️",
        "🎶"
      ],
      "pack_id": "hollywood_essentials",
      "year": 2012
    },
    {
      "id": "np_14_07",
      "title": "The Lost Boys",
      "aliases": [],
      "emojis": [
        "🌃",
        "🎡",
        "🏖️",
        "🎷",
        "🏍️",
        "👦",
        "🐸",
        "🧛",
        "🥡",
        "🪱",
        "🧄",
        "💀"
      ],
      "pack_id": "hollywood_essentials",
      "year": 1987
    },
    {
      "id": "np_14_08",
      "title": "The Lion King",
      "aliases": [
        "Lion King"
      ],
      "emojis": [
        "🐒",
        "🦁",
        "🌅",
        "🦬",
        "💀",
        "🐗",
        "🦡",
        "🔥"
      ],
      "pack_id": "hollywood_essentials",
      "year": 1994
    },
    {
      "id": "np_14_09",
      "title": "Get Out",
      "aliases": [],
      "emojis": [
        "👨🏿",
        "👩",
        "🚗",
        "🦌",
        "☕",
        "😵‍💫",
        "🕳️",
        "📸",
        "🧠",
        "🏃‍➡️",
        "🚓",
        "🔫"
      ],
      "pack_id": "hollywood_essentials",
      "year": 2017
    },
    {
      "id": "np_14_10",
      "title": "The Fast and the Furious",
      "aliases": [
        "Fast and Furious",
        "The Fast and Furious"
      ],
      "emojis": [
        "🚗",
        "🏎️",
        "🏁",
        "💵",
        "👪",
        "🏎️",
        "🚚",
        "🏎️",
        "🚓"
      ],
      "pack_id": "hollywood_essentials",
      "year": 2001
    },
    {
      "id": "np_15_01",
      "title": "Fargo",
      "aliases": [],
      "emojis": [
        "❄️",
        "🚗",
        "👮‍♀️",
        "🤰",
        "🤕",
        "💵",
        "🪏",
        "🔫",
        "🩸",
        "🪓",
        "🪵",
        "⛓️"
      ],
      "pack_id": "hollywood_essentials",
      "year": 1996
    },
    {
      "id": "np_15_02",
      "title": "Austin Powers: International Man of Mystery",
      "aliases": [
        "Austin Powers"
      ],
      "emojis": [
        "😈",
        "🚀",
        "🕵️‍♂️",
        "👓",
        "☮️",
        "🥶",
        "😴",
        "⏩",
        "🐈",
        "💵",
        "⛰️",
        "🦈"
      ],
      "pack_id": "hollywood_essentials",
      "year": 1997
    },
    {
      "id": "np_15_03",
      "title": "When Harry Met Sally",
      "aliases": [
        "When Harry Met Sally..."
      ],
      "emojis": [
        "👨",
        "👩",
        "🚗",
        "🗽",
        "👋",
        "⏩",
        "🤝",
        "🛏️",
        "😳",
        "🥗",
        "🎉",
        "💋"
      ],
      "pack_id": "hollywood_essentials",
      "year": 1989
    },
    {
      "id": "np_15_04",
      "title": "The Jungle Book",
      "aliases": [
        "Jungle Book"
      ],
      "emojis": [
        "👶🏽",
        "🌳",
        "🐻",
        "🎶",
        "🐯",
        "🐵",
        "🐍"
      ],
      "pack_id": "hollywood_essentials",
      "year": 1967
    },
    {
      "id": "np_15_05",
      "title": "Gravity",
      "aliases": [],
      "emojis": [
        "🚀",
        "👩‍🚀",
        "💥",
        "🌀",
        "😱",
        "🪂",
        "🌊",
        "🌎"
      ],
      "pack_id": "hollywood_essentials",
      "year": 2013
    },
    {
      "id": "np_15_06",
      "title": "Hereditary",
      "aliases": [],
      "emojis": [
        "👧",
        "🐦",
        "🩸",
        "🚗",
        "👧",
        "💀",
        "🕯️",
        "🔥",
        "👨🏻",
        "🔥",
        "⛤",
        "😱"
      ],
      "pack_id": "hollywood_essentials",
      "year": 2018
    },
    {
      "id": "np_15_07",
      "title": "The Lighthouse",
      "aliases": [
        "Lighthouse"
      ],
      "emojis": [
        "⚫",
        "⚪",
        "🏖️",
        "🧔‍♂️",
        "🧔🏻‍♂️",
        "🌊",
        "🏠",
        "🥃",
        "🦆",
        "⛵",
        "🪓",
        "🧜‍♀️"
      ],
      "pack_id": "hollywood_essentials",
      "year": 2019
    },
    {
      "id": "np_15_08",
      "title": "Raiders of the Lost Ark",
      "aliases": [
        "Indiana Jones",
        "Indiana Jones and the Raiders of the Lost Ark"
      ],
      "emojis": [
        "🤠",
        "🪨",
        "🏃",
        "🏆",
        "🗺️",
        "🪏",
        "🐍",
        "⚡",
        "🫠",
        "😱",
        "📦"
      ],
      "pack_id": "hollywood_essentials",
      "year": 1981
    },
    {
      "id": "np_15_09",
      "title": "Raising Arizona",
      "aliases": [],
      "emojis": [
        "🏜️",
        "👨",
        "⛓️",
        "👮🏻‍♀️",
        "💍",
        "🪜",
        "👶",
        "💨",
        "📰",
        "🏍️",
        "🧨",
        "💥"
      ],
      "pack_id": "hollywood_essentials",
      "year": 1987
    },
    {
      "id": "np_15_10",
      "title": "Eternal Sunshine of the Spotless Mind",
      "aliases": [
        "Eternal Sunshine"
      ],
      "emojis": [
        "👩‍❤️‍👨",
        "💔",
        "🧠",
        "⚡",
        "🗑️",
        "🚂",
        "❄️",
        "🏖️",
        "🔄"
      ],
      "pack_id": "hollywood_essentials",
      "year": 2004
    },
    {
      "id": "np_16_01",
      "title": "Fatal Attraction",
      "aliases": [],
      "emojis": [
        "👨",
        "👩",
        "🤫",
        "🤪",
        "🔪",
        "🥘",
        "🐰",
        "💀",
        "😱",
        "🛁",
        "🔫",
        "💀"
      ],
      "pack_id": "hollywood_essentials",
      "year": 1987
    },
    {
      "id": "np_16_02",
      "title": "West Side Story",
      "aliases": [
        "West Side Story 1961"
      ],
      "emojis": [
        "🗽",
        "🇺🇸",
        "🎶",
        "🦈",
        "🆚",
        "🛩️",
        "💥",
        "🕺🏼",
        "💃🏾",
        "❤️",
        "💀",
        "😢"
      ],
      "pack_id": "hollywood_essentials",
      "year": 1961
    },
    {
      "id": "np_16_03",
      "title": "Dead Poets Society",
      "aliases": [],
      "emojis": [
        "🏫",
        "👨‍🏫",
        "📚",
        "🔦",
        "🤫",
        "🎭",
        "🔫",
        "💀",
        "🪑",
        "🧍",
        "🪑",
        "🧍🏽"
      ],
      "pack_id": "hollywood_essentials",
      "year": 1989
    },
    {
      "id": "np_16_04",
      "title": "One Battle After Another",
      "aliases": [],
      "emojis": [
        "👨",
        "👩🏿",
        "👧🏽",
        "✊",
        "💥",
        "🏃",
        "1️⃣",
        "⚔️",
        "➡️",
        "⚔️",
        "➡️",
        "⚔️"
      ],
      "pack_id": "hollywood_essentials",
      "year": 2025
    },
    {
      "id": "np_16_05",
      "title": "Adaptation",
      "aliases": [],
      "emojis": [
        "👨",
        "👨",
        "👯",
        "✍️",
        "🎬",
        "📘",
        "🌸",
        "👩",
        "👨",
        "🔫",
        "🐊"
      ],
      "pack_id": "hollywood_essentials",
      "year": 2002
    },
    {
      "id": "np_16_06",
      "title": "Citizen Kane",
      "aliases": [],
      "emojis": [
        "👨",
        "📰",
        "💰",
        "🏰",
        "❤️",
        "💔",
        "🔍",
        "🤐",
        "❄️",
        "🌹",
        "🛷",
        "🔥"
      ],
      "pack_id": "hollywood_essentials",
      "year": 1941
    },
    {
      "id": "np_16_07",
      "title": "An American Werewolf in London",
      "aliases": [],
      "emojis": [
        "🇺🇸",
        "👨🏻",
        "🇬🇧",
        "🎒",
        "🌕",
        "🐺",
        "🩸",
        "💀",
        "👻",
        "👩🏻‍⚕️",
        "❤️",
        "🔫"
      ],
      "pack_id": "hollywood_essentials",
      "year": 1981
    },
    {
      "id": "np_16_08",
      "title": "Fight Club",
      "aliases": [],
      "emojis": [
        "👨",
        "👊",
        "👨",
        "🤫",
        "🧼",
        "🧊",
        "🐧",
        "👫",
        "🏢",
        "💥",
        "🏢",
        "💥"
      ],
      "pack_id": "hollywood_essentials",
      "year": 1999
    },
    {
      "id": "np_16_09",
      "title": "Forrest Gump",
      "aliases": [],
      "emojis": [
        "👨",
        "🚏",
        "🪶",
        "🍫",
        "👟",
        "🪖",
        "🇨🇳",
        "🏓",
        "🏃",
        "⛵",
        "🦐"
      ],
      "pack_id": "hollywood_essentials",
      "year": 1994
    },
    {
      "id": "np_16_10",
      "title": "Blade Runner",
      "aliases": [],
      "emojis": [
        "🌆",
        "🏢",
        "📹",
        "👁️",
        "🤖",
        "🕵️‍♂️",
        "🔫",
        "😢",
        "🌧️",
        "📃",
        "🦄"
      ],
      "pack_id": "hollywood_essentials",
      "year": 1982
    },
    {
      "id": "np_17_01",
      "title": "Oppenheimer",
      "aliases": [],
      "emojis": [
        "👨‍🔬",
        "🏜️",
        "☢️",
        "💣",
        "💥",
        "🥳",
        "🫤",
        "⚖️"
      ],
      "pack_id": "hollywood_essentials",
      "year": 2023
    },
    {
      "id": "np_17_02",
      "title": "The Wolf of Wall Street",
      "aliases": [
        "Wolf of Wall Street"
      ],
      "emojis": [
        "📈",
        "💵",
        "🥃",
        "💊",
        "🤪",
        "🎉",
        "🛥️",
        "👮‍♂️",
        "⛓️",
        "🐺"
      ],
      "pack_id": "hollywood_essentials",
      "year": 2013
    },
    {
      "id": "np_17_03",
      "title": "Good Will Hunting",
      "aliases": [],
      "emojis": [
        "👨",
        "🏫",
        "🧹",
        "🧠",
        "➕",
        "➖",
        "➗",
        "⛓️",
        "👨🏻‍🏫",
        "🥃",
        "🍎",
        "❤️"
      ],
      "pack_id": "hollywood_essentials",
      "year": 1997
    },
    {
      "id": "np_17_04",
      "title": "A Few Good Men",
      "aliases": [],
      "emojis": [
        "🇨🇺",
        "🪖",
        "💀",
        "🇺🇸",
        "⚖️",
        "🗣️",
        "🎖️",
        "😡",
        "⛓️"
      ],
      "pack_id": "hollywood_essentials",
      "year": 1992
    },
    {
      "id": "np_17_05",
      "title": "Ratatouille",
      "aliases": [],
      "emojis": [
        "🇫🇷",
        "👨‍🍳",
        "🐀",
        "🗣️",
        "🍅",
        "🍆",
        "🍝",
        "😀",
        "✍️"
      ],
      "pack_id": "hollywood_essentials",
      "year": 2007
    },
    {
      "id": "np_17_06",
      "title": "Back to the Future",
      "aliases": [],
      "emojis": [
        "👨‍🔬",
        "👦🏻",
        "☢️",
        "🚗",
        "⏪",
        "🛹",
        "🎸",
        "🎤",
        "🕰️",
        "⚡",
        "⏩",
        "🏠"
      ],
      "pack_id": "hollywood_essentials",
      "year": 1985
    },
    {
      "id": "np_17_07",
      "title": "The Godfather",
      "aliases": [
        "Godfather"
      ],
      "emojis": [
        "🤵‍♂️",
        "👰‍♀️",
        "🍝",
        "🐴",
        "💀",
        "🍊",
        "🔫",
        "👴",
        "💀"
      ],
      "pack_id": "hollywood_essentials",
      "year": 1972
    },
    {
      "id": "np_17_08",
      "title": "The Fly",
      "aliases": [],
      "emojis": [
        "👨‍🔬",
        "🐒",
        "⚡",
        "💀",
        "💻",
        "🧪",
        "🧬",
        "⚡",
        "👨",
        "➕",
        "🪰",
        "😱"
      ],
      "pack_id": "hollywood_essentials",
      "year": 1986
    },
    {
      "id": "np_17_09",
      "title": "Dirty Dancing",
      "aliases": [],
      "emojis": [
        "🏨",
        "🍉",
        "💃",
        "🌊",
        "💑",
        "🪑",
        "🚫",
        "🕺",
        "🙌"
      ],
      "pack_id": "hollywood_essentials",
      "year": 1987
    },
    {
      "id": "np_17_10",
      "title": "Harry Potter and the Sorcerer's Stone",
      "aliases": [
        "Harry Potter",
        "Harry Potter and the Philosopher's Stone",
        "Sorcerer's Stone"
      ],
      "emojis": [
        "⚡",
        "🦉",
        "💌",
        "🚂",
        "🏫",
        "🧙",
        "🧌",
        "♟️",
        "💎"
      ],
      "pack_id": "hollywood_essentials",
      "year": 2001
    },
    {
      "id": "np_18_01",
      "title": "Apocalypse Now",
      "aliases": [],
      "emojis": [
        "🚁",
        "🌴",
        "🇻🇳",
        "⛵",
        "🪖",
        "🏝️",
        "💥",
        "🏄‍♂️",
        "💥",
        "👨",
        "🐂",
        "🗡️"
      ],
      "pack_id": "hollywood_essentials",
      "year": 1979
    },
    {
      "id": "np_18_02",
      "title": "Batman Returns",
      "aliases": [],
      "emojis": [
        "🦇",
        "🐧",
        "🎩",
        "🐈",
        "👩",
        "🥛",
        "❄️",
        "🌃",
        "🐧",
        "🧨",
        "🚀"
      ],
      "pack_id": "hollywood_essentials",
      "year": 1992
    },
    {
      "id": "np_18_03",
      "title": "Rushmore",
      "aliases": [],
      "emojis": [
        "🏫",
        "👦🏻",
        "👓",
        "💘",
        "👩‍🏫",
        "💔",
        "👨🏻",
        "🐝",
        "💈",
        "✍️",
        "🎭",
        "👏"
      ],
      "pack_id": "hollywood_essentials",
      "year": 1998
    },
    {
      "id": "np_18_04",
      "title": "The Wedding Singer",
      "aliases": [],
      "emojis": [
        "💒",
        "🎤",
        "🎵",
        "💍",
        "💔",
        "😢",
        "👱‍♀️",
        "❤️",
        "✈️",
        "🎸",
        "🎵",
        "👩‍❤️‍👨"
      ],
      "pack_id": "hollywood_essentials",
      "year": 1998
    },
    {
      "id": "np_18_05",
      "title": "Casablanca",
      "aliases": [],
      "emojis": [
        "🇲🇦",
        "☕",
        "🥃",
        "🤵‍♂️",
        "🎩",
        "👩",
        "🎹",
        "🎵",
        "👮🏻‍♂️",
        "🌫️",
        "🛫",
        "💔"
      ],
      "pack_id": "hollywood_essentials",
      "year": 1942
    },
    {
      "id": "np_18_06",
      "title": "Clueless",
      "aliases": [],
      "emojis": [
        "🌴",
        "👱‍♀️",
        "💻",
        "👗",
        "🏫",
        "🎾",
        "💘",
        "🛍️",
        "⛲",
        "💘",
        "🙍🏻‍♂️"
      ],
      "pack_id": "hollywood_essentials",
      "year": 1995
    },
    {
      "id": "np_18_07",
      "title": "O Brother, Where Art Thou?",
      "aliases": [
        "O Brother Where Art Thou"
      ],
      "emojis": [
        "⛓️",
        "🏃",
        "🏃",
        "🏃",
        "🎙️",
        "🎵",
        "📻",
        "⭐",
        "📣",
        "🌊",
        "🌊",
        "🌊"
      ],
      "pack_id": "hollywood_essentials",
      "year": 2000
    },
    {
      "id": "np_18_08",
      "title": "Full Metal Jacket",
      "aliases": [],
      "emojis": [
        "🪖",
        "👨",
        "😠",
        "🔫",
        "💀",
        "🇻🇳",
        "🃏",
        "🤠",
        "🎱",
        "🔫",
        "💥",
        "💀"
      ],
      "pack_id": "hollywood_essentials",
      "year": 1987
    },
    {
      "id": "np_18_09",
      "title": "Shrek",
      "aliases": [],
      "emojis": [
        "🟢",
        "👹",
        "🐴",
        "🧅",
        "🏰",
        "🐲",
        "👸",
        "🌙",
        "💒",
        "💋"
      ],
      "pack_id": "hollywood_essentials",
      "year": 2001
    },
    {
      "id": "np_18_10",
      "title": "2001: A Space Odyssey",
      "aliases": [
        "2001 A Space Odyssey",
        "2001"
      ],
      "emojis": [
        "🐒",
        "🪨",
        "⬛",
        "🦴",
        "🚀",
        "👨‍🚀",
        "🖥️",
        "🤪",
        "👁️",
        "🌌",
        "👶"
      ],
      "pack_id": "hollywood_essentials",
      "year": 1968
    },
    {
      "id": "np_19_01",
      "title": "Black Panther",
      "aliases": [],
      "emojis": [
        "🐈‍⬛",
        "🌍",
        "👑",
        "💎",
        "⚔️",
        "🔥"
      ],
      "pack_id": "hollywood_essentials",
      "year": 2018
    },
    {
      "id": "np_19_02",
      "title": "Whiplash",
      "aliases": [],
      "emojis": [
        "🏫",
        "🎵",
        "👨",
        "🥁",
        "👨‍🏫",
        "🎺",
        "🎷",
        "🎹",
        "😠",
        "😓",
        "🎶"
      ],
      "pack_id": "hollywood_essentials",
      "year": 2014
    },
    {
      "id": "np_19_03",
      "title": "Scream",
      "aliases": [],
      "emojis": [
        "👧",
        "🏠",
        "📞",
        "🍿",
        "👻",
        "😱",
        "🔪",
        "🩸",
        "🔫",
        "💀"
      ],
      "pack_id": "hollywood_essentials",
      "year": 1996
    },
    {
      "id": "np_19_04",
      "title": "Dunkirk",
      "aliases": [],
      "emojis": [
        "🇬🇧",
        "🏖️",
        "🪖",
        "🌊",
        "⛵",
        "✈️",
        "🏖️",
        "🔥"
      ],
      "pack_id": "hollywood_essentials",
      "year": 2017
    },
    {
      "id": "np_19_05",
      "title": "The Wizard of Oz",
      "aliases": [
        "Wizard of Oz"
      ],
      "emojis": [
        "👧",
        "🐕",
        "🌈",
        "🌪️",
        "🏠",
        "👠",
        "🟡",
        "🧱",
        "🦁",
        "🤖",
        "🧙",
        "🏠"
      ],
      "pack_id": "hollywood_essentials",
      "year": 1939
    },
    {
      "id": "np_19_06",
      "title": "Close Encounters of the Third Kind",
      "aliases": [],
      "emojis": [
        "🛸",
        "🌌",
        "👨",
        "🥔",
        "👩",
        "👦",
        "⛰️",
        "🎹",
        "🛸",
        "👽",
        "👦",
        "👽"
      ],
      "pack_id": "hollywood_essentials",
      "year": 1977
    },
    {
      "id": "np_19_07",
      "title": "Inglourious Basterds",
      "aliases": [
        "Inglorious Basterds"
      ],
      "emojis": [
        "🇺🇸",
        "🪖",
        "🇫🇷",
        "🐻",
        "✡️",
        "👩",
        "👨🏿",
        "📽️",
        "🎞️",
        "🚬",
        "🔥",
        "💥"
      ],
      "pack_id": "hollywood_essentials",
      "year": 2009
    },
    {
      "id": "np_19_08",
      "title": "Interstellar",
      "aliases": [],
      "emojis": [
        "🌽",
        "👨‍🚀",
        "🚀",
        "🌀",
        "🌊",
        "🤖",
        "🧊",
        "👧",
        "📚",
        "🕰️",
        "🔄",
        "🤯"
      ],
      "pack_id": "hollywood_essentials",
      "year": 2014
    },
    {
      "id": "np_19_09",
      "title": "Poltergeist",
      "aliases": [],
      "emojis": [
        "👪",
        "🏠",
        "📺",
        "👧",
        "👐",
        "👻",
        "🌳",
        "🤡",
        "😱",
        "🏘️",
        "🔨",
        "🪦"
      ],
      "pack_id": "hollywood_essentials",
      "year": 1982
    },
    {
      "id": "np_19_10",
      "title": "The Good, the Bad and the Ugly",
      "aliases": [
        "Good Bad Ugly"
      ],
      "emojis": [
        "🤠",
        "🤠",
        "🤠",
        "💰",
        "🪦",
        "🪦",
        "🔫",
        "🪦",
        "🪦"
      ],
      "pack_id": "hollywood_essentials",
      "year": 1966
    },
    {
      "id": "np_20_01",
      "title": "Toy Story",
      "aliases": [],
      "emojis": [
        "🤠",
        "👨‍🚀",
        "🎂",
        "😠",
        "🍕",
        "👽",
        "🚚",
        "🧨",
        "🪂"
      ],
      "pack_id": "hollywood_essentials",
      "year": 1995
    },
    {
      "id": "np_20_02",
      "title": "Taken",
      "aliases": [],
      "emojis": [
        "🇺🇸",
        "👨",
        "📞",
        "🇫🇷",
        "👧",
        "💨",
        "🚫",
        "✈️",
        "🥋",
        "🔫",
        "🚗",
        "🏠"
      ],
      "pack_id": "hollywood_essentials",
      "year": 2008
    },
    {
      "id": "np_20_03",
      "title": "Heathers",
      "aliases": [],
      "emojis": [
        "👧🏻",
        "💃",
        "💃",
        "💃",
        "🥤",
        "☠️",
        "🏈",
        "🔫",
        "💀",
        "🏫",
        "💣"
      ],
      "pack_id": "hollywood_essentials",
      "year": 1988
    },
    {
      "id": "np_20_04",
      "title": "Black Widow",
      "aliases": [],
      "emojis": [
        "🇷🇺",
        "👪",
        "🦸‍♂️",
        "🦸‍♀️",
        "🕷️",
        "🦸‍♀️",
        "🕷️",
        "⛓️",
        "💥"
      ],
      "pack_id": "hollywood_essentials",
      "year": 2021
    },
    {
      "id": "np_20_05",
      "title": "Highlander",
      "aliases": [],
      "emojis": [
        "🏴󠁧󠁢󠁳󠁣󠁴󠁿",
        "👨",
        "⚔️",
        "♾️",
        "🗽",
        "⚔️",
        "👨🏻",
        "🩸",
        "⚡",
        "☝️"
      ],
      "pack_id": "hollywood_essentials",
      "year": 1986
    },
    {
      "id": "np_20_06",
      "title": "American Psycho",
      "aliases": [],
      "emojis": [
        "🤵‍♂️",
        "💵",
        "📈",
        "🗃️",
        "👨",
        "🎵",
        "🥃",
        "🤪",
        "🪓",
        "🩸",
        "💀",
        "🕵️‍♂️"
      ],
      "pack_id": "hollywood_essentials",
      "year": 2000
    },
    {
      "id": "np_20_07",
      "title": "The Girl with the Dragon Tattoo",
      "aliases": [],
      "emojis": [
        "🇸🇪",
        "❄️",
        "📰",
        "👴",
        "🏝️",
        "👧",
        "❓",
        "🐉",
        "💻",
        "🔍",
        "🐈",
        "💀"
      ],
      "pack_id": "hollywood_essentials",
      "year": 2011
    },
    {
      "id": "np_20_08",
      "title": "Mary Poppins",
      "aliases": [],
      "emojis": [
        "🇬🇧",
        "👩",
        "☂️",
        "👧",
        "👦",
        "🧹",
        "✨",
        "🐧",
        "🎠",
        "🎶"
      ],
      "pack_id": "hollywood_essentials",
      "year": 1964
    },
    {
      "id": "np_20_09",
      "title": "Snow White and the Seven Dwarfs",
      "aliases": [
        "Snow White"
      ],
      "emojis": [
        "🪞",
        "👸",
        "😡",
        "🌲",
        "👸",
        "👵",
        "🍎",
        "☠️",
        "😴",
        "⚰️",
        "💋",
        "🥳"
      ],
      "pack_id": "hollywood_essentials",
      "year": 1937
    },
    {
      "id": "np_20_10",
      "title": "Scarface",
      "aliases": [],
      "emojis": [
        "👨🏽",
        "🇨🇺",
        "➡️",
        "🇺🇸",
        "🏖️",
        "🚿",
        "🪚",
        "🩸",
        "🏰",
        "❄️",
        "🔫",
        "💀"
      ],
      "pack_id": "hollywood_essentials",
      "year": 1983
    },
    {
      "id": "np_21_01",
      "title": "Blink Twice",
      "aliases": [],
      "emojis": [
        "🤑",
        "👩🏿",
        "👩🏻",
        "✈️",
        "🏝️",
        "💊",
        "😴",
        "😱",
        "😐",
        "😑",
        "😐",
        "😑"
      ],
      "pack_id": "hollywood_essentials",
      "year": 2024
    },
    {
      "id": "np_21_02",
      "title": "The Thing",
      "aliases": [],
      "emojis": [
        "❄️",
        "🛸",
        "🐕",
        "👽",
        "🕷️",
        "🧬",
        "🩸",
        "🧫",
        "🔥",
        "💀"
      ],
      "pack_id": "hollywood_essentials",
      "year": 1982
    },
    {
      "id": "np_21_03",
      "title": "The Nightmare Before Christmas",
      "aliases": [],
      "emojis": [
        "🎶",
        "💀",
        "🎃",
        "🎄",
        "🌙",
        "🕷️",
        "🎅",
        "🎲",
        "🛷",
        "🌃",
        "💥"
      ],
      "pack_id": "hollywood_essentials",
      "year": 1993
    },
    {
      "id": "np_21_04",
      "title": "Vertigo",
      "aliases": [],
      "emojis": [
        "🌉",
        "🕵️‍♂️",
        "🙆‍♂️",
        "🌀",
        "👩",
        "🖼️",
        "⛪",
        "🌀",
        "💀",
        "💔",
        "👩",
        "💎"
      ],
      "pack_id": "hollywood_essentials",
      "year": 1958
    },
    {
      "id": "np_21_05",
      "title": "American Pie",
      "aliases": [],
      "emojis": [
        "🤝",
        "🏫",
        "🎶",
        "🥍",
        "💩",
        "🏠",
        "💻",
        "🥧",
        "🥳",
        "🍻",
        "🪈"
      ],
      "pack_id": "hollywood_essentials",
      "year": 1999
    },
    {
      "id": "np_21_06",
      "title": "Raging Bull",
      "aliases": [],
      "emojis": [
        "⚫",
        "⚪",
        "👨",
        "🥊",
        "⏩",
        "👴",
        "🥃",
        "🎤",
        "😡",
        "🐂"
      ],
      "pack_id": "hollywood_essentials",
      "year": 1980
    },
    {
      "id": "np_21_07",
      "title": "Bohemian Rhapsody",
      "aliases": [],
      "emojis": [
        "🇬🇧",
        "🧔🏻",
        "🌈",
        "🎤",
        "🎹",
        "🏟️",
        "🎵"
      ],
      "pack_id": "hollywood_essentials",
      "year": 2018
    },
    {
      "id": "np_21_08",
      "title": "Saving Private Ryan",
      "aliases": [],
      "emojis": [
        "👴",
        "🪦",
        "⏪",
        "🪖",
        "🌊",
        "🛥️",
        "💥",
        "🩸",
        "💥",
        "🩸",
        "✉️",
        "👨"
      ],
      "pack_id": "hollywood_essentials",
      "year": 1998
    },
    {
      "id": "np_21_09",
      "title": "Dr. Strangelove",
      "aliases": [
        "Dr Strangelove",
        "Doctor Strangelove"
      ],
      "emojis": [
        "☎️",
        "🔴",
        "🪖",
        "🎖️",
        "☢️",
        "✈️",
        "🤠",
        "💣",
        "💥",
        "🌍"
      ],
      "pack_id": "hollywood_essentials",
      "year": 1964
    },
    {
      "id": "np_21_10",
      "title": "Braveheart",
      "aliases": [],
      "emojis": [
        "🏴󠁧󠁢󠁳󠁣󠁴󠁿",
        "💍",
        "🔪",
        "🔵",
        "🐎",
        "⚔️",
        "⛓️",
        "🗣️",
        "💀"
      ],
      "pack_id": "hollywood_essentials",
      "year": 1995
    },
    {
      "id": "np_22_01",
      "title": "Cast Away",
      "aliases": [],
      "emojis": [
        "📦",
        "✈️",
        "⛈️",
        "🆘",
        "💥",
        "🌊",
        "🏝️",
        "🏐",
        "🔥",
        "🛶",
        "🚢",
        "🏠"
      ],
      "pack_id": "hollywood_essentials",
      "year": 2000
    },
    {
      "id": "np_22_02",
      "title": "Singin' in the Rain",
      "aliases": [
        "Singin in the Rain"
      ],
      "emojis": [
        "🌴",
        "🎬",
        "🌧️",
        "🎶",
        "🕺",
        "☔",
        "💡",
        "👮‍♂️",
        "🌧️",
        "🎶"
      ],
      "pack_id": "hollywood_essentials",
      "year": 1952
    },
    {
      "id": "np_22_03",
      "title": "Hocus Pocus",
      "aliases": [],
      "emojis": [
        "🧙‍♀️",
        "🧙‍♀️",
        "🧙‍♀️",
        "🔥",
        "⏩",
        "🎃",
        "🐈‍⬛",
        "📖",
        "🕯️",
        "🧙‍♀️",
        "🧙‍♀️",
        "🧙‍♀️"
      ],
      "pack_id": "hollywood_essentials",
      "year": 1993
    },
    {
      "id": "np_22_04",
      "title": "Sheep Detectives",
      "aliases": [],
      "emojis": [
        "🇬🇧",
        "👨",
        "📖",
        "🗣️",
        "🐑",
        "🐏",
        "👨",
        "☠️",
        "🐑",
        "🐏",
        "🕵️‍♀️"
      ],
      "pack_id": "hollywood_essentials",
      "year": 2026
    },
    {
      "id": "np_22_05",
      "title": "The Terminator",
      "aliases": [
        "Terminator"
      ],
      "emojis": [
        "⚡",
        "⌛",
        "🤖",
        "😎",
        "👩",
        "🔫",
        "🚓",
        "💥",
        "🏭",
        "💥"
      ],
      "pack_id": "hollywood_essentials",
      "year": 1984
    },
    {
      "id": "np_22_06",
      "title": "Once Upon a Time in Hollywood",
      "aliases": [],
      "emojis": [
        "🌴",
        "🤠",
        "🎬",
        "🚗",
        "🏚️",
        "🥋",
        "👊",
        "🔪",
        "🥫",
        "🐕",
        "🏊",
        "🔥"
      ],
      "pack_id": "hollywood_essentials",
      "year": 2019
    },
    {
      "id": "np_22_07",
      "title": "Cool Hand Luke",
      "aliases": [],
      "emojis": [
        "👨",
        "⛓️",
        "🥚",
        "🥚",
        "🏃‍♂️",
        "💨",
        "👮‍♂️",
        "⛓️",
        "🏃‍♂️",
        "💨",
        "👮‍♂️",
        "⛓️"
      ],
      "pack_id": "hollywood_essentials",
      "year": 1967
    },
    {
      "id": "np_22_08",
      "title": "The Great Escape",
      "aliases": [
        "Great Escape"
      ],
      "emojis": [
        "🇩🇪",
        "🪖",
        "🏕️",
        "⚾",
        "⛏️",
        "🕳️",
        "🕳️",
        "🕳️",
        "🏍️",
        "🌳",
        "💥",
        "⚾"
      ],
      "pack_id": "hollywood_essentials",
      "year": 1963
    },
    {
      "id": "np_22_09",
      "title": "The Big Lebowski",
      "aliases": [
        "Big Lebowski"
      ],
      "emojis": [
        "🌴",
        "🧔‍♂️",
        "🥛",
        "🎳",
        "♿",
        "📝",
        "💰",
        "⚱️",
        "💨"
      ],
      "pack_id": "hollywood_essentials",
      "year": 1998
    },
    {
      "id": "np_22_10",
      "title": "First Blood",
      "aliases": [
        "Rambo",
        "Rambo: First Blood"
      ],
      "emojis": [
        "🌧️",
        "🪖",
        "🚓",
        "🏃",
        "🌲",
        "🔪",
        "👮‍♂️",
        "💀",
        "🩸",
        "💪"
      ],
      "pack_id": "hollywood_essentials",
      "year": 1982
    },
    {
      "id": "np_23_01",
      "title": "A Star Is Born",
      "aliases": [
        "Star Is Born"
      ],
      "emojis": [
        "🤠",
        "👩",
        "❤️",
        "🎤",
        "👩‍🎤",
        "🌟",
        "⬆️",
        "🤠",
        "⬇️",
        "💔",
        "💀"
      ],
      "pack_id": "hollywood_essentials",
      "year": 2018
    },
    {
      "id": "np_23_02",
      "title": "Tropic Thunder",
      "aliases": [],
      "emojis": [
        "🎬",
        "🇲🇲",
        "🪖",
        "🚁",
        "🌳",
        "💣",
        "💀",
        "💊",
        "🔥",
        "🐉",
        "📽️",
        "🏆"
      ],
      "pack_id": "hollywood_essentials",
      "year": 2008
    },
    {
      "id": "np_23_03",
      "title": "Hugo",
      "aliases": [],
      "emojis": [
        "🇫🇷",
        "👦",
        "🚂",
        "⚙️",
        "👴",
        "🎬",
        "🚀",
        "🌝",
        "🤖",
        "🎨"
      ],
      "pack_id": "hollywood_essentials",
      "year": 2011
    },
    {
      "id": "np_23_04",
      "title": "The Matrix",
      "aliases": [
        "Matrix"
      ],
      "emojis": [
        "💻",
        "🐇",
        "😎",
        "💊",
        "🔴",
        "🤖",
        "🥋",
        "🔫",
        "✋"
      ],
      "pack_id": "hollywood_essentials",
      "year": 1999
    },
    {
      "id": "np_23_05",
      "title": "Dumbo",
      "aliases": [],
      "emojis": [
        "🚂",
        "🐘",
        "👂",
        "🐭",
        "🪶",
        "✨",
        "🌳",
        "🐦‍⬛",
        "🎪",
        "🐘",
        "🌟",
        "👏"
      ],
      "pack_id": "hollywood_essentials",
      "year": 1941
    },
    {
      "id": "np_23_06",
      "title": "Armageddon",
      "aliases": [],
      "emojis": [
        "🗽",
        "☄️",
        "🌎",
        "💥",
        "🆘",
        "👨‍🚀",
        "🚀",
        "☄️",
        "💥",
        "🚀",
        "🌎",
        "🎉"
      ],
      "pack_id": "hollywood_essentials",
      "year": 1998
    },
    {
      "id": "np_23_07",
      "title": "Rosemary's Baby",
      "aliases": [
        "Rosemarys Baby"
      ],
      "emojis": [
        "🗽",
        "🎬",
        "👨",
        "🤰",
        "🏢",
        "🧙🏻‍♀️",
        "👶",
        "⛤",
        "😈",
        "👀",
        "😱"
      ],
      "pack_id": "hollywood_essentials",
      "year": 1968
    },
    {
      "id": "np_23_08",
      "title": "Arrival",
      "aliases": [],
      "emojis": [
        "🛸",
        "🪖",
        "👨🏿",
        "👩‍🏫",
        "🛸",
        "👽",
        "🗣️",
        "🔣",
        "💻",
        "💣",
        "🕰️"
      ],
      "pack_id": "hollywood_essentials",
      "year": 2016
    },
    {
      "id": "np_23_09",
      "title": "The Magnificent Seven",
      "aliases": [
        "Magnificent Seven"
      ],
      "emojis": [
        "🏜️",
        "🤠",
        "🤠",
        "🤠",
        "🤠",
        "🤠",
        "🤠",
        "🤠",
        "🔫",
        "💥"
      ],
      "pack_id": "hollywood_essentials",
      "year": 1960
    },
    {
      "id": "np_23_10",
      "title": "Cars",
      "aliases": [],
      "emojis": [
        "🏎️",
        "🏜️",
        "🚙",
        "🛻",
        "🏎️",
        "🏁",
        "🏆"
      ],
      "pack_id": "hollywood_essentials",
      "year": 2006
    },
    {
      "id": "np_24_01",
      "title": "Labyrinth",
      "aliases": [],
      "emojis": [
        "👧🏻",
        "🦉",
        "👶",
        "💨",
        "🌀",
        "🏰",
        "👺",
        "👑",
        "🎶",
        "🔮",
        "👶",
        "👧🏻"
      ],
      "pack_id": "hollywood_essentials",
      "year": 1986
    },
    {
      "id": "np_24_02",
      "title": "The Hangover",
      "aliases": [
        "Hangover"
      ],
      "emojis": [
        "💍",
        "🚗",
        "🎰",
        "🐺",
        "🍻",
        "👀",
        "🐯",
        "🦷",
        "👶",
        "🚓",
        "💒",
        "📷"
      ],
      "pack_id": "hollywood_essentials",
      "year": 2009
    },
    {
      "id": "np_24_03",
      "title": "School of Rock",
      "aliases": [],
      "emojis": [
        "👨‍🏫",
        "🚫",
        "👨🏻",
        "🥃",
        "👦",
        "🎸",
        "👧",
        "🥁",
        "🏟️",
        "🎶"
      ],
      "pack_id": "hollywood_essentials",
      "year": 2003
    },
    {
      "id": "np_24_04",
      "title": "Project Hail Mary",
      "aliases": [],
      "emojis": [
        "🚀",
        "😴",
        "👨‍🚀",
        "🌌",
        "🔬",
        "🔭",
        "🛸",
        "🪨",
        "👽",
        "🤝",
        "🧫",
        "🙌"
      ],
      "pack_id": "hollywood_essentials",
      "year": 2026
    },
    {
      "id": "np_24_05",
      "title": "Pretty in Pink",
      "aliases": [],
      "emojis": [
        "🏫",
        "👧",
        "💿",
        "🕺",
        "💘",
        "👦",
        "💔",
        "🪡",
        "🧵",
        "✂️",
        "👗",
        "🩷"
      ],
      "pack_id": "hollywood_essentials",
      "year": 1986
    },
    {
      "id": "np_24_06",
      "title": "Pirates of the Caribbean",
      "aliases": [
        "Pirates of the Caribbean: The Curse of the Black Pearl"
      ],
      "emojis": [
        "⛵",
        "🏴‍☠️",
        "🌕",
        "👻",
        "🪙",
        "⚔️",
        "🏝️",
        "🍾",
        "🔥"
      ],
      "pack_id": "hollywood_essentials",
      "year": 2003
    },
    {
      "id": "np_24_07",
      "title": "The Breakfast Club",
      "aliases": [
        "Breakfast Club"
      ],
      "emojis": [
        "🏫",
        "📝",
        "🤓",
        "🏈",
        "👸",
        "🤪",
        "🚬",
        "✊",
        "🥞"
      ],
      "pack_id": "hollywood_essentials",
      "year": 1985
    },
    {
      "id": "np_24_08",
      "title": "The Avengers",
      "aliases": [
        "Avengers"
      ],
      "emojis": [
        "😈",
        "🟦",
        "🛡️",
        "🔨",
        "🕷️",
        "🏹",
        "🟢",
        "🛸",
        "🥙"
      ],
      "pack_id": "hollywood_essentials",
      "year": 2012
    },
    {
      "id": "np_24_09",
      "title": "Cool Runnings",
      "aliases": [],
      "emojis": [
        "🇯🇲",
        "👨🏿",
        "👨🏿",
        "🛷",
        "🇨🇦",
        "❄️",
        "🛷",
        "💥",
        "🏃🏿‍♂️",
        "🏁",
        "👏"
      ],
      "pack_id": "hollywood_essentials",
      "year": 1993
    },
    {
      "id": "np_24_10",
      "title": "Lady and the Tramp",
      "aliases": [],
      "emojis": [
        "🎄",
        "🎁",
        "🐶",
        "🐕",
        "🌃",
        "🎵",
        "🍝",
        "❤️",
        "👶",
        "😾",
        "😾",
        "🐀"
      ],
      "pack_id": "hollywood_essentials",
      "year": 1955
    },
    {
      "id": "np_25_01",
      "title": "Saw",
      "aliases": [],
      "emojis": [
        "😴",
        "😕",
        "🚻",
        "🚽",
        "⛓️",
        "📼",
        "📺",
        "🧩",
        "🪚",
        "🦶",
        "😱"
      ],
      "pack_id": "hollywood_essentials",
      "year": 2004
    },
    {
      "id": "np_25_02",
      "title": "A Nightmare on Elm Street",
      "aliases": [
        "Nightmare on Elm Street"
      ],
      "emojis": [
        "😴",
        "😈",
        "🧤",
        "🔪",
        "😱",
        "👧",
        "🛁",
        "😴",
        "🧤",
        "🔪",
        "😱"
      ],
      "pack_id": "hollywood_essentials",
      "year": 1984
    },
    {
      "id": "np_25_03",
      "title": "The Aristocats",
      "aliases": [],
      "emojis": [
        "🇫🇷",
        "🐱",
        "🎨",
        "🎹",
        "🤵‍♂️",
        "🥛",
        "☠️",
        "🐈",
        "🎺",
        "🎷",
        "🎶",
        "❤️"
      ],
      "pack_id": "hollywood_essentials",
      "year": 1970
    },
    {
      "id": "np_25_04",
      "title": "A Clockwork Orange",
      "aliases": [
        "Clockwork Orange"
      ],
      "emojis": [
        "🇬🇧",
        "🎩",
        "👊",
        "🥛",
        "👮‍♂️",
        "👀",
        "📽️",
        "🎻",
        "🛏️",
        "🤕",
        "🧠"
      ],
      "pack_id": "hollywood_essentials",
      "year": 1971
    },
    {
      "id": "np_25_05",
      "title": "Footloose",
      "aliases": [],
      "emojis": [
        "🌽",
        "⛪",
        "💃",
        "🚫",
        "🚜",
        "🚜",
        "🐔",
        "💥",
        "🏭",
        "🕺",
        "📖",
        "🪩"
      ],
      "pack_id": "hollywood_essentials",
      "year": 1984
    },
    {
      "id": "np_25_06",
      "title": "Good Morning, Vietnam",
      "aliases": [],
      "emojis": [
        "🇻🇳",
        "🌅",
        "🎙️",
        "📻",
        "🪖",
        "🤣"
      ],
      "pack_id": "hollywood_essentials",
      "year": 1987
    },
    {
      "id": "np_25_07",
      "title": "Ice Age",
      "aliases": [],
      "emojis": [
        "❄️",
        "🧊",
        "🐿️",
        "🌰",
        "🦣",
        "🦥",
        "🐅",
        "👶"
      ],
      "pack_id": "hollywood_essentials",
      "year": 2002
    },
    {
      "id": "np_25_08",
      "title": "Breakfast at Tiffany's",
      "aliases": [
        "Breakfast at Tiffanys"
      ],
      "emojis": [
        "🗽",
        "👩",
        "🐈",
        "👨",
        "🎭",
        "🪟",
        "🎸",
        "🚕",
        "🌧️",
        "🐈",
        "💋"
      ],
      "pack_id": "hollywood_essentials",
      "year": 1961
    },
    {
      "id": "np_25_09",
      "title": "The Great Gatsby",
      "aliases": [],
      "emojis": [
        "🤑",
        "🏰",
        "🎉",
        "🥂",
        "🟢",
        "💡",
        "🚗",
        "💥",
        "💀",
        "🏊",
        "🔫",
        "💀"
      ],
      "pack_id": "hollywood_essentials",
      "year": 2013
    },
    {
      "id": "np_25_10",
      "title": "Disclosure Day",
      "aliases": [],
      "emojis": [
        "⛅",
        "👩",
        "🎤",
        "📺",
        "🪄",
        "🏠",
        "🦌",
        "🦝",
        "👧",
        "👽",
        "📣",
        "🌎"
      ],
      "pack_id": "hollywood_essentials",
      "year": 2026
    },
    {
      "id": "np_26_01",
      "title": "Office Space",
      "aliases": [],
      "emojis": [
        "🏢",
        "😡",
        "👊",
        "🖨️",
        "👨🏻",
        "😵‍💫",
        "😀",
        "💾",
        "🏦",
        "💵",
        "🏢",
        "🔥"
      ],
      "pack_id": "hollywood_essentials",
      "year": 1999
    },
    {
      "id": "np_26_02",
      "title": "John Wick",
      "aliases": [],
      "emojis": [
        "🔫",
        "🐶",
        "💔",
        "🧔🏻‍♂️",
        "🚗",
        "🪙",
        "🏨",
        "🥋",
        "👊",
        "🔫",
        "👊",
        "🔫"
      ],
      "pack_id": "hollywood_essentials",
      "year": 2014
    },
    {
      "id": "np_26_03",
      "title": "Jerry Maguire",
      "aliases": [],
      "emojis": [
        "💼",
        "🏈",
        "⚾",
        "💵",
        "🐟",
        "👩",
        "👦",
        "👓",
        "❤️",
        "👨🏿",
        "🏈",
        "📃"
      ],
      "pack_id": "hollywood_essentials",
      "year": 1996
    },
    {
      "id": "np_26_04",
      "title": "The Room",
      "aliases": [],
      "emojis": [
        "🌉",
        "👨🏻",
        "👩",
        "💔",
        "🥄",
        "🤵‍♂️",
        "🏈",
        "🤵🏻‍♂️",
        "🎉",
        "💋",
        "🔫",
        "💀"
      ],
      "pack_id": "hollywood_essentials",
      "year": 2003
    },
    {
      "id": "np_26_05",
      "title": "The Silence of the Lambs",
      "aliases": [
        "Silence of the Lambs"
      ],
      "emojis": [
        "👮‍♀️",
        "👨‍⚕️",
        "🤪",
        "🩸",
        "🍷",
        "🦋",
        "🕳️",
        "🐩",
        "🧺",
        "🤫",
        "🐑"
      ],
      "pack_id": "hollywood_essentials",
      "year": 1991
    },
    {
      "id": "np_26_06",
      "title": "Miss Congeniality",
      "aliases": [],
      "emojis": [
        "👮🏻‍♀️",
        "👓",
        "💄",
        "👠",
        "🎽",
        "👗",
        "💣",
        "🗽",
        "💥",
        "🔫",
        "👮🏽‍♂️",
        "💘"
      ],
      "pack_id": "hollywood_essentials",
      "year": 2000
    },
    {
      "id": "np_26_07",
      "title": "Blades of Glory",
      "aliases": [],
      "emojis": [
        "⛸️",
        "🥇",
        "🥇",
        "👊",
        "👬",
        "⛸️",
        "🏟️",
        "🪷",
        "👏",
        "🥇"
      ],
      "pack_id": "hollywood_essentials",
      "year": 2007
    },
    {
      "id": "np_26_08",
      "title": "Black Swan",
      "aliases": [],
      "emojis": [
        "🩰",
        "⚪",
        "⚫",
        "🦢",
        "💋",
        "🍰",
        "🪞",
        "🪶",
        "🩸",
        "👏"
      ],
      "pack_id": "hollywood_essentials",
      "year": 2010
    },
    {
      "id": "np_26_09",
      "title": "A Simple Plan",
      "aliases": [],
      "emojis": [
        "❄️",
        "✈️",
        "💥",
        "💀",
        "👝",
        "💵",
        "💵",
        "🤫",
        "🪾",
        "🐦‍⬛",
        "👨",
        "🔫"
      ],
      "pack_id": "hollywood_essentials",
      "year": 1998
    },
    {
      "id": "np_26_10",
      "title": "Cinderella",
      "aliases": [],
      "emojis": [
        "👩",
        "🧹",
        "🐭",
        "👵",
        "✨",
        "🎃",
        "🐴",
        "💃",
        "🤴",
        "🕛",
        "👠",
        "💍"
      ],
      "pack_id": "hollywood_essentials",
      "year": 1950
    },
    {
      "id": "np_27_01",
      "title": "Twisters",
      "aliases": [],
      "emojis": [
        "👩",
        "🤠",
        "📡",
        "⛈️",
        "🚗",
        "🚙",
        "🌽",
        "🚜",
        "🌪️",
        "🌪️",
        "💥",
        "💀"
      ],
      "pack_id": "hollywood_essentials",
      "year": 2024
    },
    {
      "id": "np_27_02",
      "title": "The Ring",
      "aliases": [
        "Ring"
      ],
      "emojis": [
        "👩",
        "📼",
        "📞",
        "📅",
        "⛴️",
        "🐎",
        "👧🏻",
        "🕳️",
        "📺",
        "👧",
        "💀"
      ],
      "pack_id": "hollywood_essentials",
      "year": 2002
    },
    {
      "id": "np_27_03",
      "title": "The Green Mile",
      "aliases": [
        "Green Mile"
      ],
      "emojis": [
        "🏛️",
        "⛓️",
        "⚡",
        "🪑",
        "👮‍♂️",
        "👨🏿",
        "🐁",
        "🧵",
        "🤒",
        "👐🏿",
        "✨",
        "😀"
      ],
      "pack_id": "hollywood_essentials",
      "year": 1999
    },
    {
      "id": "np_27_04",
      "title": "Alien",
      "aliases": [],
      "emojis": [
        "😴",
        "📡",
        "🛸",
        "🥚",
        "🍽️",
        "🩸",
        "😱",
        "💀",
        "🐱",
        "👩‍🚀",
        "😴"
      ],
      "pack_id": "hollywood_essentials",
      "year": 1979
    },
    {
      "id": "np_27_05",
      "title": "Memento",
      "aliases": [],
      "emojis": [
        "📷",
        "💀",
        "⏪",
        "🏨",
        "👨",
        "🖊️",
        "🧠",
        "🚫",
        "🏃",
        "⏪",
        "👩",
        "🍺"
      ],
      "pack_id": "hollywood_essentials",
      "year": 2000
    },
    {
      "id": "np_27_06",
      "title": "The Little Mermaid",
      "aliases": [
        "Little Mermaid"
      ],
      "emojis": [
        "🧜‍♀️",
        "🔱",
        "🚢",
        "⛈️",
        "💥",
        "🤴",
        "🐶",
        "🐙",
        "🦵",
        "❤️",
        "🎶"
      ],
      "pack_id": "hollywood_essentials",
      "year": 1987
    },
    {
      "id": "np_27_07",
      "title": "Her",
      "aliases": [],
      "emojis": [
        "🌴",
        "👨",
        "✍️",
        "💌",
        "❤️",
        "📱",
        "🤯",
        "💔",
        "👩",
        "🌅"
      ],
      "pack_id": "hollywood_essentials",
      "year": 2013
    },
    {
      "id": "np_27_08",
      "title": "Pinocchio",
      "aliases": [],
      "emojis": [
        "👴",
        "🐱",
        "🪵",
        "🧚",
        "👦🏻",
        "🦗",
        "🎩",
        "🤥",
        "🎱",
        "🚬",
        "🐳",
        "👦🏻"
      ],
      "pack_id": "hollywood_essentials",
      "year": 1940
    },
    {
      "id": "np_27_09",
      "title": "Point Break",
      "aliases": [],
      "emojis": [
        "🏦",
        "🎭",
        "🔫",
        "💵",
        "🕵️‍♂️",
        "🪂",
        "🏖️",
        "🌧️",
        "🌊",
        "🏄‍♂️",
        "💀"
      ],
      "pack_id": "hollywood_essentials",
      "year": 1991
    },
    {
      "id": "np_27_10",
      "title": "Guardians of the Galaxy",
      "aliases": [],
      "emojis": [
        "🚀",
        "🌌",
        "🦸",
        "🦝",
        "🌳",
        "🤺",
        "👩",
        "🟢",
        "📼",
        "🎶",
        "💥"
      ],
      "pack_id": "hollywood_essentials",
      "year": 2014
    },
    {
      "id": "np_28_01",
      "title": "Cocaine Bear",
      "aliases": [],
      "emojis": [
        "✈️",
        "👝",
        "❄️",
        "🪂",
        "🏞️",
        "🐻",
        "❄️",
        "🤪",
        "🩸",
        "🚑",
        "💀"
      ],
      "pack_id": "hollywood_essentials",
      "year": 2023
    },
    {
      "id": "np_28_02",
      "title": "American Beauty",
      "aliases": [],
      "emojis": [
        "👨",
        "🌹",
        "🌹",
        "🌹",
        "🛁",
        "🌹",
        "👱‍♀️",
        "🌹",
        "🌹",
        "🌹",
        "🌹",
        "🌹"
      ],
      "pack_id": "hollywood_essentials",
      "year": 1999
    },
    {
      "id": "np_28_03",
      "title": "Zodiac",
      "aliases": [],
      "emojis": [
        "🌉",
        "🚗",
        "🔫",
        "💀",
        "✉️",
        "📰",
        "🔣",
        "🧩",
        "🕵️‍♂️"
      ],
      "pack_id": "hollywood_essentials",
      "year": 2007
    },
    {
      "id": "np_28_04",
      "title": "Up",
      "aliases": [],
      "emojis": [
        "👨",
        "❤️",
        "👩",
        "💀",
        "😢",
        "🎈",
        "🏠",
        "🎈",
        "👦",
        "🐕",
        "🗣️"
      ],
      "pack_id": "hollywood_essentials",
      "year": 2009
    },
    {
      "id": "np_28_05",
      "title": "Predator",
      "aliases": [],
      "emojis": [
        "💪🏻",
        "💪🏿",
        "🤝",
        "🚁",
        "🌳",
        "👽",
        "🌳",
        "🔫",
        "🩸",
        "💀",
        "🚁"
      ],
      "pack_id": "hollywood_essentials",
      "year": 1987
    },
    {
      "id": "np_28_06",
      "title": "Beetlejuice",
      "aliases": [],
      "emojis": [
        "🚗",
        "💥",
        "💀",
        "🏠",
        "🪦",
        "👻",
        "🪦",
        "👧🏻",
        "🏜️",
        "🚪",
        "🐛",
        "🎵"
      ],
      "pack_id": "hollywood_essentials",
      "year": 1988
    },
    {
      "id": "np_28_07",
      "title": "Groundhog Day",
      "aliases": [],
      "emojis": [
        "👨",
        "🎤",
        "📺",
        "🐹",
        "⏰",
        "🔄",
        "🔄",
        "🔄",
        "❤️"
      ],
      "pack_id": "hollywood_essentials",
      "year": 1993
    },
    {
      "id": "np_28_08",
      "title": "The Conjuring",
      "aliases": [
        "Conjuring"
      ],
      "emojis": [
        "👨",
        "👩",
        "🏠",
        "🌀",
        "🪆",
        "👪",
        "👏",
        "🕯️",
        "📿",
        "👻",
        "😈",
        "✝️"
      ],
      "pack_id": "hollywood_essentials",
      "year": 2013
    },
    {
      "id": "np_28_09",
      "title": "Meet the Parents",
      "aliases": [],
      "emojis": [
        "👩‍❤️‍👨",
        "💍",
        "👴",
        "👵",
        "🐱",
        "🚽",
        "⚱️",
        "💨",
        "🤥",
        "🏐",
        "🩸",
        "🔥"
      ],
      "pack_id": "hollywood_essentials",
      "year": 2000
    },
    {
      "id": "np_28_10",
      "title": "Spirited Away",
      "aliases": [],
      "emojis": [
        "🇯🇵",
        "👧🏻",
        "🚗",
        "🏯",
        "🐉",
        "🛁",
        "👻",
        "🐷",
        "🚂"
      ],
      "pack_id": "hollywood_essentials",
      "year": 2001
    },
    {
      "id": "np_29_01",
      "title": "WALL-E",
      "aliases": [
        "WallE",
        "Wall E"
      ],
      "emojis": [
        "🤖",
        "🗑️",
        "🌱",
        "🤖",
        "🚀",
        "🧯",
        "✨",
        "🌍",
        "🌱"
      ],
      "pack_id": "hollywood_essentials",
      "year": 2008
    },
    {
      "id": "np_29_02",
      "title": "Spider-Man",
      "aliases": [
        "Spiderman",
        "Spider Man"
      ],
      "emojis": [
        "🏫",
        "👦",
        "👧",
        "📷",
        "🕷️",
        "🕸️",
        "🟢",
        "👺",
        "🙃",
        "💋",
        "👧"
      ],
      "pack_id": "hollywood_essentials",
      "year": 2002
    },
    {
      "id": "np_29_03",
      "title": "Election",
      "aliases": [],
      "emojis": [
        "🏫",
        "👱‍♀️",
        "🧁",
        "😠",
        "🐝",
        "👁️",
        "🗳️",
        "🗑️"
      ],
      "pack_id": "hollywood_essentials",
      "year": 1999
    },
    {
      "id": "np_29_04",
      "title": "Avatar",
      "aliases": [],
      "emojis": [
        "♿",
        "🪖",
        "🚀",
        "🌕",
        "🪨",
        "💙",
        "🌳",
        "🐉",
        "🔥",
        "⚔️",
        "👁️"
      ],
      "pack_id": "hollywood_essentials",
      "year": 2009
    },
    {
      "id": "np_29_05",
      "title": "Happy Gilmore",
      "aliases": [],
      "emojis": [
        "👨🏻",
        "🏒",
        "👵🏻",
        "🏠",
        "🏌️",
        "💥",
        "👨🏿",
        "✋🏿",
        "🐊",
        "📺",
        "👊",
        "🏆"
      ],
      "pack_id": "hollywood_essentials",
      "year": 1996
    },
    {
      "id": "np_29_06",
      "title": "Ted",
      "aliases": [],
      "emojis": [
        "🎄",
        "🌃",
        "👦🏻",
        "✨",
        "🧸",
        "🗣️",
        "😱",
        "🥃",
        "😮‍💨",
        "🤣"
      ],
      "pack_id": "hollywood_essentials",
      "year": 2012
    },
    {
      "id": "np_29_07",
      "title": "Paddington",
      "aliases": [],
      "emojis": [
        "🇵🇪",
        "👨",
        "🐻",
        "🐻",
        "⏩",
        "🇬🇧",
        "🚂",
        "🐻",
        "👪",
        "❤️"
      ],
      "pack_id": "hollywood_essentials",
      "year": 2014
    },
    {
      "id": "np_29_08",
      "title": "Wicked",
      "aliases": [],
      "emojis": [
        "👩🏻",
        "👩🏿‍🦱",
        "🟢",
        "🧙‍♀️",
        "🏫",
        "🐐",
        "🧙‍♂️",
        "✨",
        "🧹",
        "☁️",
        "🎶"
      ],
      "pack_id": "hollywood_essentials",
      "year": 2024
    },
    {
      "id": "np_29_09",
      "title": "Beverly Hills Cop",
      "aliases": [],
      "emojis": [
        "👮🏿‍♂️",
        "🚗",
        "🌴",
        "👮🏻‍♂️",
        "👮‍♂️",
        "🚓",
        "🍌",
        "🖼️",
        "🏰",
        "🔫"
      ],
      "pack_id": "hollywood_essentials",
      "year": 1984
    },
    {
      "id": "np_29_10",
      "title": "Luca",
      "aliases": [],
      "emojis": [
        "🌊",
        "🐟",
        "👦",
        "👦🏻",
        "🛵",
        "🍝",
        "🚲",
        "🌧️"
      ],
      "pack_id": "hollywood_essentials",
      "year": 2021
    },
    {
      "id": "np_30_01",
      "title": "Iron Man",
      "aliases": [],
      "emojis": [
        "👨",
        "💰",
        "🥃",
        "💥",
        "🦾",
        "🧲",
        "🦸‍♂️"
      ],
      "pack_id": "hollywood_essentials",
      "year": 2008
    },
    {
      "id": "np_30_02",
      "title": "Goodfellas",
      "aliases": [],
      "emojis": [
        "🤵‍♂️",
        "🗽",
        "🔫",
        "💵",
        "🥃",
        "🤡",
        "🤣",
        "⛓️",
        "🍝",
        "❄️",
        "🚁",
        "⚖️"
      ],
      "pack_id": "hollywood_essentials",
      "year": 1990
    },
    {
      "id": "np_30_03",
      "title": "Men in Black",
      "aliases": [
        "MIB",
        "Men In Black"
      ],
      "emojis": [
        "🤵‍♂️",
        "🤵🏿‍♂️",
        "😎",
        "🪳",
        "👽",
        "🛸",
        "🔫",
        "💥"
      ],
      "pack_id": "hollywood_essentials",
      "year": 1997
    },
    {
      "id": "np_30_04",
      "title": "How the Grinch Stole Christmas",
      "aliases": [
        "The Grinch 2000",
        "The Grinch"
      ],
      "emojis": [
        "🟢",
        "😠",
        "⛰️",
        "🐶",
        "🛷",
        "🎄",
        "💨",
        "🎁",
        "💨",
        "👫",
        "🎶",
        "💚"
      ],
      "pack_id": "hollywood_essentials",
      "year": 2000
    },
    {
      "id": "np_30_05",
      "title": "Ocean's Eleven",
      "aliases": [
        "Oceans Eleven",
        "Oceans 11"
      ],
      "emojis": [
        "🤵‍♂️",
        "🤝",
        "🎰",
        "🏦",
        "💥",
        "💰",
        "⛲"
      ],
      "pack_id": "hollywood_essentials",
      "year": 2001
    },
    {
      "id": "np_30_06",
      "title": "Inside Out",
      "aliases": [],
      "emojis": [
        "👧",
        "🧠",
        "😀",
        "😢",
        "😠",
        "😨",
        "🤢",
        "🐘",
        "🚀",
        "💀",
        "😢"
      ],
      "pack_id": "hollywood_essentials",
      "year": 2015
    },
    {
      "id": "np_30_07",
      "title": "Independence Day",
      "aliases": [],
      "emojis": [
        "🛸",
        "🌆",
        "🏛️",
        "💥",
        "👊🏿",
        "👽",
        "✈️",
        "🛜",
        "🛸",
        "💥"
      ],
      "pack_id": "hollywood_essentials",
      "year": 1996
    },
    {
      "id": "np_30_08",
      "title": "Fantastic Mr. Fox",
      "aliases": [
        "Fantastic Mr Fox"
      ],
      "emojis": [
        "🦊",
        "👪",
        "🌳",
        "🍂",
        "😠",
        "🦡",
        "😵‍💫",
        "🍎",
        "🍷",
        "👨‍🌾",
        "🔫"
      ],
      "pack_id": "hollywood_essentials",
      "year": 2009
    },
    {
      "id": "np_30_09",
      "title": "Superbad",
      "aliases": [],
      "emojis": [
        "🏫",
        "🎓",
        "🏪",
        "🪪",
        "🍺",
        "👮‍♂️",
        "🥳",
        "💃",
        "🕺",
        "🩸",
        "👊",
        "💥"
      ],
      "pack_id": "hollywood_essentials",
      "year": 2007
    },
    {
      "id": "np_30_10",
      "title": "Misery",
      "aliases": [],
      "emojis": [
        "✍️",
        "❄️",
        "🚗",
        "💥",
        "🏠",
        "🛏️",
        "👩‍⚕️",
        "🤪",
        "🔨",
        "🦶",
        "📖",
        "🔥"
      ],
      "pack_id": "hollywood_essentials",
      "year": 1990
    },
    {
      "id": "fo_hunger_games",
      "title": "The Hunger Games",
      "aliases": [
        "Hunger Games"
      ],
      "emojis": [
        "🏹",
        "👧",
        "🔥",
        "🍞",
        "📺",
        "🏆"
      ],
      "pack_id": "flickoff_exclusive",
      "year": 2012
    },
    {
      "id": "fo_i_am_legend",
      "title": "I Am Legend",
      "aliases": [],
      "emojis": [
        "🗽",
        "🧟",
        "🐕",
        "👨🏿",
        "🌃",
        "💉"
      ],
      "pack_id": "flickoff_exclusive",
      "year": 2007
    },
    {
      "id": "fo_space_jam",
      "title": "Space Jam",
      "aliases": [],
      "emojis": [
        "🏀",
        "🐰",
        "👽",
        "⭐",
        "😤"
      ],
      "pack_id": "flickoff_exclusive",
      "year": 1996
    },
    {
      "id": "fo_addams_family",
      "title": "The Addams Family",
      "aliases": [
        "Addams Family"
      ],
      "emojis": [
        "🏚️",
        "🖐️",
        "💀",
        "🎩",
        "⚡"
      ],
      "pack_id": "flickoff_exclusive",
      "year": 1991
    },
    {
      "id": "fo_wonderful_life",
      "title": "It's a Wonderful Life",
      "aliases": [
        "Its a Wonderful Life"
      ],
      "emojis": [
        "👼",
        "🌉",
        "💰",
        "🏘️",
        "🔔",
        "🎄"
      ],
      "pack_id": "flickoff_exclusive",
      "year": 1946
    },
    {
      "id": "fo_twister",
      "title": "Twister",
      "aliases": [],
      "emojis": [
        "🌪️",
        "🚗",
        "🐄",
        "👫",
        "📡"
      ],
      "pack_id": "flickoff_exclusive",
      "year": 1996
    },
    {
      "id": "fo_world_war_z",
      "title": "World War Z",
      "aliases": [],
      "emojis": [
        "🧟",
        "🌍",
        "✈️",
        "🧱",
        "💉",
        "🚁"
      ],
      "pack_id": "flickoff_exclusive",
      "year": 2013
    },
    {
      "id": "fo_21_jump_street",
      "title": "21 Jump Street",
      "aliases": [
        "Twenty One Jump Street"
      ],
      "emojis": [
        "👮",
        "👮",
        "🏫",
        "💊",
        "🎓",
        "🔫"
      ],
      "pack_id": "flickoff_exclusive",
      "year": 2012
    },
    {
      "id": "fo_hook",
      "title": "Hook",
      "aliases": [],
      "emojis": [
        "✈️",
        "👨‍👩‍👧‍👦",
        "🏴‍☠️",
        "🪝",
        "👦",
        "🐊",
        "⏰"
      ],
      "pack_id": "flickoff_exclusive",
      "year": 1991
    },
    {
      "id": "fo_free_willy",
      "title": "Free Willy",
      "aliases": [],
      "emojis": [
        "👦",
        "🎨",
        "🐋",
        "🤝",
        "🎶",
        "😈",
        "🚛",
        "🌊",
        "🙌"
      ],
      "pack_id": "flickoff_exclusive",
      "year": 1993
    },
    {
      "id": "fo_santa_clause",
      "title": "The Santa Clause",
      "aliases": [
        "Santa Clause"
      ],
      "emojis": [
        "👨",
        "👦",
        "🎅",
        "🏠",
        "💀",
        "🧥",
        "📜",
        "🦌",
        "🎄"
      ],
      "pack_id": "flickoff_exclusive",
      "year": 1994
    },
    {
      "id": "fo_casper",
      "title": "Casper",
      "aliases": [],
      "emojis": [
        "👻",
        "🏰",
        "👧",
        "💕",
        "🧪"
      ],
      "pack_id": "flickoff_exclusive",
      "year": 1995
    },
    {
      "id": "fo_parent_trap",
      "title": "The Parent Trap",
      "aliases": [
        "Parent Trap"
      ],
      "emojis": [
        "👯‍♀️",
        "🏕️",
        "🤝",
        "🔄",
        "💍"
      ],
      "pack_id": "flickoff_exclusive",
      "year": 1998
    },
    {
      "id": "fo_scooby_doo",
      "title": "Scooby-Doo",
      "aliases": [
        "Scooby Doo"
      ],
      "emojis": [
        "🐶",
        "🚐",
        "👻",
        "🏝️",
        "🥪"
      ],
      "pack_id": "flickoff_exclusive",
      "year": 2002
    },
    {
      "id": "fo_alvin",
      "title": "Alvin and the Chipmunks",
      "aliases": [],
      "emojis": [
        "🐿️",
        "🐿️",
        "🐿️",
        "🎤",
        "🎸"
      ],
      "pack_id": "flickoff_exclusive",
      "year": 2007
    },
    {
      "id": "fo_babe",
      "title": "Babe",
      "aliases": [],
      "emojis": [
        "🐷",
        "🐑",
        "👨",
        "🌾",
        "🏆"
      ],
      "pack_id": "flickoff_exclusive",
      "year": 1995
    },
    {
      "id": "fo_honey_shrunk",
      "title": "Honey, I Shrunk the Kids",
      "aliases": [
        "Honey I Shrunk the Kids"
      ],
      "emojis": [
        "👨‍🔬",
        "🔬",
        "👦",
        "👧",
        "🐜",
        "🌱",
        "🍪"
      ],
      "pack_id": "flickoff_exclusive",
      "year": 1989
    },
    {
      "id": "fo_kindergarten_cop",
      "title": "Kindergarten Cop",
      "aliases": [],
      "emojis": [
        "👮",
        "🏫",
        "👶",
        "🐹",
        "🔫"
      ],
      "pack_id": "flickoff_exclusive",
      "year": 1990
    },
    {
      "id": "fo_bodyguard",
      "title": "The Bodyguard",
      "aliases": [
        "Bodyguard"
      ],
      "emojis": [
        "👨",
        "🛡️",
        "👩🏿",
        "🎤",
        "💌",
        "💘",
        "🏆",
        "🔫",
        "✈️"
      ],
      "pack_id": "flickoff_exclusive",
      "year": 1992
    },
    {
      "id": "fo_training_day",
      "title": "Training Day",
      "aliases": [],
      "emojis": [
        "👮🏿",
        "🚔",
        "💊",
        "💵",
        "🔫",
        "🌃"
      ],
      "pack_id": "flickoff_exclusive",
      "year": 2001
    },
    {
      "id": "fo_waynes_world",
      "title": "Wayne's World",
      "aliases": [
        "Waynes World"
      ],
      "emojis": [
        "🎸",
        "📺",
        "🚗",
        "🤘",
        "🎶"
      ],
      "pack_id": "flickoff_exclusive",
      "year": 1992
    },
    {
      "id": "fo_blues_brothers",
      "title": "The Blues Brothers",
      "aliases": [
        "Blues Brothers"
      ],
      "emojis": [
        "🕶️",
        "🎩",
        "🎷",
        "⛪",
        "🚓",
        "💥"
      ],
      "pack_id": "flickoff_exclusive",
      "year": 1980
    },
    {
      "id": "fo_sat_night_fever",
      "title": "Saturday Night Fever",
      "aliases": [],
      "emojis": [
        "🕺",
        "🪩",
        "🗽",
        "🎶",
        "👔"
      ],
      "pack_id": "flickoff_exclusive",
      "year": 1977
    },
    {
      "id": "fo_beethoven",
      "title": "Beethoven",
      "aliases": [],
      "emojis": [
        "🐶",
        "🏡",
        "👨‍👩‍👧‍👦",
        "💉",
        "🦴"
      ],
      "pack_id": "flickoff_exclusive",
      "year": 1992
    },
    {
      "id": "fo_stuart_little",
      "title": "Stuart Little",
      "aliases": [],
      "emojis": [
        "🐭",
        "👨‍👩‍👦",
        "🏠",
        "🐈",
        "⛵"
      ],
      "pack_id": "flickoff_exclusive",
      "year": 1999
    },
    {
      "id": "fo_marley_me",
      "title": "Marley & Me",
      "aliases": [
        "Marley and Me"
      ],
      "emojis": [
        "🐶",
        "💑",
        "📰",
        "🛋️",
        "💔"
      ],
      "pack_id": "flickoff_exclusive",
      "year": 2008
    },
    {
      "id": "fo_perfect_storm",
      "title": "The Perfect Storm",
      "aliases": [
        "Perfect Storm"
      ],
      "emojis": [
        "🌊",
        "⛵",
        "🎣",
        "⚡",
        "🌀"
      ],
      "pack_id": "flickoff_exclusive",
      "year": 2000
    },
    {
      "id": "fo_deep_impact",
      "title": "Deep Impact",
      "aliases": [],
      "emojis": [
        "☄️",
        "🌊",
        "🌍",
        "📰",
        "🚀"
      ],
      "pack_id": "flickoff_exclusive",
      "year": 1998
    },
    {
      "id": "fo_jingle_all_way",
      "title": "Jingle All the Way",
      "aliases": [],
      "emojis": [
        "🎄",
        "👨",
        "🛍️",
        "🤖",
        "💪"
      ],
      "pack_id": "flickoff_exclusive",
      "year": 1996
    },
    {
      "id": "fo_were_the_millers",
      "title": "We're the Millers",
      "aliases": [
        "Were the Millers"
      ],
      "emojis": [
        "🌿",
        "🚐",
        "👨‍👩‍👧‍👦",
        "🇲🇽",
        "🚓",
        "💍"
      ],
      "pack_id": "flickoff_exclusive",
      "year": 2013
    },
    {
      "id": "fo_twins",
      "title": "Twins",
      "aliases": [],
      "emojis": [
        "👬",
        "💪",
        "🤓",
        "🚗",
        "💰"
      ],
      "pack_id": "flickoff_exclusive",
      "year": 1988
    },
    {
      "id": "fo_spy_kids",
      "title": "Spy Kids",
      "aliases": [],
      "emojis": [
        "🕵️",
        "👧🏽",
        "👦🏽",
        "🤖",
        "🦈"
      ],
      "pack_id": "flickoff_exclusive",
      "year": 2001
    },
    {
      "id": "fo_neverending",
      "title": "The NeverEnding Story",
      "aliases": [
        "Neverending Story",
        "The Neverending Story"
      ],
      "emojis": [
        "📖",
        "👦",
        "🐉",
        "☁️",
        "🐺"
      ],
      "pack_id": "flickoff_exclusive",
      "year": 1984
    },
    {
      "id": "fo_sister_act",
      "title": "Sister Act",
      "aliases": [],
      "emojis": [
        "👩🏿",
        "🎤",
        "🔫",
        "👀",
        "🚓",
        "⛪",
        "🙏",
        "🎶",
        "⭐"
      ],
      "pack_id": "flickoff_exclusive",
      "year": 1992
    },
    {
      "id": "fo_bill_ted",
      "title": "Bill & Ted's Excellent Adventure",
      "aliases": [
        "Bill and Teds Excellent Adventure",
        "Bill and Ted"
      ],
      "emojis": [
        "☎️",
        "⏰",
        "🎸",
        "📜",
        "👬",
        "🎢"
      ],
      "pack_id": "flickoff_exclusive",
      "year": 1989
    },
    {
      "id": "fo_trading_places",
      "title": "Trading Places",
      "aliases": [],
      "emojis": [
        "💼",
        "🥃",
        "🔄",
        "🍊",
        "📈"
      ],
      "pack_id": "flickoff_exclusive",
      "year": 1983
    },
    {
      "id": "fo_george_jungle",
      "title": "George of the Jungle",
      "aliases": [],
      "emojis": [
        "🦍",
        "👨",
        "🌴",
        "🌳",
        "💥",
        "❤️"
      ],
      "pack_id": "flickoff_exclusive",
      "year": 1997
    },
    {
      "id": "fo_flubber",
      "title": "Flubber",
      "aliases": [],
      "emojis": [
        "👨‍🔬",
        "🧪",
        "🟢",
        "🏀",
        "✈️"
      ],
      "pack_id": "flickoff_exclusive",
      "year": 1997
    },
    {
      "id": "fo_patch_adams",
      "title": "Patch Adams",
      "aliases": [],
      "emojis": [
        "🤡",
        "🩺",
        "🏥",
        "😂",
        "❤️"
      ],
      "pack_id": "flickoff_exclusive",
      "year": 1998
    },
    {
      "id": "fo_limitless",
      "title": "Limitless",
      "aliases": [],
      "emojis": [
        "💊",
        "🧠",
        "📈",
        "✍️",
        "💼",
        "🔫"
      ],
      "pack_id": "flickoff_exclusive",
      "year": 2011
    },
    {
      "id": "fo_prisoners",
      "title": "Prisoners",
      "aliases": [],
      "emojis": [
        "👧",
        "👧",
        "🚐",
        "🙏",
        "🔨",
        "🕵️",
        "🌧️"
      ],
      "pack_id": "flickoff_exclusive",
      "year": 2013
    },
    {
      "id": "fo_life_is_beautiful",
      "title": "Life Is Beautiful",
      "aliases": [],
      "emojis": [
        "🇮🇹",
        "💑",
        "👶",
        "🚂",
        "🤡",
        "💔"
      ],
      "pack_id": "flickoff_exclusive",
      "year": 1997
    },
    {
      "id": "fo_step_up",
      "title": "Step Up",
      "aliases": [],
      "emojis": [
        "👨",
        "💥",
        "🏫",
        "🧹",
        "👩",
        "🩰",
        "🤝",
        "🕺",
        "🎓"
      ],
      "pack_id": "flickoff_exclusive",
      "year": 2006
    },
    {
      "id": "fo_walk_remember",
      "title": "A Walk to Remember",
      "aliases": [
        "Walk to Remember"
      ],
      "emojis": [
        "👦",
        "👧",
        "⛪",
        "🎭",
        "💘",
        "🤒",
        "🔭",
        "💍",
        "💔"
      ],
      "pack_id": "flickoff_exclusive",
      "year": 2002
    },
    {
      "id": "fo_cliffhanger",
      "title": "Cliffhanger",
      "aliases": [],
      "emojis": [
        "🏔️",
        "🧗",
        "💰",
        "✈️",
        "❄️"
      ],
      "pack_id": "flickoff_exclusive",
      "year": 1993
    },
    {
      "id": "fo_backdraft",
      "title": "Backdraft",
      "aliases": [],
      "emojis": [
        "🔥",
        "👬",
        "🚒",
        "🕵️",
        "💔"
      ],
      "pack_id": "flickoff_exclusive",
      "year": 1991
    },
    {
      "id": "fo_outbreak",
      "title": "Outbreak",
      "aliases": [],
      "emojis": [
        "🦠",
        "🐒",
        "🏘️",
        "🚁",
        "😷"
      ],
      "pack_id": "flickoff_exclusive",
      "year": 1995
    },
    {
      "id": "fo_volcano",
      "title": "Volcano",
      "aliases": [],
      "emojis": [
        "🌴",
        "🏙️",
        "🕳️",
        "🌋",
        "🔥",
        "🚇",
        "🚒",
        "🧱"
      ],
      "pack_id": "flickoff_exclusive",
      "year": 1997
    },
    {
      "id": "fo_dantes_peak",
      "title": "Dante's Peak",
      "aliases": [
        "Dantes Peak"
      ],
      "emojis": [
        "🌋",
        "🏔️",
        "🚙",
        "👨‍👩‍👧‍👦",
        "💨"
      ],
      "pack_id": "flickoff_exclusive",
      "year": 1997
    },
    {
      "id": "fo_big_fish",
      "title": "Big Fish",
      "aliases": [],
      "emojis": [
        "🐟",
        "👴",
        "📖",
        "🎪",
        "💍",
        "🌼"
      ],
      "pack_id": "flickoff_exclusive",
      "year": 2003
    },
    {
      "id": "fo_splash",
      "title": "Splash",
      "aliases": [],
      "emojis": [
        "🧜‍♀️",
        "🗽",
        "❤️",
        "👨",
        "🌊"
      ],
      "pack_id": "flickoff_exclusive",
      "year": 1984
    },
    {
      "id": "fo_willow",
      "title": "Willow",
      "aliases": [],
      "emojis": [
        "🧙",
        "👶",
        "⚔️",
        "🪄",
        "🏰"
      ],
      "pack_id": "flickoff_exclusive",
      "year": 1988
    },
    {
      "id": "fo_small_soldiers",
      "title": "Small Soldiers",
      "aliases": [],
      "emojis": [
        "🧸",
        "🤖",
        "🪖",
        "💥",
        "🏠"
      ],
      "pack_id": "flickoff_exclusive",
      "year": 1998
    },
    {
      "id": "fo_uncle_buck",
      "title": "Uncle Buck",
      "aliases": [],
      "emojis": [
        "👨",
        "🚗",
        "🥞",
        "👧",
        "🎩"
      ],
      "pack_id": "flickoff_exclusive",
      "year": 1989
    },
    {
      "id": "fo_sky_high",
      "title": "Sky High",
      "aliases": [],
      "emojis": [
        "🦸",
        "🏫",
        "☁️",
        "👦",
        "💥"
      ],
      "pack_id": "flickoff_exclusive",
      "year": 2005
    },
    {
      "id": "dx_hitch",
      "title": "Hitch",
      "aliases": [],
      "emojis": [
        "👨🏿",
        "💼",
        "💘",
        "🕺",
        "😬",
        "🌶️",
        "📰",
        "💔",
        "💃🏽"
      ],
      "pack_id": "daily_exclusive",
      "year": 2005
    },
    {
      "id": "dx_enchanted",
      "title": "Enchanted",
      "aliases": [],
      "emojis": [
        "👸",
        "🎨",
        "💍",
        "🕳️",
        "🌆",
        "😳",
        "👨",
        "💃",
        "💋"
      ],
      "pack_id": "daily_exclusive",
      "year": 2007
    },
    {
      "id": "dx_cheaper_by_the_dozen",
      "title": "Cheaper by the Dozen",
      "aliases": [],
      "emojis": [
        "👨",
        "👩",
        "👶👶👶",
        "🏠",
        "🌪️",
        "🏈",
        "😅",
        "💔",
        "🤗"
      ],
      "pack_id": "daily_exclusive",
      "year": 2003
    },
    {
      "id": "dx_what_women_want",
      "title": "What Women Want",
      "aliases": [],
      "emojis": [
        "👨",
        "⚡",
        "🛁",
        "💭",
        "👩",
        "👂",
        "😏",
        "💼",
        "💘"
      ],
      "pack_id": "daily_exclusive",
      "year": 2000
    },
    {
      "id": "dx_air_force_one",
      "title": "Air Force One",
      "aliases": [],
      "emojis": [
        "✈️",
        "🇺🇸",
        "🦹",
        "🔫",
        "😤",
        "👊",
        "📞",
        "🪂",
        "🦅"
      ],
      "pack_id": "daily_exclusive",
      "year": 1997
    },
    {
      "id": "dx_mighty_ducks",
      "title": "The Mighty Ducks",
      "aliases": [
        "The Mighty Ducks",
        "Mighty Ducks"
      ],
      "emojis": [
        "👨‍⚖️",
        "🚓",
        "🏒",
        "👦👧",
        "😤",
        "🦆",
        "🥅",
        "🏆",
        "🎉"
      ],
      "pack_id": "daily_exclusive",
      "year": 1992
    },
    {
      "id": "dx_daddy_day_care",
      "title": "Daddy Day Care",
      "aliases": [],
      "emojis": [
        "👨🏿",
        "💼",
        "📉",
        "👶",
        "👶",
        "🏠",
        "🎨",
        "🌪️",
        "❤️"
      ],
      "pack_id": "daily_exclusive",
      "year": 2003
    },
    {
      "id": "dx_inspector_gadget",
      "title": "Inspector Gadget",
      "aliases": [],
      "emojis": [
        "👮",
        "🤖",
        "🦾",
        "🚁",
        "🎩",
        "🦹",
        "⚙️",
        "💥",
        "🏆"
      ],
      "pack_id": "daily_exclusive",
      "year": 1999
    },
    {
      "id": "dx_johnny_english",
      "title": "Johnny English",
      "aliases": [],
      "emojis": [
        "🕵️",
        "🇬🇧",
        "😅",
        "👑",
        "💎",
        "🦹",
        "🤦",
        "💥",
        "🏆"
      ],
      "pack_id": "daily_exclusive",
      "year": 2003
    },
    {
      "id": "dx_nanny_mcphee",
      "title": "Nanny McPhee",
      "aliases": [],
      "emojis": [
        "👶👶👶",
        "😈",
        "👵",
        "✨",
        "📏",
        "🎂",
        "💍",
        "🌨️",
        "🤗"
      ],
      "pack_id": "daily_exclusive",
      "year": 2005
    },
    {
      "id": "dx_ella_enchanted",
      "title": "Ella Enchanted",
      "aliases": [],
      "emojis": [
        "👶",
        "🧚",
        "✨",
        "🙇‍♀️",
        "👸",
        "🤴",
        "🦹",
        "💪",
        "💍"
      ],
      "pack_id": "daily_exclusive",
      "year": 2004
    },
    {
      "id": "dx_rookie_of_the_year",
      "title": "Rookie of the Year",
      "aliases": [],
      "emojis": [
        "👦",
        "⚾",
        "🤕",
        "💪",
        "🚀",
        "🏟️",
        "😱",
        "🏆",
        "🎉"
      ],
      "pack_id": "daily_exclusive",
      "year": 1993
    },
    {
      "id": "dx_little_giants",
      "title": "Little Giants",
      "aliases": [],
      "emojis": [
        "🏈",
        "👧",
        "👦👦",
        "😤",
        "🆚",
        "👨",
        "🏟️",
        "🎉",
        "🏆"
      ],
      "pack_id": "daily_exclusive",
      "year": 1994
    },
    {
      "id": "dx_angels_in_the_outfield",
      "title": "Angels in the Outfield",
      "aliases": [],
      "emojis": [
        "👦",
        "⚾",
        "🙏",
        "👼",
        "✨",
        "🏆",
        "😇",
        "🤗",
        "🏠"
      ],
      "pack_id": "daily_exclusive",
      "year": 1994
    },
    {
      "id": "dx_the_pacifier",
      "title": "The Pacifier",
      "aliases": [],
      "emojis": [
        "🪖",
        "👨",
        "🏠",
        "👶👧👦",
        "😤",
        "🦆",
        "🥋",
        "🕺",
        "❤️"
      ],
      "pack_id": "daily_exclusive",
      "year": 2005
    },
    {
      "id": "dx_the_game_plan",
      "title": "The Game Plan",
      "aliases": [],
      "emojis": [
        "🏈",
        "💪",
        "🚪",
        "👧",
        "🩰",
        "😱",
        "🥞",
        "❤️",
        "🏆"
      ],
      "pack_id": "daily_exclusive",
      "year": 2007
    },
    {
      "id": "dx_bedtime_stories",
      "title": "Bedtime Stories",
      "aliases": [],
      "emojis": [
        "👨",
        "🛏️",
        "📖",
        "👧👦",
        "✨",
        "🌧️",
        "🍬",
        "🏨",
        "🌟"
      ],
      "pack_id": "daily_exclusive",
      "year": 2008
    },
    {
      "id": "dx_agent_cody_banks",
      "title": "Agent Cody Banks",
      "aliases": [],
      "emojis": [
        "👦",
        "🕵️",
        "🏫",
        "👧",
        "🧪",
        "🦹",
        "🛹",
        "💥",
        "😎"
      ],
      "pack_id": "daily_exclusive",
      "year": 2003
    },
    {
      "id": "dx_cats_dogs",
      "title": "Cats & Dogs",
      "aliases": [
        "Cats and Dogs"
      ],
      "emojis": [
        "🐱",
        "🆚",
        "🐶",
        "🕵️",
        "🧪",
        "🤧",
        "🌍",
        "💥",
        "🏆"
      ],
      "pack_id": "daily_exclusive",
      "year": 2001
    },
    {
      "id": "dx_snow_dogs",
      "title": "Snow Dogs",
      "aliases": [],
      "emojis": [
        "👨🏿‍⚕️",
        "🌴",
        "📜",
        "❄️",
        "🐶",
        "🐶",
        "😱",
        "🛷",
        "🏁"
      ],
      "pack_id": "daily_exclusive",
      "year": 2002
    },
    {
      "id": "dx_racing_stripes",
      "title": "Racing Stripes",
      "aliases": [],
      "emojis": [
        "🦓",
        "🚚",
        "🏠",
        "👧",
        "🐴",
        "😂",
        "🏇",
        "🏁",
        "🏆"
      ],
      "pack_id": "daily_exclusive",
      "year": 2005
    },
    {
      "id": "dx_dolphin_tale",
      "title": "Dolphin Tale",
      "aliases": [],
      "emojis": [
        "👦",
        "🐬",
        "🪢",
        "🤕",
        "🏥",
        "🔧",
        "🦾",
        "🏊",
        "🎉"
      ],
      "pack_id": "daily_exclusive",
      "year": 2011
    },
    {
      "id": "dx_soul_surfer",
      "title": "Soul Surfer",
      "aliases": [],
      "emojis": [
        "👧",
        "🏄",
        "🦈",
        "😱",
        "🏥",
        "💪",
        "🌊",
        "🙏",
        "🏆"
      ],
      "pack_id": "daily_exclusive",
      "year": 2011
    },
    {
      "id": "dx_eight_below",
      "title": "Eight Below",
      "aliases": [],
      "emojis": [
        "❄️",
        "🐶🐶",
        "👨",
        "🚁",
        "😢",
        "🐧",
        "🌨️",
        "🏃",
        "🤗"
      ],
      "pack_id": "daily_exclusive",
      "year": 2006
    },
    {
      "id": "dx_fly_away_home",
      "title": "Fly Away Home",
      "aliases": [],
      "emojis": [
        "👧",
        "💔",
        "🥚",
        "🦢",
        "🤱",
        "✈️",
        "🗺️",
        "🌅",
        "👋"
      ],
      "pack_id": "daily_exclusive",
      "year": 1996
    },
    {
      "id": "dx_because_of_winn_dixie",
      "title": "Because of Winn-Dixie",
      "aliases": [
        "Because of Winn Dixie"
      ],
      "emojis": [
        "👧",
        "🛒",
        "🐶",
        "🤝",
        "🏘️",
        "👵",
        "🎉",
        "⛈️",
        "❤️"
      ],
      "pack_id": "daily_exclusive",
      "year": 2005
    },
    {
      "id": "dx_nim_s_island",
      "title": "Nim's Island",
      "aliases": [
        "Nims Island"
      ],
      "emojis": [
        "🏝️",
        "👧",
        "🦎",
        "📚",
        "👩",
        "✈️",
        "🌊",
        "💪",
        "🤗"
      ],
      "pack_id": "daily_exclusive",
      "year": 2008
    },
    {
      "id": "dx_the_water_horse",
      "title": "The Water Horse",
      "aliases": [],
      "emojis": [
        "👦",
        "🥚",
        "🐉",
        "🌊",
        "🏰",
        "🪖",
        "😱",
        "💙",
        "👋"
      ],
      "pack_id": "daily_exclusive",
      "year": 2007
    },
    {
      "id": "aa_top_gun_maverick",
      "title": "Top Gun: Maverick",
      "aliases": [
        "Top Gun Maverick",
        "Top Gun 2",
        "Maverick",
        "Top Gun Two"
      ],
      "emojis": [
        "👨",
        "🏍️",
        "✈️",
        "🕶️",
        "🧑‍✈️",
        "🏔️",
        "🎯",
        "💥",
        "🛩️"
      ],
      "pack_id": "daily_exclusive",
      "year": 2022
    },
    {
      "id": "aa_mission_impossible",
      "title": "Mission: Impossible",
      "aliases": [
        "Mission Impossible"
      ],
      "emojis": [
        "🕵️",
        "🎭",
        "💀",
        "🚫",
        "🕴️",
        "💾",
        "🚄",
        "🚁",
        "💥"
      ],
      "pack_id": "daily_exclusive",
      "year": 1996
    },
    {
      "id": "rc_notebook",
      "title": "The Notebook",
      "aliases": [
        "Notebook"
      ],
      "emojis": [
        "👴",
        "📖",
        "🎡",
        "✉️",
        "🏠",
        "🛶",
        "🌧️",
        "💋",
        "🛏️"
      ],
      "pack_id": "daily_exclusive",
      "year": 2004
    },
    {
      "id": "spielberg_catch_me",
      "title": "Catch Me If You Can",
      "aliases": [],
      "emojis": [
        "✈️",
        "👨‍✈️",
        "💵",
        "✏️",
        "🚔",
        "💉",
        "💑"
      ],
      "pack_id": "daily_exclusive",
      "year": 2002
    },
    {
      "id": "hr_zombieland",
      "title": "Zombieland",
      "aliases": [],
      "emojis": [
        "🧟",
        "📋",
        "🤠",
        "🚗",
        "🍰",
        "🎬",
        "🎢",
        "🔫"
      ],
      "pack_id": "daily_exclusive",
      "year": 2009
    },
    {
      "id": "dc_v_vendetta",
      "title": "Watchmen",
      "aliases": [],
      "emojis": [
        "🙂",
        "🩸",
        "🪟",
        "💀",
        "🕵️",
        "🟦",
        "🔴",
        "🦉",
        "💥"
      ],
      "pack_id": "daily_exclusive",
      "year": 2009
    },
    {
      "id": "alt_sense_sensibility",
      "title": "Sense and Sensibility",
      "aliases": [],
      "emojis": [
        "👩",
        "👩",
        "🏡",
        "💸",
        "🐎",
        "🌧️",
        "🤒",
        "💔",
        "💒"
      ],
      "pack_id": "daily_exclusive",
      "year": 1995
    },
    {
      "id": "alt_seven_pounds",
      "title": "Seven Pounds",
      "aliases": [],
      "emojis": [
        "👨🏿",
        "📱",
        "🚗",
        "💥",
        "😢",
        "🫀",
        "💑",
        "🪼",
        "🛁"
      ],
      "pack_id": "daily_exclusive",
      "year": 2008
    },
    {
      "id": "sf_demolition_man",
      "title": "Demolition Man",
      "aliases": [],
      "emojis": [
        "❄️",
        "🔫",
        "🏙️",
        "🦋",
        "🐚",
        "💪"
      ],
      "pack_id": "daily_exclusive",
      "year": 1993
    },
    {
      "id": "ni_doubtfire",
      "title": "Mrs. Doubtfire",
      "aliases": [
        "Mrs Doubtfire"
      ],
      "emojis": [
        "👨",
        "💔",
        "🏴󠁧󠁢󠁳󠁣󠁴󠁿",
        "👵",
        "🧹",
        "🎂",
        "🔥",
        "🍽️",
        "😱"
      ],
      "pack_id": "daily_exclusive",
      "year": 1993
    },
    {
      "id": "an_snow_white",
      "title": "Snow White",
      "aliases": [
        "Snow White and the Seven Dwarfs"
      ],
      "emojis": [
        "👸",
        "🪞",
        "🧙‍♀️",
        "🏡",
        "⛏️",
        "🍎",
        "😴",
        "⚰️",
        "💋"
      ],
      "pack_id": "daily_exclusive",
      "year": 1937
    },
    {
      "id": "mi_bourne_identity",
      "title": "The Bourne Identity",
      "aliases": [
        "Bourne Identity"
      ],
      "emojis": [
        "🌊",
        "💉",
        "🧠",
        "🇨🇭",
        "🏦",
        "🛂",
        "🔫",
        "🖊️",
        "🚗"
      ],
      "pack_id": "daily_exclusive",
      "year": 2002
    },
    {
      "id": "mcu_spider_homecoming",
      "title": "Spider-Man: Homecoming",
      "aliases": [
        "Spider Man Homecoming"
      ],
      "emojis": [
        "🕷️",
        "🎓",
        "🦅",
        "🏫",
        "🚢",
        "🛗"
      ],
      "pack_id": "daily_exclusive",
      "year": 2017
    },
    {
      "id": "fam_polar_express",
      "title": "The Polar Express",
      "aliases": [],
      "emojis": [
        "🚂",
        "🎄",
        "🔔",
        "🎩",
        "☕",
        "🦌"
      ],
      "pack_id": "daily_exclusive",
      "year": 2004
    },
    {
      "id": "an_spiderverse",
      "title": "Spider-Man: Into the Spider-Verse",
      "aliases": [
        "Into the Spider-Verse",
        "Spiderverse"
      ],
      "emojis": [
        "🕷️",
        "🕸️",
        "👦🏾",
        "🌌",
        "🕷️",
        "🕷️",
        "🎨"
      ],
      "pack_id": "daily_exclusive",
      "year": 2018
    },
    {
      "id": "an_lego_movie",
      "title": "The Lego Movie",
      "aliases": [
        "Lego Movie"
      ],
      "emojis": [
        "🧱",
        "🟡",
        "🦇",
        "🚀",
        "✨",
        "💑"
      ],
      "pack_id": "daily_exclusive",
      "year": 2014
    },
    {
      "id": "sf_star_trek",
      "title": "Star Trek",
      "aliases": [],
      "emojis": [
        "🌌",
        "🚀",
        "🖖",
        "👨‍✈️",
        "👽",
        "💥",
        "🌟"
      ],
      "pack_id": "daily_exclusive",
      "year": 2009
    },
    {
      "id": "scorsese_shutter_island",
      "title": "Shutter Island",
      "aliases": [],
      "emojis": [
        "⛴️",
        "🏝️",
        "🏥",
        "🚬",
        "🌪️",
        "🔥",
        "🤯"
      ],
      "pack_id": "daily_exclusive",
      "year": 2010
    },
    {
      "id": "fam_charlie_factory",
      "title": "Charlie and the Chocolate Factory",
      "aliases": [
        "Charlie and the Chocolate Factory"
      ],
      "emojis": [
        "👦",
        "🍫",
        "🎟️",
        "👨",
        "🏭",
        "🐿️"
      ],
      "pack_id": "daily_exclusive",
      "year": 2005
    },
    {
      "id": "alt_to_kill_mockingbird",
      "title": "To Kill a Mockingbird",
      "aliases": [],
      "emojis": [
        "👧",
        "👨",
        "🌳",
        "🎁",
        "⚖️",
        "👨🏿",
        "💔",
        "🌙",
        "👤"
      ],
      "pack_id": "daily_exclusive",
      "year": 1962
    },
    {
      "id": "mcu_thor",
      "title": "Thor",
      "aliases": [],
      "emojis": [
        "⚡",
        "🔨",
        "🌈",
        "👴",
        "🏜️",
        "🤘"
      ],
      "pack_id": "daily_exclusive",
      "year": 2011
    },
    {
      "id": "aa_cap_first_avenger",
      "title": "Captain America: The First Avenger",
      "aliases": [
        "Captain America First Avenger"
      ],
      "emojis": [
        "👨",
        "💉",
        "💪",
        "🛡️",
        "🪖",
        "💧",
        "❄️"
      ],
      "pack_id": "daily_exclusive",
      "year": 2011
    },
    {
      "id": "aa_300",
      "title": "300",
      "aliases": [
        "Three Hundred"
      ],
      "emojis": [
        "👑",
        "🦵",
        "🕳️",
        "🛡️",
        "⚔️",
        "🐘",
        "🏹",
        "💀"
      ],
      "pack_id": "daily_exclusive",
      "year": 2006
    },
    {
      "id": "an_despicable_me",
      "title": "Despicable Me",
      "aliases": [],
      "emojis": [
        "🌙",
        "🥷",
        "🟡",
        "👧",
        "💔",
        "🎢"
      ],
      "pack_id": "daily_exclusive",
      "year": 2010
    },
    {
      "id": "alt_ben_hur",
      "title": "Ben-Hur",
      "aliases": [
        "Ben Hur"
      ],
      "emojis": [
        "🤴",
        "⛓️",
        "🚣",
        "⚓",
        "🐎",
        "🐎",
        "🏆",
        "✝️"
      ],
      "pack_id": "daily_exclusive",
      "year": 1959
    },
    {
      "id": "the_mask",
      "title": "The Mask",
      "aliases": [],
      "emojis": [
        "👨",
        "🏦",
        "🌉",
        "🎭",
        "🟢",
        "🌀",
        "💃",
        "🐶"
      ],
      "pack_id": "daily_exclusive",
      "year": 1994
    },
    {
      "id": "spielberg_lincoln",
      "title": "Lincoln",
      "aliases": [],
      "emojis": [
        "🎩",
        "🇺🇸",
        "⚔️",
        "🏛️",
        "✊",
        "🪦"
      ],
      "pack_id": "daily_exclusive",
      "year": 2012
    },
    {
      "id": "mcu_deadpool",
      "title": "Deadpool",
      "aliases": [],
      "emojis": [
        "🗡️",
        "🔴",
        "🤡",
        "💉",
        "🚕",
        "🍔",
        "💔"
      ],
      "pack_id": "daily_exclusive",
      "year": 2016
    },
    {
      "id": "scorsese_irishman",
      "title": "The Irishman",
      "aliases": [],
      "emojis": [
        "🤵",
        "🔫",
        "🐟",
        "🚚",
        "🎩",
        "🪦"
      ],
      "pack_id": "daily_exclusive",
      "year": 2019
    },
    {
      "id": "alt_my_fair_lady",
      "title": "My Fair Lady",
      "aliases": [],
      "emojis": [
        "🌹",
        "👩",
        "🎩",
        "🗣️",
        "☔",
        "🐎",
        "👑",
        "💃"
      ],
      "pack_id": "daily_exclusive",
      "year": 1964
    },
    {
      "id": "mcu_doctor_strange",
      "title": "Doctor Strange",
      "aliases": [],
      "emojis": [
        "🚗",
        "💥",
        "🙌",
        "🌀",
        "🪄",
        "🇳🇵",
        "👁️"
      ],
      "pack_id": "daily_exclusive",
      "year": 2016
    },
    {
      "id": "scorsese_age_innocence",
      "title": "The Age of Innocence",
      "aliases": [],
      "emojis": [
        "🗽",
        "🎭",
        "🤵",
        "💍",
        "👰",
        "💘",
        "👩",
        "🤐",
        "💔"
      ],
      "pack_id": "daily_exclusive",
      "year": 1993
    },
    {
      "id": "he_inception",
      "title": "Inception",
      "aliases": [],
      "emojis": [
        "💤",
        "💼",
        "🏙️",
        "🔃",
        "🚐",
        "🏨",
        "🌀",
        "❄️",
        "🪀"
      ],
      "pack_id": "daily_exclusive",
      "year": 2010
    },
    {
      "id": "an_incredibles",
      "title": "The Incredibles",
      "aliases": [
        "Incredibles"
      ],
      "emojis": [
        "💪",
        "🦸",
        "😩",
        "🏝️",
        "🦹",
        "🚫",
        "🧥",
        "👨‍👩‍👧‍👦",
        "👶"
      ],
      "pack_id": "daily_exclusive",
      "year": 2004
    },
    {
      "id": "an_soul",
      "title": "Soul",
      "aliases": [],
      "emojis": [
        "👨🏿",
        "🎹",
        "🎷",
        "🕳️",
        "💀",
        "🌌",
        "🐱",
        "🎶",
        "🍂"
      ],
      "pack_id": "daily_exclusive",
      "year": 2020
    },
    {
      "id": "an_encanto",
      "title": "Encanto",
      "aliases": [],
      "emojis": [
        "🇨🇴",
        "🕯️",
        "🏠",
        "🚪",
        "✨",
        "💥",
        "🤫",
        "🔮",
        "🦋"
      ],
      "pack_id": "daily_exclusive",
      "year": 2021
    },
    {
      "id": "an_lilo_stitch",
      "title": "Lilo & Stitch",
      "aliases": [
        "Lilo and Stitch"
      ],
      "emojis": [
        "👽",
        "🛸",
        "🏝️",
        "👧🏽",
        "🐕",
        "🎸",
        "🏄",
        "👨‍👩‍👧",
        "🤙🏽"
      ],
      "pack_id": "daily_exclusive",
      "year": 2002
    },
    {
      "id": "ni_schindlers_list",
      "title": "Schindler's List",
      "aliases": [
        "Schindlers List"
      ],
      "emojis": [
        "🕯️",
        "🏭",
        "✡️",
        "🔴",
        "🧥",
        "📋",
        "🚂",
        "💍",
        "😢"
      ],
      "pack_id": "daily_exclusive",
      "year": 1993
    },
    {
      "id": "ni_romeo_juliet",
      "title": "Romeo + Juliet",
      "aliases": [
        "Romeo and Juliet"
      ],
      "emojis": [
        "⛽",
        "🔫",
        "🎭",
        "🐠",
        "💒",
        "🏖️",
        "💊",
        "💀"
      ],
      "pack_id": "daily_exclusive",
      "year": 1996
    },
    {
      "id": "ni_trainspotting",
      "title": "Trainspotting",
      "aliases": [],
      "emojis": [
        "🏴󠁧󠁢󠁳󠁣󠁴󠁿",
        "🏃",
        "💉",
        "🚽",
        "👶",
        "💀",
        "💼",
        "💷"
      ],
      "pack_id": "daily_exclusive",
      "year": 1996
    },
    {
      "id": "ni_heat",
      "title": "Heat",
      "aliases": [],
      "emojis": [
        "🚚",
        "💥",
        "☕",
        "🏦",
        "🔫",
        "✈️",
        "🤝"
      ],
      "pack_id": "daily_exclusive",
      "year": 1995
    },
    {
      "id": "ni_apollo_13",
      "title": "Apollo 13",
      "aliases": [
        "Apollo Thirteen"
      ],
      "emojis": [
        "🚀",
        "💥",
        "🆘",
        "🌕",
        "❄️",
        "🔥",
        "🪂",
        "🌊"
      ],
      "pack_id": "daily_exclusive",
      "year": 1995
    },
    {
      "id": "mi_departed",
      "title": "The Departed",
      "aliases": [
        "Departed"
      ],
      "emojis": [
        "👮",
        "🕵️",
        "☘️",
        "📱",
        "🏢",
        "🛗",
        "🔫",
        "🐀"
      ],
      "pack_id": "daily_exclusive",
      "year": 2006
    },
    {
      "id": "mi_devil_wears_prada",
      "title": "The Devil Wears Prada",
      "aliases": [
        "Devil Wears Prada"
      ],
      "emojis": [
        "👩",
        "☕",
        "👠",
        "👗",
        "📚",
        "🇫🇷",
        "📱",
        "⛲",
        "📰"
      ],
      "pack_id": "daily_exclusive",
      "year": 2006
    },
    {
      "id": "th_gone_girl",
      "title": "Gone Girl",
      "aliases": [],
      "emojis": [
        "💍",
        "🏠",
        "🔍",
        "📓",
        "📺",
        "✂️",
        "🩸",
        "🤰"
      ],
      "pack_id": "daily_exclusive",
      "year": 2014
    },
    {
      "id": "an_monsters_inc",
      "title": "Monsters Inc.",
      "aliases": [
        "Monsters Inc",
        "Monsters Incorporated"
      ],
      "emojis": [
        "👹",
        "👁️",
        "🏭",
        "😱",
        "⚡",
        "👧",
        "🚪",
        "🚪",
        "😂"
      ],
      "pack_id": "daily_exclusive",
      "year": 2001
    },
    {
      "id": "aa_casino_royale",
      "title": "Casino Royale",
      "aliases": [],
      "emojis": [
        "🤵",
        "🃏",
        "🍸",
        "⚡",
        "🪑",
        "💘",
        "🌊",
        "💔"
      ],
      "pack_id": "daily_exclusive",
      "year": 2006
    },
    {
      "id": "dumb_dumber",
      "title": "Dumb and Dumber",
      "aliases": [],
      "emojis": [
        "👨",
        "👨",
        "💼",
        "🐕",
        "🚐",
        "🏔️",
        "💸",
        "👱‍♀️"
      ],
      "pack_id": "daily_exclusive",
      "year": 1994
    },
    {
      "id": "spielberg_color_purple",
      "title": "The Color Purple",
      "aliases": [],
      "emojis": [
        "💜",
        "✉️",
        "👩🏿",
        "🌾",
        "🎶",
        "👨🏿‍👩🏿‍👧🏿"
      ],
      "pack_id": "daily_exclusive",
      "year": 1985
    },
    {
      "id": "spielberg_amistad",
      "title": "Amistad",
      "aliases": [],
      "emojis": [
        "⛓️",
        "⚓",
        "⚖️",
        "🇺🇸",
        "👨🏿",
        "🦅"
      ],
      "pack_id": "daily_exclusive",
      "year": 1997
    },
    {
      "id": "spielberg_a_i",
      "title": "A.I. Artificial Intelligence",
      "aliases": [
        "AI Artificial Intelligence"
      ],
      "emojis": [
        "🤖",
        "👶",
        "🧚",
        "🌊",
        "🧊",
        "💙"
      ],
      "pack_id": "daily_exclusive",
      "year": 2001
    },
    {
      "id": "wa_royal_tenenbaums",
      "title": "The Royal Tenenbaums",
      "aliases": [],
      "emojis": [
        "🎾",
        "🦅",
        "🚬",
        "✏️",
        "👴",
        "🐀",
        "🚕"
      ],
      "pack_id": "daily_exclusive",
      "year": 2001
    },
    {
      "id": "dis_alice_wonderland",
      "title": "Alice in Wonderland",
      "aliases": [],
      "emojis": [
        "👧",
        "🐇",
        "🍵",
        "🃏",
        "😺",
        "🌹"
      ],
      "pack_id": "daily_exclusive",
      "year": 1951
    },
    {
      "id": "sp_sandlot",
      "title": "The Sandlot",
      "aliases": [],
      "emojis": [
        "⚾",
        "🐕",
        "👦",
        "🍔",
        "🚲",
        "🌳"
      ],
      "pack_id": "daily_exclusive",
      "year": 1993
    },
    {
      "id": "sp_million_dollar_baby",
      "title": "Million Dollar Baby",
      "aliases": [],
      "emojis": [
        "🥊",
        "👴",
        "👩",
        "🪦",
        "💉",
        "💔"
      ],
      "pack_id": "daily_exclusive",
      "year": 2004
    },
    {
      "id": "fam_matilda",
      "title": "Matilda",
      "aliases": [],
      "emojis": [
        "👧",
        "📚",
        "🎂",
        "🧙‍♀️",
        "🥄",
        "🏫"
      ],
      "pack_id": "daily_exclusive",
      "year": 1996
    },
    {
      "id": "alt_american_sniper",
      "title": "American Sniper",
      "aliases": [],
      "emojis": [
        "🎯",
        "🇺🇸",
        "🪖",
        "👨",
        "🍼",
        "🌅"
      ],
      "pack_id": "daily_exclusive",
      "year": 2014
    },
    {
      "id": "alt_unforgiven",
      "title": "Unforgiven",
      "aliases": [],
      "emojis": [
        "🐷",
        "🤠",
        "👩",
        "🔪",
        "💰",
        "🤕",
        "🍺",
        "⛈️",
        "🔫"
      ],
      "pack_id": "daily_exclusive",
      "year": 1992
    },
    {
      "id": "alt_roman_holiday",
      "title": "Roman Holiday",
      "aliases": [],
      "emojis": [
        "👸",
        "🇮🇹",
        "🛵",
        "🍦",
        "📰",
        "💔"
      ],
      "pack_id": "daily_exclusive",
      "year": 1953
    },
    {
      "id": "alt_life_pi",
      "title": "Life of Pi",
      "aliases": [],
      "emojis": [
        "🐯",
        "⛵",
        "🌊",
        "🌈",
        "🇮🇳",
        "🐠"
      ],
      "pack_id": "daily_exclusive",
      "year": 2012
    },
    {
      "id": "alt_little_women_2019",
      "title": "Little Women",
      "aliases": [
        "Little Women"
      ],
      "emojis": [
        "👩",
        "👩",
        "👩",
        "👩",
        "✍️",
        "🎹",
        "🤒",
        "💔",
        "📖"
      ],
      "pack_id": "daily_exclusive",
      "year": 2019
    },
    {
      "id": "ns_lucy",
      "title": "Lucy",
      "aliases": [],
      "emojis": [
        "💊",
        "🧠",
        "💯",
        "✈️",
        "💻",
        "🌌"
      ],
      "pack_id": "daily_exclusive",
      "year": 2014
    },
    {
      "id": "mi_django",
      "title": "Django Unchained",
      "aliases": [],
      "emojis": [
        "⛓️",
        "👨🏿",
        "🔫",
        "💰",
        "👩🏿",
        "💥",
        "🏠",
        "🩸"
      ],
      "pack_id": "daily_exclusive",
      "year": 2012
    },
    {
      "id": "aa_batman_2022",
      "title": "The Batman",
      "aliases": [
        "Batman 2022",
        "The Batman 2022"
      ],
      "emojis": [
        "🦇",
        "🌧️",
        "🌃",
        "❓",
        "🎭",
        "🔍",
        "🚓"
      ],
      "pack_id": "daily_exclusive",
      "year": 2022
    },
    {
      "id": "ace_ventura",
      "title": "Ace Ventura: Pet Detective",
      "aliases": [
        "Ace Ventura"
      ],
      "emojis": [
        "🕵️",
        "🐬",
        "🦈",
        "🦅",
        "🏈",
        "🐧"
      ],
      "pack_id": "daily_exclusive",
      "year": 1994
    },
    {
      "id": "spielberg_ready_player",
      "title": "Ready Player One",
      "aliases": [],
      "emojis": [
        "🕶️",
        "🌳",
        "🎮",
        "🥚",
        "🚗",
        "🤖",
        "🌐"
      ],
      "pack_id": "daily_exclusive",
      "year": 2018
    },
    {
      "id": "wa_life_aquatic",
      "title": "The Life Aquatic with Steve Zissou",
      "aliases": [
        "Life Aquatic"
      ],
      "emojis": [
        "🦈",
        "🚢",
        "🐠",
        "🤿",
        "🔴",
        "🎶"
      ],
      "pack_id": "daily_exclusive",
      "year": 2004
    },
    {
      "id": "scorsese_flower_moon",
      "title": "Killers of the Flower Moon",
      "aliases": [],
      "emojis": [
        "🛢️",
        "🌹",
        "🌙",
        "💀",
        "🇺🇸",
        "🪙",
        "🩸"
      ],
      "pack_id": "daily_exclusive",
      "year": 2023
    },
    {
      "id": "mcu_captain_marvel",
      "title": "Captain Marvel",
      "aliases": [],
      "emojis": [
        "👩",
        "🌌",
        "💥",
        "📼",
        "👨🏿",
        "🐱",
        "✈️",
        "👽",
        "🔥"
      ],
      "pack_id": "daily_exclusive",
      "year": 2019
    },
    {
      "id": "dc_aquaman",
      "title": "Aquaman",
      "aliases": [],
      "emojis": [
        "🟦",
        "🔱",
        "🐟",
        "👑",
        "🌊",
        "🐙",
        "💎"
      ],
      "pack_id": "daily_exclusive",
      "year": 2018
    },
    {
      "id": "talladega",
      "title": "Talladega Nights",
      "aliases": [],
      "emojis": [
        "🏎️",
        "🇺🇸",
        "🏆",
        "💥",
        "😱",
        "🇫🇷",
        "🐆",
        "🏁"
      ],
      "pack_id": "daily_exclusive",
      "year": 2006
    },
    {
      "id": "50_first_dates",
      "title": "50 First Dates",
      "aliases": [
        "Fifty First Dates"
      ],
      "emojis": [
        "🌺",
        "👨",
        "👩",
        "🥞",
        "💘",
        "🧠",
        "🔁",
        "📼",
        "⛵"
      ],
      "pack_id": "daily_exclusive",
      "year": 2004
    },
    {
      "id": "qt_hateful_eight",
      "title": "The Hateful Eight",
      "aliases": [],
      "emojis": [
        "❄️",
        "🐎",
        "⛓️",
        "🛖",
        "☕",
        "☠️",
        "🔫",
        "🩸"
      ],
      "pack_id": "daily_exclusive",
      "year": 2015
    },
    {
      "id": "spielberg_war_horse",
      "title": "War Horse",
      "aliases": [],
      "emojis": [
        "🐎",
        "🌾",
        "🪖",
        "🇬🇧",
        "🚜",
        "🌅"
      ],
      "pack_id": "daily_exclusive",
      "year": 2011
    },
    {
      "id": "wa_isle_dogs",
      "title": "Isle of Dogs",
      "aliases": [],
      "emojis": [
        "🐕",
        "🏝️",
        "🇯🇵",
        "👦",
        "🗑️",
        "🐶"
      ],
      "pack_id": "daily_exclusive",
      "year": 2018
    },
    {
      "id": "dis_101_dalmatians",
      "title": "101 Dalmatians",
      "aliases": [
        "One Hundred and One Dalmatians",
        "One Hundred One Dalmatians"
      ],
      "emojis": [
        "🐶",
        "🐶",
        "🐶",
        "🧥",
        "👤",
        "🚗"
      ],
      "pack_id": "daily_exclusive",
      "year": 1961
    },
    {
      "id": "com_bruce_almighty",
      "title": "Bruce Almighty",
      "aliases": [],
      "emojis": [
        "⚡",
        "🙏",
        "📰",
        "💑",
        "🌙",
        "🐶"
      ],
      "pack_id": "daily_exclusive",
      "year": 2003
    },
    {
      "id": "alt_shakespeare_love",
      "title": "Shakespeare in Love",
      "aliases": [],
      "emojis": [
        "✍️",
        "🌹",
        "🎭",
        "💑",
        "🇬🇧",
        "💔"
      ],
      "pack_id": "daily_exclusive",
      "year": 1998
    },
    {
      "id": "alt_green_book",
      "title": "Green Book",
      "aliases": [],
      "emojis": [
        "🚗",
        "🎹",
        "🍗",
        "👨🏿",
        "🇺🇸",
        "🤝"
      ],
      "pack_id": "daily_exclusive",
      "year": 2018
    },
    {
      "id": "alt_steel_magnolias",
      "title": "Steel Magnolias",
      "aliases": [],
      "emojis": [
        "💇‍♀️",
        "👰",
        "🎂",
        "💉",
        "🤰",
        "👶",
        "🏥",
        "⚰️",
        "😢"
      ],
      "pack_id": "daily_exclusive",
      "year": 1989
    },
    {
      "id": "sf_dune",
      "title": "Dune",
      "aliases": [],
      "emojis": [
        "🤚",
        "📦",
        "🏜️",
        "✨",
        "🪱",
        "🔥",
        "🔵",
        "⚔️"
      ],
      "pack_id": "daily_exclusive",
      "year": 2021
    },
    {
      "id": "rc_youve_got_mail",
      "title": "You've Got Mail",
      "aliases": [
        "Youve Got Mail"
      ],
      "emojis": [
        "📧",
        "💻",
        "📚",
        "🏬",
        "🌹",
        "😢",
        "🌼",
        "🐶",
        "💑"
      ],
      "pack_id": "daily_exclusive",
      "year": 1998
    },
    {
      "id": "rc_crazy_rich",
      "title": "Crazy Rich Asians",
      "aliases": [],
      "emojis": [
        "✈️",
        "🇸🇬",
        "💰",
        "💍",
        "👨‍👩‍👧‍👦",
        "🥟",
        "🐠",
        "💑"
      ],
      "pack_id": "daily_exclusive",
      "year": 2018
    },
    {
      "id": "rc_bridesmaids",
      "title": "Bridesmaids",
      "aliases": [],
      "emojis": [
        "💍",
        "👰",
        "👯‍♀️",
        "🍰",
        "🤢",
        "✈️",
        "💉",
        "💑"
      ],
      "pack_id": "daily_exclusive",
      "year": 2011
    },
    {
      "id": "aa_lethal_weapon",
      "title": "Lethal Weapon",
      "aliases": [],
      "emojis": [
        "👮‍♂️",
        "👮🏿‍♂️",
        "🤝",
        "🎄",
        "🔫",
        "🚗",
        "💥",
        "😂"
      ],
      "pack_id": "daily_exclusive",
      "year": 1987
    },
    {
      "id": "aa_casino",
      "title": "Casino",
      "aliases": [],
      "emojis": [
        "🎰",
        "🏜️",
        "💰",
        "🤵",
        "🔫",
        "💎",
        "💥",
        "🚗"
      ],
      "pack_id": "daily_exclusive",
      "year": 1995
    },
    {
      "id": "mc_revenant",
      "title": "The Revenant",
      "aliases": [
        "Revenant"
      ],
      "emojis": [
        "🏔️",
        "🐻",
        "🩸",
        "❄️",
        "🐴",
        "🔪",
        "🪦",
        "🏃",
        "🌅"
      ],
      "pack_id": "daily_exclusive",
      "year": 2015
    },
    {
      "id": "coen_true_grit",
      "title": "True Grit",
      "aliases": [],
      "emojis": [
        "🤠",
        "👧",
        "🐎",
        "🐍",
        "🌟",
        "⚔️"
      ],
      "pack_id": "daily_exclusive",
      "year": 2010
    },
    {
      "id": "fincher_panic_room",
      "title": "Panic Room",
      "aliases": [],
      "emojis": [
        "🏠",
        "👩",
        "👧",
        "🔒",
        "🔦",
        "🩸"
      ],
      "pack_id": "daily_exclusive",
      "year": 2002
    },
    {
      "id": "spielberg_post",
      "title": "The Post",
      "aliases": [],
      "emojis": [
        "📰",
        "🪖",
        "🇻🇳",
        "👩",
        "📞",
        "🇺🇸"
      ],
      "pack_id": "daily_exclusive",
      "year": 2017
    },
    {
      "id": "scorsese_aviator",
      "title": "The Aviator",
      "aliases": [],
      "emojis": [
        "✈️",
        "💰",
        "🎬",
        "💔",
        "🧼",
        "👻"
      ],
      "pack_id": "daily_exclusive",
      "year": 2004
    },
    {
      "id": "dis_peter_pan",
      "title": "Peter Pan",
      "aliases": [],
      "emojis": [
        "🧚",
        "👦",
        "🏝️",
        "🐊",
        "🪝",
        "🌟",
        "☁️"
      ],
      "pack_id": "daily_exclusive",
      "year": 1953
    },
    {
      "id": "heist_inside_man",
      "title": "Inside Man",
      "aliases": [],
      "emojis": [
        "🏦",
        "🎭",
        "👨‍💼",
        "👮🏿",
        "💎",
        "🤐"
      ],
      "pack_id": "daily_exclusive",
      "year": 2006
    },
    {
      "id": "fam_jumanji",
      "title": "Jumanji",
      "aliases": [],
      "emojis": [
        "🎲",
        "🥁",
        "👦",
        "🌀",
        "👨",
        "🦁",
        "🦏",
        "🐒",
        "🏚️"
      ],
      "pack_id": "daily_exclusive",
      "year": 1995
    },
    {
      "id": "alt_platoon",
      "title": "Platoon",
      "aliases": [],
      "emojis": [
        "👦",
        "🪖",
        "🇻🇳",
        "😇",
        "😈",
        "🔥",
        "🙌",
        "🔫"
      ],
      "pack_id": "daily_exclusive",
      "year": 1986
    },
    {
      "id": "alt_butch_cassidy",
      "title": "Butch Cassidy and the Sundance Kid",
      "aliases": [],
      "emojis": [
        "🤠",
        "🤠",
        "🚂",
        "💰",
        "🇧🇴",
        "💥"
      ],
      "pack_id": "daily_exclusive",
      "year": 1969
    },
    {
      "id": "ns_click",
      "title": "Click",
      "aliases": [],
      "emojis": [
        "🕹️",
        "⏩",
        "👨",
        "👨‍👩‍👧‍👦",
        "😢",
        "⏰"
      ],
      "pack_id": "daily_exclusive",
      "year": 2006
    },
    {
      "id": "mc_social_network",
      "title": "The Social Network",
      "aliases": [
        "Social Network"
      ],
      "emojis": [
        "💻",
        "🎓",
        "💔",
        "👨",
        "👬",
        "🚣",
        "💰",
        "⚖️",
        "🌐"
      ],
      "pack_id": "daily_exclusive",
      "year": 2010
    },
    {
      "id": "mi_v_vendetta",
      "title": "V for Vendetta",
      "aliases": [],
      "emojis": [
        "🎭",
        "💥",
        "🇬🇧",
        "🏛️",
        "📺",
        "🌹",
        "🔥"
      ],
      "pack_id": "daily_exclusive",
      "year": 2005
    },
    {
      "id": "bond_dr_no",
      "title": "Dr. No",
      "aliases": [
        "Doctor No"
      ],
      "emojis": [
        "🤵",
        "🇯🇲",
        "🕷️",
        "🏝️",
        "👙",
        "🐚",
        "🦾",
        "☢️",
        "💥"
      ],
      "pack_id": "daily_exclusive",
      "year": 1962
    },
    {
      "id": "waterboy",
      "title": "The Waterboy",
      "aliases": [],
      "emojis": [
        "💧",
        "🏈",
        "👨‍🦱",
        "👵",
        "🐍",
        "🏆"
      ],
      "pack_id": "daily_exclusive",
      "year": 1998
    },
    {
      "id": "spielberg_minority_report",
      "title": "Minority Report",
      "aliases": [],
      "emojis": [
        "👁️",
        "🚓",
        "💊",
        "🏃",
        "🌐",
        "🤖"
      ],
      "pack_id": "daily_exclusive",
      "year": 2002
    },
    {
      "id": "alt_8_mile",
      "title": "8 Mile",
      "aliases": [
        "Eight Mile"
      ],
      "emojis": [
        "🎤",
        "🚗",
        "🏭",
        "✊",
        "💔",
        "🚌"
      ],
      "pack_id": "daily_exclusive",
      "year": 2002
    },
    {
      "id": "alt_the_rock",
      "title": "The Rock",
      "aliases": [],
      "emojis": [
        "🪨",
        "🏝️",
        "💣",
        "🇺🇸",
        "🪖",
        "💉"
      ],
      "pack_id": "daily_exclusive",
      "year": 1996
    },
    {
      "id": "mi_slumdog",
      "title": "Slumdog Millionaire",
      "aliases": [],
      "emojis": [
        "🇮🇳",
        "🧒🏾",
        "💩",
        "📺",
        "❓",
        "📞",
        "💰",
        "💑",
        "💃🏾"
      ],
      "pack_id": "daily_exclusive",
      "year": 2008
    },
    {
      "id": "mi_1917",
      "title": "1917",
      "aliases": [
        "Nineteen Seventeen"
      ],
      "emojis": [
        "🪖",
        "🌅",
        "🏞️",
        "🐀",
        "🚪",
        "💌",
        "💥",
        "🌅"
      ],
      "pack_id": "daily_exclusive",
      "year": 2019
    },
    {
      "id": "spielberg_terminal",
      "title": "The Terminal",
      "aliases": [],
      "emojis": [
        "✈️",
        "🛂",
        "🇺🇸",
        "🥫",
        "💑",
        "👤"
      ],
      "pack_id": "daily_exclusive",
      "year": 2004
    },
    {
      "id": "an_beauty_and_beast",
      "title": "Beauty and the Beast",
      "aliases": [],
      "emojis": [
        "👩",
        "📚",
        "🏰",
        "🌹",
        "🕯️",
        "🍽️",
        "💃",
        "🥀",
        "🤴"
      ],
      "pack_id": "daily_exclusive",
      "year": 1991
    },
    {
      "id": "sp_league_their_own",
      "title": "A League of Their Own",
      "aliases": [],
      "emojis": [
        "⚾",
        "👩",
        "🪖",
        "👨",
        "🎤",
        "🏆"
      ],
      "pack_id": "daily_exclusive",
      "year": 1992
    },
    {
      "id": "sp_blind_side",
      "title": "The Blind Side",
      "aliases": [],
      "emojis": [
        "🏈",
        "👨🏿",
        "👨‍👩‍👧",
        "🏠",
        "🏫",
        "💞"
      ],
      "pack_id": "daily_exclusive",
      "year": 2009
    },
    {
      "id": "sp_miracle",
      "title": "Miracle",
      "aliases": [],
      "emojis": [
        "🏒",
        "🇺🇸",
        "🇷🇺",
        "🏆",
        "🥶",
        "🎉"
      ],
      "pack_id": "daily_exclusive",
      "year": 2004
    },
    {
      "id": "alt_napoleon",
      "title": "Napoleon",
      "aliases": [],
      "emojis": [
        "👑",
        "🇫🇷",
        "🐎",
        "⚔️",
        "💑",
        "🇷🇺"
      ],
      "pack_id": "daily_exclusive",
      "year": 2023
    },
    {
      "id": "alt_dirty_dozen",
      "title": "The Dirty Dozen",
      "aliases": [],
      "emojis": [
        "⛓️",
        "🪖",
        "🎖️",
        "🪂",
        "🇩🇪",
        "🏰",
        "⛽",
        "💥"
      ],
      "pack_id": "daily_exclusive",
      "year": 1967
    },
    {
      "id": "mi_anchorman",
      "title": "Anchorman",
      "aliases": [],
      "emojis": [
        "📺",
        "🥃",
        "👩",
        "🪈",
        "🔱",
        "🌯",
        "🐶",
        "🐻"
      ],
      "pack_id": "daily_exclusive",
      "year": 2004
    },
    {
      "id": "rc_princess_diaries",
      "title": "The Princess Diaries",
      "aliases": [
        "Princess Diaries"
      ],
      "emojis": [
        "👧",
        "🪞",
        "👵",
        "👸",
        "🌷",
        "🏰",
        "✏️",
        "💑"
      ],
      "pack_id": "daily_exclusive",
      "year": 2001
    },
    {
      "id": "rc_knocked_up",
      "title": "Knocked Up",
      "aliases": [],
      "emojis": [
        "🍻",
        "🪩",
        "💑",
        "🛏️",
        "🤰",
        "👶",
        "💔",
        "💑"
      ],
      "pack_id": "daily_exclusive",
      "year": 2007
    },
    {
      "id": "mi_beautiful_mind",
      "title": "A Beautiful Mind",
      "aliases": [
        "Beautiful Mind"
      ],
      "emojis": [
        "🧮",
        "👨",
        "🧠",
        "😱",
        "👻",
        "📚",
        "🏆",
        "💑"
      ],
      "pack_id": "daily_exclusive",
      "year": 2001
    },
    {
      "id": "an_wreck_ralph",
      "title": "Wreck-It Ralph",
      "aliases": [
        "Wreck It Ralph"
      ],
      "emojis": [
        "🎮",
        "👨‍🦰",
        "😢",
        "🍭",
        "🚗",
        "🦸",
        "🤝"
      ],
      "pack_id": "daily_exclusive",
      "year": 2012
    },
    {
      "id": "mcu_ant_man",
      "title": "Ant-Man",
      "aliases": [
        "Ant Man"
      ],
      "emojis": [
        "🔓",
        "🥷",
        "🛁",
        "🐜",
        "👴",
        "🐝",
        "🚂",
        "👧"
      ],
      "pack_id": "daily_exclusive",
      "year": 2015
    },
    {
      "id": "creed_1",
      "title": "Creed",
      "aliases": [],
      "emojis": [
        "🥊",
        "👨🏿",
        "👴",
        "💪",
        "🏆",
        "💔"
      ],
      "pack_id": "daily_exclusive",
      "year": 2015
    },
    {
      "id": "the_holiday",
      "title": "The Holiday",
      "aliases": [],
      "emojis": [
        "🇬🇧",
        "🇺🇸",
        "🏠",
        "🔄",
        "🎄",
        "💑"
      ],
      "pack_id": "daily_exclusive",
      "year": 2006
    },
    {
      "id": "spielberg_bridge_spies",
      "title": "Bridge of Spies",
      "aliases": [],
      "emojis": [
        "🤝",
        "🇩🇪",
        "🪖",
        "✈️",
        "🌉",
        "💼"
      ],
      "pack_id": "daily_exclusive",
      "year": 2015
    },
    {
      "id": "pix_good_dino",
      "title": "The Good Dinosaur",
      "aliases": [],
      "emojis": [
        "🦕",
        "🌧️",
        "👶",
        "🦂",
        "💔",
        "🏞️"
      ],
      "pack_id": "daily_exclusive",
      "year": 2015
    },
    {
      "id": "rc_crazy_stupid",
      "title": "Crazy, Stupid, Love",
      "aliases": [
        "Crazy Stupid Love"
      ],
      "emojis": [
        "💔",
        "🍸",
        "🤵",
        "🛍️",
        "💪",
        "😍",
        "🤸",
        "😱",
        "💑"
      ],
      "pack_id": "daily_exclusive",
      "year": 2011
    },
    {
      "id": "rc_silver_linings",
      "title": "Silver Linings Playbook",
      "aliases": [],
      "emojis": [
        "🧠",
        "💃",
        "🏈",
        "💔",
        "💑",
        "🥡"
      ],
      "pack_id": "daily_exclusive",
      "year": 2012
    },
    {
      "id": "rc_fault_stars",
      "title": "The Fault in Our Stars",
      "aliases": [
        "Fault in Our Stars"
      ],
      "emojis": [
        "⭐",
        "💔",
        "🇳🇱",
        "✈️",
        "💑",
        "🚬"
      ],
      "pack_id": "daily_exclusive",
      "year": 2014
    },
    {
      "id": "rc_to_all_boys",
      "title": "To All the Boys I've Loved Before",
      "aliases": [
        "To All the Boys"
      ],
      "emojis": [
        "💌",
        "💌",
        "💌",
        "🥢",
        "🏫",
        "💑"
      ],
      "pack_id": "daily_exclusive",
      "year": 2018
    },
    {
      "id": "sp_rudy",
      "title": "Rudy",
      "aliases": [],
      "emojis": [
        "👦",
        "🏭",
        "☘️",
        "📚",
        "🏈",
        "💪",
        "🙌"
      ],
      "pack_id": "daily_exclusive",
      "year": 1993
    },
    {
      "id": "bio_amadeus",
      "title": "Amadeus",
      "aliases": [],
      "emojis": [
        "🎼",
        "🎻",
        "👤",
        "✝️",
        "🎭",
        "💀"
      ],
      "pack_id": "daily_exclusive",
      "year": 1984
    },
    {
      "id": "act_bad_boys",
      "title": "Bad Boys",
      "aliases": [],
      "emojis": [
        "🚓",
        "👨🏿‍🤝‍👨🏿",
        "🇺🇸",
        "💉",
        "🌴",
        "🔫"
      ],
      "pack_id": "daily_exclusive",
      "year": 1995
    },
    {
      "id": "sf_5th_element",
      "title": "The Fifth Element",
      "aliases": [],
      "emojis": [
        "🚖",
        "👩‍🦰",
        "🪨",
        "🎤",
        "👽",
        "🛳️",
        "💥",
        "❤️"
      ],
      "pack_id": "daily_exclusive",
      "year": 1997
    },
    {
      "id": "com_hot_fuzz",
      "title": "Hot Fuzz",
      "aliases": [],
      "emojis": [
        "🚓",
        "🇬🇧",
        "🏘️",
        "🦢",
        "🔫",
        "🍦"
      ],
      "pack_id": "daily_exclusive",
      "year": 2007
    },
    {
      "id": "fam_chronicles_narnia",
      "title": "The Chronicles of Narnia: The Lion, the Witch and the Wardrobe",
      "aliases": [
        "Chronicles of Narnia",
        "The Lion, the Witch and the Wardrobe"
      ],
      "emojis": [
        "🚪",
        "❄️",
        "🦁",
        "🧙‍♀️",
        "⚔️",
        "👑"
      ],
      "pack_id": "daily_exclusive",
      "year": 2005
    },
    {
      "id": "for_downfall",
      "title": "Downfall",
      "aliases": [],
      "emojis": [
        "👩",
        "📝",
        "🇩🇪",
        "🗺️",
        "😡",
        "💥",
        "💊",
        "🔫",
        "🔥"
      ],
      "pack_id": "daily_exclusive",
      "year": 2004
    },
    {
      "id": "act_mr_mrs_smith",
      "title": "Mr. & Mrs. Smith",
      "aliases": [
        "Mr and Mrs Smith"
      ],
      "emojis": [
        "🤵",
        "👰",
        "💑",
        "🔫",
        "💥",
        "🏠",
        "💃"
      ],
      "pack_id": "daily_exclusive",
      "year": 2005
    },
    {
      "id": "alt_deer_hunter",
      "title": "The Deer Hunter",
      "aliases": [
        "Deer Hunter"
      ],
      "emojis": [
        "🦌",
        "🏔️",
        "💒",
        "🪖",
        "🇻🇳",
        "🔫",
        "😵",
        "♿",
        "🕯️"
      ],
      "pack_id": "daily_exclusive",
      "year": 1978
    },
    {
      "id": "alt_all_about_eve",
      "title": "All About Eve",
      "aliases": [],
      "emojis": [
        "🎭",
        "👩",
        "🌟",
        "🤝",
        "🐍",
        "💔",
        "🏆",
        "🪞"
      ],
      "pack_id": "daily_exclusive",
      "year": 1950
    },
    {
      "id": "alt_pride_prejudice",
      "title": "Pride & Prejudice",
      "aliases": [
        "Pride and Prejudice"
      ],
      "emojis": [
        "👩",
        "📖",
        "💃",
        "🤵",
        "🏰",
        "🌧️",
        "💌",
        "🌅",
        "💑"
      ],
      "pack_id": "daily_exclusive",
      "year": 2005
    },
    {
      "id": "alt_dolce_vita",
      "title": "La Dolce Vita",
      "aliases": [],
      "emojis": [
        "⛲",
        "🇮🇹",
        "🎬",
        "💃",
        "💔",
        "🌹"
      ],
      "pack_id": "daily_exclusive",
      "year": 1960
    },
    {
      "id": "ns_horrible_bosses",
      "title": "Horrible Bosses",
      "aliases": [],
      "emojis": [
        "💼",
        "😈",
        "👨",
        "👨",
        "👨",
        "🔪",
        "🚓"
      ],
      "pack_id": "daily_exclusive",
      "year": 2011
    },
    {
      "id": "mi_imitation_game",
      "title": "The Imitation Game",
      "aliases": [
        "Imitation Game"
      ],
      "emojis": [
        "🧠",
        "🔠",
        "💻",
        "🪖",
        "🇬🇧",
        "🤐",
        "💔"
      ],
      "pack_id": "daily_exclusive",
      "year": 2014
    },
    {
      "id": "mcu_shang_chi",
      "title": "Shang-Chi and the Legend of the Ten Rings",
      "aliases": [
        "Shang Chi",
        "Shang-Chi"
      ],
      "emojis": [
        "💍",
        "🥋",
        "🏯",
        "🐉",
        "🚌",
        "🌳"
      ],
      "pack_id": "daily_exclusive",
      "year": 2021
    },
    {
      "id": "dc_shazam",
      "title": "Shazam!",
      "aliases": [
        "Shazam"
      ],
      "emojis": [
        "👦",
        "⚡",
        "💪",
        "🚌",
        "🚇",
        "🍩",
        "👨‍👩‍👧‍👦"
      ],
      "pack_id": "daily_exclusive",
      "year": 2019
    },
    {
      "id": "bio_ali",
      "title": "Ali",
      "aliases": [],
      "emojis": [
        "🥊",
        "✊🏿",
        "🇺🇸",
        "🕌",
        "🏆",
        "👨🏿"
      ],
      "pack_id": "daily_exclusive",
      "year": 2001
    },
    {
      "id": "alt_con_air",
      "title": "Con Air",
      "aliases": [],
      "emojis": [
        "✈️",
        "⛓️",
        "🤠",
        "🐰",
        "💪",
        "🐍"
      ],
      "pack_id": "daily_exclusive",
      "year": 1997
    },
    {
      "id": "alt_terms_endearment",
      "title": "Terms of Endearment",
      "aliases": [],
      "emojis": [
        "👩",
        "👨‍👩‍👧",
        "🚀",
        "🛏️",
        "💔",
        "🪦"
      ],
      "pack_id": "daily_exclusive",
      "year": 1983
    },
    {
      "id": "alt_witness",
      "title": "Witness",
      "aliases": [],
      "emojis": [
        "👦",
        "🚉",
        "🔪",
        "👀",
        "👮",
        "🌾",
        "🐴",
        "🔨",
        "🌽"
      ],
      "pack_id": "daily_exclusive",
      "year": 1985
    },
    {
      "id": "ns_hancock",
      "title": "Hancock",
      "aliases": [],
      "emojis": [
        "🦸🏿",
        "🥃",
        "🏙️",
        "💼",
        "👩",
        "💥"
      ],
      "pack_id": "daily_exclusive",
      "year": 2008
    },
    {
      "id": "ns_the_town",
      "title": "The Town",
      "aliases": [],
      "emojis": [
        "🏦",
        "🎭",
        "👮",
        "💑",
        "🚓",
        "💐"
      ],
      "pack_id": "daily_exclusive",
      "year": 2010
    },
    {
      "id": "rc_sleepless",
      "title": "Sleepless in Seattle",
      "aliases": [],
      "emojis": [
        "⚰️",
        "💔",
        "👨",
        "👶",
        "📻",
        "✉️",
        "❤️",
        "🏢",
        "💑"
      ],
      "pack_id": "daily_exclusive",
      "year": 1993
    },
    {
      "id": "cl_some_like_hot",
      "title": "Some Like It Hot",
      "aliases": [],
      "emojis": [
        "🎷",
        "🎻",
        "🔫",
        "🤐",
        "👗",
        "👗",
        "🚂",
        "🏖️",
        "💋"
      ],
      "pack_id": "daily_exclusive",
      "year": 1959
    },
    {
      "id": "ni_cuckoos_nest",
      "title": "One Flew Over the Cuckoo's Nest",
      "aliases": [
        "One Flew Over the Cuckoos Nest"
      ],
      "emojis": [
        "🏥",
        "👨‍🦰",
        "😈",
        "👩‍⚕️",
        "🎣",
        "⚡",
        "🛏️",
        "🌑"
      ],
      "pack_id": "daily_exclusive",
      "year": 1975
    },
    {
      "id": "knocked_up_2",
      "title": "This Is the End",
      "aliases": [],
      "emojis": [
        "🎬",
        "🌋",
        "🕳️",
        "👹",
        "🎉",
        "⭐"
      ],
      "pack_id": "daily_exclusive",
      "year": 2013
    },
    {
      "id": "the_proposal",
      "title": "The Proposal",
      "aliases": [],
      "emojis": [
        "💼",
        "👩",
        "💍",
        "🇨🇦",
        "👵",
        "💃"
      ],
      "pack_id": "daily_exclusive",
      "year": 2009
    },
    {
      "id": "spielberg_bfg",
      "title": "The BFG",
      "aliases": [
        "BFG"
      ],
      "emojis": [
        "👧",
        "👤",
        "🌙",
        "💭",
        "🇬🇧",
        "🏰"
      ],
      "pack_id": "daily_exclusive",
      "year": 2016
    },
    {
      "id": "wa_darjeeling",
      "title": "The Darjeeling Limited",
      "aliases": [],
      "emojis": [
        "🚂",
        "🇮🇳",
        "👬",
        "🐍",
        "🌅",
        "🧳"
      ],
      "pack_id": "daily_exclusive",
      "year": 2007
    },
    {
      "id": "wa_french_dispatch",
      "title": "The French Dispatch",
      "aliases": [],
      "emojis": [
        "📰",
        "🇫🇷",
        "🎨",
        "✊",
        "🍳",
        "🥖"
      ],
      "pack_id": "daily_exclusive",
      "year": 2021
    },
    {
      "id": "pix_onward",
      "title": "Onward",
      "aliases": [],
      "emojis": [
        "🧝",
        "👬",
        "🪄",
        "🚐",
        "🦄",
        "💔"
      ],
      "pack_id": "daily_exclusive",
      "year": 2020
    },
    {
      "id": "dis_tarzan",
      "title": "Tarzan",
      "aliases": [],
      "emojis": [
        "🌳",
        "🦍",
        "👶",
        "👨",
        "👩",
        "🐆"
      ],
      "pack_id": "daily_exclusive",
      "year": 1999
    },
    {
      "id": "dw_kfp",
      "title": "Kung Fu Panda",
      "aliases": [],
      "emojis": [
        "🐼",
        "🥋",
        "🐢",
        "🐦",
        "🥟",
        "🐆"
      ],
      "pack_id": "daily_exclusive",
      "year": 2008
    },
    {
      "id": "hr_omen",
      "title": "The Omen",
      "aliases": [],
      "emojis": [
        "👨",
        "👶",
        "😈",
        "🪢",
        "🐕",
        "✝️",
        "🔪",
        "🪦"
      ],
      "pack_id": "daily_exclusive",
      "year": 1976
    },
    {
      "id": "sp_remember_titans",
      "title": "Remember the Titans",
      "aliases": [],
      "emojis": [
        "🏈",
        "🏫",
        "🤝",
        "✊",
        "🏆",
        "👨🏿"
      ],
      "pack_id": "daily_exclusive",
      "year": 2000
    },
    {
      "id": "sp_friday_night_lights",
      "title": "Friday Night Lights",
      "aliases": [],
      "emojis": [
        "🏈",
        "🌃",
        "🏫",
        "🇺🇸",
        "🎶",
        "🌟"
      ],
      "pack_id": "daily_exclusive",
      "year": 2004
    },
    {
      "id": "bio_rocketman",
      "title": "Rocketman",
      "aliases": [],
      "emojis": [
        "🎹",
        "🕶️",
        "🚀",
        "🪶",
        "💎",
        "✨"
      ],
      "pack_id": "daily_exclusive",
      "year": 2019
    },
    {
      "id": "fam_night_museum",
      "title": "Night at the Museum",
      "aliases": [],
      "emojis": [
        "🏛️",
        "🌙",
        "🦴",
        "🤠",
        "🐒",
        "👤"
      ],
      "pack_id": "daily_exclusive",
      "year": 2006
    },
    {
      "id": "for_book_thief",
      "title": "The Book Thief",
      "aliases": [],
      "emojis": [
        "📚",
        "🇩🇪",
        "👧",
        "✡️",
        "🔥",
        "💔"
      ],
      "pack_id": "daily_exclusive",
      "year": 2013
    },
    {
      "id": "alt_hurt_locker",
      "title": "The Hurt Locker",
      "aliases": [
        "Hurt Locker"
      ],
      "emojis": [
        "💣",
        "🪖",
        "🇮🇶",
        "🤖",
        "💥",
        "🧰"
      ],
      "pack_id": "daily_exclusive",
      "year": 2008
    },
    {
      "id": "alt_hacksaw_ridge",
      "title": "Hacksaw Ridge",
      "aliases": [],
      "emojis": [
        "✝️",
        "🪖",
        "🚫",
        "🔫",
        "⚖️",
        "🧗",
        "🩹",
        "🪢"
      ],
      "pack_id": "daily_exclusive",
      "year": 2016
    },
    {
      "id": "alt_tombstone",
      "title": "Tombstone",
      "aliases": [],
      "emojis": [
        "🪦",
        "🤠",
        "⭐",
        "🃏",
        "😷",
        "🔫",
        "🐎",
        "💀"
      ],
      "pack_id": "daily_exclusive",
      "year": 1993
    },
    {
      "id": "alt_greatest_showman",
      "title": "The Greatest Showman",
      "aliases": [],
      "emojis": [
        "🎪",
        "🎩",
        "🐘",
        "💃🏾",
        "🎤",
        "✨"
      ],
      "pack_id": "daily_exclusive",
      "year": 2017
    },
    {
      "id": "alt_erin_brockovich",
      "title": "Erin Brockovich",
      "aliases": [],
      "emojis": [
        "💼",
        "💧",
        "🏭",
        "⚖️",
        "👩",
        "🏆"
      ],
      "pack_id": "daily_exclusive",
      "year": 2000
    },
    {
      "id": "ns_i_robot",
      "title": "I, Robot",
      "aliases": [
        "I Robot"
      ],
      "emojis": [
        "🤖",
        "🕵🏿",
        "🏙️",
        "🚗",
        "🧠",
        "⚙️"
      ],
      "pack_id": "daily_exclusive",
      "year": 2004
    },
    {
      "id": "ns_american_gangster",
      "title": "American Gangster",
      "aliases": [],
      "emojis": [
        "👨🏿",
        "✈️",
        "⚰️",
        "💵",
        "💊",
        "🚔"
      ],
      "pack_id": "daily_exclusive",
      "year": 2007
    },
    {
      "id": "mi_ford_ferrari",
      "title": "Ford v Ferrari",
      "aliases": [
        "Ford vs Ferrari"
      ],
      "emojis": [
        "🇺🇸",
        "🏎️",
        "🇮🇹",
        "🔧",
        "🇫🇷",
        "🌧️",
        "🏁",
        "😔",
        "💥"
      ],
      "pack_id": "daily_exclusive",
      "year": 2019
    },
    {
      "id": "just_go_with_it",
      "title": "Just Go With It",
      "aliases": [],
      "emojis": [
        "💍",
        "👩",
        "👨",
        "🏝️",
        "👧",
        "👦",
        "🥥"
      ],
      "pack_id": "daily_exclusive",
      "year": 2011
    },
    {
      "id": "dodgeball",
      "title": "Dodgeball: A True Underdog Story",
      "aliases": [
        "Dodgeball"
      ],
      "emojis": [
        "🏋️",
        "💸",
        "🤝",
        "🏴‍☠️",
        "🔧",
        "🎰",
        "🏐",
        "🏆"
      ],
      "pack_id": "daily_exclusive",
      "year": 2004
    },
    {
      "id": "yes_man",
      "title": "Yes Man",
      "aliases": [],
      "emojis": [
        "🙋",
        "🚗",
        "🏍️",
        "💑",
        "🎸",
        "🤙"
      ],
      "pack_id": "daily_exclusive",
      "year": 2008
    },
    {
      "id": "ns_equalizer",
      "title": "The Equalizer",
      "aliases": [
        "Equalizer"
      ],
      "emojis": [
        "👨🏿",
        "📖",
        "⏱️",
        "🔧",
        "🔫",
        "🇷🇺"
      ],
      "pack_id": "daily_exclusive",
      "year": 2014
    },
    {
      "id": "he_call_me_by_your_name",
      "title": "Call Me by Your Name",
      "aliases": [
        "Call Me By Your Name",
        "CMBYN"
      ],
      "emojis": [
        "🇮🇹",
        "☀️",
        "🚲",
        "🏊",
        "❤️",
        "🍑",
        "🚂",
        "🔥",
        "😢"
      ],
      "pack_id": "daily_exclusive",
      "year": 2017
    },
    {
      "id": "an_sleeping_beauty",
      "title": "Sleeping Beauty",
      "aliases": [],
      "emojis": [
        "👸",
        "🧚‍♀️",
        "🧙‍♀️",
        "🪡",
        "😴",
        "🤴",
        "🐉",
        "⚔️",
        "💋"
      ],
      "pack_id": "daily_exclusive",
      "year": 1959
    },
    {
      "id": "an_bambi",
      "title": "Bambi",
      "aliases": [],
      "emojis": [
        "🦌",
        "🐰",
        "🦨",
        "⛸️",
        "🔫",
        "💔",
        "🌸",
        "🔥",
        "🦌"
      ],
      "pack_id": "daily_exclusive",
      "year": 1942
    },
    {
      "id": "an_hercules",
      "title": "Hercules",
      "aliases": [],
      "emojis": [
        "⚡",
        "👶",
        "💪",
        "🐐",
        "🐎",
        "🐍",
        "🔥",
        "💑",
        "⭐"
      ],
      "pack_id": "daily_exclusive",
      "year": 1997
    },
    {
      "id": "mi_lotr_fellowship",
      "title": "The Lord of the Rings",
      "aliases": [
        "Lord of the Rings",
        "LOTR",
        "The Lord of the Rings: The Fellowship of the Ring",
        "Fellowship of the Ring"
      ],
      "emojis": [
        "🏡",
        "💍",
        "🧙‍♂️",
        "⚔️",
        "🏹",
        "🪓",
        "👹",
        "🔥",
        "🛶"
      ],
      "pack_id": "daily_exclusive",
      "year": 2001
    },
    {
      "id": "mi_borat",
      "title": "Borat",
      "aliases": [],
      "emojis": [
        "🇰🇿",
        "✈️",
        "🇺🇸",
        "🎤",
        "🤠",
        "🚐",
        "🐻",
        "🤼",
        "💍"
      ],
      "pack_id": "daily_exclusive",
      "year": 2006
    },
    {
      "id": "rc_notting_hill",
      "title": "Notting Hill",
      "aliases": [],
      "emojis": [
        "🇬🇧",
        "📚",
        "🌹",
        "⭐",
        "💋",
        "🍹",
        "📰",
        "💑"
      ],
      "pack_id": "daily_exclusive",
      "year": 1999
    },
    {
      "id": "rc_40_year_virgin",
      "title": "The 40-Year-Old Virgin",
      "aliases": [
        "40 Year Old Virgin"
      ],
      "emojis": [
        "👨",
        "🤖",
        "🚲",
        "🃏",
        "😳",
        "🩹",
        "👩",
        "💒"
      ],
      "pack_id": "daily_exclusive",
      "year": 2005
    },
    {
      "id": "rc_step_brothers",
      "title": "Step Brothers",
      "aliases": [],
      "emojis": [
        "👨",
        "👨",
        "💑",
        "🏠",
        "🛏️",
        "🥁",
        "🤜",
        "🚤"
      ],
      "pack_id": "daily_exclusive",
      "year": 2008
    },
    {
      "id": "aa_black_hawk_down",
      "title": "Black Hawk Down",
      "aliases": [],
      "emojis": [
        "🚁",
        "🪖",
        "🇸🇴",
        "🏙️",
        "🔫",
        "💥",
        "🩸",
        "🫡"
      ],
      "pack_id": "daily_exclusive",
      "year": 2001
    },
    {
      "id": "ci_little_miss_sunshine",
      "title": "Little Miss Sunshine",
      "aliases": [],
      "emojis": [
        "🚐",
        "👨‍👩‍👧",
        "👴",
        "👓",
        "☀️",
        "👑",
        "💃",
        "💔"
      ],
      "pack_id": "daily_exclusive",
      "year": 2006
    },
    {
      "id": "ci_three_billboards",
      "title": "Three Billboards Outside Ebbing, Missouri",
      "aliases": [
        "Three Billboards"
      ],
      "emojis": [
        "👩",
        "⚰️",
        "🪧",
        "🪧",
        "🪧",
        "👮",
        "🔥",
        "🚗",
        "🔫"
      ],
      "pack_id": "daily_exclusive",
      "year": 2017
    },
    {
      "id": "cl_sting",
      "title": "The Sting",
      "aliases": [],
      "emojis": [
        "💀",
        "🤝",
        "🃏",
        "🚂",
        "🏇",
        "💵",
        "🔫",
        "😉"
      ],
      "pack_id": "daily_exclusive",
      "year": 1973
    },
    {
      "id": "mi_la_confidential",
      "title": "L.A. Confidential",
      "aliases": [
        "LA Confidential"
      ],
      "emojis": [
        "🌴",
        "👮",
        "👮",
        "👮",
        "☕",
        "🔫",
        "👱‍♀️",
        "📰",
        "💥"
      ],
      "pack_id": "daily_exclusive",
      "year": 1997
    },
    {
      "id": "mi_jojo_rabbit",
      "title": "Jojo Rabbit",
      "aliases": [],
      "emojis": [
        "🇩🇪",
        "👦",
        "🪖",
        "👤",
        "✡️",
        "👩",
        "🐰",
        "💃"
      ],
      "pack_id": "daily_exclusive",
      "year": 2019
    },
    {
      "id": "hp_fantastic_beasts",
      "title": "Fantastic Beasts and Where to Find Them",
      "aliases": [
        "Fantastic Beasts"
      ],
      "emojis": [
        "🧳",
        "🦡",
        "🦅",
        "🐦",
        "🌃",
        "🪄"
      ],
      "pack_id": "daily_exclusive",
      "year": 2016
    },
    {
      "id": "zoolander",
      "title": "Zoolander",
      "aliases": [],
      "emojis": [
        "💁‍♂️",
        "📰",
        "💉",
        "💃",
        "🏢",
        "🐒"
      ],
      "pack_id": "daily_exclusive",
      "year": 2001
    },
    {
      "id": "its_complicated",
      "title": "It's Complicated",
      "aliases": [],
      "emojis": [
        "💔",
        "💑",
        "🥐",
        "🛁",
        "👩",
        "🍷"
      ],
      "pack_id": "daily_exclusive",
      "year": 2009
    },
    {
      "id": "ghibli_totoro",
      "title": "My Neighbor Totoro",
      "aliases": [
        "Totoro"
      ],
      "emojis": [
        "🐰",
        "🌳",
        "👧",
        "☂️",
        "🐈",
        "🚌"
      ],
      "pack_id": "daily_exclusive",
      "year": 1988
    },
    {
      "id": "dis_pocahontas",
      "title": "Pocahontas",
      "aliases": [],
      "emojis": [
        "👩🏽",
        "🪶",
        "🌳",
        "⛵",
        "🌬️",
        "🐦"
      ],
      "pack_id": "daily_exclusive",
      "year": 1995
    },
    {
      "id": "dis_zootopia",
      "title": "Zootopia",
      "aliases": [],
      "emojis": [
        "🐰",
        "🦊",
        "🚓",
        "🏙️",
        "🐑",
        "🌵"
      ],
      "pack_id": "daily_exclusive",
      "year": 2016
    },
    {
      "id": "dw_prince_egypt",
      "title": "The Prince of Egypt",
      "aliases": [],
      "emojis": [
        "👶🏽",
        "🌊",
        "🐍",
        "⚡",
        "🏜️",
        "🪄"
      ],
      "pack_id": "daily_exclusive",
      "year": 1998
    },
    {
      "id": "dw_httyd",
      "title": "How to Train Your Dragon",
      "aliases": [],
      "emojis": [
        "🐉",
        "🪖",
        "👦",
        "✈️",
        "🏝️",
        "🤝"
      ],
      "pack_id": "daily_exclusive",
      "year": 2010
    },
    {
      "id": "hr_shaun_dead",
      "title": "Shaun of the Dead",
      "aliases": [],
      "emojis": [
        "😴",
        "💔",
        "🧟",
        "💿",
        "🏏",
        "🍻",
        "🔫",
        "💕"
      ],
      "pack_id": "daily_exclusive",
      "year": 2004
    },
    {
      "id": "rc_10_things",
      "title": "10 Things I Hate About You",
      "aliases": [
        "Ten Things I Hate About You"
      ],
      "emojis": [
        "👩",
        "😠",
        "💵",
        "🤝",
        "🎤",
        "🏟️",
        "🎨",
        "📝",
        "🎸"
      ],
      "pack_id": "daily_exclusive",
      "year": 1999
    },
    {
      "id": "heist_now_you_see",
      "title": "Now You See Me",
      "aliases": [],
      "emojis": [
        "🎩",
        "💵",
        "🎟️",
        "🐰",
        "🔮",
        "🪞"
      ],
      "pack_id": "daily_exclusive",
      "year": 2013
    },
    {
      "id": "sp_tin_cup",
      "title": "Tin Cup",
      "aliases": [],
      "emojis": [
        "🏌️",
        "🏜️",
        "👩",
        "💘",
        "🇺🇸",
        "💦",
        "💦",
        "⛳"
      ],
      "pack_id": "daily_exclusive",
      "year": 1996
    },
    {
      "id": "sp_chariots_fire",
      "title": "Chariots of Fire",
      "aliases": [],
      "emojis": [
        "🏃",
        "🏃",
        "🏖️",
        "🇬🇧",
        "✡️",
        "✝️",
        "🇫🇷",
        "🥇"
      ],
      "pack_id": "daily_exclusive",
      "year": 1981
    },
    {
      "id": "bio_pursuit_happyness",
      "title": "The Pursuit of Happyness",
      "aliases": [
        "Pursuit of Happyness"
      ],
      "emojis": [
        "👨🏿",
        "👦🏿",
        "💸",
        "🏚️",
        "🚻",
        "💼",
        "📈",
        "😭"
      ],
      "pack_id": "daily_exclusive",
      "year": 2006
    },
    {
      "id": "sf_godzilla_2014",
      "title": "Godzilla",
      "aliases": [
        "Godzilla 2014"
      ],
      "emojis": [
        "🦖",
        "🏙️",
        "🌊",
        "☢️",
        "💥",
        "🚁"
      ],
      "pack_id": "daily_exclusive",
      "year": 2014
    },
    {
      "id": "com_grown_ups",
      "title": "Grown Ups",
      "aliases": [],
      "emojis": [
        "👬",
        "🛶",
        "🏞️",
        "🏀",
        "🤡",
        "💧"
      ],
      "pack_id": "daily_exclusive",
      "year": 2010
    },
    {
      "id": "an_secret_life_pets",
      "title": "The Secret Life of Pets",
      "aliases": [],
      "emojis": [
        "🐶",
        "🐱",
        "🏙️",
        "🚇",
        "🐰",
        "🐦"
      ],
      "pack_id": "daily_exclusive",
      "year": 2016
    },
    {
      "id": "for_intouchables",
      "title": "The Intouchables",
      "aliases": [],
      "emojis": [
        "♿",
        "👨🏿",
        "🇫🇷",
        "🪂",
        "🎶",
        "💞"
      ],
      "pack_id": "daily_exclusive",
      "year": 2011
    },
    {
      "id": "for_handmaiden",
      "title": "The Handmaiden",
      "aliases": [],
      "emojis": [
        "🏠",
        "👩",
        "👩",
        "💋",
        "💰",
        "🐙"
      ],
      "pack_id": "daily_exclusive",
      "year": 2016
    },
    {
      "id": "alt_lone_survivor",
      "title": "Lone Survivor",
      "aliases": [],
      "emojis": [
        "🪖",
        "🏔️",
        "🐐",
        "🔫",
        "🧗",
        "🚁",
        "💥",
        "🤝"
      ],
      "pack_id": "daily_exclusive",
      "year": 2013
    },
    {
      "id": "alt_empire_sun",
      "title": "Empire of the Sun",
      "aliases": [],
      "emojis": [
        "👦",
        "🇨🇳",
        "🪖",
        "🇯🇵",
        "✈️",
        "🌅"
      ],
      "pack_id": "daily_exclusive",
      "year": 1987
    },
    {
      "id": "alt_apartment",
      "title": "The Apartment",
      "aliases": [],
      "emojis": [
        "🏢",
        "🔑",
        "💼",
        "👩",
        "💊",
        "🎄",
        "🍝",
        "🎾",
        "💑"
      ],
      "pack_id": "daily_exclusive",
      "year": 1960
    },
    {
      "id": "alt_moulin_rouge",
      "title": "Moulin Rouge!",
      "aliases": [
        "Moulin Rouge"
      ],
      "emojis": [
        "✍️",
        "🇫🇷",
        "💃",
        "🐘",
        "💎",
        "🤵",
        "🎭",
        "🩸",
        "💔"
      ],
      "pack_id": "daily_exclusive",
      "year": 2001
    },
    {
      "id": "alt_philadelphia",
      "title": "Philadelphia",
      "aliases": [],
      "emojis": [
        "👨‍💼",
        "🌈",
        "🩹",
        "🚪",
        "👨🏿",
        "⚖️",
        "🏆",
        "🪦"
      ],
      "pack_id": "daily_exclusive",
      "year": 1993
    },
    {
      "id": "alt_united_93",
      "title": "United 93",
      "aliases": [
        "Flight 93",
        "United Ninety Three"
      ],
      "emojis": [
        "🛫",
        "🔪",
        "📞",
        "😨",
        "✊",
        "🌾",
        "🇺🇸"
      ],
      "pack_id": "daily_exclusive",
      "year": 2006
    },
    {
      "id": "alt_127_hours",
      "title": "127 Hours",
      "aliases": [
        "One Hundred Twenty Seven Hours",
        "One Twenty Seven Hours"
      ],
      "emojis": [
        "🚵",
        "🏜️",
        "🕳️",
        "🪨",
        "📹",
        "💧",
        "🔪",
        "🩸",
        "🚶"
      ],
      "pack_id": "daily_exclusive",
      "year": 2010
    },
    {
      "id": "alt_nomadland",
      "title": "Nomadland",
      "aliases": [],
      "emojis": [
        "🚐",
        "🏜️",
        "👵",
        "🌅",
        "💼",
        "🌌"
      ],
      "pack_id": "daily_exclusive",
      "year": 2020
    },
    {
      "id": "alt_seventh_seal",
      "title": "The Seventh Seal",
      "aliases": [
        "Seventh Seal"
      ],
      "emojis": [
        "♟️",
        "💀",
        "🇸🇪",
        "🪦",
        "🛡️",
        "🌅"
      ],
      "pack_id": "daily_exclusive",
      "year": 1957
    },
    {
      "id": "alt_chocolat",
      "title": "Chocolat",
      "aliases": [],
      "emojis": [
        "👩",
        "👧",
        "🏘️",
        "🍫",
        "🏪",
        "⛪",
        "🙅",
        "🛶",
        "💘"
      ],
      "pack_id": "daily_exclusive",
      "year": 2000
    },
    {
      "id": "alt_fried_green",
      "title": "Fried Green Tomatoes",
      "aliases": [],
      "emojis": [
        "👵",
        "📖",
        "👩",
        "👩",
        "🚂",
        "😢",
        "🍳",
        "🍅",
        "🍖"
      ],
      "pack_id": "daily_exclusive",
      "year": 1991
    },
    {
      "id": "alt_fall_guy",
      "title": "The Fall Guy",
      "aliases": [],
      "emojis": [
        "🎬",
        "💥",
        "🚗",
        "🪂",
        "💑",
        "🦄"
      ],
      "pack_id": "daily_exclusive",
      "year": 2024
    },
    {
      "id": "alt_grapes_wrath",
      "title": "The Grapes of Wrath",
      "aliases": [],
      "emojis": [
        "🚜",
        "🍇",
        "🌾",
        "👨‍👩‍👧",
        "🌅",
        "💔"
      ],
      "pack_id": "daily_exclusive",
      "year": 1940
    },
    {
      "id": "ns_maze_runner",
      "title": "The Maze Runner",
      "aliases": [
        "Maze Runner"
      ],
      "emojis": [
        "🏃",
        "🌀",
        "🧱",
        "👦",
        "🕷️",
        "🚪"
      ],
      "pack_id": "daily_exclusive",
      "year": 2014
    },
    {
      "id": "ns_flight",
      "title": "Flight",
      "aliases": [],
      "emojis": [
        "✈️",
        "🙃",
        "🥃",
        "⚖️",
        "👨🏿‍✈️"
      ],
      "pack_id": "daily_exclusive",
      "year": 2012
    },
    {
      "id": "mi_mystic_river",
      "title": "Mystic River",
      "aliases": [],
      "emojis": [
        "🏘️",
        "👬",
        "🚗",
        "😢",
        "🩸",
        "🕵️",
        "🌊"
      ],
      "pack_id": "daily_exclusive",
      "year": 2003
    },
    {
      "id": "coen_hail_caesar",
      "title": "Hail, Caesar!",
      "aliases": [
        "Hail Caesar"
      ],
      "emojis": [
        "🎬",
        "⚔️",
        "🚢",
        "💃",
        "🏛️",
        "🤠"
      ],
      "pack_id": "daily_exclusive",
      "year": 2016
    },
    {
      "id": "nolan_tenet",
      "title": "Tenet",
      "aliases": [],
      "emojis": [
        "🔄",
        "🎻",
        "🔫",
        "⏰",
        "🌀",
        "🤐"
      ],
      "pack_id": "daily_exclusive",
      "year": 2020
    },
    {
      "id": "ns_enemy_state",
      "title": "Enemy of the State",
      "aliases": [],
      "emojis": [
        "👨🏿",
        "💼",
        "📼",
        "🛰️",
        "👁️",
        "🏃",
        "🕵️",
        "💥"
      ],
      "pack_id": "daily_exclusive",
      "year": 1998
    },
    {
      "id": "mi_prestige",
      "title": "The Prestige",
      "aliases": [
        "Prestige"
      ],
      "emojis": [
        "🎩",
        "🐦",
        "💧",
        "⚡",
        "🪞",
        "👯‍♂️",
        "🎭"
      ],
      "pack_id": "daily_exclusive",
      "year": 2006
    },
    {
      "id": "mi_spotlight",
      "title": "Spotlight",
      "aliases": [],
      "emojis": [
        "📰",
        "🔍",
        "⛪",
        "👶",
        "😢",
        "🏛️",
        "📓"
      ],
      "pack_id": "daily_exclusive",
      "year": 2015
    },
    {
      "id": "walk_hard",
      "title": "Walk Hard",
      "aliases": [],
      "emojis": [
        "👦",
        "👦",
        "🔪",
        "🎸",
        "🎤",
        "💊",
        "💍",
        "💔",
        "🎶"
      ],
      "pack_id": "daily_exclusive",
      "year": 2007
    },
    {
      "id": "coen_burn_after",
      "title": "Burn After Reading",
      "aliases": [],
      "emojis": [
        "💪",
        "💪",
        "💾",
        "🕵️",
        "🔫",
        "😅"
      ],
      "pack_id": "daily_exclusive",
      "year": 2008
    },
    {
      "id": "coen_buster_scruggs",
      "title": "The Ballad of Buster Scruggs",
      "aliases": [],
      "emojis": [
        "🤠",
        "🎵",
        "🐎",
        "💀",
        "💰",
        "🏜️"
      ],
      "pack_id": "daily_exclusive",
      "year": 2018
    },
    {
      "id": "wa_asteroid_city",
      "title": "Asteroid City",
      "aliases": [],
      "emojis": [
        "🚗",
        "🏜️",
        "☄️",
        "🛸",
        "🌵",
        "👽"
      ],
      "pack_id": "daily_exclusive",
      "year": 2023
    },
    {
      "id": "scorsese_silence",
      "title": "Silence",
      "aliases": [],
      "emojis": [
        "✝️",
        "🇯🇵",
        "🪦",
        "🤐",
        "🌊",
        "💧"
      ],
      "pack_id": "daily_exclusive",
      "year": 2016
    },
    {
      "id": "an_mulan",
      "title": "Mulan",
      "aliases": [],
      "emojis": [
        "👧",
        "💄",
        "✂️",
        "⚔️",
        "🪖",
        "🐉",
        "🏔️",
        "❄️",
        "🎆"
      ],
      "pack_id": "daily_exclusive",
      "year": 1998
    },
    {
      "id": "sf_signs",
      "title": "Signs",
      "aliases": [],
      "emojis": [
        "🌾",
        "👽",
        "📺",
        "🥃",
        "✝️",
        "💧"
      ],
      "pack_id": "daily_exclusive",
      "year": 2002
    },
    {
      "id": "alt_driving_miss_daisy",
      "title": "Driving Miss Daisy",
      "aliases": [],
      "emojis": [
        "🚗",
        "👵",
        "👨🏿",
        "💜",
        "🤝",
        "🎄"
      ],
      "pack_id": "daily_exclusive",
      "year": 1989
    },
    {
      "id": "alt_frida",
      "title": "Frida",
      "aliases": [],
      "emojis": [
        "🎨",
        "🇲🇽",
        "♿",
        "💔",
        "🦋",
        "👩🏽"
      ],
      "pack_id": "daily_exclusive",
      "year": 2002
    },
    {
      "id": "alt_captain_phillips",
      "title": "Captain Phillips",
      "aliases": [],
      "emojis": [
        "🚢",
        "🇸🇴",
        "🔫",
        "💧",
        "🪖",
        "💔"
      ],
      "pack_id": "daily_exclusive",
      "year": 2013
    },
    {
      "id": "alt_marriage_story",
      "title": "Marriage Story",
      "aliases": [],
      "emojis": [
        "💑",
        "💔",
        "⚖️",
        "🎭",
        "👶",
        "🗽"
      ],
      "pack_id": "daily_exclusive",
      "year": 2019
    },
    {
      "id": "ns_divergent",
      "title": "Divergent",
      "aliases": [],
      "emojis": [
        "🏙️",
        "🧠",
        "💉",
        "🚂",
        "🏹",
        "💑"
      ],
      "pack_id": "daily_exclusive",
      "year": 2014
    },
    {
      "id": "mi_old_school",
      "title": "Old School",
      "aliases": [],
      "emojis": [
        "💔",
        "🏠",
        "🎉",
        "🍺",
        "🏃",
        "👴",
        "💀",
        "🎓",
        "🤸"
      ],
      "pack_id": "daily_exclusive",
      "year": 2003
    },
    {
      "id": "rc_13_going_30",
      "title": "13 Going on 30",
      "aliases": [
        "Thirteen Going on Thirty"
      ],
      "emojis": [
        "🎂",
        "✨",
        "🛏️",
        "👩",
        "📰",
        "🕺",
        "💘",
        "⏪",
        "💒"
      ],
      "pack_id": "daily_exclusive",
      "year": 2004
    },
    {
      "id": "ci_lady_bird",
      "title": "Lady Bird",
      "aliases": [],
      "emojis": [
        "🎀",
        "👧",
        "🚗",
        "🏫",
        "✝️",
        "💑",
        "✈️",
        "🗽",
        "💔"
      ],
      "pack_id": "daily_exclusive",
      "year": 2017
    },
    {
      "id": "an_klaus",
      "title": "Klaus",
      "aliases": [],
      "emojis": [
        "📮",
        "🏝️",
        "👴",
        "🪵",
        "🎁",
        "🦌",
        "🎄"
      ],
      "pack_id": "daily_exclusive",
      "year": 2019
    },
    {
      "id": "mcu_eternals",
      "title": "Eternals",
      "aliases": [],
      "emojis": [
        "🛸",
        "🏺",
        "🐺",
        "💀",
        "🌊",
        "✋",
        "🤝",
        "🗿"
      ],
      "pack_id": "daily_exclusive",
      "year": 2021
    },
    {
      "id": "dc_suicide_squad_2016",
      "title": "Suicide Squad",
      "aliases": [],
      "emojis": [
        "💀",
        "🦹‍♀️",
        "🦹",
        "🐊",
        "🔫",
        "🌃"
      ],
      "pack_id": "daily_exclusive",
      "year": 2016
    },
    {
      "id": "the_other_guys",
      "title": "The Other Guys",
      "aliases": [],
      "emojis": [
        "👮",
        "👮",
        "🖥️",
        "🏢",
        "💀",
        "🦁",
        "🐟",
        "💵",
        "💥"
      ],
      "pack_id": "daily_exclusive",
      "year": 2010
    },
    {
      "id": "scorsese_last_temptation",
      "title": "The Last Temptation of Christ",
      "aliases": [],
      "emojis": [
        "✝️",
        "👨",
        "🌵",
        "👼",
        "💔",
        "🩸"
      ],
      "pack_id": "daily_exclusive",
      "year": 1988
    },
    {
      "id": "dw_madagascar",
      "title": "Madagascar",
      "aliases": [],
      "emojis": [
        "🦁",
        "🦒",
        "🦓",
        "🦛",
        "🐧",
        "🏝️"
      ],
      "pack_id": "daily_exclusive",
      "year": 2005
    },
    {
      "id": "argo",
      "title": "Argo",
      "aliases": [],
      "emojis": [
        "🎬",
        "🇮🇷",
        "✈️",
        "🇨🇦",
        "🤝",
        "📜"
      ],
      "pack_id": "daily_exclusive",
      "year": 2012
    },
    {
      "id": "hr_amityville",
      "title": "The Amityville Horror",
      "aliases": [],
      "emojis": [
        "🏠",
        "🪟",
        "🩸",
        "🐀",
        "✝️",
        "🪓"
      ],
      "pack_id": "daily_exclusive",
      "year": 1979
    },
    {
      "id": "hr_night_living",
      "title": "Night of the Living Dead",
      "aliases": [],
      "emojis": [
        "🧟",
        "🏠",
        "📻",
        "👨🏿",
        "🌃",
        "🩸"
      ],
      "pack_id": "daily_exclusive",
      "year": 1968
    },
    {
      "id": "rc_cruel_intentions",
      "title": "Cruel Intentions",
      "aliases": [],
      "emojis": [
        "😈",
        "🤝",
        "🚗",
        "💋",
        "💘",
        "💔",
        "🚑",
        "📓"
      ],
      "pack_id": "daily_exclusive",
      "year": 1999
    },
    {
      "id": "sp_hoosiers",
      "title": "Hoosiers",
      "aliases": [],
      "emojis": [
        "👨",
        "🚗",
        "🌾",
        "🏀",
        "🏫",
        "📏",
        "🎯",
        "🏆"
      ],
      "pack_id": "daily_exclusive",
      "year": 1986
    },
    {
      "id": "sp_coach_carter",
      "title": "Coach Carter",
      "aliases": [],
      "emojis": [
        "👨🏿",
        "🏀",
        "📋",
        "📚",
        "🔒",
        "📰",
        "🤝",
        "🎓"
      ],
      "pack_id": "daily_exclusive",
      "year": 2005
    },
    {
      "id": "bio_walk_line",
      "title": "Walk the Line",
      "aliases": [],
      "emojis": [
        "🎸",
        "🚂",
        "🔥",
        "💑",
        "🇺🇸",
        "🎤"
      ],
      "pack_id": "daily_exclusive",
      "year": 2005
    },
    {
      "id": "act_expendables",
      "title": "The Expendables",
      "aliases": [],
      "emojis": [
        "💪",
        "💪",
        "💪",
        "🪖",
        "💣",
        "🔫"
      ],
      "pack_id": "daily_exclusive",
      "year": 2010
    },
    {
      "id": "com_date_night",
      "title": "Date Night",
      "aliases": [],
      "emojis": [
        "💑",
        "🥱",
        "🍽️",
        "🔫",
        "🏃",
        "💾",
        "🚕",
        "💃",
        "👮"
      ],
      "pack_id": "daily_exclusive",
      "year": 2010
    },
    {
      "id": "an_rio",
      "title": "Rio",
      "aliases": [],
      "emojis": [
        "🦜",
        "🇧🇷",
        "🌳",
        "🎶",
        "🕺",
        "💑"
      ],
      "pack_id": "daily_exclusive",
      "year": 2011
    },
    {
      "id": "for_water_elephants",
      "title": "Water for Elephants",
      "aliases": [],
      "emojis": [
        "🎪",
        "🐘",
        "💑",
        "🚂",
        "🌧️",
        "💍"
      ],
      "pack_id": "daily_exclusive",
      "year": 2011
    },
    {
      "id": "for_memories_murder",
      "title": "Memories of Murder",
      "aliases": [],
      "emojis": [
        "🇰🇷",
        "🔍",
        "🌾",
        "🔪",
        "🚓",
        "🌧️"
      ],
      "pack_id": "daily_exclusive",
      "year": 2003
    },
    {
      "id": "for_snowpiercer",
      "title": "Snowpiercer",
      "aliases": [],
      "emojis": [
        "🚂",
        "❄️",
        "🌍",
        "✊",
        "🪓",
        "🐟"
      ],
      "pack_id": "daily_exclusive",
      "year": 2013
    },
    {
      "id": "alt_all_quiet_western",
      "title": "All Quiet on the Western Front",
      "aliases": [],
      "emojis": [
        "🪖",
        "🇩🇪",
        "🌧️",
        "💔",
        "🦋",
        "🌾"
      ],
      "pack_id": "daily_exclusive",
      "year": 2022
    },
    {
      "id": "alt_open_range",
      "title": "Open Range",
      "aliases": [],
      "emojis": [
        "🤠",
        "🐂",
        "🌾",
        "☔",
        "⚰️",
        "🏘️",
        "🔫",
        "💑"
      ],
      "pack_id": "daily_exclusive",
      "year": 2003
    },
    {
      "id": "alt_notorious",
      "title": "Notorious",
      "aliases": [],
      "emojis": [
        "🍷",
        "💋",
        "🇩🇪",
        "🔑",
        "🇧🇷",
        "💔"
      ],
      "pack_id": "daily_exclusive",
      "year": 1946
    },
    {
      "id": "alt_modern_times",
      "title": "Modern Times",
      "aliases": [],
      "emojis": [
        "⚙️",
        "👨",
        "🍴",
        "🏭",
        "🔧",
        "🌅"
      ],
      "pack_id": "daily_exclusive",
      "year": 1936
    },
    {
      "id": "alt_bicycle_thieves",
      "title": "Bicycle Thieves",
      "aliases": [
        "The Bicycle Thief"
      ],
      "emojis": [
        "🚲",
        "🇮🇹",
        "👨‍👦",
        "💼",
        "🎬",
        "💔"
      ],
      "pack_id": "daily_exclusive",
      "year": 1948
    },
    {
      "id": "ns_real_steel",
      "title": "Real Steel",
      "aliases": [],
      "emojis": [
        "🤖",
        "🥊",
        "👨",
        "👦",
        "🏆"
      ],
      "pack_id": "daily_exclusive",
      "year": 2011
    },
    {
      "id": "cl_lawrence_arabia",
      "title": "Lawrence of Arabia",
      "aliases": [],
      "emojis": [
        "🇬🇧",
        "👤",
        "🏜️",
        "🐪",
        "⚔️",
        "🚂",
        "🌅"
      ],
      "pack_id": "daily_exclusive",
      "year": 1962
    },
    {
      "id": "ni_chinatown",
      "title": "Chinatown",
      "aliases": [],
      "emojis": [
        "🕵️",
        "👃",
        "🩹",
        "💧",
        "👩",
        "🏙️",
        "🌵"
      ],
      "pack_id": "daily_exclusive",
      "year": 1974
    },
    {
      "id": "mi_12_years_slave",
      "title": "12 Years a Slave",
      "aliases": [
        "Twelve Years a Slave"
      ],
      "emojis": [
        "🎻",
        "👨🏿",
        "⛓️",
        "🌾",
        "🪓",
        "🩸",
        "🕊️"
      ],
      "pack_id": "daily_exclusive",
      "year": 2013
    },
    {
      "id": "dis_hunchback",
      "title": "The Hunchback of Notre Dame",
      "aliases": [],
      "emojis": [
        "🔔",
        "⛪",
        "💃🏽",
        "🪞",
        "🐐",
        "🇫🇷"
      ],
      "pack_id": "daily_exclusive",
      "year": 1996
    },
    {
      "id": "hr_texas_chainsaw",
      "title": "The Texas Chain Saw Massacre",
      "aliases": [
        "Texas Chainsaw Massacre"
      ],
      "emojis": [
        "🪚",
        "👤",
        "🏚️",
        "🪝",
        "🇺🇸",
        "🩸"
      ],
      "pack_id": "daily_exclusive",
      "year": 1974
    },
    {
      "id": "hr_paranormal",
      "title": "Paranormal Activity",
      "aliases": [],
      "emojis": [
        "📹",
        "🛏️",
        "👻",
        "🚪",
        "👣",
        "🌃"
      ],
      "pack_id": "daily_exclusive",
      "year": 2007
    },
    {
      "id": "bio_mlk_selma_skip",
      "title": "Selma",
      "aliases": [],
      "emojis": [
        "✊🏿",
        "🌉",
        "🏛️",
        "🇺🇸",
        "👨🏿",
        "🎤"
      ],
      "pack_id": "daily_exclusive",
      "year": 2014
    },
    {
      "id": "ind_nightcrawler",
      "title": "Nightcrawler",
      "aliases": [],
      "emojis": [
        "👨",
        "📹",
        "🌃",
        "🚨",
        "🩸",
        "📺",
        "💵",
        "😈"
      ],
      "pack_id": "daily_exclusive",
      "year": 2014
    },
    {
      "id": "sf_edge_tomorrow",
      "title": "Edge of Tomorrow",
      "aliases": [],
      "emojis": [
        "⏰",
        "🪖",
        "👽",
        "💥",
        "🔁",
        "🔫"
      ],
      "pack_id": "daily_exclusive",
      "year": 2014
    },
    {
      "id": "com_neighbors",
      "title": "Neighbors",
      "aliases": [],
      "emojis": [
        "🏠",
        "🏠",
        "👶",
        "🍻",
        "🏫",
        "💥"
      ],
      "pack_id": "daily_exclusive",
      "year": 2014
    },
    {
      "id": "alt_sweeney_todd",
      "title": "Sweeney Todd",
      "aliases": [],
      "emojis": [
        "✂️",
        "🪒",
        "🥧",
        "🩸",
        "🇬🇧",
        "💔"
      ],
      "pack_id": "daily_exclusive",
      "year": 2007
    },
    {
      "id": "alt_up_in_air",
      "title": "Up in the Air",
      "aliases": [],
      "emojis": [
        "✈️",
        "👨‍💼",
        "📦",
        "🎒",
        "💑",
        "💒",
        "💔",
        "✈️"
      ],
      "pack_id": "daily_exclusive",
      "year": 2009
    },
    {
      "id": "alt_disaster_artist",
      "title": "The Disaster Artist",
      "aliases": [],
      "emojis": [
        "👨",
        "👨",
        "🎭",
        "🌆",
        "🎬",
        "🏈",
        "🤣",
        "👏"
      ],
      "pack_id": "daily_exclusive",
      "year": 2017
    },
    {
      "id": "alt_chicago_7",
      "title": "The Trial of the Chicago 7",
      "aliases": [
        "Chicago 7"
      ],
      "emojis": [
        "⚖️",
        "✊",
        "🇺🇸",
        "🇻🇳",
        "🚓",
        "🎤"
      ],
      "pack_id": "daily_exclusive",
      "year": 2020
    },
    {
      "id": "ns_in_time",
      "title": "In Time",
      "aliases": [],
      "emojis": [
        "⏰",
        "💰",
        "🏃",
        "💑",
        "🔫"
      ],
      "pack_id": "daily_exclusive",
      "year": 2011
    },
    {
      "id": "bio_iron_lady",
      "title": "The Iron Lady",
      "aliases": [],
      "emojis": [
        "👵",
        "💭",
        "🗳️",
        "🇬🇧",
        "🏛️",
        "👜",
        "🚢",
        "😢"
      ],
      "pack_id": "daily_exclusive",
      "year": 2011
    },
    {
      "id": "alt_ordinary_people",
      "title": "Ordinary People",
      "aliases": [],
      "emojis": [
        "⛵",
        "⛈️",
        "💀",
        "👦",
        "🛁",
        "🧠",
        "🗣️",
        "👩",
        "🚪"
      ],
      "pack_id": "daily_exclusive",
      "year": 1980
    },
    {
      "id": "alt_christine",
      "title": "Christine",
      "aliases": [],
      "emojis": [
        "🚗",
        "🔴",
        "🎵",
        "💔",
        "🔥",
        "💀"
      ],
      "pack_id": "daily_exclusive",
      "year": 1983
    },
    {
      "id": "alt_papillon",
      "title": "Papillon",
      "aliases": [],
      "emojis": [
        "🦋",
        "⛓️",
        "🏝️",
        "🥥",
        "🌊",
        "🌅"
      ],
      "pack_id": "daily_exclusive",
      "year": 1973
    },
    {
      "id": "rc_something_about_mary",
      "title": "There's Something About Mary",
      "aliases": [
        "Theres Something About Mary"
      ],
      "emojis": [
        "🏫",
        "💃",
        "👨",
        "🐕",
        "🎣",
        "💇‍♂️",
        "🚓",
        "💑"
      ],
      "pack_id": "daily_exclusive",
      "year": 1998
    },
    {
      "id": "aa_crouching_tiger",
      "title": "Crouching Tiger, Hidden Dragon",
      "aliases": [
        "Crouching Tiger Hidden Dragon"
      ],
      "emojis": [
        "🇨🇳",
        "🥋",
        "🗡️",
        "🐅",
        "🐉",
        "🎋",
        "🏔️",
        "💑"
      ],
      "pack_id": "daily_exclusive",
      "year": 2000
    },
    {
      "id": "ci_boyhood",
      "title": "Boyhood",
      "aliases": [],
      "emojis": [
        "👶",
        "👦",
        "🧒",
        "👨‍🎓",
        "🎂",
        "🎂",
        "🎂",
        "🎂",
        "🚗",
        "📷"
      ],
      "pack_id": "daily_exclusive",
      "year": 2014
    },
    {
      "id": "cl_rear_window",
      "title": "Rear Window",
      "aliases": [],
      "emojis": [
        "📷",
        "🦴",
        "🪟",
        "🔍",
        "🔪",
        "🚪",
        "👮‍♂️"
      ],
      "pack_id": "daily_exclusive",
      "year": 1954
    },
    {
      "id": "cl_12_angry_men",
      "title": "12 Angry Men",
      "aliases": [
        "Twelve Angry Men"
      ],
      "emojis": [
        "⚖️",
        "🚪",
        "🗳️",
        "☝️",
        "🥵",
        "🔪",
        "👓",
        "🤝"
      ],
      "pack_id": "daily_exclusive",
      "year": 1957
    },
    {
      "id": "ni_robocop",
      "title": "RoboCop",
      "aliases": [
        "Robocop",
        "Robo Cop"
      ],
      "emojis": [
        "👮‍♂️",
        "🔫",
        "💀",
        "🤖",
        "🏙️",
        "🎯"
      ],
      "pack_id": "daily_exclusive",
      "year": 1987
    },
    {
      "id": "mi_sin_city",
      "title": "Sin City",
      "aliases": [],
      "emojis": [
        "🏙️",
        "⚫",
        "⚪",
        "🩸",
        "🔫",
        "👤",
        "💃"
      ],
      "pack_id": "daily_exclusive",
      "year": 2005
    },
    {
      "id": "billy_madison",
      "title": "Billy Madison",
      "aliases": [],
      "emojis": [
        "👨",
        "🏫",
        "💩",
        "🐧",
        "💼",
        "🦌"
      ],
      "pack_id": "daily_exclusive",
      "year": 1995
    },
    {
      "id": "nacho_libre",
      "title": "Nacho Libre",
      "aliases": [],
      "emojis": [
        "🇲🇽",
        "⛪",
        "🍲",
        "👶",
        "🎭",
        "🤼",
        "🥚",
        "🏆"
      ],
      "pack_id": "daily_exclusive",
      "year": 2006
    },
    {
      "id": "coen_hudsucker",
      "title": "The Hudsucker Proxy",
      "aliases": [],
      "emojis": [
        "📬",
        "🏢",
        "💼",
        "⭕",
        "🎉",
        "📉",
        "🕰️",
        "👼"
      ],
      "pack_id": "daily_exclusive",
      "year": 1994
    },
    {
      "id": "coen_inside_llewyn",
      "title": "Inside Llewyn Davis",
      "aliases": [],
      "emojis": [
        "🎸",
        "🐈",
        "🚪",
        "❄️",
        "🎙️",
        "🚗"
      ],
      "pack_id": "daily_exclusive",
      "year": 2013
    },
    {
      "id": "fincher_killer",
      "title": "The Killer",
      "aliases": [],
      "emojis": [
        "🎯",
        "🔫",
        "🌍",
        "🎧",
        "🤐",
        "🎵"
      ],
      "pack_id": "daily_exclusive",
      "year": 2023
    },
    {
      "id": "spielberg_munich",
      "title": "Munich",
      "aliases": [],
      "emojis": [
        "🇮🇱",
        "🕯️",
        "🔫",
        "🇩🇪",
        "🎯",
        "💼"
      ],
      "pack_id": "daily_exclusive",
      "year": 2005
    },
    {
      "id": "pix_turning_red",
      "title": "Turning Red",
      "aliases": [],
      "emojis": [
        "🧧",
        "🐼",
        "👧",
        "🎵",
        "💪",
        "🩸"
      ],
      "pack_id": "daily_exclusive",
      "year": 2022
    },
    {
      "id": "ghibli_kiki",
      "title": "Kiki's Delivery Service",
      "aliases": [
        "Kikis Delivery Service"
      ],
      "emojis": [
        "🧹",
        "🐈",
        "📦",
        "🥖",
        "🛬",
        "🌅"
      ],
      "pack_id": "daily_exclusive",
      "year": 1989
    },
    {
      "id": "dis_robin_hood",
      "title": "Robin Hood",
      "aliases": [],
      "emojis": [
        "🏹",
        "🦊",
        "👑",
        "🦁",
        "🐍",
        "💰"
      ],
      "pack_id": "daily_exclusive",
      "year": 1973
    },
    {
      "id": "dis_princess_frog",
      "title": "The Princess and the Frog",
      "aliases": [],
      "emojis": [
        "👩🏿",
        "🐸",
        "🤴🏾",
        "🌃",
        "🎷",
        "🐊",
        "✨"
      ],
      "pack_id": "daily_exclusive",
      "year": 2009
    },
    {
      "id": "dis_big_hero_6",
      "title": "Big Hero 6",
      "aliases": [
        "Big Hero Six"
      ],
      "emojis": [
        "🤖",
        "👦",
        "💖",
        "🏙️",
        "🦠",
        "🌀"
      ],
      "pack_id": "daily_exclusive",
      "year": 2014
    },
    {
      "id": "kingsman",
      "title": "Kingsman: The Secret Service",
      "aliases": [
        "Kingsman"
      ],
      "emojis": [
        "☂️",
        "🤵",
        "💪",
        "🍔",
        "🌍",
        "💥"
      ],
      "pack_id": "daily_exclusive",
      "year": 2014
    },
    {
      "id": "hr_28_days",
      "title": "28 Days Later",
      "aliases": [
        "Twenty Eight Days Later"
      ],
      "emojis": [
        "🐒",
        "🦠",
        "🛌",
        "🏥",
        "🇬🇧",
        "🧟",
        "🏃",
        "🪖"
      ],
      "pack_id": "daily_exclusive",
      "year": 2002
    },
    {
      "id": "hr_insidious",
      "title": "Insidious",
      "aliases": [],
      "emojis": [
        "👦",
        "🪜",
        "😴",
        "🏠",
        "👻",
        "👵",
        "🕯️",
        "🚪",
        "👹"
      ],
      "pack_id": "daily_exclusive",
      "year": 2010
    },
    {
      "id": "hr_others",
      "title": "The Others",
      "aliases": [],
      "emojis": [
        "🕯️",
        "👻",
        "🏚️",
        "👶",
        "🪟",
        "🌫️"
      ],
      "pack_id": "daily_exclusive",
      "year": 2001
    },
    {
      "id": "rc_shes_all_that",
      "title": "She's All That",
      "aliases": [
        "Shes All That"
      ],
      "emojis": [
        "🤝",
        "💵",
        "👓",
        "🎨",
        "✂️",
        "👗",
        "😍",
        "👑",
        "💃"
      ],
      "pack_id": "daily_exclusive",
      "year": 1999
    },
    {
      "id": "sp_fighter",
      "title": "The Fighter",
      "aliases": [],
      "emojis": [
        "🥊",
        "👨‍👩‍👦",
        "💪",
        "🇺🇸",
        "🏆",
        "💉"
      ],
      "pack_id": "daily_exclusive",
      "year": 2010
    },
    {
      "id": "sp_wrestler",
      "title": "The Wrestler",
      "aliases": [],
      "emojis": [
        "🤼",
        "💪",
        "💔",
        "🍔",
        "👨‍👧",
        "🩹"
      ],
      "pack_id": "daily_exclusive",
      "year": 2008
    },
    {
      "id": "bio_dallas_buyers",
      "title": "Dallas Buyers Club",
      "aliases": [],
      "emojis": [
        "💊",
        "🤠",
        "🐂",
        "🤝",
        "🏥",
        "🇺🇸"
      ],
      "pack_id": "daily_exclusive",
      "year": 2013
    },
    {
      "id": "act_a_team",
      "title": "The A-Team",
      "aliases": [
        "A Team"
      ],
      "emojis": [
        "🪖",
        "🚁",
        "💥",
        "🪂",
        "💵",
        "🔫"
      ],
      "pack_id": "daily_exclusive",
      "year": 2010
    },
    {
      "id": "act_man_on_fire",
      "title": "Man on Fire",
      "aliases": [],
      "emojis": [
        "👨🏿",
        "🥃",
        "👧",
        "🏊",
        "🇲🇽",
        "😱",
        "💰",
        "🔥",
        "🔫"
      ],
      "pack_id": "daily_exclusive",
      "year": 2004
    },
    {
      "id": "ind_pacific_rim",
      "title": "Pacific Rim",
      "aliases": [],
      "emojis": [
        "🤖",
        "🐉",
        "🌊",
        "🥊",
        "👨‍🚀",
        "🇭🇰"
      ],
      "pack_id": "daily_exclusive",
      "year": 2013
    },
    {
      "id": "sf_war_worlds_2005",
      "title": "War of the Worlds",
      "aliases": [],
      "emojis": [
        "🛸",
        "🌍",
        "👨‍👧",
        "💥",
        "⚡",
        "🏚️"
      ],
      "pack_id": "daily_exclusive",
      "year": 2005
    },
    {
      "id": "sf_galaxy_quest",
      "title": "Galaxy Quest",
      "aliases": [],
      "emojis": [
        "📺",
        "🎤",
        "👽",
        "🚀",
        "🪨",
        "⚙️",
        "🦑",
        "🛬",
        "👏"
      ],
      "pack_id": "daily_exclusive",
      "year": 1999
    },
    {
      "id": "com_clerks",
      "title": "Clerks",
      "aliases": [],
      "emojis": [
        "🏪",
        "⚫",
        "💬",
        "🏒",
        "⚰️",
        "🚬",
        "💔"
      ],
      "pack_id": "daily_exclusive",
      "year": 1994
    },
    {
      "id": "for_run_lola_run",
      "title": "Run Lola Run",
      "aliases": [],
      "emojis": [
        "☎️",
        "👩‍🦰",
        "🏃",
        "⏳",
        "💰",
        "🎰",
        "🔫",
        "🔁"
      ],
      "pack_id": "daily_exclusive",
      "year": 1998
    },
    {
      "id": "for_volver",
      "title": "Volver",
      "aliases": [],
      "emojis": [
        "👩",
        "🇪🇸",
        "🔪",
        "🩸",
        "🧊",
        "🍽️",
        "👵",
        "👻",
        "🤗"
      ],
      "pack_id": "daily_exclusive",
      "year": 2006
    },
    {
      "id": "for_lives_others",
      "title": "The Lives of Others",
      "aliases": [],
      "emojis": [
        "🎧",
        "🇩🇪",
        "✍️",
        "🤐",
        "💔",
        "📚"
      ],
      "pack_id": "daily_exclusive",
      "year": 2006
    },
    {
      "id": "alt_we_were_soldiers",
      "title": "We Were Soldiers",
      "aliases": [],
      "emojis": [
        "🪖",
        "🚁",
        "🇻🇳",
        "🎺",
        "💔",
        "💌"
      ],
      "pack_id": "daily_exclusive",
      "year": 2002
    },
    {
      "id": "alt_letters_iwo",
      "title": "Letters from Iwo Jima",
      "aliases": [],
      "emojis": [
        "🇯🇵",
        "💌",
        "🪖",
        "🏝️",
        "💔",
        "🪦"
      ],
      "pack_id": "daily_exclusive",
      "year": 2006
    },
    {
      "id": "alt_paths_glory",
      "title": "Paths of Glory",
      "aliases": [],
      "emojis": [
        "🪖",
        "🇫🇷",
        "⛰️",
        "💥",
        "⚖️",
        "🔫",
        "😢",
        "🎶"
      ],
      "pack_id": "daily_exclusive",
      "year": 1957
    },
    {
      "id": "alt_310_yuma",
      "title": "3:10 to Yuma",
      "aliases": [
        "Three Ten to Yuma"
      ],
      "emojis": [
        "🚂",
        "🤠",
        "🤠",
        "⏰",
        "💰",
        "💪"
      ],
      "pack_id": "daily_exclusive",
      "year": 2007
    },
    {
      "id": "alt_hidalgo",
      "title": "Hidalgo",
      "aliases": [],
      "emojis": [
        "🤠",
        "🐎",
        "🚢",
        "🇸🇦",
        "🏜️",
        "🌪️",
        "🏁",
        "🏆"
      ],
      "pack_id": "daily_exclusive",
      "year": 2004
    },
    {
      "id": "alt_wyatt_earp",
      "title": "Wyatt Earp",
      "aliases": [],
      "emojis": [
        "👦",
        "🌽",
        "👰",
        "⚰️",
        "🥃",
        "⭐",
        "🃏",
        "🔫",
        "🐎"
      ],
      "pack_id": "daily_exclusive",
      "year": 1994
    },
    {
      "id": "alt_hairspray",
      "title": "Hairspray",
      "aliases": [],
      "emojis": [
        "👧",
        "💇‍♀️",
        "📺",
        "💃🏿",
        "🚫",
        "✊🏿",
        "🏆",
        "💑"
      ],
      "pack_id": "daily_exclusive",
      "year": 2007
    },
    {
      "id": "alt_jfk",
      "title": "JFK",
      "aliases": [],
      "emojis": [
        "🇺🇸",
        "🚗",
        "🔫",
        "⚰️",
        "🕵️",
        "🎞️",
        "⚖️",
        "❓"
      ],
      "pack_id": "daily_exclusive",
      "year": 1991
    },
    {
      "id": "alt_12_monkeys",
      "title": "12 Monkeys",
      "aliases": [
        "Twelve Monkeys"
      ],
      "emojis": [
        "🐒",
        "🦠",
        "⏰",
        "🧠",
        "🔫",
        "🛬"
      ],
      "pack_id": "daily_exclusive",
      "year": 1995
    },
    {
      "id": "alt_english_patient",
      "title": "The English Patient",
      "aliases": [],
      "emojis": [
        "🛫",
        "🏜️",
        "🩹",
        "💔",
        "🗺️",
        "💑"
      ],
      "pack_id": "daily_exclusive",
      "year": 1996
    },
    {
      "id": "alt_traffic",
      "title": "Traffic",
      "aliases": [],
      "emojis": [
        "🌵",
        "💉",
        "👨‍⚖️",
        "🇲🇽",
        "💔",
        "💼"
      ],
      "pack_id": "daily_exclusive",
      "year": 2000
    },
    {
      "id": "alt_queen",
      "title": "The Queen",
      "aliases": [],
      "emojis": [
        "👑",
        "🇬🇧",
        "🌹",
        "🦌",
        "💔",
        "📺"
      ],
      "pack_id": "daily_exclusive",
      "year": 2006
    },
    {
      "id": "alt_blackkklansman",
      "title": "BlacKkKlansman",
      "aliases": [],
      "emojis": [
        "👨🏿",
        "☎️",
        "🇺🇸",
        "✊",
        "💔",
        "🔥"
      ],
      "pack_id": "daily_exclusive",
      "year": 2018
    },
    {
      "id": "alt_father",
      "title": "The Father",
      "aliases": [],
      "emojis": [
        "👴",
        "🏠",
        "⌚",
        "💔",
        "🌪️",
        "🪞"
      ],
      "pack_id": "daily_exclusive",
      "year": 2020
    },
    {
      "id": "alt_breathless",
      "title": "Breathless",
      "aliases": [],
      "emojis": [
        "🚬",
        "🚗",
        "🇫🇷",
        "🔫",
        "💔",
        "🕶️"
      ],
      "pack_id": "daily_exclusive",
      "year": 1960
    },
    {
      "id": "ns_law_abiding",
      "title": "Law Abiding Citizen",
      "aliases": [],
      "emojis": [
        "⚖️",
        "💔",
        "🔪",
        "⛓️",
        "💣",
        "🏛️"
      ],
      "pack_id": "daily_exclusive",
      "year": 2009
    },
    {
      "id": "an_moana",
      "title": "Moana",
      "aliases": [],
      "emojis": [
        "👧🏾",
        "🌊",
        "💚",
        "⛵",
        "🐔",
        "💪🏾",
        "🪝",
        "🌋",
        "🌺"
      ],
      "pack_id": "daily_exclusive",
      "year": 2016
    },
    {
      "id": "fincher_mank",
      "title": "Mank",
      "aliases": [],
      "emojis": [
        "✍️",
        "🍷",
        "🎬",
        "🏰",
        "⚫",
        "⚪"
      ],
      "pack_id": "daily_exclusive",
      "year": 2020
    },
    {
      "id": "hr_invisible_man_2020",
      "title": "The Invisible Man",
      "aliases": [
        "Invisible Man 2020"
      ],
      "emojis": [
        "👩",
        "🌃",
        "🏃",
        "⚰️",
        "👤",
        "🔪",
        "🏥",
        "🤵",
        "💀"
      ],
      "pack_id": "daily_exclusive",
      "year": 2020
    },
    {
      "id": "rc_save_last_dance",
      "title": "Save the Last Dance",
      "aliases": [],
      "emojis": [
        "🩰",
        "💔",
        "💃",
        "🏫",
        "🕺🏿",
        "🎵"
      ],
      "pack_id": "daily_exclusive",
      "year": 2001
    },
    {
      "id": "sp_white_men_jump",
      "title": "White Men Can't Jump",
      "aliases": [
        "White Men Cant Jump"
      ],
      "emojis": [
        "🏀",
        "🌞",
        "👨🏿‍🤝‍👨🏻",
        "💰",
        "🌴",
        "🎯"
      ],
      "pack_id": "daily_exclusive",
      "year": 1992
    },
    {
      "id": "sp_days_thunder",
      "title": "Days of Thunder",
      "aliases": [],
      "emojis": [
        "🏎️",
        "🇺🇸",
        "🏁",
        "💥",
        "🤕",
        "👩‍⚕️",
        "💑",
        "🏆"
      ],
      "pack_id": "daily_exclusive",
      "year": 1990
    },
    {
      "id": "alt_in_bruges",
      "title": "In Bruges",
      "aliases": [],
      "emojis": [
        "🔫",
        "⛪",
        "👦",
        "😢",
        "🇧🇪",
        "🗼",
        "🛶",
        "😠",
        "💥"
      ],
      "pack_id": "daily_exclusive",
      "year": 2008
    },
    {
      "id": "alt_cujo",
      "title": "Cujo",
      "aliases": [],
      "emojis": [
        "🐕",
        "🚗",
        "🦠",
        "👩",
        "👦",
        "🪟"
      ],
      "pack_id": "daily_exclusive",
      "year": 1983
    },
    {
      "id": "hr_dawn_dead",
      "title": "Dawn of the Dead",
      "aliases": [],
      "emojis": [
        "🏬",
        "🧟",
        "🛒",
        "🪖",
        "🚁",
        "🩸"
      ],
      "pack_id": "daily_exclusive",
      "year": 1978
    },
    {
      "id": "sp_bull_durham",
      "title": "Bull Durham",
      "aliases": [],
      "emojis": [
        "👩",
        "⛪",
        "⚾",
        "🔥",
        "🧢",
        "💋",
        "🛁",
        "🕯️",
        "💑"
      ],
      "pack_id": "daily_exclusive",
      "year": 1988
    },
    {
      "id": "sp_natural",
      "title": "The Natural",
      "aliases": [],
      "emojis": [
        "⚾",
        "⚡",
        "🌳",
        "🌟",
        "💉",
        "🏆"
      ],
      "pack_id": "daily_exclusive",
      "year": 1984
    },
    {
      "id": "bio_steve_jobs",
      "title": "Steve Jobs",
      "aliases": [],
      "emojis": [
        "🍎",
        "💻",
        "👨",
        "🎤",
        "💔",
        "👧"
      ],
      "pack_id": "daily_exclusive",
      "year": 2015
    },
    {
      "id": "alt_shane",
      "title": "Shane",
      "aliases": [],
      "emojis": [
        "🤠",
        "🐎",
        "🏡",
        "👦",
        "🪓",
        "🤜",
        "🔫",
        "😢",
        "🌄"
      ],
      "pack_id": "daily_exclusive",
      "year": 1953
    },
    {
      "id": "alt_third_man",
      "title": "The Third Man",
      "aliases": [],
      "emojis": [
        "✍️",
        "🇦🇹",
        "⚰️",
        "🕵️",
        "🐈",
        "🎡",
        "🚇",
        "🔫"
      ],
      "pack_id": "daily_exclusive",
      "year": 1949
    },
    {
      "id": "alt_cabaret",
      "title": "Cabaret",
      "aliases": [],
      "emojis": [
        "💃",
        "🎤",
        "🎩",
        "🇩🇪",
        "🥂",
        "💑",
        "💔",
        "🪖"
      ],
      "pack_id": "daily_exclusive",
      "year": 1972
    },
    {
      "id": "alt_ripley",
      "title": "The Talented Mr. Ripley",
      "aliases": [],
      "emojis": [
        "👨",
        "🎹",
        "🇮🇹",
        "🎷",
        "⛵",
        "🚣",
        "💀",
        "🎭"
      ],
      "pack_id": "daily_exclusive",
      "year": 1999
    },
    {
      "id": "alt_about_schmidt",
      "title": "About Schmidt",
      "aliases": [],
      "emojis": [
        "👴",
        "🚐",
        "💔",
        "💌",
        "🌅",
        "🏡"
      ],
      "pack_id": "daily_exclusive",
      "year": 2002
    },
    {
      "id": "alt_michael_clayton",
      "title": "Michael Clayton",
      "aliases": [],
      "emojis": [
        "💼",
        "⚖️",
        "🤪",
        "📄",
        "💉",
        "🐎",
        "💥",
        "🚕"
      ],
      "pack_id": "daily_exclusive",
      "year": 2007
    },
    {
      "id": "alt_promising_young",
      "title": "Promising Young Woman",
      "aliases": [],
      "emojis": [
        "👩",
        "🍸",
        "🥴",
        "📓",
        "👩‍⚕️",
        "🎉",
        "💀",
        "🔥",
        "📱"
      ],
      "pack_id": "daily_exclusive",
      "year": 2020
    },
    {
      "id": "fincher_game",
      "title": "The Game",
      "aliases": [],
      "emojis": [
        "💼",
        "🎂",
        "🎁",
        "🤡",
        "📺",
        "💸",
        "🇲🇽",
        "🏢",
        "🎉"
      ],
      "pack_id": "daily_exclusive",
      "year": 1997
    },
    {
      "id": "atomic_blonde",
      "title": "Atomic Blonde",
      "aliases": [],
      "emojis": [
        "👱‍♀️",
        "🇩🇪",
        "🧊",
        "🔫",
        "🚗",
        "🎶"
      ],
      "pack_id": "daily_exclusive",
      "year": 2017
    },
    {
      "id": "hr_cloverfield",
      "title": "Cloverfield",
      "aliases": [],
      "emojis": [
        "🗽",
        "🦴",
        "📹",
        "🌃",
        "💥",
        "🦗"
      ],
      "pack_id": "daily_exclusive",
      "year": 2008
    },
    {
      "id": "rc_never_been_kissed",
      "title": "Never Been Kissed",
      "aliases": [],
      "emojis": [
        "👩",
        "📰",
        "🏫",
        "🤓",
        "💄",
        "👨‍🏫",
        "⚾",
        "💋"
      ],
      "pack_id": "daily_exclusive",
      "year": 1999
    },
    {
      "id": "bio_cinderella_man",
      "title": "Cinderella Man",
      "aliases": [],
      "emojis": [
        "🥊",
        "📉",
        "👨‍👩‍👧",
        "🥛",
        "⚓",
        "💪",
        "🥊",
        "🏆"
      ],
      "pack_id": "daily_exclusive",
      "year": 2005
    },
    {
      "id": "alt_doubt",
      "title": "Doubt",
      "aliases": [],
      "emojis": [
        "⛪",
        "🏫",
        "👨",
        "👦🏿",
        "🍷",
        "👩",
        "🗣️",
        "🚪",
        "❓"
      ],
      "pack_id": "daily_exclusive",
      "year": 2008
    },
    {
      "id": "alt_challengers",
      "title": "Challengers",
      "aliases": [],
      "emojis": [
        "🎾",
        "👩🏾",
        "👬",
        "💋",
        "🤕",
        "💍",
        "💔",
        "🎾",
        "🫂"
      ],
      "pack_id": "daily_exclusive",
      "year": 2024
    },
    {
      "id": "mi_bring_it_on",
      "title": "Bring It On",
      "aliases": [],
      "emojis": [
        "👱‍♀️",
        "📣",
        "👯‍♀️",
        "📼",
        "😱",
        "👩🏿",
        "💃",
        "🏆",
        "🥈"
      ],
      "pack_id": "daily_exclusive",
      "year": 2000
    },
    {
      "id": "ni_pianist",
      "title": "The Pianist",
      "aliases": [
        "Pianist"
      ],
      "emojis": [
        "🎹",
        "🇵🇱",
        "✡️",
        "🪖",
        "🏚️",
        "🍞",
        "🤝"
      ],
      "pack_id": "daily_exclusive",
      "year": 2002
    },
    {
      "id": "mi_drive",
      "title": "Drive",
      "aliases": [],
      "emojis": [
        "🚗",
        "🎬",
        "🧥",
        "💑",
        "🔨",
        "🩸",
        "🪙"
      ],
      "pack_id": "daily_exclusive",
      "year": 2011
    },
    {
      "id": "mi_shape_water",
      "title": "The Shape of Water",
      "aliases": [
        "Shape of Water"
      ],
      "emojis": [
        "🤐",
        "👩",
        "💧",
        "🐟",
        "❤️",
        "🌧️",
        "🏊‍♀️"
      ],
      "pack_id": "daily_exclusive",
      "year": 2017
    },
    {
      "id": "get_him_greek",
      "title": "Get Him to the Greek",
      "aliases": [],
      "emojis": [
        "✈️",
        "🇬🇧",
        "🎸",
        "💊",
        "🎰",
        "🧱",
        "🏛️",
        "🎤"
      ],
      "pack_id": "daily_exclusive",
      "year": 2010
    },
    {
      "id": "coen_millers_crossing",
      "title": "Miller's Crossing",
      "aliases": [
        "Millers Crossing"
      ],
      "emojis": [
        "🎩",
        "🌬️",
        "🌳",
        "🥃",
        "🤝",
        "💔",
        "🙏",
        "🔫"
      ],
      "pack_id": "daily_exclusive",
      "year": 1990
    },
    {
      "id": "spielberg_fabelmans",
      "title": "The Fabelmans",
      "aliases": [],
      "emojis": [
        "🎬",
        "👦",
        "👩‍🦰",
        "🚂",
        "🎥",
        "💔",
        "🌅"
      ],
      "pack_id": "daily_exclusive",
      "year": 2022
    },
    {
      "id": "scorsese_after_hours",
      "title": "After Hours",
      "aliases": [],
      "emojis": [
        "💻",
        "👩",
        "🚖",
        "💸",
        "🌃",
        "🏃",
        "🗿",
        "🌅"
      ],
      "pack_id": "daily_exclusive",
      "year": 1985
    },
    {
      "id": "pix_lightyear",
      "title": "Lightyear",
      "aliases": [],
      "emojis": [
        "🚀",
        "🤖",
        "🐱",
        "👴",
        "⚡",
        "🌌"
      ],
      "pack_id": "daily_exclusive",
      "year": 2022
    },
    {
      "id": "ghibli_howl",
      "title": "Howl's Moving Castle",
      "aliases": [
        "Howls Moving Castle"
      ],
      "emojis": [
        "🏰",
        "🦶",
        "👵",
        "🔥",
        "🪄",
        "🌟"
      ],
      "pack_id": "daily_exclusive",
      "year": 2004
    },
    {
      "id": "dis_bolt",
      "title": "Bolt",
      "aliases": [],
      "emojis": [
        "🐕",
        "⚡",
        "📺",
        "🐈",
        "🐹",
        "✈️"
      ],
      "pack_id": "daily_exclusive",
      "year": 2008
    },
    {
      "id": "dw_megamind",
      "title": "Megamind",
      "aliases": [],
      "emojis": [
        "👽",
        "🦸",
        "🎙️",
        "🦈",
        "🏙️",
        "🐟"
      ],
      "pack_id": "daily_exclusive",
      "year": 2010
    },
    {
      "id": "zero_dark_thirty",
      "title": "Zero Dark Thirty",
      "aliases": [],
      "emojis": [
        "🌑",
        "🇵🇰",
        "🪖",
        "💀",
        "💻",
        "🚁"
      ],
      "pack_id": "daily_exclusive",
      "year": 2012
    },
    {
      "id": "hr_evil_dead",
      "title": "The Evil Dead",
      "aliases": [],
      "emojis": [
        "📖",
        "🌲",
        "🩸",
        "🪓",
        "🪞",
        "💀"
      ],
      "pack_id": "daily_exclusive",
      "year": 1981
    },
    {
      "id": "hr_train_busan",
      "title": "Train to Busan",
      "aliases": [],
      "emojis": [
        "🚄",
        "🇰🇷",
        "🧟",
        "👨‍👧",
        "💔",
        "🏟️"
      ],
      "pack_id": "daily_exclusive",
      "year": 2016
    },
    {
      "id": "sp_any_given_sunday",
      "title": "Any Given Sunday",
      "aliases": [],
      "emojis": [
        "🏈",
        "👴",
        "🤕",
        "👨🏿",
        "🤮",
        "🌟",
        "🗣️",
        "🏟️"
      ],
      "pack_id": "daily_exclusive",
      "year": 1999
    },
    {
      "id": "sp_concussion",
      "title": "Concussion",
      "aliases": [],
      "emojis": [
        "👨🏿‍⚕️",
        "⚰️",
        "🔬",
        "🧠",
        "🏈",
        "📄",
        "😡",
        "✊"
      ],
      "pack_id": "daily_exclusive",
      "year": 2015
    },
    {
      "id": "bio_bombshell",
      "title": "Bombshell",
      "aliases": [],
      "emojis": [
        "👱‍♀️",
        "👱‍♀️",
        "📺",
        "🦊",
        "👴",
        "🤫",
        "✊",
        "⚖️"
      ],
      "pack_id": "daily_exclusive",
      "year": 2019
    },
    {
      "id": "bio_milk",
      "title": "Milk",
      "aliases": [],
      "emojis": [
        "🌈",
        "🥛",
        "🏛️",
        "🇺🇸",
        "🔫",
        "💔"
      ],
      "pack_id": "daily_exclusive",
      "year": 2008
    },
    {
      "id": "bio_atonement",
      "title": "Atonement",
      "aliases": [],
      "emojis": [
        "👧",
        "⛲",
        "💌",
        "💑",
        "😡",
        "👮",
        "🪖",
        "🏖️",
        "✍️"
      ],
      "pack_id": "daily_exclusive",
      "year": 2007
    },
    {
      "id": "act_collateral",
      "title": "Collateral",
      "aliases": [],
      "emojis": [
        "🚕",
        "🤵",
        "🔫",
        "🌃",
        "👨🏿",
        "💥"
      ],
      "pack_id": "daily_exclusive",
      "year": 2004
    },
    {
      "id": "act_extraction",
      "title": "Extraction",
      "aliases": [],
      "emojis": [
        "👨",
        "💪",
        "🇦🇺",
        "👦🏽",
        "😱",
        "🏙️",
        "🔫",
        "🌉",
        "🌊"
      ],
      "pack_id": "daily_exclusive",
      "year": 2020
    },
    {
      "id": "sf_planet_apes_2011",
      "title": "Rise of the Planet of the Apes",
      "aliases": [
        "Rise of the Apes"
      ],
      "emojis": [
        "🦍",
        "🧪",
        "🌉",
        "🌳",
        "💉",
        "✊"
      ],
      "pack_id": "daily_exclusive",
      "year": 2011
    },
    {
      "id": "com_pineapple",
      "title": "Pineapple Express",
      "aliases": [],
      "emojis": [
        "🍍",
        "🌿",
        "🚗",
        "🔫",
        "🤝",
        "🐶"
      ],
      "pack_id": "daily_exclusive",
      "year": 2008
    },
    {
      "id": "fam_golden_compass",
      "title": "The Golden Compass",
      "aliases": [],
      "emojis": [
        "🧭",
        "🐻",
        "👧",
        "❄️",
        "✨",
        "🎒"
      ],
      "pack_id": "daily_exclusive",
      "year": 2007
    },
    {
      "id": "fam_dennis_menace",
      "title": "Dennis the Menace",
      "aliases": [],
      "emojis": [
        "👦",
        "🪀",
        "👴",
        "😡",
        "🪙",
        "🦹",
        "🪤",
        "🔥"
      ],
      "pack_id": "daily_exclusive",
      "year": 1993
    },
    {
      "id": "for_y_tu_mama",
      "title": "Y Tu Mamá También",
      "aliases": [
        "Y Tu Mama Tambien"
      ],
      "emojis": [
        "🚗",
        "🏖️",
        "🇲🇽",
        "👬🏽",
        "👩🏽",
        "🛏️"
      ],
      "pack_id": "daily_exclusive",
      "year": 2001
    },
    {
      "id": "for_mother",
      "title": "Mother",
      "aliases": [],
      "emojis": [
        "👵",
        "👦",
        "🚓",
        "🔍",
        "😱",
        "🔪",
        "🔥",
        "💃"
      ],
      "pack_id": "daily_exclusive",
      "year": 2009
    },
    {
      "id": "for_the_host",
      "title": "The Host",
      "aliases": [],
      "emojis": [
        "🌊",
        "🦎",
        "🇰🇷",
        "👨‍👩‍👧",
        "🦠",
        "🏃"
      ],
      "pack_id": "daily_exclusive",
      "year": 2006
    },
    {
      "id": "alt_stalag_17",
      "title": "Stalag 17",
      "aliases": [
        "Stalag Seventeen"
      ],
      "emojis": [
        "🪖",
        "⛓️",
        "🇩🇪",
        "🏃",
        "💀",
        "🐀",
        "🚬",
        "💡",
        "🏃"
      ],
      "pack_id": "daily_exclusive",
      "year": 1953
    },
    {
      "id": "alt_line_fire",
      "title": "In the Line of Fire",
      "aliases": [],
      "emojis": [
        "🕵️",
        "🇺🇸",
        "☎️",
        "😈",
        "🏃",
        "🔫",
        "🛡️"
      ],
      "pack_id": "daily_exclusive",
      "year": 1993
    },
    {
      "id": "an_tangled",
      "title": "Tangled",
      "aliases": [],
      "emojis": [
        "👶",
        "🏰",
        "👱‍♀️",
        "🍳",
        "🏮",
        "✂️",
        "💧",
        "✨",
        "💑"
      ],
      "pack_id": "daily_exclusive",
      "year": 2010
    },
    {
      "id": "alt_good_night_luck",
      "title": "Good Night, and Good Luck",
      "aliases": [],
      "emojis": [
        "📺",
        "🚬",
        "🎤",
        "🇺🇸",
        "🔍",
        "⚫"
      ],
      "pack_id": "daily_exclusive",
      "year": 2005
    },
    {
      "id": "alt_babel",
      "title": "Babel",
      "aliases": [],
      "emojis": [
        "🔫",
        "🌍",
        "🇲🇽",
        "🇯🇵",
        "🇲🇦",
        "💔"
      ],
      "pack_id": "daily_exclusive",
      "year": 2006
    },
    {
      "id": "alt_diving_bell",
      "title": "The Diving Bell and the Butterfly",
      "aliases": [],
      "emojis": [
        "♿",
        "🦋",
        "👁️",
        "🇫🇷",
        "✍️",
        "💔"
      ],
      "pack_id": "daily_exclusive",
      "year": 2007
    },
    {
      "id": "alt_nebraska",
      "title": "Nebraska",
      "aliases": [],
      "emojis": [
        "👴",
        "📨",
        "💰",
        "🚶",
        "👨‍👦",
        "🚗",
        "🍺",
        "🚚"
      ],
      "pack_id": "daily_exclusive",
      "year": 2013
    },
    {
      "id": "alt_florida_project",
      "title": "The Florida Project",
      "aliases": [],
      "emojis": [
        "👧",
        "💜",
        "🏨",
        "🍦",
        "🌴",
        "🔥",
        "💔",
        "🏰"
      ],
      "pack_id": "daily_exclusive",
      "year": 2017
    },
    {
      "id": "alt_beale_street",
      "title": "If Beale Street Could Talk",
      "aliases": [],
      "emojis": [
        "👩🏿‍❤️‍👨🏿",
        "🤰🏿",
        "🚔",
        "⛓️",
        "⚖️",
        "👶",
        "💔"
      ],
      "pack_id": "daily_exclusive",
      "year": 2018
    },
    {
      "id": "alt_two_popes",
      "title": "The Two Popes",
      "aliases": [],
      "emojis": [
        "⛪",
        "✝️",
        "🇦🇷",
        "🇩🇪",
        "🕺",
        "🤝"
      ],
      "pack_id": "daily_exclusive",
      "year": 2019
    },
    {
      "id": "alt_road_perdition",
      "title": "Road to Perdition",
      "aliases": [],
      "emojis": [
        "🚗",
        "☔",
        "💼",
        "🔫",
        "👨‍👦",
        "🪦"
      ],
      "pack_id": "daily_exclusive",
      "year": 2002
    },
    {
      "id": "alt_the_mist",
      "title": "The Mist",
      "aliases": [],
      "emojis": [
        "🌫️",
        "🏪",
        "🪲",
        "✝️",
        "🔫",
        "💔"
      ],
      "pack_id": "daily_exclusive",
      "year": 2007
    },
    {
      "id": "alt_metropolis",
      "title": "Metropolis",
      "aliases": [],
      "emojis": [
        "🏙️",
        "🤖",
        "⚙️",
        "💔",
        "🪜",
        "💥"
      ],
      "pack_id": "daily_exclusive",
      "year": 1927
    },
    {
      "id": "hr_descent",
      "title": "The Descent",
      "aliases": [],
      "emojis": [
        "🕳️",
        "🧗‍♀️",
        "🔦",
        "🩸",
        "💀",
        "🦇"
      ],
      "pack_id": "daily_exclusive",
      "year": 2005
    },
    {
      "id": "hr_dont_breathe",
      "title": "Don't Breathe",
      "aliases": [
        "Dont Breathe"
      ],
      "emojis": [
        "🌃",
        "🔓",
        "🏚️",
        "💰",
        "👴",
        "🕶️",
        "🤫",
        "🐕",
        "🔫"
      ],
      "pack_id": "daily_exclusive",
      "year": 2016
    },
    {
      "id": "an_brave",
      "title": "Brave",
      "aliases": [],
      "emojis": [
        "🏴󠁧󠁢󠁳󠁣󠁴󠁿",
        "👩‍🦰",
        "🏹",
        "🎯",
        "🧙‍♀️",
        "🍰",
        "🐻",
        "🧵",
        "🤝"
      ],
      "pack_id": "daily_exclusive",
      "year": 2012
    },
    {
      "id": "cl_annie_hall",
      "title": "Annie Hall",
      "aliases": [],
      "emojis": [
        "🗽",
        "👨",
        "👩",
        "💑",
        "🎬",
        "🪞",
        "💔",
        "🦞"
      ],
      "pack_id": "daily_exclusive",
      "year": 1977
    },
    {
      "id": "mi_snatch",
      "title": "Snatch",
      "aliases": [],
      "emojis": [
        "💎",
        "🥊",
        "👤",
        "🇮🇪",
        "🐷",
        "🔫",
        "🤣"
      ],
      "pack_id": "daily_exclusive",
      "year": 2000
    },
    {
      "id": "nolan_insomnia",
      "title": "Insomnia",
      "aliases": [],
      "emojis": [
        "☀️",
        "🌫️",
        "🚓",
        "💀",
        "🏔️",
        "😵"
      ],
      "pack_id": "daily_exclusive",
      "year": 2002
    },
    {
      "id": "dis_emperor_groove",
      "title": "The Emperor's New Groove",
      "aliases": [
        "Emperors New Groove"
      ],
      "emojis": [
        "👑",
        "🦙",
        "🧪",
        "🌵",
        "🥗",
        "🌧️"
      ],
      "pack_id": "daily_exclusive",
      "year": 2000
    },
    {
      "id": "dw_boss_baby",
      "title": "The Boss Baby",
      "aliases": [],
      "emojis": [
        "👶",
        "💼",
        "🍼",
        "🐶",
        "👨‍👩‍👦",
        "🎯"
      ],
      "pack_id": "daily_exclusive",
      "year": 2017
    },
    {
      "id": "hr_cabin_woods",
      "title": "The Cabin in the Woods",
      "aliases": [
        "Cabin in the Woods"
      ],
      "emojis": [
        "🏚️",
        "🌲",
        "🧟",
        "📋",
        "🛗",
        "🌍"
      ],
      "pack_id": "daily_exclusive",
      "year": 2012
    },
    {
      "id": "hr_sinister",
      "title": "Sinister",
      "aliases": [],
      "emojis": [
        "📼",
        "✍️",
        "👹",
        "🏠",
        "👧",
        "💀"
      ],
      "pack_id": "daily_exclusive",
      "year": 2012
    },
    {
      "id": "sp_warrior",
      "title": "Warrior",
      "aliases": [],
      "emojis": [
        "👨",
        "👨",
        "💔",
        "👴",
        "🍺",
        "🥋",
        "🥊",
        "🤼",
        "🤗"
      ],
      "pack_id": "daily_exclusive",
      "year": 2011
    },
    {
      "id": "sp_southpaw",
      "title": "Southpaw",
      "aliases": [],
      "emojis": [
        "🥊",
        "🏆",
        "👰",
        "🔫",
        "💔",
        "👧",
        "👨🏿",
        "💪",
        "🏆"
      ],
      "pack_id": "daily_exclusive",
      "year": 2015
    },
    {
      "id": "act_jack_reacher",
      "title": "Jack Reacher",
      "aliases": [],
      "emojis": [
        "🎯",
        "🔫",
        "😵",
        "🚶",
        "🔍",
        "🚗",
        "💥",
        "👊"
      ],
      "pack_id": "daily_exclusive",
      "year": 2012
    },
    {
      "id": "act_gone_60_secs",
      "title": "Gone in 60 Seconds",
      "aliases": [
        "Gone in Sixty Seconds"
      ],
      "emojis": [
        "👨",
        "🆘",
        "📋",
        "🔑",
        "🚗",
        "🌙",
        "🚓",
        "🌉",
        "💨"
      ],
      "pack_id": "daily_exclusive",
      "year": 2000
    },
    {
      "id": "act_white_house_down",
      "title": "White House Down",
      "aliases": [],
      "emojis": [
        "🏛️",
        "🇺🇸",
        "👨🏿",
        "🔫",
        "👨‍👧",
        "🚁"
      ],
      "pack_id": "daily_exclusive",
      "year": 2013
    },
    {
      "id": "sf_passengers",
      "title": "Passengers",
      "aliases": [],
      "emojis": [
        "🚀",
        "💤",
        "🌌",
        "💑",
        "🤖",
        "🍸"
      ],
      "pack_id": "daily_exclusive",
      "year": 2016
    },
    {
      "id": "com_central_intel",
      "title": "Central Intelligence",
      "aliases": [],
      "emojis": [
        "🏫",
        "😢",
        "💪🏿",
        "👨🏾",
        "🧮",
        "🕵🏿",
        "💻",
        "🔫",
        "🎉"
      ],
      "pack_id": "daily_exclusive",
      "year": 2016
    },
    {
      "id": "alt_awakenings",
      "title": "Awakenings",
      "aliases": [],
      "emojis": [
        "👨‍⚕️",
        "🏥",
        "⚾",
        "💊",
        "😀",
        "💃",
        "😢",
        "🛏️"
      ],
      "pack_id": "daily_exclusive",
      "year": 1990
    },
    {
      "id": "alt_insider",
      "title": "The Insider",
      "aliases": [],
      "emojis": [
        "🚬",
        "📰",
        "📺",
        "🤐",
        "💔",
        "⚖️"
      ],
      "pack_id": "daily_exclusive",
      "year": 1999
    },
    {
      "id": "alt_hours",
      "title": "The Hours",
      "aliases": [],
      "emojis": [
        "⏰",
        "👩",
        "✍️",
        "👩",
        "🎂",
        "👩",
        "🌹",
        "🪟",
        "🌊"
      ],
      "pack_id": "daily_exclusive",
      "year": 2002
    },
    {
      "id": "alt_once",
      "title": "Once",
      "aliases": [],
      "emojis": [
        "🎸",
        "🇮🇪",
        "🎤",
        "🎹",
        "💑",
        "🚪"
      ],
      "pack_id": "daily_exclusive",
      "year": 2007
    },
    {
      "id": "alt_margin_call",
      "title": "Margin Call",
      "aliases": [],
      "emojis": [
        "👨‍💼",
        "📦",
        "💾",
        "📊",
        "😨",
        "🌃",
        "🏦",
        "📉"
      ],
      "pack_id": "daily_exclusive",
      "year": 2011
    },
    {
      "id": "alt_sound_metal",
      "title": "Sound of Metal",
      "aliases": [],
      "emojis": [
        "🥁",
        "🤘",
        "🔇",
        "🦻",
        "💔",
        "👨🏽"
      ],
      "pack_id": "daily_exclusive",
      "year": 2019
    },
    {
      "id": "alt_history_violence",
      "title": "A History of Violence",
      "aliases": [],
      "emojis": [
        "☕",
        "🔫",
        "👨‍👩‍👧‍👦",
        "🩸",
        "🏠",
        "💔"
      ],
      "pack_id": "daily_exclusive",
      "year": 2005
    },
    {
      "id": "alt_pet_sematary",
      "title": "Pet Sematary",
      "aliases": [],
      "emojis": [
        "🐈",
        "🪦",
        "👶",
        "🚛",
        "🌲",
        "💀"
      ],
      "pack_id": "daily_exclusive",
      "year": 1989
    },
    {
      "id": "mi_500_days_summer",
      "title": "500 Days of Summer",
      "aliases": [
        "(500) Days of Summer"
      ],
      "emojis": [
        "📅",
        "💌",
        "🎤",
        "🛋️",
        "🕺",
        "🐦",
        "💔",
        "🍂"
      ],
      "pack_id": "daily_exclusive",
      "year": 2009
    },
    {
      "id": "ci_donnie_darko",
      "title": "Donnie Darko",
      "aliases": [],
      "emojis": [
        "👦",
        "😴",
        "🚪",
        "🐰",
        "✈️",
        "🌌",
        "⏰",
        "💀",
        "🚲"
      ],
      "pack_id": "daily_exclusive",
      "year": 2001
    },
    {
      "id": "coen_blood_simple",
      "title": "Blood Simple",
      "aliases": [],
      "emojis": [
        "🍺",
        "💔",
        "🕵️",
        "💵",
        "🔫",
        "🪦",
        "🖐️",
        "🔪"
      ],
      "pack_id": "daily_exclusive",
      "year": 1984
    },
    {
      "id": "ghibli_ponyo",
      "title": "Ponyo",
      "aliases": [],
      "emojis": [
        "🐠",
        "👦",
        "🌊",
        "👵",
        "🚤",
        "💗"
      ],
      "pack_id": "daily_exclusive",
      "year": 2008
    },
    {
      "id": "dis_sword_stone",
      "title": "The Sword in the Stone",
      "aliases": [],
      "emojis": [
        "⚔️",
        "🪨",
        "🧙",
        "👦",
        "🦅",
        "👑"
      ],
      "pack_id": "daily_exclusive",
      "year": 1963
    },
    {
      "id": "dis_ralph_breaks",
      "title": "Ralph Breaks the Internet",
      "aliases": [],
      "emojis": [
        "🎮",
        "👨‍🦰",
        "🌐",
        "💃",
        "🥇",
        "🐰"
      ],
      "pack_id": "daily_exclusive",
      "year": 2018
    },
    {
      "id": "salt",
      "title": "Salt",
      "aliases": [],
      "emojis": [
        "👩",
        "🇷🇺",
        "🔫",
        "🏃",
        "💉",
        "🇺🇸"
      ],
      "pack_id": "daily_exclusive",
      "year": 2010
    },
    {
      "id": "rc_just_married",
      "title": "Just Married",
      "aliases": [],
      "emojis": [
        "💒",
        "✈️",
        "🇮🇹",
        "🚗",
        "🔌",
        "🔥",
        "🏨",
        "💔",
        "💑"
      ],
      "pack_id": "daily_exclusive",
      "year": 2003
    },
    {
      "id": "rc_how_lose_guy",
      "title": "How to Lose a Guy in 10 Days",
      "aliases": [
        "How to Lose a Guy in Ten Days"
      ],
      "emojis": [
        "📰",
        "✍️",
        "🤝",
        "💑",
        "🌿",
        "🐶",
        "💎",
        "😱",
        "🏍️"
      ],
      "pack_id": "daily_exclusive",
      "year": 2003
    },
    {
      "id": "rc_maid_manhattan",
      "title": "Maid in Manhattan",
      "aliases": [],
      "emojis": [
        "👩🏽",
        "🧹",
        "🏨",
        "👗",
        "🤵",
        "🐕",
        "💘",
        "📰",
        "💑"
      ],
      "pack_id": "daily_exclusive",
      "year": 2002
    },
    {
      "id": "rc_two_weeks_notice",
      "title": "Two Weeks Notice",
      "aliases": [],
      "emojis": [
        "👩",
        "⚖️",
        "🏗️",
        "🤵",
        "💼",
        "📝",
        "💔",
        "💑"
      ],
      "pack_id": "daily_exclusive",
      "year": 2002
    },
    {
      "id": "rc_sweet_home_alabama",
      "title": "Sweet Home Alabama",
      "aliases": [],
      "emojis": [
        "💍",
        "💛",
        "⚡",
        "🏠",
        "🐊",
        "💑"
      ],
      "pack_id": "daily_exclusive",
      "year": 2002
    },
    {
      "id": "rc_kate_leopold",
      "title": "Kate & Leopold",
      "aliases": [
        "Kate and Leopold"
      ],
      "emojis": [
        "👑",
        "🏰",
        "🌉",
        "⏰",
        "💑",
        "💍"
      ],
      "pack_id": "daily_exclusive",
      "year": 2001
    },
    {
      "id": "rc_my_big_greek",
      "title": "My Big Fat Greek Wedding",
      "aliases": [],
      "emojis": [
        "🇬🇷",
        "👩",
        "💑",
        "🥗",
        "💍",
        "👨‍👩‍👧"
      ],
      "pack_id": "daily_exclusive",
      "year": 2002
    },
    {
      "id": "rc_wedding_planner",
      "title": "The Wedding Planner",
      "aliases": [],
      "emojis": [
        "👩🏽",
        "📋",
        "💒",
        "🗑️",
        "🤕",
        "👨‍⚕️",
        "💘",
        "😱",
        "👰"
      ],
      "pack_id": "daily_exclusive",
      "year": 2001
    },
    {
      "id": "rc_definitely_maybe",
      "title": "Definitely, Maybe",
      "aliases": [
        "Definitely Maybe"
      ],
      "emojis": [
        "👨",
        "👧",
        "🛏️",
        "📖",
        "👩",
        "👩",
        "👩",
        "❓",
        "📕"
      ],
      "pack_id": "daily_exclusive",
      "year": 2008
    },
    {
      "id": "rc_letters_juliet",
      "title": "Letters to Juliet",
      "aliases": [],
      "emojis": [
        "💌",
        "🇮🇹",
        "💑",
        "🍇",
        "🏰",
        "💍"
      ],
      "pack_id": "daily_exclusive",
      "year": 2010
    },
    {
      "id": "rc_ps_love_you",
      "title": "P.S. I Love You",
      "aliases": [
        "PS I Love You"
      ],
      "emojis": [
        "💑",
        "⚰️",
        "🎂",
        "💌",
        "🇮🇪",
        "🎸",
        "💔",
        "🌅"
      ],
      "pack_id": "daily_exclusive",
      "year": 2007
    },
    {
      "id": "rc_dear_john",
      "title": "Dear John",
      "aliases": [],
      "emojis": [
        "🏖️",
        "👜",
        "💑",
        "🪖",
        "✈️",
        "💌",
        "💔",
        "💍",
        "🪙"
      ],
      "pack_id": "daily_exclusive",
      "year": 2010
    },
    {
      "id": "rc_lake_house",
      "title": "The Lake House",
      "aliases": [],
      "emojis": [
        "🏠",
        "💌",
        "📮",
        "🌊",
        "⏰",
        "💑"
      ],
      "pack_id": "daily_exclusive",
      "year": 2006
    },
    {
      "id": "rc_music_lyrics",
      "title": "Music and Lyrics",
      "aliases": [],
      "emojis": [
        "🕺",
        "📼",
        "🎹",
        "👩",
        "🌱",
        "✍️",
        "🎤",
        "💑"
      ],
      "pack_id": "daily_exclusive",
      "year": 2007
    },
    {
      "id": "rc_no_strings",
      "title": "No Strings Attached",
      "aliases": [],
      "emojis": [
        "👩‍⚕️",
        "📱",
        "🛏️",
        "🚫",
        "💘",
        "💿",
        "💔",
        "💑"
      ],
      "pack_id": "daily_exclusive",
      "year": 2011
    },
    {
      "id": "rc_friends_benefits",
      "title": "Friends with Benefits",
      "aliases": [],
      "emojis": [
        "👩",
        "✈️",
        "🗽",
        "🤝",
        "📱",
        "🛏️",
        "🚫",
        "💔",
        "💃"
      ],
      "pack_id": "daily_exclusive",
      "year": 2011
    },
    {
      "id": "rc_about_a_boy",
      "title": "About a Boy",
      "aliases": [],
      "emojis": [
        "👨",
        "💷",
        "🛋️",
        "👦",
        "🦆",
        "🍞",
        "🏫",
        "🎤",
        "🎸"
      ],
      "pack_id": "daily_exclusive",
      "year": 2002
    },
    {
      "id": "rc_the_vow",
      "title": "The Vow",
      "aliases": [],
      "emojis": [
        "🚗",
        "💥",
        "🧠",
        "💍",
        "🎨",
        "💑"
      ],
      "pack_id": "daily_exclusive",
      "year": 2012
    },
    {
      "id": "rc_safe_haven",
      "title": "Safe Haven",
      "aliases": [],
      "emojis": [
        "👩",
        "🩸",
        "🏃",
        "🚌",
        "🏖️",
        "💑",
        "👮",
        "🔥",
        "👻"
      ],
      "pack_id": "daily_exclusive",
      "year": 2013
    },
    {
      "id": "rc_me_before_you",
      "title": "Me Before You",
      "aliases": [],
      "emojis": [
        "👩",
        "🏰",
        "♿",
        "🤵",
        "🐝",
        "💛",
        "🏖️",
        "💔",
        "💌"
      ],
      "pack_id": "daily_exclusive",
      "year": 2016
    },
    {
      "id": "rc_easy_a",
      "title": "Easy A",
      "aliases": [],
      "emojis": [
        "👩",
        "🤥",
        "🗣️",
        "🏫",
        "🅰️",
        "👗",
        "📹",
        "🚜",
        "💑"
      ],
      "pack_id": "daily_exclusive",
      "year": 2010
    },
    {
      "id": "rc_remember_me",
      "title": "Remember Me",
      "aliases": [],
      "emojis": [
        "👨",
        "💔",
        "👮",
        "👩",
        "💑",
        "🏢",
        "✈️",
        "🕊️"
      ],
      "pack_id": "daily_exclusive",
      "year": 2010
    },
    {
      "id": "rc_proposal_2",
      "title": "Anyone But You",
      "aliases": [],
      "emojis": [
        "👨",
        "👩",
        "💔",
        "✈️",
        "🇦🇺",
        "💒",
        "🤝",
        "🕷️",
        "💘"
      ],
      "pack_id": "daily_exclusive",
      "year": 2023
    },
    {
      "id": "rc_set_it_up",
      "title": "Set It Up",
      "aliases": [],
      "emojis": [
        "👩",
        "👨",
        "💼",
        "👩‍💼",
        "👨🏿‍💼",
        "💘",
        "🍕",
        "💋"
      ],
      "pack_id": "daily_exclusive",
      "year": 2018
    },
    {
      "id": "rc_always_be_my_maybe",
      "title": "Always Be My Maybe",
      "aliases": [],
      "emojis": [
        "👦",
        "👧",
        "🚗",
        "💔",
        "👩‍🍳",
        "🎸",
        "🍽️",
        "🕶️",
        "💑"
      ],
      "pack_id": "daily_exclusive",
      "year": 2019
    },
    {
      "id": "bio_judy",
      "title": "Judy",
      "aliases": [],
      "emojis": [
        "🌈",
        "👠",
        "🎤",
        "💔",
        "💊",
        "💃"
      ],
      "pack_id": "daily_exclusive",
      "year": 2019
    },
    {
      "id": "bio_king_richard",
      "title": "King Richard",
      "aliases": [],
      "emojis": [
        "🎾",
        "👨🏿",
        "👧🏿",
        "👧🏿",
        "✊🏿",
        "🏆"
      ],
      "pack_id": "daily_exclusive",
      "year": 2021
    },
    {
      "id": "com_house_bunny",
      "title": "The House Bunny",
      "aliases": [],
      "emojis": [
        "🐰",
        "👱‍♀️",
        "🏠",
        "💄",
        "🎓",
        "💋"
      ],
      "pack_id": "daily_exclusive",
      "year": 2008
    },
    {
      "id": "com_zack_miri",
      "title": "Zack and Miri Make a Porno",
      "aliases": [],
      "emojis": [
        "🎬",
        "💑",
        "🏠",
        "💵",
        "💞",
        "💋"
      ],
      "pack_id": "daily_exclusive",
      "year": 2008
    },
    {
      "id": "fam_a_wrinkle_time",
      "title": "A Wrinkle in Time",
      "aliases": [],
      "emojis": [
        "👧🏿",
        "👨‍🔬",
        "❓",
        "👵🏿",
        "✨",
        "🌌",
        "🧠",
        "❤️"
      ],
      "pack_id": "daily_exclusive",
      "year": 2018
    },
    {
      "id": "alt_thin_red_line",
      "title": "The Thin Red Line",
      "aliases": [
        "Thin Red Line"
      ],
      "emojis": [
        "🌾",
        "🪖",
        "🌊",
        "🇯🇵",
        "🩸",
        "🌅"
      ],
      "pack_id": "daily_exclusive",
      "year": 1998
    },
    {
      "id": "alt_unbreakable",
      "title": "Unbreakable",
      "aliases": [],
      "emojis": [
        "🚂",
        "💪",
        "💧",
        "🪟",
        "🟣",
        "🌧️"
      ],
      "pack_id": "daily_exclusive",
      "year": 2000
    },
    {
      "id": "alt_ides_march",
      "title": "The Ides of March",
      "aliases": [],
      "emojis": [
        "🗳️",
        "👨",
        "🎤",
        "👩",
        "🛏️",
        "🤰",
        "💊",
        "⚰️",
        "😶"
      ],
      "pack_id": "daily_exclusive",
      "year": 2011
    },
    {
      "id": "cl_cinema_paradiso",
      "title": "Cinema Paradiso",
      "aliases": [],
      "emojis": [
        "🇮🇹",
        "👦",
        "👴",
        "🎬",
        "💕",
        "📽️",
        "✂️"
      ],
      "pack_id": "daily_exclusive",
      "year": 1988
    },
    {
      "id": "ni_once_upon_west",
      "title": "Once Upon a Time in the West",
      "aliases": [],
      "emojis": [
        "🤠",
        "🪕",
        "⌛",
        "🛤️",
        "💀",
        "🌵",
        "🔫"
      ],
      "pack_id": "daily_exclusive",
      "year": 1968
    },
    {
      "id": "ni_amhx",
      "title": "American History X",
      "aliases": [],
      "emojis": [
        "✋",
        "😈",
        "👨‍🦲",
        "👨‍👦",
        "🪞",
        "💔",
        "🏫",
        "🩸"
      ],
      "pack_id": "daily_exclusive",
      "year": 1998
    },
    {
      "id": "coen_barton_fink",
      "title": "Barton Fink",
      "aliases": [],
      "emojis": [
        "✍️",
        "🎬",
        "🏨",
        "🦟",
        "📦",
        "🔥",
        "🏖️"
      ],
      "pack_id": "daily_exclusive",
      "year": 1991
    },
    {
      "id": "dis_brother_bear",
      "title": "Brother Bear",
      "aliases": [],
      "emojis": [
        "🐻",
        "🪶",
        "🏞️",
        "🐻",
        "👬",
        "✨"
      ],
      "pack_id": "daily_exclusive",
      "year": 2003
    },
    {
      "id": "dw_spirit",
      "title": "Spirit: Stallion of the Cimarron",
      "aliases": [
        "Spirit"
      ],
      "emojis": [
        "🐎",
        "🌅",
        "🪖",
        "🇺🇸",
        "🌾",
        "🪶"
      ],
      "pack_id": "daily_exclusive",
      "year": 2002
    },
    {
      "id": "hr_smile",
      "title": "Smile",
      "aliases": [],
      "emojis": [
        "👩‍⚕️",
        "🏥",
        "😁",
        "🔪",
        "👻",
        "😱",
        "🏚️",
        "🔥"
      ],
      "pack_id": "daily_exclusive",
      "year": 2022
    },
    {
      "id": "hr_lights_out",
      "title": "Lights Out",
      "aliases": [],
      "emojis": [
        "💡",
        "👻",
        "🛏️",
        "👧",
        "🪨",
        "🌑"
      ],
      "pack_id": "daily_exclusive",
      "year": 2016
    },
    {
      "id": "sp_rush_2013",
      "title": "Rush",
      "aliases": [],
      "emojis": [
        "🏎️",
        "🇬🇧",
        "🇦🇹",
        "🔥",
        "💉",
        "🏆"
      ],
      "pack_id": "daily_exclusive",
      "year": 2013
    },
    {
      "id": "act_red",
      "title": "Red",
      "aliases": [],
      "emojis": [
        "👴",
        "👵",
        "🔫",
        "💼",
        "💑",
        "💥"
      ],
      "pack_id": "daily_exclusive",
      "year": 2010
    },
    {
      "id": "act_olympus_fallen",
      "title": "Olympus Has Fallen",
      "aliases": [],
      "emojis": [
        "🏛️",
        "🇺🇸",
        "💥",
        "🔫",
        "🪖",
        "🇰🇵"
      ],
      "pack_id": "daily_exclusive",
      "year": 2013
    },
    {
      "id": "sf_event_horizon",
      "title": "Event Horizon",
      "aliases": [],
      "emojis": [
        "🚀",
        "🌌",
        "🕳️",
        "👻",
        "💀",
        "🔥"
      ],
      "pack_id": "daily_exclusive",
      "year": 1997
    },
    {
      "id": "alt_dead_man_walking",
      "title": "Dead Man Walking",
      "aliases": [],
      "emojis": [
        "⛪",
        "👩",
        "✉️",
        "⛓️",
        "💔",
        "🙏",
        "💉",
        "🪦"
      ],
      "pack_id": "daily_exclusive",
      "year": 1995
    },
    {
      "id": "alt_eyes_wide_shut",
      "title": "Eyes Wide Shut",
      "aliases": [],
      "emojis": [
        "🎭",
        "🌃",
        "💑",
        "🔑",
        "💀",
        "💔"
      ],
      "pack_id": "daily_exclusive",
      "year": 1999
    },
    {
      "id": "alt_requiem",
      "title": "Requiem for a Dream",
      "aliases": [],
      "emojis": [
        "💉",
        "📺",
        "💊",
        "💔",
        "🧠",
        "🪦"
      ],
      "pack_id": "daily_exclusive",
      "year": 2000
    },
    {
      "id": "alt_eastern_promises",
      "title": "Eastern Promises",
      "aliases": [],
      "emojis": [
        "🇷🇺",
        "🛁",
        "💉",
        "🔪",
        "🦅",
        "💔"
      ],
      "pack_id": "daily_exclusive",
      "year": 2007
    },
    {
      "id": "alt_seven_psychopaths",
      "title": "Seven Psychopaths",
      "aliases": [],
      "emojis": [
        "✍️",
        "📖",
        "👬",
        "🐕",
        "😡",
        "🔫",
        "🌵",
        "💥"
      ],
      "pack_id": "daily_exclusive",
      "year": 2012
    },
    {
      "id": "alt_thank_you_smoking",
      "title": "Thank You for Smoking",
      "aliases": [],
      "emojis": [
        "🚬",
        "💼",
        "📺",
        "👨‍👦",
        "👩",
        "📰",
        "🩹",
        "😵",
        "🏛️"
      ],
      "pack_id": "daily_exclusive",
      "year": 2005
    },
    {
      "id": "rc_about_time",
      "title": "About Time",
      "aliases": [],
      "emojis": [
        "👨‍🦰",
        "🚪",
        "✊",
        "⏪",
        "💘",
        "💒",
        "☔",
        "🏓",
        "⚰️"
      ],
      "pack_id": "daily_exclusive",
      "year": 2013
    },
    {
      "id": "ci_birdman",
      "title": "Birdman",
      "aliases": [],
      "emojis": [
        "🐦",
        "🎭",
        "🥷",
        "🪟",
        "🩲",
        "🎤",
        "🌟",
        "🎬"
      ],
      "pack_id": "daily_exclusive",
      "year": 2014
    },
    {
      "id": "mi_donnie_brasco",
      "title": "Donnie Brasco",
      "aliases": [],
      "emojis": [
        "🕵️",
        "🤵",
        "🤝",
        "🤐",
        "💔",
        "🤜",
        "🔫"
      ],
      "pack_id": "daily_exclusive",
      "year": 1997
    },
    {
      "id": "dc_flash_2023",
      "title": "The Flash",
      "aliases": [
        "Flash 2023"
      ],
      "emojis": [
        "⚡",
        "🏃",
        "⏰",
        "👶",
        "🟦",
        "🦇",
        "🌀"
      ],
      "pack_id": "daily_exclusive",
      "year": 2023
    },
    {
      "id": "coen_serious_man",
      "title": "A Serious Man",
      "aliases": [],
      "emojis": [
        "👨",
        "🧑‍🏫",
        "🌪️",
        "✡️",
        "💔",
        "🎵"
      ],
      "pack_id": "daily_exclusive",
      "year": 2009
    },
    {
      "id": "wa_bottle_rocket",
      "title": "Bottle Rocket",
      "aliases": [],
      "emojis": [
        "🚗",
        "🏢",
        "🤓",
        "📚",
        "🌵",
        "💛"
      ],
      "pack_id": "daily_exclusive",
      "year": 1996
    },
    {
      "id": "ghibli_mononoke",
      "title": "Princess Mononoke",
      "aliases": [],
      "emojis": [
        "🌲",
        "🐺",
        "🤴",
        "🐗",
        "🏹",
        "💚"
      ],
      "pack_id": "daily_exclusive",
      "year": 1997
    },
    {
      "id": "dw_antz",
      "title": "Antz",
      "aliases": [],
      "emojis": [
        "🐜",
        "😟",
        "👸",
        "🪖",
        "⚔️",
        "🗑️",
        "💧",
        "💑"
      ],
      "pack_id": "daily_exclusive",
      "year": 1998
    },
    {
      "id": "dw_trolls",
      "title": "Trolls",
      "aliases": [],
      "emojis": [
        "🌈",
        "🎤",
        "🍰",
        "💗",
        "🎵",
        "🤗"
      ],
      "pack_id": "daily_exclusive",
      "year": 2016
    },
    {
      "id": "hr_pearl",
      "title": "Pearl",
      "aliases": [],
      "emojis": [
        "🌽",
        "👩",
        "🐊",
        "🪓",
        "🎭",
        "🌹"
      ],
      "pack_id": "daily_exclusive",
      "year": 2022
    },
    {
      "id": "heist_blood_diamond",
      "title": "Blood Diamond",
      "aliases": [],
      "emojis": [
        "💎",
        "🌍",
        "🩸",
        "👨🏿",
        "🪖",
        "✈️"
      ],
      "pack_id": "daily_exclusive",
      "year": 2006
    },
    {
      "id": "heist_logan_lucky",
      "title": "Logan Lucky",
      "aliases": [],
      "emojis": [
        "👷",
        "🦾",
        "💣",
        "🏁",
        "🏟️",
        "💰",
        "👧",
        "🎤"
      ],
      "pack_id": "daily_exclusive",
      "year": 2017
    },
    {
      "id": "heist_widows",
      "title": "Widows",
      "aliases": [],
      "emojis": [
        "👰🏿",
        "👰",
        "👰",
        "💰",
        "🚓",
        "🔫"
      ],
      "pack_id": "daily_exclusive",
      "year": 2018
    },
    {
      "id": "heist_kings_summer",
      "title": "Hell or High Water",
      "aliases": [],
      "emojis": [
        "🏦",
        "🤠",
        "🤠",
        "🌵",
        "💰",
        "🚓"
      ],
      "pack_id": "daily_exclusive",
      "year": 2016
    },
    {
      "id": "heist_killing_them_softly",
      "title": "Killing Them Softly",
      "aliases": [],
      "emojis": [
        "🔫",
        "🚗",
        "💼",
        "🃏",
        "🩸",
        "🇺🇸"
      ],
      "pack_id": "daily_exclusive",
      "year": 2012
    },
    {
      "id": "heist_layer_cake",
      "title": "Layer Cake",
      "aliases": [],
      "emojis": [
        "🤵",
        "🇬🇧",
        "💊",
        "💼",
        "🔍",
        "👧",
        "🤝",
        "🔫"
      ],
      "pack_id": "daily_exclusive",
      "year": 2004
    },
    {
      "id": "sp_we_marshall",
      "title": "We Are Marshall",
      "aliases": [],
      "emojis": [
        "🏈",
        "💔",
        "✈️",
        "🏫",
        "💪",
        "🏆"
      ],
      "pack_id": "daily_exclusive",
      "year": 2006
    },
    {
      "id": "sp_invincible",
      "title": "Invincible",
      "aliases": [],
      "emojis": [
        "🏈",
        "🍻",
        "💔",
        "🇺🇸",
        "🏟️",
        "💪"
      ],
      "pack_id": "daily_exclusive",
      "year": 2006
    },
    {
      "id": "bio_jackie",
      "title": "Jackie",
      "aliases": [],
      "emojis": [
        "👩",
        "🎀",
        "🚗",
        "🔫",
        "🩸",
        "⚰️",
        "📺",
        "🏛️"
      ],
      "pack_id": "daily_exclusive",
      "year": 2016
    },
    {
      "id": "bio_glory",
      "title": "Glory",
      "aliases": [],
      "emojis": [
        "🎖️",
        "👨🏿",
        "👨🏿",
        "🪖",
        "👞",
        "✊🏿",
        "🥁",
        "🏖️",
        "💥"
      ],
      "pack_id": "daily_exclusive",
      "year": 1989
    },
    {
      "id": "act_unstoppable",
      "title": "Unstoppable",
      "aliases": [],
      "emojis": [
        "🚂",
        "💨",
        "☣️",
        "👨🏿",
        "👨",
        "🚁",
        "🏙️",
        "🛑"
      ],
      "pack_id": "daily_exclusive",
      "year": 2010
    },
    {
      "id": "sf_oblivion",
      "title": "Oblivion",
      "aliases": [],
      "emojis": [
        "👨",
        "🔧",
        "🤖",
        "🏜️",
        "🛰️",
        "👩",
        "💤",
        "👯‍♂️",
        "💣"
      ],
      "pack_id": "daily_exclusive",
      "year": 2013
    },
    {
      "id": "com_paul",
      "title": "Paul",
      "aliases": [],
      "emojis": [
        "🇺🇸",
        "👽",
        "🚐",
        "🛸",
        "💚",
        "🌵"
      ],
      "pack_id": "daily_exclusive",
      "year": 2011
    },
    {
      "id": "an_ferdinand",
      "title": "Ferdinand",
      "aliases": [],
      "emojis": [
        "🐂",
        "🌹",
        "🇪🇸",
        "🏃",
        "🌸",
        "💗"
      ],
      "pack_id": "daily_exclusive",
      "year": 2017
    },
    {
      "id": "fam_richie_rich",
      "title": "Richie Rich",
      "aliases": [],
      "emojis": [
        "👦",
        "💰",
        "🏰",
        "🍔",
        "✈️",
        "😈",
        "🗿",
        "🔫"
      ],
      "pack_id": "daily_exclusive",
      "year": 1994
    },
    {
      "id": "for_okja",
      "title": "Okja",
      "aliases": [],
      "emojis": [
        "🐷",
        "👧",
        "🇰🇷",
        "🏙️",
        "🚚",
        "🌳"
      ],
      "pack_id": "daily_exclusive",
      "year": 2017
    },
    {
      "id": "for_anatomy_fall",
      "title": "Anatomy of a Fall",
      "aliases": [],
      "emojis": [
        "🏔️",
        "🪦",
        "👩",
        "👦",
        "⚖️",
        "🐕"
      ],
      "pack_id": "daily_exclusive",
      "year": 2023
    },
    {
      "id": "alt_in_heights",
      "title": "In the Heights",
      "aliases": [],
      "emojis": [
        "👨🏽",
        "🏪",
        "🇩🇴",
        "🎶",
        "🎟️",
        "💰",
        "⚡",
        "🌃",
        "💃🏽"
      ],
      "pack_id": "daily_exclusive",
      "year": 2021
    },
    {
      "id": "alt_education",
      "title": "An Education",
      "aliases": [],
      "emojis": [
        "🎓",
        "🇬🇧",
        "🚗",
        "💍",
        "💔",
        "📚"
      ],
      "pack_id": "daily_exclusive",
      "year": 2009
    },
    {
      "id": "alt_gattaca",
      "title": "Gattaca",
      "aliases": [],
      "emojis": [
        "🧬",
        "🚀",
        "🌌",
        "💪",
        "💔",
        "🪞"
      ],
      "pack_id": "daily_exclusive",
      "year": 1997
    },
    {
      "id": "alt_civil_war_2024",
      "title": "Civil War",
      "aliases": [
        "Civil War 2024"
      ],
      "emojis": [
        "📷",
        "👩",
        "🚙",
        "🇺🇸",
        "💥",
        "🪖",
        "🕶️",
        "🏛️",
        "🔫"
      ],
      "pack_id": "daily_exclusive",
      "year": 2024
    },
    {
      "id": "dis_raya",
      "title": "Raya and the Last Dragon",
      "aliases": [
        "Raya"
      ],
      "emojis": [
        "🐉",
        "👸🏽",
        "🌏",
        "💧",
        "💎",
        "🤝"
      ],
      "pack_id": "daily_exclusive",
      "year": 2021
    },
    {
      "id": "alt_crash",
      "title": "Crash",
      "aliases": [],
      "emojis": [
        "🚗",
        "💥",
        "🌃",
        "👮",
        "🚙",
        "🔥",
        "🔫",
        "👧",
        "❄️"
      ],
      "pack_id": "daily_exclusive",
      "year": 2004
    },
    {
      "id": "mc_amelie",
      "title": "Amélie",
      "aliases": [
        "Amelie"
      ],
      "emojis": [
        "🇫🇷",
        "👩",
        "📸",
        "💛",
        "📔",
        "🐟",
        "☕",
        "🏃",
        "💑"
      ],
      "pack_id": "daily_exclusive",
      "year": 2001
    },
    {
      "id": "dc_man_steel",
      "title": "Man of Steel",
      "aliases": [],
      "emojis": [
        "👶",
        "🚀",
        "🌾",
        "🟦",
        "⚔️",
        "🏙️",
        "💥"
      ],
      "pack_id": "daily_exclusive",
      "year": 2013
    },
    {
      "id": "dw_chicken_run",
      "title": "Chicken Run",
      "aliases": [],
      "emojis": [
        "🐔",
        "🥧",
        "🚀",
        "🐓",
        "✈️",
        "🇬🇧"
      ],
      "pack_id": "daily_exclusive",
      "year": 2000
    },
    {
      "id": "hr_orphanage",
      "title": "The Orphanage",
      "aliases": [],
      "emojis": [
        "🏚️",
        "👦",
        "🎭",
        "🚪",
        "💔",
        "🪦"
      ],
      "pack_id": "daily_exclusive",
      "year": 2007
    },
    {
      "id": "rc_perks_wallflower",
      "title": "The Perks of Being a Wallflower",
      "aliases": [
        "Perks of Being a Wallflower"
      ],
      "emojis": [
        "👦",
        "✍️",
        "🏫",
        "🎭",
        "💄",
        "📼",
        "🚙",
        "🎶",
        "🙌"
      ],
      "pack_id": "daily_exclusive",
      "year": 2012
    },
    {
      "id": "sp_42",
      "title": "42",
      "aliases": [
        "Forty Two"
      ],
      "emojis": [
        "⚾",
        "👨🏿",
        "✊",
        "🇺🇸",
        "💪",
        "🏆"
      ],
      "pack_id": "daily_exclusive",
      "year": 2013
    },
    {
      "id": "sp_major_league",
      "title": "Major League",
      "aliases": [],
      "emojis": [
        "⚾",
        "🤡",
        "👓",
        "🎯",
        "🏆",
        "🤝"
      ],
      "pack_id": "daily_exclusive",
      "year": 1989
    },
    {
      "id": "sp_glory_road",
      "title": "Glory Road",
      "aliases": [],
      "emojis": [
        "👨",
        "🏀",
        "👨🏿",
        "👨🏿",
        "👨🏿",
        "👨🏿",
        "👨🏿",
        "✊",
        "🏆"
      ],
      "pack_id": "daily_exclusive",
      "year": 2006
    },
    {
      "id": "bio_ray",
      "title": "Ray",
      "aliases": [],
      "emojis": [
        "🎹",
        "🕶️",
        "🎤",
        "🎵",
        "💔",
        "👨🏿"
      ],
      "pack_id": "daily_exclusive",
      "year": 2004
    },
    {
      "id": "com_baby_mama",
      "title": "Baby Mama",
      "aliases": [],
      "emojis": [
        "👩",
        "💼",
        "🚫",
        "🤰",
        "💵",
        "🤝",
        "🏠",
        "⚖️",
        "👶"
      ],
      "pack_id": "daily_exclusive",
      "year": 2008
    },
    {
      "id": "alt_born_july",
      "title": "Born on the Fourth of July",
      "aliases": [],
      "emojis": [
        "🇺🇸",
        "🪖",
        "♿",
        "✊",
        "💔",
        "🎤"
      ],
      "pack_id": "daily_exclusive",
      "year": 1989
    },
    {
      "id": "alt_match_point",
      "title": "Match Point",
      "aliases": [],
      "emojis": [
        "🎾",
        "👨",
        "🇬🇧",
        "💋",
        "🤰",
        "🔫",
        "💍",
        "🌉"
      ],
      "pack_id": "daily_exclusive",
      "year": 2005
    },
    {
      "id": "alt_eighth_grade",
      "title": "Eighth Grade",
      "aliases": [],
      "emojis": [
        "👧",
        "📹",
        "📱",
        "😰",
        "🏊",
        "📦",
        "🔥"
      ],
      "pack_id": "daily_exclusive",
      "year": 2018
    },
    {
      "id": "hr_longlegs",
      "title": "Longlegs",
      "aliases": [],
      "emojis": [
        "🕵️‍♀️",
        "✉️",
        "🔪",
        "🏠",
        "🪆",
        "😈",
        "🎂"
      ],
      "pack_id": "daily_exclusive",
      "year": 2024
    },
    {
      "id": "sf_district_9",
      "title": "District 9",
      "aliases": [
        "District Nine"
      ],
      "emojis": [
        "🛸",
        "🇿🇦",
        "🦐",
        "🥫",
        "🧪",
        "🦾",
        "🤖",
        "🔫"
      ],
      "pack_id": "daily_exclusive",
      "year": 2009
    },
    {
      "id": "sf_looper",
      "title": "Looper",
      "aliases": [],
      "emojis": [
        "⏰",
        "🔫",
        "🪙",
        "👴",
        "☕",
        "🌽",
        "👦",
        "🤯",
        "💀"
      ],
      "pack_id": "daily_exclusive",
      "year": 2012
    },
    {
      "id": "th_babadook",
      "title": "The Babadook",
      "aliases": [
        "Babadook"
      ],
      "emojis": [
        "👩",
        "👦",
        "📖",
        "🎩",
        "👤",
        "😱",
        "⬇️",
        "🐛"
      ],
      "pack_id": "daily_exclusive",
      "year": 2014
    },
    {
      "id": "aa_road_warrior",
      "title": "The Road Warrior",
      "aliases": [
        "Mad Max 2",
        "Road Warrior"
      ],
      "emojis": [
        "🚗",
        "⛽",
        "🏜️",
        "💀",
        "🪖",
        "🔥",
        "💥"
      ],
      "pack_id": "daily_exclusive",
      "year": 1981
    },
    {
      "id": "ci_parasite",
      "title": "Parasite",
      "aliases": [],
      "emojis": [
        "🇰🇷",
        "🪜",
        "👨‍👩‍👧‍👦",
        "💰",
        "🏠",
        "🧑‍🎓",
        "🐛",
        "🌧️",
        "🩸",
        "🪨"
      ],
      "pack_id": "daily_exclusive",
      "year": 2019
    },
    {
      "id": "dc_black_adam",
      "title": "Black Adam",
      "aliases": [],
      "emojis": [
        "⚡",
        "🟦",
        "👤",
        "🇪🇬",
        "💪🏾",
        "🪨"
      ],
      "pack_id": "daily_exclusive",
      "year": 2022
    },
    {
      "id": "nolan_following",
      "title": "Following",
      "aliases": [],
      "emojis": [
        "🚶",
        "🔍",
        "💼",
        "⚫",
        "⚪",
        "🗝️"
      ],
      "pack_id": "daily_exclusive",
      "year": 1998
    },
    {
      "id": "pix_elemental",
      "title": "Elemental",
      "aliases": [],
      "emojis": [
        "🔥",
        "💧",
        "💑",
        "🏙️",
        "🌳",
        "🌅"
      ],
      "pack_id": "daily_exclusive",
      "year": 2023
    },
    {
      "id": "dis_atlantis",
      "title": "Atlantis: The Lost Empire",
      "aliases": [
        "Atlantis"
      ],
      "emojis": [
        "🌊",
        "🐋",
        "💎",
        "⚓",
        "🇫🇷",
        "🪄"
      ],
      "pack_id": "daily_exclusive",
      "year": 2001
    },
    {
      "id": "dw_bee_movie",
      "title": "Bee Movie",
      "aliases": [],
      "emojis": [
        "🐝",
        "🌻",
        "🍯",
        "⚖️",
        "🚗",
        "🌐"
      ],
      "pack_id": "daily_exclusive",
      "year": 2007
    },
    {
      "id": "safe_house",
      "title": "Safe House",
      "aliases": [],
      "emojis": [
        "🏠",
        "🇿🇦",
        "🔫",
        "💼",
        "🏃🏿",
        "🚗"
      ],
      "pack_id": "daily_exclusive",
      "year": 2012
    },
    {
      "id": "hr_x",
      "title": "X",
      "aliases": [],
      "emojis": [
        "🎬",
        "🏠",
        "🐊",
        "🪓",
        "👵",
        "🚜"
      ],
      "pack_id": "daily_exclusive",
      "year": 2022
    },
    {
      "id": "rc_failure_launch",
      "title": "Failure to Launch",
      "aliases": [],
      "emojis": [
        "👨",
        "🛋️",
        "👨‍👩‍👦",
        "💵",
        "👩",
        "💘",
        "🐬",
        "😡",
        "💑"
      ],
      "pack_id": "daily_exclusive",
      "year": 2006
    },
    {
      "id": "sp_for_love_game",
      "title": "For Love of the Game",
      "aliases": [],
      "emojis": [
        "⚾",
        "🧓",
        "🏟️",
        "💭",
        "💑",
        "💔",
        "🎯",
        "👋"
      ],
      "pack_id": "daily_exclusive",
      "year": 1999
    },
    {
      "id": "sp_foxcatcher",
      "title": "Foxcatcher",
      "aliases": [],
      "emojis": [
        "🤼",
        "🦊",
        "💪",
        "💔",
        "🔫",
        "💀"
      ],
      "pack_id": "daily_exclusive",
      "year": 2014
    },
    {
      "id": "sp_senna",
      "title": "Senna",
      "aliases": [],
      "emojis": [
        "🏎️",
        "🇧🇷",
        "🌧️",
        "🏆",
        "💔",
        "🇫🇷"
      ],
      "pack_id": "daily_exclusive",
      "year": 2010
    },
    {
      "id": "bio_elvis_2",
      "title": "Priscilla",
      "aliases": [],
      "emojis": [
        "👧",
        "🇩🇪",
        "🎸",
        "💑",
        "🏰",
        "💄",
        "👶",
        "💊",
        "🚗"
      ],
      "pack_id": "daily_exclusive",
      "year": 2023
    },
    {
      "id": "bio_unbroken",
      "title": "Unbroken",
      "aliases": [],
      "emojis": [
        "🏃",
        "🥇",
        "✈️",
        "💥",
        "🌊",
        "🦈",
        "🚣",
        "🇯🇵",
        "🪵"
      ],
      "pack_id": "daily_exclusive",
      "year": 2014
    },
    {
      "id": "bio_judas",
      "title": "Judas and the Black Messiah",
      "aliases": [
        "Judas Black Messiah"
      ],
      "emojis": [
        "👨🏿",
        "🚓",
        "🤝",
        "🕵️",
        "✊🏿",
        "🎤",
        "💊",
        "🛏️",
        "🔫"
      ],
      "pack_id": "daily_exclusive",
      "year": 2021
    },
    {
      "id": "act_taking_pelham",
      "title": "The Taking of Pelham 123",
      "aliases": [
        "Pelham 123"
      ],
      "emojis": [
        "👨🏿",
        "🎧",
        "🚇",
        "🔫",
        "⏰",
        "💰",
        "🚓",
        "🏃",
        "🔫"
      ],
      "pack_id": "daily_exclusive",
      "year": 2009
    },
    {
      "id": "act_machete",
      "title": "Machete",
      "aliases": [],
      "emojis": [
        "👨🏽",
        "🔪",
        "💵",
        "🎯",
        "🤵",
        "💥",
        "🌮",
        "✊"
      ],
      "pack_id": "daily_exclusive",
      "year": 2010
    },
    {
      "id": "act_gray_man",
      "title": "The Gray Man",
      "aliases": [],
      "emojis": [
        "🕴️",
        "🌍",
        "🇨🇿",
        "🔫",
        "🚂",
        "💥"
      ],
      "pack_id": "daily_exclusive",
      "year": 2022
    },
    {
      "id": "sf_annihilation",
      "title": "Annihilation",
      "aliases": [],
      "emojis": [
        "👩",
        "🔬",
        "🌈",
        "🐊",
        "🌸",
        "🐻",
        "🗼",
        "🔥"
      ],
      "pack_id": "daily_exclusive",
      "year": 2018
    },
    {
      "id": "sf_ender",
      "title": "Ender's Game",
      "aliases": [
        "Enders Game"
      ],
      "emojis": [
        "👦",
        "🚀",
        "🐜",
        "🌌",
        "🪖",
        "🎮"
      ],
      "pack_id": "daily_exclusive",
      "year": 2013
    },
    {
      "id": "com_get_smart",
      "title": "Get Smart",
      "aliases": [],
      "emojis": [
        "🕴️",
        "🎩",
        "👞",
        "🔫",
        "💑",
        "💼"
      ],
      "pack_id": "daily_exclusive",
      "year": 2008
    },
    {
      "id": "com_bored_to_death",
      "title": "Tower Heist",
      "aliases": [],
      "emojis": [
        "🏢",
        "💸",
        "😡",
        "🤝",
        "🔓",
        "🏎️",
        "🪟",
        "🎈"
      ],
      "pack_id": "daily_exclusive",
      "year": 2011
    },
    {
      "id": "com_mallrats",
      "title": "Mallrats",
      "aliases": [],
      "emojis": [
        "🛍️",
        "🦇",
        "💞",
        "🍪",
        "🛗",
        "🎮"
      ],
      "pack_id": "daily_exclusive",
      "year": 1995
    },
    {
      "id": "fam_zathura",
      "title": "Zathura",
      "aliases": [],
      "emojis": [
        "🎲",
        "🚀",
        "🌌",
        "🤖",
        "👬",
        "🦎"
      ],
      "pack_id": "daily_exclusive",
      "year": 2005
    },
    {
      "id": "for_motorcycle_diaries",
      "title": "The Motorcycle Diaries",
      "aliases": [
        "Motorcycle Diaries"
      ],
      "emojis": [
        "🏍️",
        "🌎",
        "✊🏽",
        "🇦🇷",
        "🌊",
        "🧭"
      ],
      "pack_id": "daily_exclusive",
      "year": 2004
    },
    {
      "id": "for_blue_warmest",
      "title": "Blue Is the Warmest Color",
      "aliases": [
        "Blue Is the Warmest Colour"
      ],
      "emojis": [
        "💙",
        "💑",
        "🍝",
        "🎨",
        "💔",
        "🇫🇷"
      ],
      "pack_id": "daily_exclusive",
      "year": 2013
    },
    {
      "id": "alt_streetcar",
      "title": "A Streetcar Named Desire",
      "aliases": [],
      "emojis": [
        "👩",
        "🚋",
        "🏚️",
        "🃏",
        "📣",
        "🏮",
        "💔",
        "🚑"
      ],
      "pack_id": "daily_exclusive",
      "year": 1951
    },
    {
      "id": "alt_dog_day",
      "title": "Dog Day Afternoon",
      "aliases": [],
      "emojis": [
        "🏦",
        "🔫",
        "🌃",
        "🌈",
        "📞",
        "🚓"
      ],
      "pack_id": "daily_exclusive",
      "year": 1975
    },
    {
      "id": "alt_my_left_foot",
      "title": "My Left Foot",
      "aliases": [],
      "emojis": [
        "♿",
        "🦶",
        "✏️",
        "🎨",
        "🇮🇪",
        "💔"
      ],
      "pack_id": "daily_exclusive",
      "year": 1989
    },
    {
      "id": "alt_stranger_fiction",
      "title": "Stranger Than Fiction",
      "aliases": [],
      "emojis": [
        "✍️",
        "⌚",
        "🍪",
        "🚌",
        "🎻",
        "💑"
      ],
      "pack_id": "daily_exclusive",
      "year": 2006
    },
    {
      "id": "alt_iron_giant",
      "title": "The Iron Giant",
      "aliases": [],
      "emojis": [
        "👦",
        "🌲",
        "🤖",
        "🔩",
        "🦌",
        "🪖",
        "🚀",
        "🦸"
      ],
      "pack_id": "daily_exclusive",
      "year": 1999
    },
    {
      "id": "knight_day",
      "title": "Knight and Day",
      "aliases": [],
      "emojis": [
        "👩",
        "✈️",
        "🔫",
        "💥",
        "🌽",
        "🔋",
        "💊",
        "🐂"
      ],
      "pack_id": "daily_exclusive",
      "year": 2010
    },
    {
      "id": "act_old_guard",
      "title": "The Old Guard",
      "aliases": [],
      "emojis": [
        "🪓",
        "💀",
        "🩹",
        "👩🏿",
        "🪖",
        "🧬",
        "💊",
        "🏢",
        "🔫"
      ],
      "pack_id": "daily_exclusive",
      "year": 2020
    },
    {
      "id": "com_pink_panther_06",
      "title": "The Pink Panther",
      "aliases": [
        "Pink Panther 2006"
      ],
      "emojis": [
        "💎",
        "🇫🇷",
        "🕵️",
        "🎀",
        "🎵",
        "🤡"
      ],
      "pack_id": "daily_exclusive",
      "year": 2006
    },
    {
      "id": "alt_marathon_man",
      "title": "Marathon Man",
      "aliases": [],
      "emojis": [
        "🏃",
        "🦷",
        "🇩🇪",
        "💎",
        "💉",
        "🔍"
      ],
      "pack_id": "daily_exclusive",
      "year": 1976
    },
    {
      "id": "alt_name_father",
      "title": "In the Name of the Father",
      "aliases": [],
      "emojis": [
        "👨",
        "🇮🇪",
        "💣",
        "🚔",
        "⛓️",
        "👨‍👦",
        "⚖️",
        "🕊️"
      ],
      "pack_id": "daily_exclusive",
      "year": 1993
    },
    {
      "id": "alt_punch_drunk",
      "title": "Punch-Drunk Love",
      "aliases": [
        "Punch Drunk Love"
      ],
      "emojis": [
        "📞",
        "🍫",
        "✈️",
        "🪗",
        "💑",
        "🥋"
      ],
      "pack_id": "daily_exclusive",
      "year": 2002
    },
    {
      "id": "ci_witch",
      "title": "The Witch",
      "aliases": [
        "Witch",
        "The VVitch"
      ],
      "emojis": [
        "⛪",
        "🌲",
        "👨‍👩‍👧‍👦",
        "👶",
        "🐐",
        "🩸",
        "🌫️",
        "🔥",
        "🧙‍♀️"
      ],
      "pack_id": "daily_exclusive",
      "year": 2015
    },
    {
      "id": "mc_pans_labyrinth",
      "title": "Pan's Labyrinth",
      "aliases": [
        "Pans Labyrinth"
      ],
      "emojis": [
        "🇪🇸",
        "👧",
        "🏰",
        "🐐",
        "👁️",
        "🪦",
        "📖",
        "🧚",
        "🩸"
      ],
      "pack_id": "daily_exclusive",
      "year": 2006
    },
    {
      "id": "scorsese_kundun",
      "title": "Kundun",
      "aliases": [],
      "emojis": [
        "👶",
        "🙏",
        "🏔️",
        "☸️",
        "🇨🇳",
        "🪖",
        "🐎",
        "🇮🇳"
      ],
      "pack_id": "daily_exclusive",
      "year": 1997
    },
    {
      "id": "dw_croods",
      "title": "The Croods",
      "aliases": [],
      "emojis": [
        "🦴",
        "👨‍👩‍👧",
        "🌋",
        "🌎",
        "💡",
        "🦥"
      ],
      "pack_id": "daily_exclusive",
      "year": 2013
    },
    {
      "id": "heist_the_italian_job_orig",
      "title": "The Italian Job",
      "aliases": [
        "Italian Job 1969"
      ],
      "emojis": [
        "🇮🇹",
        "🪙",
        "🚗",
        "🚗",
        "🚗",
        "🇬🇧",
        "🚐"
      ],
      "pack_id": "daily_exclusive",
      "year": 1969
    },
    {
      "id": "heist_lock_stock",
      "title": "Lock, Stock and Two Smoking Barrels",
      "aliases": [
        "Lock Stock"
      ],
      "emojis": [
        "🇬🇧",
        "🔫",
        "💵",
        "🃏",
        "🌿",
        "🤝"
      ],
      "pack_id": "daily_exclusive",
      "year": 1998
    },
    {
      "id": "sp_slap_shot",
      "title": "Slap Shot",
      "aliases": [],
      "emojis": [
        "🏒",
        "👴",
        "👓",
        "👓",
        "👓",
        "🤛",
        "🩸",
        "🩲",
        "🏆"
      ],
      "pack_id": "daily_exclusive",
      "year": 1977
    },
    {
      "id": "bio_trumbo",
      "title": "Trumbo",
      "aliases": [],
      "emojis": [
        "✍️",
        "🏛️",
        "🚬",
        "🛁",
        "🇺🇸",
        "🏆"
      ],
      "pack_id": "daily_exclusive",
      "year": 2015
    },
    {
      "id": "bio_blonde",
      "title": "Blonde",
      "aliases": [],
      "emojis": [
        "👱‍♀️",
        "🎬",
        "👗",
        "💨",
        "💍",
        "💔",
        "🤰",
        "💊"
      ],
      "pack_id": "daily_exclusive",
      "year": 2022
    },
    {
      "id": "bio_3_idiots",
      "title": "3 Idiots",
      "aliases": [
        "Three Idiots"
      ],
      "emojis": [
        "👨🏽",
        "👨🏽",
        "👨🏽",
        "🎓",
        "🇮🇳",
        "📚",
        "😅",
        "🛵",
        "🏔️"
      ],
      "pack_id": "daily_exclusive",
      "year": 2009
    },
    {
      "id": "com_other_woman",
      "title": "The Other Woman",
      "aliases": [],
      "emojis": [
        "👩",
        "💘",
        "🤵",
        "💍",
        "😱",
        "👩",
        "👩",
        "💊",
        "🏝️"
      ],
      "pack_id": "daily_exclusive",
      "year": 2014
    },
    {
      "id": "for_pain_glory",
      "title": "Pain and Glory",
      "aliases": [],
      "emojis": [
        "🎬",
        "🇪🇸",
        "💊",
        "👨",
        "💔",
        "🎨"
      ],
      "pack_id": "daily_exclusive",
      "year": 2019
    },
    {
      "id": "for_chungking",
      "title": "Chungking Express",
      "aliases": [],
      "emojis": [
        "🍍",
        "👮",
        "🇭🇰",
        "💔",
        "🛫",
        "🤝"
      ],
      "pack_id": "daily_exclusive",
      "year": 1994
    },
    {
      "id": "alt_grand_illusion",
      "title": "La Grande Illusion",
      "aliases": [
        "Grande Illusion"
      ],
      "emojis": [
        "🪖",
        "🇫🇷",
        "🇩🇪",
        "🏰",
        "🤝",
        "💔"
      ],
      "pack_id": "daily_exclusive",
      "year": 1937
    },
    {
      "id": "alt_bringing_up_baby",
      "title": "Bringing Up Baby",
      "aliases": [],
      "emojis": [
        "🐆",
        "🦴",
        "👩",
        "🤓",
        "🦷",
        "🐶"
      ],
      "pack_id": "daily_exclusive",
      "year": 1938
    },
    {
      "id": "alt_amores_perros",
      "title": "Amores Perros",
      "aliases": [],
      "emojis": [
        "🐕",
        "🚗",
        "🇲🇽",
        "💔",
        "🩸",
        "🎬"
      ],
      "pack_id": "daily_exclusive",
      "year": 2000
    },
    {
      "id": "alt_8_half",
      "title": "8½",
      "aliases": [
        "Eight and a Half",
        "8 1/2"
      ],
      "emojis": [
        "🎬",
        "🇮🇹",
        "🪂",
        "💑",
        "🤔",
        "✨"
      ],
      "pack_id": "daily_exclusive",
      "year": 1963
    },
    {
      "id": "ns_source_code",
      "title": "Source Code",
      "aliases": [],
      "emojis": [
        "🚂",
        "💥",
        "🔁",
        "🧠",
        "⏰",
        "💑"
      ],
      "pack_id": "daily_exclusive",
      "year": 2011
    },
    {
      "id": "ghibli_castle_sky",
      "title": "Castle in the Sky",
      "aliases": [],
      "emojis": [
        "☁️",
        "🤖",
        "💎",
        "👦",
        "👧",
        "🪂"
      ],
      "pack_id": "daily_exclusive",
      "year": 1986
    },
    {
      "id": "ghibli_arrietty",
      "title": "The Secret World of Arrietty",
      "aliases": [
        "Arrietty"
      ],
      "emojis": [
        "🌱",
        "👧",
        "🏠",
        "🐈",
        "🪡",
        "🪲"
      ],
      "pack_id": "daily_exclusive",
      "year": 2010
    },
    {
      "id": "dis_wish",
      "title": "Wish",
      "aliases": [],
      "emojis": [
        "🌟",
        "👩🏾",
        "🤴",
        "🐐",
        "✨",
        "💔"
      ],
      "pack_id": "daily_exclusive",
      "year": 2023
    },
    {
      "id": "hr_barbarian",
      "title": "Barbarian",
      "aliases": [],
      "emojis": [
        "🌧️",
        "🏚️",
        "🔑",
        "👩",
        "👨",
        "🚪",
        "🕳️",
        "👹",
        "🍼"
      ],
      "pack_id": "daily_exclusive",
      "year": 2022
    },
    {
      "id": "bio_big_eyes",
      "title": "Big Eyes",
      "aliases": [],
      "emojis": [
        "👁️",
        "🎨",
        "💑",
        "⚖️",
        "💔",
        "🎨"
      ],
      "pack_id": "daily_exclusive",
      "year": 2014
    },
    {
      "id": "act_48_hrs",
      "title": "48 Hrs.",
      "aliases": [
        "48 Hrs"
      ],
      "emojis": [
        "🚓",
        "👨🏿",
        "⛓️",
        "🌃",
        "🍻",
        "🔫"
      ],
      "pack_id": "daily_exclusive",
      "year": 1982
    },
    {
      "id": "act_smokin_aces",
      "title": "Smokin' Aces",
      "aliases": [
        "Smokin Aces"
      ],
      "emojis": [
        "🎩",
        "🃏",
        "💰",
        "🎯",
        "🏨",
        "🛗",
        "🔫",
        "🔌"
      ],
      "pack_id": "daily_exclusive",
      "year": 2006
    },
    {
      "id": "ind_revolutionary",
      "title": "Revolutionary Road",
      "aliases": [],
      "emojis": [
        "💑",
        "🏡",
        "🥂",
        "🇫🇷",
        "😤",
        "🤰",
        "🩸",
        "💀"
      ],
      "pack_id": "daily_exclusive",
      "year": 2008
    },
    {
      "id": "ind_minari",
      "title": "Minari",
      "aliases": [],
      "emojis": [
        "👨‍👩‍👧‍👦",
        "🇰🇷",
        "🚚",
        "🏡",
        "🌱",
        "👵",
        "🃏",
        "🔥",
        "🌿"
      ],
      "pack_id": "daily_exclusive",
      "year": 2020
    },
    {
      "id": "sf_riddick",
      "title": "Pitch Black",
      "aliases": [],
      "emojis": [
        "🌑",
        "👁️",
        "🚀",
        "🪐",
        "🩸",
        "🌗"
      ],
      "pack_id": "daily_exclusive",
      "year": 2000
    },
    {
      "id": "alt_african_queen",
      "title": "The African Queen",
      "aliases": [],
      "emojis": [
        "⛵",
        "👩",
        "🥃",
        "🌊",
        "🪱",
        "🇩🇪",
        "🚢",
        "💥",
        "💑"
      ],
      "pack_id": "daily_exclusive",
      "year": 1951
    },
    {
      "id": "alt_network",
      "title": "Network",
      "aliases": [],
      "emojis": [
        "📺",
        "🎤",
        "😡",
        "🪟",
        "📣",
        "📈",
        "💼",
        "🔫"
      ],
      "pack_id": "daily_exclusive",
      "year": 1976
    },
    {
      "id": "alt_glengarry",
      "title": "Glengarry Glen Ross",
      "aliases": [],
      "emojis": [
        "💼",
        "📞",
        "🚗",
        "🔪",
        "☕",
        "📇",
        "🌧️",
        "👮"
      ],
      "pack_id": "daily_exclusive",
      "year": 1992
    },
    {
      "id": "alt_bronx_tale",
      "title": "A Bronx Tale",
      "aliases": [
        "Bronx Tale"
      ],
      "emojis": [
        "👦",
        "🔫",
        "🤐",
        "🎲",
        "🚌",
        "👩🏿",
        "🔥",
        "⚰️"
      ],
      "pack_id": "daily_exclusive",
      "year": 1993
    },
    {
      "id": "alt_kevin",
      "title": "We Need to Talk About Kevin",
      "aliases": [],
      "emojis": [
        "👶",
        "🏹",
        "🍅",
        "🔪",
        "💔",
        "🚪"
      ],
      "pack_id": "daily_exclusive",
      "year": 2011
    },
    {
      "id": "alt_american_fiction",
      "title": "American Fiction",
      "aliases": [],
      "emojis": [
        "👨🏿",
        "📚",
        "😤",
        "✍️",
        "🎭",
        "💰",
        "🏆",
        "🎬"
      ],
      "pack_id": "daily_exclusive",
      "year": 2023
    },
    {
      "id": "alt_seventh_seal_c",
      "title": "M",
      "aliases": [
        "M (1931)"
      ],
      "emojis": [
        "🇩🇪",
        "👤",
        "🎈",
        "🌃",
        "🔪",
        "🪦"
      ],
      "pack_id": "daily_exclusive",
      "year": 1931
    },
    {
      "id": "ci_manchester_sea",
      "title": "Manchester by the Sea",
      "aliases": [],
      "emojis": [
        "🧹",
        "☎️",
        "⚰️",
        "🚗",
        "⛵",
        "👦",
        "🔥",
        "💔"
      ],
      "pack_id": "daily_exclusive",
      "year": 2016
    },
    {
      "id": "ci_grand_budapest",
      "title": "The Grand Budapest Hotel",
      "aliases": [
        "Grand Budapest",
        "Grand Budapest Hotel"
      ],
      "emojis": [
        "🏨",
        "🎂",
        "🎀",
        "👨‍✈️",
        "💀",
        "🖼️",
        "🐎",
        "🚂",
        "⛷️"
      ],
      "pack_id": "daily_exclusive",
      "year": 2014
    },
    {
      "id": "ni_once_upon_america",
      "title": "Once Upon a Time in America",
      "aliases": [],
      "emojis": [
        "👬",
        "🌉",
        "👁️",
        "💃",
        "💰",
        "🔫",
        "☎️",
        "⏰",
        "💨"
      ],
      "pack_id": "daily_exclusive",
      "year": 1984
    },
    {
      "id": "ghibli_boy_heron",
      "title": "The Boy and the Heron",
      "aliases": [],
      "emojis": [
        "👦",
        "🪶",
        "🏯",
        "🐦",
        "🔥",
        "🌌"
      ],
      "pack_id": "daily_exclusive",
      "year": 2023
    },
    {
      "id": "dis_treasure_planet",
      "title": "Treasure Planet",
      "aliases": [],
      "emojis": [
        "🪐",
        "🏴‍☠️",
        "🗺️",
        "👦",
        "🤖",
        "💎"
      ],
      "pack_id": "daily_exclusive",
      "year": 2002
    },
    {
      "id": "dw_captain_underpants",
      "title": "Captain Underpants: The First Epic Movie",
      "aliases": [
        "Captain Underpants"
      ],
      "emojis": [
        "🩲",
        "🦸",
        "🏫",
        "🚽",
        "😂",
        "🤜"
      ],
      "pack_id": "daily_exclusive",
      "year": 2017
    },
    {
      "id": "rc_crossroads",
      "title": "Crossroads",
      "aliases": [],
      "emojis": [
        "👧",
        "👧",
        "👧",
        "📦",
        "🚗",
        "🛣️",
        "🎤",
        "🤰",
        "🎶"
      ],
      "pack_id": "daily_exclusive",
      "year": 2002
    },
    {
      "id": "sp_bagger_vance",
      "title": "The Legend of Bagger Vance",
      "aliases": [
        "Bagger Vance"
      ],
      "emojis": [
        "👨",
        "🪖",
        "💔",
        "🥃",
        "🏌️",
        "👨🏿",
        "🌙",
        "⛳"
      ],
      "pack_id": "daily_exclusive",
      "year": 2000
    },
    {
      "id": "bio_capote",
      "title": "Capote",
      "aliases": [],
      "emojis": [
        "✍️",
        "📰",
        "🏚️",
        "🔪",
        "⛓️",
        "🤝",
        "📖",
        "💔"
      ],
      "pack_id": "daily_exclusive",
      "year": 2005
    },
    {
      "id": "bio_nyad",
      "title": "Nyad",
      "aliases": [],
      "emojis": [
        "🌊",
        "🏊‍♀️",
        "🇨🇺",
        "🇺🇸",
        "💪",
        "🦈"
      ],
      "pack_id": "daily_exclusive",
      "year": 2023
    },
    {
      "id": "ind_past_lives",
      "title": "Past Lives",
      "aliases": [],
      "emojis": [
        "👧",
        "👦",
        "🇰🇷",
        "✈️",
        "💻",
        "🗽",
        "💍",
        "🍻",
        "😢"
      ],
      "pack_id": "daily_exclusive",
      "year": 2023
    },
    {
      "id": "ind_seven_samurai",
      "title": "Seven Samurai",
      "aliases": [],
      "emojis": [
        "🏘️",
        "🌾",
        "🐎",
        "😨",
        "🗡️",
        "🍚",
        "🌧️",
        "⚔️",
        "🪦"
      ],
      "pack_id": "daily_exclusive",
      "year": 1954
    },
    {
      "id": "sf_jupiter_ascending",
      "title": "Jupiter Ascending",
      "aliases": [],
      "emojis": [
        "👩",
        "🧹",
        "👽",
        "🐺",
        "🛼",
        "🐝",
        "👑",
        "🚀",
        "💥"
      ],
      "pack_id": "daily_exclusive",
      "year": 2015
    },
    {
      "id": "sf_chappie",
      "title": "Chappie",
      "aliases": [],
      "emojis": [
        "🤖",
        "🇿🇦",
        "👶",
        "🔫",
        "🎵",
        "💔"
      ],
      "pack_id": "daily_exclusive",
      "year": 2015
    },
    {
      "id": "sf_serenity",
      "title": "Serenity",
      "aliases": [],
      "emojis": [
        "🚀",
        "🤠",
        "👧",
        "🧠",
        "🗡️",
        "🧟",
        "📡",
        "⚔️"
      ],
      "pack_id": "daily_exclusive",
      "year": 2005
    },
    {
      "id": "an_coco",
      "title": "Coco",
      "aliases": [],
      "emojis": [
        "👦🏽",
        "🇲🇽",
        "🎸",
        "💀",
        "🌉",
        "🌺",
        "👴🏽",
        "🎶",
        "❤️"
      ],
      "pack_id": "daily_exclusive",
      "year": 2017
    },
    {
      "id": "com_dogma",
      "title": "Dogma",
      "aliases": [],
      "emojis": [
        "👼",
        "👼",
        "⛪",
        "👩",
        "👨🏿",
        "🚂",
        "🩸",
        "👩🏽‍🎤"
      ],
      "pack_id": "daily_exclusive",
      "year": 1999
    },
    {
      "id": "alt_philadelphia_story",
      "title": "The Philadelphia Story",
      "aliases": [],
      "emojis": [
        "👰",
        "💍",
        "🤵",
        "📰",
        "📸",
        "🥂",
        "🏊",
        "💒"
      ],
      "pack_id": "daily_exclusive",
      "year": 1940
    },
    {
      "id": "alt_beasts_southern",
      "title": "Beasts of the Southern Wild",
      "aliases": [],
      "emojis": [
        "🐗",
        "💧",
        "🌊",
        "👧🏿",
        "🌅",
        "🔥"
      ],
      "pack_id": "daily_exclusive",
      "year": 2012
    },
    {
      "id": "alt_saltburn",
      "title": "Saltburn",
      "aliases": [],
      "emojis": [
        "🏰",
        "🛁",
        "🌹",
        "🩸",
        "🇬🇧",
        "💔"
      ],
      "pack_id": "daily_exclusive",
      "year": 2023
    },
    {
      "id": "alt_anora",
      "title": "Anora",
      "aliases": [],
      "emojis": [
        "💃",
        "🇷🇺",
        "💵",
        "🎰",
        "💍",
        "😡",
        "🔍",
        "💔",
        "😢"
      ],
      "pack_id": "daily_exclusive",
      "year": 2024
    },
    {
      "id": "alt_being_there",
      "title": "Being There",
      "aliases": [],
      "emojis": [
        "👨",
        "🌷",
        "📺",
        "🚗",
        "🏰",
        "🗣️",
        "🇺🇸",
        "🚶",
        "🌊"
      ],
      "pack_id": "daily_exclusive",
      "year": 1979
    },
    {
      "id": "alt_force_majeure",
      "title": "Force Majeure",
      "aliases": [],
      "emojis": [
        "👨‍👩‍👧‍👦",
        "🎿",
        "🏔️",
        "🍽️",
        "❄️",
        "🏃‍♂️",
        "📱",
        "💔",
        "😭"
      ],
      "pack_id": "daily_exclusive",
      "year": 2014
    },
    {
      "id": "ghibli_wind_rises",
      "title": "The Wind Rises",
      "aliases": [],
      "emojis": [
        "✈️",
        "✏️",
        "🌬️",
        "💔",
        "🇯🇵",
        "🚂"
      ],
      "pack_id": "daily_exclusive",
      "year": 2013
    },
    {
      "id": "alt_three_kings",
      "title": "Three Kings",
      "aliases": [],
      "emojis": [
        "🏜️",
        "💰",
        "🪖",
        "🇮🇶",
        "🤝",
        "🐂"
      ],
      "pack_id": "daily_exclusive",
      "year": 1999
    },
    {
      "id": "mc_city_of_god",
      "title": "City of God",
      "aliases": [],
      "emojis": [
        "🇧🇷",
        "🏘️",
        "🔫",
        "🧒🏿",
        "📷",
        "🐔",
        "🩸"
      ],
      "pack_id": "daily_exclusive",
      "year": 2002
    },
    {
      "id": "mc_room",
      "title": "Room",
      "aliases": [],
      "emojis": [
        "🚪",
        "🛏️",
        "👩",
        "👦",
        "🛻",
        "🆓",
        "🌳",
        "🏠"
      ],
      "pack_id": "daily_exclusive",
      "year": 2015
    },
    {
      "id": "dc_blue_beetle",
      "title": "Blue Beetle",
      "aliases": [],
      "emojis": [
        "🪲",
        "👦🏽",
        "🦾",
        "🇲🇽",
        "👨‍👩‍👧‍👦",
        "🛸"
      ],
      "pack_id": "daily_exclusive",
      "year": 2023
    },
    {
      "id": "ghibli_nausicaa",
      "title": "Nausicaä of the Valley of the Wind",
      "aliases": [
        "Nausicaa"
      ],
      "emojis": [
        "👸",
        "🌫️",
        "🪱",
        "🪂",
        "🌬️",
        "🌿"
      ],
      "pack_id": "daily_exclusive",
      "year": 1984
    },
    {
      "id": "dis_strange_world",
      "title": "Strange World",
      "aliases": [],
      "emojis": [
        "🌍",
        "✈️",
        "👨‍👩‍👦",
        "🐙",
        "🐉",
        "🌳"
      ],
      "pack_id": "daily_exclusive",
      "year": 2022
    },
    {
      "id": "hr_pandora",
      "title": "Pandorum",
      "aliases": [],
      "emojis": [
        "🚀",
        "💤",
        "🧠",
        "🔦",
        "👹",
        "⚙️",
        "🌊",
        "🌅"
      ],
      "pack_id": "daily_exclusive",
      "year": 2009
    },
    {
      "id": "bio_pollock",
      "title": "Pollock",
      "aliases": [],
      "emojis": [
        "👨",
        "🎨",
        "💦",
        "🖼️",
        "🥃",
        "😡",
        "🚗",
        "💥"
      ],
      "pack_id": "daily_exclusive",
      "year": 2000
    },
    {
      "id": "bio_marie_antoinette",
      "title": "Marie Antoinette",
      "aliases": [],
      "emojis": [
        "👑",
        "🍰",
        "🎀",
        "🇫🇷",
        "💃",
        "⚔️"
      ],
      "pack_id": "daily_exclusive",
      "year": 2006
    },
    {
      "id": "bio_ferrari",
      "title": "Ferrari",
      "aliases": [],
      "emojis": [
        "🏎️",
        "🇮🇹",
        "💔",
        "🛐",
        "🚗",
        "🏆"
      ],
      "pack_id": "daily_exclusive",
      "year": 2023
    },
    {
      "id": "ind_phantom_thread",
      "title": "Phantom Thread",
      "aliases": [],
      "emojis": [
        "✂️",
        "👗",
        "🇬🇧",
        "🍳",
        "💔",
        "🍄"
      ],
      "pack_id": "daily_exclusive",
      "year": 2017
    },
    {
      "id": "ind_ran",
      "title": "Ran",
      "aliases": [],
      "emojis": [
        "👴",
        "👑",
        "🏹",
        "🤴",
        "🤴",
        "🤴",
        "🔥",
        "🏯",
        "😭"
      ],
      "pack_id": "daily_exclusive",
      "year": 1985
    },
    {
      "id": "com_old_dogs",
      "title": "Old Dogs",
      "aliases": [],
      "emojis": [
        "👨",
        "👨",
        "💼",
        "👦",
        "👧",
        "⛳",
        "🦍",
        "🏕️",
        "❤️"
      ],
      "pack_id": "daily_exclusive",
      "year": 2009
    },
    {
      "id": "com_tucker_dale",
      "title": "Tucker & Dale vs. Evil",
      "aliases": [
        "Tucker and Dale vs Evil"
      ],
      "emojis": [
        "🪓",
        "🌲",
        "🐝",
        "🚙",
        "🩸",
        "🤓"
      ],
      "pack_id": "daily_exclusive",
      "year": 2010
    },
    {
      "id": "for_in_mood_love",
      "title": "In the Mood for Love",
      "aliases": [],
      "emojis": [
        "👨",
        "👩",
        "🚪",
        "🍜",
        "💔",
        "🌹",
        "🇭🇰",
        "🛕",
        "🤫"
      ],
      "pack_id": "daily_exclusive",
      "year": 2000
    },
    {
      "id": "alt_double_indemnity",
      "title": "Double Indemnity",
      "aliases": [],
      "emojis": [
        "👨‍💼",
        "📄",
        "💋",
        "🤵",
        "🚂",
        "💀",
        "💰",
        "🔫"
      ],
      "pack_id": "daily_exclusive",
      "year": 1944
    },
    {
      "id": "alt_tick_tick",
      "title": "Tick, Tick... Boom!",
      "aliases": [
        "Tick Tick Boom"
      ],
      "emojis": [
        "👨",
        "🎹",
        "⏰",
        "🍳",
        "💔",
        "🎂",
        "🎶",
        "🎭"
      ],
      "pack_id": "daily_exclusive",
      "year": 2021
    },
    {
      "id": "alt_wonder_boys",
      "title": "Wonder Boys",
      "aliases": [],
      "emojis": [
        "✍️",
        "🚗",
        "💔",
        "🎓",
        "🐕",
        "📚"
      ],
      "pack_id": "daily_exclusive",
      "year": 2000
    },
    {
      "id": "alt_poor_things",
      "title": "Poor Things",
      "aliases": [],
      "emojis": [
        "🧠",
        "👩",
        "🇬🇧",
        "🚢",
        "💑",
        "🦆"
      ],
      "pack_id": "daily_exclusive",
      "year": 2023
    },
    {
      "id": "alt_village",
      "title": "The Village",
      "aliases": [],
      "emojis": [
        "🌲",
        "🏘️",
        "🪦",
        "🦌",
        "💛",
        "🤐"
      ],
      "pack_id": "daily_exclusive",
      "year": 2004
    },
    {
      "id": "alt_dancer_dark",
      "title": "Dancer in the Dark",
      "aliases": [],
      "emojis": [
        "🎵",
        "👁️",
        "🧵",
        "🇺🇸",
        "🩰",
        "💔"
      ],
      "pack_id": "daily_exclusive",
      "year": 2000
    },
    {
      "id": "ns_phone_booth",
      "title": "Phone Booth",
      "aliases": [],
      "emojis": [
        "☎️",
        "🎯",
        "🔫",
        "🚓",
        "🌃"
      ],
      "pack_id": "daily_exclusive",
      "year": 2002
    },
    {
      "id": "ghibli_kaguya",
      "title": "The Tale of the Princess Kaguya",
      "aliases": [
        "Princess Kaguya"
      ],
      "emojis": [
        "🎋",
        "👶",
        "🌙",
        "👘",
        "🌸",
        "☁️"
      ],
      "pack_id": "daily_exclusive",
      "year": 2013
    },
    {
      "id": "mi_garden_state",
      "title": "Garden State",
      "aliases": [],
      "emojis": [
        "⚰️",
        "🏡",
        "💊",
        "🎧",
        "👩",
        "👕",
        "🌧️",
        "🗣️",
        "💑"
      ],
      "pack_id": "daily_exclusive",
      "year": 2004
    },
    {
      "id": "ci_moonlight",
      "title": "Moonlight",
      "aliases": [],
      "emojis": [
        "🌙",
        "👦🏿",
        "🏖️",
        "🇨🇺",
        "💉",
        "💔",
        "🦋",
        "👨🏿‍❤️‍👨🏿"
      ],
      "pack_id": "daily_exclusive",
      "year": 2016
    },
    {
      "id": "mi_mulholland",
      "title": "Mulholland Drive",
      "aliases": [],
      "emojis": [
        "🛣️",
        "🏙️",
        "👩",
        "👱‍♀️",
        "📦",
        "🗝️",
        "🌙"
      ],
      "pack_id": "daily_exclusive",
      "year": 2001
    },
    {
      "id": "ghibli_porco",
      "title": "Porco Rosso",
      "aliases": [],
      "emojis": [
        "🐷",
        "✈️",
        "🇮🇹",
        "🌊",
        "🛠️",
        "🎬"
      ],
      "pack_id": "daily_exclusive",
      "year": 1992
    },
    {
      "id": "bio_dangal",
      "title": "Dangal",
      "aliases": [],
      "emojis": [
        "🤼‍♀️",
        "🇮🇳",
        "👨🏾",
        "👧🏾",
        "🏆",
        "✊"
      ],
      "pack_id": "daily_exclusive",
      "year": 2016
    },
    {
      "id": "ind_blue_valentine",
      "title": "Blue Valentine",
      "aliases": [],
      "emojis": [
        "🎸",
        "💃",
        "💍",
        "👶",
        "🏩",
        "🍺",
        "🏥",
        "💔"
      ],
      "pack_id": "daily_exclusive",
      "year": 2010
    },
    {
      "id": "ind_amour",
      "title": "Amour",
      "aliases": [],
      "emojis": [
        "👴",
        "👵",
        "💔",
        "🎹",
        "🇫🇷",
        "🪦"
      ],
      "pack_id": "daily_exclusive",
      "year": 2012
    },
    {
      "id": "com_pineapple_2",
      "title": "Your Highness",
      "aliases": [],
      "emojis": [
        "🤴",
        "🤴",
        "🌿",
        "👰",
        "🧙",
        "🐂",
        "🐍",
        "⚔️"
      ],
      "pack_id": "daily_exclusive",
      "year": 2011
    },
    {
      "id": "alt_waterfront",
      "title": "On the Waterfront",
      "aliases": [],
      "emojis": [
        "🥊",
        "🐦",
        "⚓",
        "💀",
        "🚕",
        "🗣️",
        "⚖️",
        "🩸",
        "🚶"
      ],
      "pack_id": "daily_exclusive",
      "year": 1954
    },
    {
      "id": "alt_power_dog",
      "title": "The Power of the Dog",
      "aliases": [],
      "emojis": [
        "🤠",
        "🤠",
        "🐂",
        "🏔️",
        "🪢",
        "💔"
      ],
      "pack_id": "daily_exclusive",
      "year": 2021
    },
    {
      "id": "alt_blue_velvet",
      "title": "Blue Velvet",
      "aliases": [],
      "emojis": [
        "👂",
        "🌹",
        "💋",
        "🐦",
        "🤐",
        "🪞"
      ],
      "pack_id": "daily_exclusive",
      "year": 1986
    },
    {
      "id": "act_drive_angry",
      "title": "Drive Angry",
      "aliases": [],
      "emojis": [
        "💀",
        "🔓",
        "🔥",
        "🚗",
        "👶",
        "😈",
        "🔫",
        "💥"
      ],
      "pack_id": "daily_exclusive",
      "year": 2011
    },
    {
      "id": "alt_secretary",
      "title": "Secretary",
      "aliases": [],
      "emojis": [
        "👩",
        "🩹",
        "💼",
        "⌨️",
        "🔴",
        "📎",
        "🙇‍♀️",
        "💘",
        "👰"
      ],
      "pack_id": "daily_exclusive",
      "year": 2002
    },
    {
      "id": "mc_oldboy",
      "title": "Oldboy",
      "aliases": [],
      "emojis": [
        "🍻",
        "🔒",
        "🛏️",
        "🥟",
        "📺",
        "🐙",
        "🔨",
        "✂️",
        "😱"
      ],
      "pack_id": "daily_exclusive",
      "year": 2003
    },
    {
      "id": "mi_roma",
      "title": "Roma",
      "aliases": [],
      "emojis": [
        "👩🏽",
        "🏠",
        "🧹",
        "🐕",
        "🤰",
        "💔",
        "🏥",
        "😢",
        "🌊"
      ],
      "pack_id": "daily_exclusive",
      "year": 2018
    },
    {
      "id": "ghibli_grave_fireflies",
      "title": "Grave of the Fireflies",
      "aliases": [],
      "emojis": [
        "✨",
        "👦",
        "👧",
        "🍬",
        "💔",
        "🪦"
      ],
      "pack_id": "daily_exclusive",
      "year": 1988
    },
    {
      "id": "bio_maestro",
      "title": "Maestro",
      "aliases": [],
      "emojis": [
        "📞",
        "🎼",
        "🌟",
        "💑",
        "👨‍❤️‍👨",
        "💔",
        "🪦",
        "🎶"
      ],
      "pack_id": "daily_exclusive",
      "year": 2023
    },
    {
      "id": "act_shoot_em_up",
      "title": "Shoot 'Em Up",
      "aliases": [
        "Shoot Em Up"
      ],
      "emojis": [
        "🔫",
        "🥕",
        "👶",
        "🚗",
        "🌃",
        "🍼"
      ],
      "pack_id": "daily_exclusive",
      "year": 2007
    },
    {
      "id": "ind_winters_bone",
      "title": "Winter's Bone",
      "aliases": [
        "Winters Bone"
      ],
      "emojis": [
        "👧",
        "❄️",
        "🏚️",
        "👮",
        "🔍",
        "👊",
        "🛶",
        "🪚",
        "✋"
      ],
      "pack_id": "daily_exclusive",
      "year": 2010
    },
    {
      "id": "ind_separation",
      "title": "A Separation",
      "aliases": [],
      "emojis": [
        "💑",
        "💔",
        "👴🏽",
        "🤰🏽",
        "🪜",
        "⚖️",
        "👧🏽",
        "❓"
      ],
      "pack_id": "daily_exclusive",
      "year": 2011
    },
    {
      "id": "ind_yojimbo",
      "title": "Yojimbo",
      "aliases": [],
      "emojis": [
        "🗡️",
        "🏘️",
        "🐕",
        "✋",
        "💰",
        "🆚",
        "🔫",
        "⚔️"
      ],
      "pack_id": "daily_exclusive",
      "year": 1961
    },
    {
      "id": "com_observe_report",
      "title": "Observe and Report",
      "aliases": [],
      "emojis": [
        "👮",
        "🛍️",
        "🧥",
        "😱",
        "💊",
        "🚓",
        "👊",
        "🔫"
      ],
      "pack_id": "daily_exclusive",
      "year": 2009
    },
    {
      "id": "alt_come_see",
      "title": "Come and See",
      "aliases": [],
      "emojis": [
        "👦",
        "🔫",
        "🌲",
        "🇩🇪",
        "✈️",
        "🐄",
        "🔥",
        "😱"
      ],
      "pack_id": "daily_exclusive",
      "year": 1985
    },
    {
      "id": "alt_bad_lieutenant",
      "title": "Bad Lieutenant",
      "aliases": [],
      "emojis": [
        "👮",
        "💉",
        "⚾",
        "🎰",
        "⛪",
        "🙏",
        "🚌",
        "🔫"
      ],
      "pack_id": "daily_exclusive",
      "year": 1992
    },
    {
      "id": "alt_brutalist",
      "title": "The Brutalist",
      "aliases": [],
      "emojis": [
        "🇭🇺",
        "🚢",
        "🗽",
        "📐",
        "💰",
        "🏗️",
        "💉",
        "⛪",
        "🏛️"
      ],
      "pack_id": "daily_exclusive",
      "year": 2024
    },
    {
      "id": "ind_master",
      "title": "The Master",
      "aliases": [],
      "emojis": [
        "🪖",
        "🥃",
        "⛵",
        "🤝",
        "👁️",
        "❓",
        "🏍️",
        "🏜️"
      ],
      "pack_id": "daily_exclusive",
      "year": 2012
    },
    {
      "id": "for_yi_yi",
      "title": "Yi Yi",
      "aliases": [],
      "emojis": [
        "👨‍👩‍👧‍👦",
        "🇹🇼",
        "📷",
        "💔",
        "🏙️",
        "🌅"
      ],
      "pack_id": "daily_exclusive",
      "year": 2000
    },
    {
      "id": "alt_prophet",
      "title": "A Prophet",
      "aliases": [],
      "emojis": [
        "👨🏽",
        "⛓️",
        "🪒",
        "🩸",
        "🤝",
        "🦌",
        "👑"
      ],
      "pack_id": "daily_exclusive",
      "year": 2009
    },
    {
      "id": "alt_zone_interest",
      "title": "The Zone of Interest",
      "aliases": [],
      "emojis": [
        "🏡",
        "🌷",
        "👨‍👩‍👧‍👦",
        "🧱",
        "🏭",
        "💨",
        "🏊",
        "🌑"
      ],
      "pack_id": "daily_exclusive",
      "year": 2023
    },
    {
      "id": "ci_moonrise_kingdom",
      "title": "Moonrise Kingdom",
      "aliases": [],
      "emojis": [
        "🏝️",
        "⛺",
        "👫",
        "📻",
        "💌",
        "🏕️",
        "⛈️",
        "🌈"
      ],
      "pack_id": "daily_exclusive",
      "year": 2012
    },
    {
      "id": "ind_take_shelter",
      "title": "Take Shelter",
      "aliases": [],
      "emojis": [
        "👨",
        "😰",
        "⛈️",
        "🐦",
        "👧",
        "🚜",
        "🕳️",
        "🚪",
        "🌊"
      ],
      "pack_id": "daily_exclusive",
      "year": 2011
    },
    {
      "id": "ind_lobster",
      "title": "The Lobster",
      "aliases": [],
      "emojis": [
        "🦞",
        "🏨",
        "💔",
        "💑",
        "🌲",
        "🪞"
      ],
      "pack_id": "daily_exclusive",
      "year": 2015
    },
    {
      "id": "ind_ikiru",
      "title": "Ikiru",
      "aliases": [],
      "emojis": [
        "👴",
        "📄",
        "🏥",
        "😢",
        "🍶",
        "🎤",
        "🏗️",
        "🛝",
        "❄️"
      ],
      "pack_id": "daily_exclusive",
      "year": 1952
    },
    {
      "id": "ind_rashomon",
      "title": "Rashomon",
      "aliases": [],
      "emojis": [
        "☔",
        "🌳",
        "🥷",
        "🗡️",
        "👻",
        "🤔"
      ],
      "pack_id": "daily_exclusive",
      "year": 1950
    },
    {
      "id": "ind_only_lovers",
      "title": "Only Lovers Left Alive",
      "aliases": [],
      "emojis": [
        "🧛",
        "🎸",
        "🏚️",
        "🩸",
        "🌃",
        "🇲🇦"
      ],
      "pack_id": "daily_exclusive",
      "year": 2013
    },
    {
      "id": "com_meet_dave",
      "title": "Meet Dave",
      "aliases": [],
      "emojis": [
        "🛸",
        "👨🏿",
        "🗽",
        "🤖",
        "👩",
        "🧂",
        "🌊",
        "❤️"
      ],
      "pack_id": "daily_exclusive",
      "year": 2008
    },
    {
      "id": "for_run_for_your",
      "title": "Run!",
      "aliases": [],
      "emojis": [
        "🏃",
        "🌃",
        "💔",
        "🚓",
        "🪙",
        "🤝"
      ],
      "pack_id": "daily_exclusive",
      "year": 2020
    },
    {
      "id": "alt_touch_evil",
      "title": "Touch of Evil",
      "aliases": [],
      "emojis": [
        "💥",
        "🚗",
        "🇲🇽",
        "🚓",
        "💀",
        "🎬"
      ],
      "pack_id": "daily_exclusive",
      "year": 1958
    },
    {
      "id": "alt_belfast",
      "title": "Belfast",
      "aliases": [],
      "emojis": [
        "👦",
        "🏘️",
        "🔥",
        "🎬",
        "💑",
        "⚰️",
        "🧳"
      ],
      "pack_id": "daily_exclusive",
      "year": 2021
    },
    {
      "id": "alt_dark_city",
      "title": "Dark City",
      "aliases": [],
      "emojis": [
        "🌃",
        "🧠",
        "🚪",
        "💉",
        "🪞",
        "🕴️"
      ],
      "pack_id": "daily_exclusive",
      "year": 1998
    },
    {
      "id": "ind_shoplifters",
      "title": "Shoplifters",
      "aliases": [],
      "emojis": [
        "👨",
        "👦",
        "🏪",
        "🤫",
        "👧",
        "🏚️",
        "👵",
        "⚰️",
        "👮"
      ],
      "pack_id": "daily_exclusive",
      "year": 2018
    },
    {
      "id": "ind_killing_sacred",
      "title": "The Killing of a Sacred Deer",
      "aliases": [],
      "emojis": [
        "🦌",
        "🩺",
        "👨‍👩‍👧‍👦",
        "🕯️",
        "🪦",
        "🍝"
      ],
      "pack_id": "daily_exclusive",
      "year": 2017
    },
    {
      "id": "sf_under_skin",
      "title": "Under the Skin",
      "aliases": [],
      "emojis": [
        "👩",
        "🚐",
        "🏴󠁧󠁢󠁳󠁣󠁴󠁿",
        "😏",
        "🖤",
        "🕳️",
        "🌲",
        "🔥"
      ],
      "pack_id": "daily_exclusive",
      "year": 2013
    },
    {
      "id": "alt_first_reformed",
      "title": "First Reformed",
      "aliases": [],
      "emojis": [
        "👨",
        "⛪",
        "🤰",
        "🌍",
        "🔫",
        "🥃",
        "🧨",
        "💏"
      ],
      "pack_id": "daily_exclusive",
      "year": 2017
    },
    {
      "id": "alt_solaris",
      "title": "Solaris",
      "aliases": [],
      "emojis": [
        "🚀",
        "🌌",
        "🧠",
        "👻",
        "💔",
        "💙"
      ],
      "pack_id": "daily_exclusive",
      "year": 1972
    },
    {
      "id": "alt_funny_games",
      "title": "Funny Games",
      "aliases": [],
      "emojis": [
        "🏡",
        "👨‍👩‍👦",
        "🥚",
        "⛳",
        "😱",
        "📼",
        "🚤",
        "💀"
      ],
      "pack_id": "daily_exclusive",
      "year": 1997
    },
    {
      "id": "mc_sing_street",
      "title": "Sing Street",
      "aliases": [],
      "emojis": [
        "🇮🇪",
        "🎸",
        "🏫",
        "👨‍👩‍👧",
        "💑",
        "🎬",
        "⛴️",
        "🎵"
      ],
      "pack_id": "daily_exclusive",
      "year": 2016
    },
    {
      "id": "ind_decision_leave",
      "title": "Decision to Leave",
      "aliases": [],
      "emojis": [
        "🧗",
        "💀",
        "🕵️",
        "👩",
        "👀",
        "💘",
        "📱",
        "🌊",
        "🕳️"
      ],
      "pack_id": "daily_exclusive",
      "year": 2022
    },
    {
      "id": "alt_stagecoach",
      "title": "Stagecoach",
      "aliases": [],
      "emojis": [
        "🐎",
        "🐎",
        "🤠",
        "🤰",
        "🏜️",
        "🏹",
        "🔫",
        "💑"
      ],
      "pack_id": "daily_exclusive",
      "year": 1939
    },
    {
      "id": "alt_chronicle",
      "title": "Chronicle",
      "aliases": [],
      "emojis": [
        "📹",
        "💪",
        "🌌",
        "👬",
        "🌪️",
        "💔"
      ],
      "pack_id": "daily_exclusive",
      "year": 2012
    },
    {
      "id": "ind_drive_my_car",
      "title": "Drive My Car",
      "aliases": [],
      "emojis": [
        "👨",
        "💔",
        "🔴",
        "🚗",
        "📼",
        "🎭",
        "👩",
        "🚬",
        "❄️"
      ],
      "pack_id": "daily_exclusive",
      "year": 2021
    },
    {
      "id": "ind_white_ribbon",
      "title": "The White Ribbon",
      "aliases": [],
      "emojis": [
        "🐎",
        "🪢",
        "🏘️",
        "⛪",
        "🎀",
        "👦",
        "🔥",
        "❓"
      ],
      "pack_id": "daily_exclusive",
      "year": 2009
    },
    {
      "id": "alt_3_days_condor",
      "title": "Three Days of the Condor",
      "aliases": [],
      "emojis": [
        "🦅",
        "📚",
        "🔫",
        "🚇",
        "💼",
        "💑"
      ],
      "pack_id": "daily_exclusive",
      "year": 1975
    },
    {
      "id": "alt_brazil",
      "title": "Brazil",
      "aliases": [],
      "emojis": [
        "⚙️",
        "🌃",
        "🪲",
        "💼",
        "🤖",
        "💔"
      ],
      "pack_id": "daily_exclusive",
      "year": 1985
    },
    {
      "id": "bio_rrr",
      "title": "RRR",
      "aliases": [],
      "emojis": [
        "🐅",
        "🐍",
        "🇮🇳",
        "🪶",
        "🔥",
        "🕺🏾"
      ],
      "pack_id": "daily_exclusive",
      "year": 2022
    },
    {
      "id": "ind_tree_life",
      "title": "The Tree of Life",
      "aliases": [],
      "emojis": [
        "👨‍👩‍👦",
        "💌",
        "💔",
        "🌌",
        "🦕",
        "🌳",
        "🏙️",
        "🏖️"
      ],
      "pack_id": "daily_exclusive",
      "year": 2011
    },
    {
      "id": "alt_sierra_madre",
      "title": "The Treasure of the Sierra Madre",
      "aliases": [
        "Treasure of the Sierra Madre"
      ],
      "emojis": [
        "👨",
        "👴",
        "⛏️",
        "🏔️",
        "💰",
        "🤪",
        "🔫",
        "🌬️"
      ],
      "pack_id": "daily_exclusive",
      "year": 1948
    },
    {
      "id": "alt_licorice_pizza",
      "title": "Licorice Pizza",
      "aliases": [],
      "emojis": [
        "🛏️",
        "🚚",
        "💑",
        "🌴",
        "🎬",
        "🌅"
      ],
      "pack_id": "daily_exclusive",
      "year": 2021
    },
    {
      "id": "alt_central_station",
      "title": "Central do Brasil",
      "aliases": [
        "Central Station"
      ],
      "emojis": [
        "🚂",
        "👵",
        "👦",
        "💌",
        "🇧🇷",
        "🌅"
      ],
      "pack_id": "daily_exclusive",
      "year": 1998
    },
    {
      "id": "alt_lost_highway",
      "title": "Lost Highway",
      "aliases": [],
      "emojis": [
        "📼",
        "🏠",
        "😨",
        "🎷",
        "💀",
        "⛓️",
        "🔄",
        "🔥",
        "🛣️"
      ],
      "pack_id": "daily_exclusive",
      "year": 1997
    },
    {
      "id": "ind_burning",
      "title": "Burning",
      "aliases": [],
      "emojis": [
        "👨",
        "👩",
        "🐈",
        "✈️",
        "🤵",
        "💃",
        "🌅",
        "🔥",
        "🔪"
      ],
      "pack_id": "daily_exclusive",
      "year": 2018
    },
    {
      "id": "ind_4_months",
      "title": "4 Months, 3 Weeks and 2 Days",
      "aliases": [
        "4 Months 3 Weeks and 2 Days"
      ],
      "emojis": [
        "👩",
        "🤰",
        "🇷🇴",
        "🏨",
        "💵",
        "😢",
        "🌃",
        "🍽️"
      ],
      "pack_id": "daily_exclusive",
      "year": 2007
    },
    {
      "id": "alt_happened_one_night",
      "title": "It Happened One Night",
      "aliases": [],
      "emojis": [
        "👰",
        "⛵",
        "🚌",
        "✍️",
        "🦵",
        "🚗",
        "🛌",
        "🎺"
      ],
      "pack_id": "daily_exclusive",
      "year": 1934
    },
    {
      "id": "alt_naked",
      "title": "Naked",
      "aliases": [],
      "emojis": [
        "🇬🇧",
        "🌃",
        "🎤",
        "🤐",
        "🚶",
        "💔"
      ],
      "pack_id": "daily_exclusive",
      "year": 1993
    },
    {
      "id": "alt_fish_tank",
      "title": "Fish Tank",
      "aliases": [],
      "emojis": [
        "💃",
        "🇬🇧",
        "🏘️",
        "🐎",
        "💔",
        "🚪"
      ],
      "pack_id": "daily_exclusive",
      "year": 2009
    },
    {
      "id": "alt_cold_war",
      "title": "Cold War",
      "aliases": [],
      "emojis": [
        "🎶",
        "💑",
        "🇵🇱",
        "🇫🇷",
        "⚫",
        "⚪"
      ],
      "pack_id": "daily_exclusive",
      "year": 2018
    },
    {
      "id": "alt_triangle",
      "title": "Triangle of Sadness",
      "aliases": [],
      "emojis": [
        "⛵",
        "💰",
        "🤮",
        "🏝️",
        "🐙",
        "🪙"
      ],
      "pack_id": "daily_exclusive",
      "year": 2022
    },
    {
      "id": "alt_aftersun",
      "title": "Aftersun",
      "aliases": [],
      "emojis": [
        "📹",
        "🏝️",
        "👨‍👧",
        "💔",
        "🎶",
        "🌅"
      ],
      "pack_id": "daily_exclusive",
      "year": 2022
    },
    {
      "id": "bio_society_snow",
      "title": "Society of the Snow",
      "aliases": [],
      "emojis": [
        "🏉",
        "🇺🇾",
        "✈️",
        "🏔️",
        "💥",
        "❄️",
        "🥶",
        "🥾",
        "🚁"
      ],
      "pack_id": "daily_exclusive",
      "year": 2023
    },
    {
      "id": "ind_dogtooth",
      "title": "Dogtooth",
      "aliases": [],
      "emojis": [
        "🏠",
        "🚧",
        "👨‍👩‍👧",
        "✈️",
        "🐱",
        "✂️",
        "📼",
        "🦷",
        "🚗"
      ],
      "pack_id": "daily_exclusive",
      "year": 2009
    },
    {
      "id": "alt_wages_fear",
      "title": "The Wages of Fear",
      "aliases": [],
      "emojis": [
        "🚚",
        "💣",
        "🌴",
        "🏜️",
        "🛢️",
        "💥"
      ],
      "pack_id": "daily_exclusive",
      "year": 1953
    },
    {
      "id": "alt_whale",
      "title": "The Whale",
      "aliases": [],
      "emojis": [
        "🐋",
        "✍️",
        "🛋️",
        "💔",
        "🍔",
        "💌"
      ],
      "pack_id": "daily_exclusive",
      "year": 2022
    },
    {
      "id": "ind_taste_cherry",
      "title": "Taste of Cherry",
      "aliases": [],
      "emojis": [
        "👨🏽",
        "🚗",
        "🇮🇷",
        "💵",
        "🪦",
        "🍒",
        "🌙",
        "❓"
      ],
      "pack_id": "daily_exclusive",
      "year": 1997
    },
    {
      "id": "alt_oslo",
      "title": "Oslo, August 31st",
      "aliases": [
        "Oslo August 31"
      ],
      "emojis": [
        "🇳🇴",
        "💊",
        "💔",
        "🚲",
        "🥃",
        "🌅"
      ],
      "pack_id": "daily_exclusive",
      "year": 2011
    },
    {
      "id": "alt_3_colors_blue",
      "title": "Three Colors: Blue",
      "aliases": [
        "Three Colours Blue"
      ],
      "emojis": [
        "💙",
        "🎼",
        "🇫🇷",
        "💔",
        "🌊",
        "🪦"
      ],
      "pack_id": "daily_exclusive",
      "year": 1993
    },
    {
      "id": "alt_tar",
      "title": "Tár",
      "aliases": [
        "Tar"
      ],
      "emojis": [
        "👩",
        "🎼",
        "🇩🇪",
        "🎻",
        "📱",
        "💀",
        "📉",
        "🎮"
      ],
      "pack_id": "daily_exclusive",
      "year": 2022
    },
    {
      "id": "alt_inland_empire",
      "title": "Inland Empire",
      "aliases": [],
      "emojis": [
        "🐰",
        "🎬",
        "💡",
        "🪞",
        "🤐",
        "🎭"
      ],
      "pack_id": "daily_exclusive",
      "year": 2006
    },
    {
      "id": "rep2_moneyball",
      "title": "Moneyball",
      "aliases": [],
      "emojis": [
        "⚾",
        "💰",
        "📊",
        "🤓",
        "🏟️",
        "🏆"
      ],
      "pack_id": "daily_exclusive",
      "year": 2011
    },
    {
      "id": "rep2_sully",
      "title": "Sully",
      "aliases": [
        "Sully Miracle on the Hudson"
      ],
      "emojis": [
        "👨‍✈️",
        "✈️",
        "🦆",
        "💥",
        "🌊",
        "🗽"
      ],
      "pack_id": "daily_exclusive",
      "year": 2016
    },
    {
      "id": "rep2_holes",
      "title": "Holes",
      "aliases": [],
      "emojis": [
        "👦",
        "⚖️",
        "🏜️",
        "⛏️",
        "🕳️",
        "🦎",
        "🍑"
      ],
      "pack_id": "daily_exclusive",
      "year": 2003
    },
    {
      "id": "rep2_seabiscuit",
      "title": "Seabiscuit",
      "aliases": [],
      "emojis": [
        "🐎",
        "📉",
        "👨",
        "🏇",
        "📻",
        "🏆"
      ],
      "pack_id": "daily_exclusive",
      "year": 2003
    },
    {
      "id": "rep2_october_sky",
      "title": "October Sky",
      "aliases": [],
      "emojis": [
        "⛏️",
        "👦",
        "🚀",
        "📐",
        "🌌",
        "🏆"
      ],
      "pack_id": "daily_exclusive",
      "year": 1999
    },
    {
      "id": "rep2_secretariat",
      "title": "Secretariat",
      "aliases": [],
      "emojis": [
        "👩",
        "🐎",
        "🏇",
        "🥇",
        "🏆",
        "❤️"
      ],
      "pack_id": "daily_exclusive",
      "year": 2010
    },
    {
      "id": "rep2_eddie_the_eagle",
      "title": "Eddie the Eagle",
      "aliases": [
        "Eddie Eagle"
      ],
      "emojis": [
        "👓",
        "🇬🇧",
        "⛷️",
        "🏔️",
        "🦅",
        "🏅"
      ],
      "pack_id": "daily_exclusive",
      "year": 2016
    },
    {
      "id": "rep2_the_rookie",
      "title": "The Rookie",
      "aliases": [
        "Rookie"
      ],
      "emojis": [
        "👨‍🏫",
        "⚾",
        "💨",
        "🏟️",
        "⏳",
        "🌟"
      ],
      "pack_id": "daily_exclusive",
      "year": 2002
    },
    {
      "id": "rep2_akeelah",
      "title": "Akeelah and the Bee",
      "aliases": [
        "Akeelah"
      ],
      "emojis": [
        "👧🏾",
        "📚",
        "🔤",
        "🐝",
        "🏆"
      ],
      "pack_id": "daily_exclusive",
      "year": 2006
    },
    {
      "id": "rep2_chef",
      "title": "Chef",
      "aliases": [],
      "emojis": [
        "👨‍🍳",
        "😤",
        "📱",
        "🚚",
        "🥪",
        "👦",
        "🇺🇸"
      ],
      "pack_id": "daily_exclusive",
      "year": 2014
    },
    {
      "id": "rep2_the_intern",
      "title": "The Intern",
      "aliases": [
        "Intern"
      ],
      "emojis": [
        "👴",
        "💼",
        "🌐",
        "👩‍💼",
        "🤝",
        "❤️"
      ],
      "pack_id": "daily_exclusive",
      "year": 2015
    },
    {
      "id": "rep2_julie_julia",
      "title": "Julie & Julia",
      "aliases": [
        "Julie and Julia"
      ],
      "emojis": [
        "👩‍💻",
        "📖",
        "👩‍🍳",
        "🇫🇷",
        "🍳",
        "🥘"
      ],
      "pack_id": "daily_exclusive",
      "year": 2009
    },
    {
      "id": "rep2_27_dresses",
      "title": "27 Dresses",
      "aliases": [
        "Twenty Seven Dresses"
      ],
      "emojis": [
        "👰",
        "👗",
        "👗",
        "👗",
        "📰",
        "💒",
        "💍"
      ],
      "pack_id": "daily_exclusive",
      "year": 2008
    },
    {
      "id": "rep2_uncut_gems",
      "title": "Uncut Gems",
      "aliases": [],
      "emojis": [
        "💎",
        "🏀",
        "🎰",
        "📿",
        "💸",
        "😰"
      ],
      "pack_id": "daily_exclusive",
      "year": 2019
    }
  ]
};
